'use strict';

materialTheme.$inject = ["$mdThemingProvider"];
runBlock.$inject = ["$rootScope", "$window", "MunicipalitiesTable", "WorkspacesTable"];
routesConfig.$inject = ["$stateProvider", "$urlRouterProvider", "$locationProvider"];
var cov_1da8q8mcdv = function () {
    var path = '/home/lobo/repos/prospector-app/src/index.js',
        hash = '4df1024e92b63e6d53a2652ff86d9a26b41b173f',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/index.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 37,
                    column: 27
                }
            },
            '1': {
                start: {
                    line: 41,
                    column: 4
                },
                end: {
                    line: 43,
                    column: 35
                }
            },
            '2': {
                start: {
                    line: 48,
                    column: 4
                },
                end: {
                    line: 50,
                    column: 6
                }
            },
            '3': {
                start: {
                    line: 49,
                    column: 8
                },
                end: {
                    line: 49,
                    column: 31
                }
            },
            '4': {
                start: {
                    line: 52,
                    column: 4
                },
                end: {
                    line: 56,
                    column: 6
                }
            },
            '5': {
                start: {
                    line: 53,
                    column: 1
                },
                end: {
                    line: 53,
                    column: 39
                }
            },
            '6': {
                start: {
                    line: 54,
                    column: 1
                },
                end: {
                    line: 54,
                    column: 42
                }
            },
            '7': {
                start: {
                    line: 55,
                    column: 1
                },
                end: {
                    line: 55,
                    column: 53
                }
            },
            '8': {
                start: {
                    line: 58,
                    column: 4
                },
                end: {
                    line: 62,
                    column: 6
                }
            },
            '9': {
                start: {
                    line: 60,
                    column: 1
                },
                end: {
                    line: 60,
                    column: 95
                }
            },
            '10': {
                start: {
                    line: 61,
                    column: 1
                },
                end: {
                    line: 61,
                    column: 49
                }
            },
            '11': {
                start: {
                    line: 64,
                    column: 4
                },
                end: {
                    line: 64,
                    column: 32
                }
            }
        },
        fnMap: {
            '0': {
                name: 'materialTheme',
                decl: {
                    start: {
                        line: 40,
                        column: 9
                    },
                    end: {
                        line: 40,
                        column: 22
                    }
                },
                loc: {
                    start: {
                        line: 40,
                        column: 43
                    },
                    end: {
                        line: 44,
                        column: 1
                    }
                },
                line: 40
            },
            '1': {
                name: 'runBlock',
                decl: {
                    start: {
                        line: 47,
                        column: 9
                    },
                    end: {
                        line: 47,
                        column: 17
                    }
                },
                loc: {
                    start: {
                        line: 47,
                        column: 77
                    },
                    end: {
                        line: 65,
                        column: 1
                    }
                },
                line: 47
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 48,
                        column: 24
                    },
                    end: {
                        line: 48,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 48,
                        column: 30
                    },
                    end: {
                        line: 50,
                        column: 5
                    }
                },
                line: 48
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 52,
                        column: 33
                    },
                    end: {
                        line: 52,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 52,
                        column: 42
                    },
                    end: {
                        line: 56,
                        column: 5
                    }
                },
                line: 52
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 58,
                        column: 32
                    },
                    end: {
                        line: 58,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 58,
                        column: 44
                    },
                    end: {
                        line: 62,
                        column: 5
                    }
                },
                line: 58
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1da8q8mcdv.s[0]++;
angular.module('app', ['ui.router', 'restmod', 'restmod.styles.drfPaged', 'ngMaterial', 'satellizer', 'ngFileUpload', 'cgBusy', 'angularMoment', 'angular-loading-bar', 'as.sortable', 'timer', 'ui.mask', 'ngMaterialDatePicker', 'mdPickers', 'textAngular', 'angular-bind-html-compile', 'nvd3']).constant('AppSettings', {
    appInProduction: false,
    // appUrl: 'http://prospector.local',
    // apiUrl: 'http://api.prospector.local',
    // mediaUrl: 'http://api.prospector.local/static/media',
    // proposalsApp: 'https://solo.com.pt/',
    appUrl: 'https://prospector.soloweb.pt',
    apiUrl: 'https://api.prospector.soloweb.pt',
    mediaUrl: 'https://api.prospector.soloweb.pt/static/media',
    proposalsApp: 'https://solo.com.pt/'
}).run(runBlock).value('cgBusyDefaults', {
    message: '',
    templateUrl: 'app/shared/html/cgbusy/cgbusy.template.html'
}).config(materialTheme);

/** @ngInject */
function materialTheme($mdThemingProvider) {
    cov_1da8q8mcdv.f[0]++;
    cov_1da8q8mcdv.s[1]++;

    $mdThemingProvider.theme('default').accentPalette('blue-grey').backgroundPalette('grey');
}

/** @ngInject */
function runBlock($rootScope, $window, MunicipalitiesTable, WorkspacesTable) {
    cov_1da8q8mcdv.f[1]++;
    cov_1da8q8mcdv.s[2]++;

    $rootScope.goBack = function () {
        cov_1da8q8mcdv.f[2]++;
        cov_1da8q8mcdv.s[3]++;

        $window.history.back();
    };

    cov_1da8q8mcdv.s[4]++;
    $rootScope.switchWorkspace = function (index) {
        cov_1da8q8mcdv.f[3]++;
        cov_1da8q8mcdv.s[5]++;

        $rootScope.me.activeWorkspace = index;
        cov_1da8q8mcdv.s[6]++;
        $rootScope.me.$save(['activeWorkspace']);
        cov_1da8q8mcdv.s[7]++;
        $rootScope.workspace = WorkspacesTable.$find(index);
    };

    cov_1da8q8mcdv.s[8]++;
    $rootScope.initStaticData = function () {
        cov_1da8q8mcdv.f[4]++;
        cov_1da8q8mcdv.s[9]++;

        /* eslint-disable camelcase */
        $rootScope.municipalities = MunicipalitiesTable.$search({ ordering: 'name', page_size: 99999 });
        cov_1da8q8mcdv.s[10]++;
        $rootScope.workspace = WorkspacesTable.$find(1);
    };

    cov_1da8q8mcdv.s[11]++;
    $rootScope.initStaticData();
}
'use strict';

var cov_22w9v7iqzx = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/users/usersList/usersList.js',
        hash = '5a37ba1f0d0ad6e26c952f1bbd1c8d71e0e5c692',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/users/usersList/usersList.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 9,
                    column: 7
                }
            }
        },
        fnMap: {},
        branchMap: {},
        s: {
            '0': 0
        },
        f: {},
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_22w9v7iqzx.s[0]++;
angular.module('app').component('usersList', {
    templateUrl: 'app/components/users/usersList/usersList.html',
    bindings: {
        members: '<',
        accountants: '<'
    }
});
'use strict';

var cov_24rlrkn1fm = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/users/editProfile/editProfile.js',
        hash = '7808b696c6ffb2325e96e0528ad673789089df4d',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/users/editProfile/editProfile.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 33
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 39
                }
            },
            '2': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 29
                }
            },
            '3': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 6,
                    column: 47
                }
            },
            '4': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 19,
                    column: 11
                }
            },
            '5': {
                start: {
                    line: 9,
                    column: 12
                },
                end: {
                    line: 18,
                    column: 13
                }
            },
            '6': {
                start: {
                    line: 10,
                    column: 16
                },
                end: {
                    line: 17,
                    column: 19
                }
            },
            '7': {
                start: {
                    line: 12,
                    column: 20
                },
                end: {
                    line: 12,
                    column: 99
                }
            },
            '8': {
                start: {
                    line: 13,
                    column: 20
                },
                end: {
                    line: 13,
                    column: 59
                }
            },
            '9': {
                start: {
                    line: 16,
                    column: 20
                },
                end: {
                    line: 16,
                    column: 98
                }
            },
            '10': {
                start: {
                    line: 23,
                    column: 8
                },
                end: {
                    line: 23,
                    column: 57
                }
            },
            '11': {
                start: {
                    line: 27,
                    column: 8
                },
                end: {
                    line: 33,
                    column: 11
                }
            },
            '12': {
                start: {
                    line: 28,
                    column: 12
                },
                end: {
                    line: 32,
                    column: 15
                }
            },
            '13': {
                start: {
                    line: 29,
                    column: 16
                },
                end: {
                    line: 29,
                    column: 94
                }
            },
            '14': {
                start: {
                    line: 31,
                    column: 16
                },
                end: {
                    line: 31,
                    column: 41
                }
            },
            '15': {
                start: {
                    line: 37,
                    column: 8
                },
                end: {
                    line: 40,
                    column: 11
                }
            },
            '16': {
                start: {
                    line: 38,
                    column: 12
                },
                end: {
                    line: 38,
                    column: 89
                }
            },
            '17': {
                start: {
                    line: 39,
                    column: 12
                },
                end: {
                    line: 39,
                    column: 66
                }
            },
            '18': {
                start: {
                    line: 44,
                    column: 0
                },
                end: {
                    line: 52,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 84
                    },
                    end: {
                        line: 20,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 8,
                        column: 43
                    },
                    end: {
                        line: 8,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 8,
                        column: 49
                    },
                    end: {
                        line: 19,
                        column: 9
                    }
                },
                line: 8
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 50
                    },
                    end: {
                        line: 10,
                        column: 51
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 56
                    },
                    end: {
                        line: 14,
                        column: 17
                    }
                },
                line: 10
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 14,
                        column: 19
                    },
                    end: {
                        line: 14,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 25
                    },
                    end: {
                        line: 17,
                        column: 17
                    }
                },
                line: 14
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 22,
                        column: 4
                    },
                    end: {
                        line: 22,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 14
                    },
                    end: {
                        line: 24,
                        column: 5
                    }
                },
                line: 22
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 26,
                        column: 4
                    },
                    end: {
                        line: 26,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 17
                    },
                    end: {
                        line: 34,
                        column: 5
                    }
                },
                line: 26
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 27,
                        column: 65
                    },
                    end: {
                        line: 27,
                        column: 66
                    }
                },
                loc: {
                    start: {
                        line: 27,
                        column: 71
                    },
                    end: {
                        line: 33,
                        column: 9
                    }
                },
                line: 27
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 28,
                        column: 62
                    },
                    end: {
                        line: 28,
                        column: 63
                    }
                },
                loc: {
                    start: {
                        line: 28,
                        column: 68
                    },
                    end: {
                        line: 30,
                        column: 13
                    }
                },
                line: 28
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 30,
                        column: 15
                    },
                    end: {
                        line: 30,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 21
                    },
                    end: {
                        line: 32,
                        column: 13
                    }
                },
                line: 30
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 36,
                        column: 4
                    },
                    end: {
                        line: 36,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 36,
                        column: 17
                    },
                    end: {
                        line: 41,
                        column: 5
                    }
                },
                line: 36
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 37,
                        column: 63
                    },
                    end: {
                        line: 37,
                        column: 64
                    }
                },
                loc: {
                    start: {
                        line: 37,
                        column: 69
                    },
                    end: {
                        line: 40,
                        column: 9
                    }
                },
                line: 37
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 9,
                        column: 12
                    },
                    end: {
                        line: 18,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 9,
                        column: 12
                    },
                    end: {
                        line: 18,
                        column: 13
                    }
                }, {
                    start: {
                        line: 9,
                        column: 12
                    },
                    end: {
                        line: 18,
                        column: 13
                    }
                }],
                line: 9
            },
            '1': {
                loc: {
                    start: {
                        line: 9,
                        column: 16
                    },
                    end: {
                        line: 9,
                        column: 95
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 9,
                        column: 16
                    },
                    end: {
                        line: 9,
                        column: 50
                    }
                }, {
                    start: {
                        line: 9,
                        column: 54
                    },
                    end: {
                        line: 9,
                        column: 95
                    }
                }],
                line: 9
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditProfileController = function () {
    EditProfileController.$inject = ["$mdToast", "AuthService", "$state", "$rootScope", "$scope", "WorkspacesTable"];
    function EditProfileController($mdToast, AuthService, $state, $rootScope, $scope, WorkspacesTable) {
        var _this = this;

        _classCallCheck(this, EditProfileController);

        cov_24rlrkn1fm.f[0]++;
        cov_24rlrkn1fm.s[0]++;

        this.$mdToast = $mdToast;
        cov_24rlrkn1fm.s[1]++;
        this.AuthService = AuthService;
        cov_24rlrkn1fm.s[2]++;
        this.$state = $state;
        cov_24rlrkn1fm.s[3]++;
        this.workspacesTable = WorkspacesTable;

        cov_24rlrkn1fm.s[4]++;
        $scope.$watch('$ctrl.user.avatar', function () {
            cov_24rlrkn1fm.f[1]++;
            cov_24rlrkn1fm.s[5]++;

            if ((cov_24rlrkn1fm.b[1][0]++, angular.isString(_this.user.avatar)) && (cov_24rlrkn1fm.b[1][1]++, _this.user.avatar !== $rootScope.me.avatar)) {
                cov_24rlrkn1fm.b[0][0]++;
                cov_24rlrkn1fm.s[6]++;

                _this.user.$save(['avatar']).$then(function () {
                    cov_24rlrkn1fm.f[2]++;
                    cov_24rlrkn1fm.s[7]++;

                    /* eslint-disable no-undef */
                    $mdToast.show($mdToast.simple().textContent(gettext('Profile image updated')));
                    cov_24rlrkn1fm.s[8]++;
                    AuthService.refreshAuthenticatedInfo();
                }, function () {
                    cov_24rlrkn1fm.f[3]++;
                    cov_24rlrkn1fm.s[9]++;

                    /* eslint-disable no-undef */
                    $mdToast.show($mdToast.simple().textContent(gettext('An error has ocurred')));
                });
            } else {
                cov_24rlrkn1fm.b[0][1]++;
            }
        });
    }

    _createClass(EditProfileController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_24rlrkn1fm.f[4]++;
            cov_24rlrkn1fm.s[10]++;

            this.workspaces = this.workspacesTable.$search();
        }
    }, {
        key: 'changeInfo',
        value: function changeInfo() {
            var _this2 = this;

            cov_24rlrkn1fm.f[5]++;
            cov_24rlrkn1fm.s[11]++;

            this.user.$save(['name', 'email', 'nif', 'phone']).$then(function () {
                cov_24rlrkn1fm.f[6]++;
                cov_24rlrkn1fm.s[12]++;

                _this2.AuthService.refreshAuthenticatedInfo().$then(function () {
                    cov_24rlrkn1fm.f[7]++;
                    cov_24rlrkn1fm.s[13]++;

                    _this2.$mdToast.show(_this2.$mdToast.simple().textContent('Perfil actualizado!'));
                }, function () {
                    cov_24rlrkn1fm.f[8]++;
                    cov_24rlrkn1fm.s[14]++;

                    _this2.$state.go('logout');
                });
            });
        }
    }, {
        key: 'changePass',
        value: function changePass() {
            var _this3 = this;

            cov_24rlrkn1fm.f[9]++;
            cov_24rlrkn1fm.s[15]++;

            this.user.$save(['password', 'confirmPassword']).$then(function () {
                cov_24rlrkn1fm.f[10]++;
                cov_24rlrkn1fm.s[16]++;

                _this3.$mdToast.show(_this3.$mdToast.simple().textContent('Password alterada!'));
                cov_24rlrkn1fm.s[17]++;
                _this3.user.password = _this3.user.confirmPassword = null;
            });
        }
    }]);

    return EditProfileController;
}();

cov_24rlrkn1fm.s[18]++;


angular.module('app').component('editProfile', {
    templateUrl: 'app/components/users/editProfile/editProfile.html',
    controller: EditProfileController,
    bindings: {
        user: '<'
    }
});
'use strict';

var cov_17c7gitvwg = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.workspaces.factory.js',
        hash = 'a0cc8e7250ab219c47c699d4b042aa4e60b5a1db',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.workspaces.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 12,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 52
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 44
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 12,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_17c7gitvwg.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_17c7gitvwg.f[0]++;
    cov_17c7gitvwg.s[1]++;
    angular.module('app').factory('WorkspacesTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_17c7gitvwg.f[1]++;
        cov_17c7gitvwg.s[2]++;

        return restmod.model('/workspaces');
    }
})();
'use strict';

var cov_26dfdrjloz = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.users.factory.js',
        hash = '16f084784ac24dd5a395f26bf643426b5d9b08c5',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.users.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 12,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 43
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 63
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 12,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_26dfdrjloz.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_26dfdrjloz.f[0]++;
    cov_26dfdrjloz.s[1]++;
    angular.module('app').factory('UsersTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_26dfdrjloz.f[1]++;
        cov_26dfdrjloz.s[2]++;

        return restmod.model('/users').mix('MixinContainable');
    }
})();
'use strict';

var cov_167hrhiwd8 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.user.story.costs.factory.js',
        hash = 'e0d033d903cb271a16fd68faaaebb947c3c1889f',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.user.story.costs.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 27,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 56
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 25,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 27,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 26,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_167hrhiwd8.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_167hrhiwd8.f[0]++;
    cov_167hrhiwd8.s[1]++;
    angular.module('app').factory('UserStoryCostsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_167hrhiwd8.f[1]++;
        cov_167hrhiwd8.s[2]++;

        return restmod.model('/user-story-costs').mix('MixinContainable', {
            $config: {
                contains: {
                    component: {
                        type: 'belongsTo',
                        table: 'ComponentsTable',
                        foreignKey: 'component'
                    },
                    userStory: {
                        type: 'belongsTo',
                        table: 'UserStoriesTable',
                        foreignKey: 'user_story'
                    }
                }
            }
        });
    }
})();
'use strict';

var cov_1x2fdx2gok = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.user.stories.factory.js',
        hash = '044757482dcb3d31a80aa0f8aea5fdc91eb63279',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.user.stories.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 31,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 53
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 29,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 31,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 30,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1x2fdx2gok.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_1x2fdx2gok.f[0]++;
    cov_1x2fdx2gok.s[1]++;
    angular.module('app').factory('UserStoriesTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_1x2fdx2gok.f[1]++;
        cov_1x2fdx2gok.s[2]++;

        return restmod.model('/user-stories').mix('MixinContainable', {
            $config: {
                contains: {
                    comments: {
                        type: 'hasMany',
                        table: 'CommentsTable',
                        foreignKey: 'object_id',
                        filters: {
                            /* eslint-disable camelcase */
                            object_type: 'USER_STORY'
                        }
                    },
                    costs: {
                        type: 'hasMany',
                        table: 'UserStoryCostsTable',
                        foreignKey: 'user_story'
                    }
                }
            }
        });
    }
})();
'use strict';

var cov_2metp44vqg = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.tags.factory.js',
        hash = '73eb6af96ed705fa24492aa5672a1c2d39432796',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.tags.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 31,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 42
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 29,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 31,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 30,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2metp44vqg.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_2metp44vqg.f[0]++;
    cov_2metp44vqg.s[1]++;
    angular.module('app').factory('TagsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_2metp44vqg.f[1]++;
        cov_2metp44vqg.s[2]++;

        return restmod.model('/tags').mix('MixinContainable', {
            $config: {
                contains: {
                    comments: {
                        type: 'hasMany',
                        table: 'CommentsTable',
                        foreignKey: 'object_id',
                        filters: {
                            /* eslint-disable camelcase */
                            object_type: 'INDUSTRY'
                        }
                    },
                    files: {
                        type: 'hasMany',
                        table: 'IndustryFilesTable',
                        foreignKey: 'industry'
                    }
                }
            }
        });
    }
})();
'use strict';

var cov_1len1h5bg4 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.stats.factory.js',
        hash = 'd0944e8775c23db2f0217691de4f44382f138f30',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.stats.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 12,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 43
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 39
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 12,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1len1h5bg4.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_1len1h5bg4.f[0]++;
    cov_1len1h5bg4.s[1]++;
    angular.module('app').factory('StatsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_1len1h5bg4.f[1]++;
        cov_1len1h5bg4.s[2]++;

        return restmod.model('/stats');
    }
})();
'use strict';

var cov_k9avntphg = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.reminders.factory.js',
        hash = '9452626a99621afe662767cc08a34d962b1c82cd',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.reminders.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 12,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 47
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 43
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 12,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_k9avntphg.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_k9avntphg.f[0]++;
    cov_k9avntphg.s[1]++;
    angular.module('app').factory('RemindersTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_k9avntphg.f[1]++;
        cov_k9avntphg.s[2]++;

        return restmod.model('/reminders');
    }
})();
'use strict';

var cov_1x226afr2m = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.rankings.factory.js',
        hash = '9bde3f3956b24930f8aaef21ffaf521bdeb54c63',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.rankings.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 12,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 46
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 70
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 12,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1x226afr2m.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_1x226afr2m.f[0]++;
    cov_1x226afr2m.s[1]++;
    angular.module('app').factory('RankingsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_1x226afr2m.f[1]++;
        cov_1x226afr2m.s[2]++;

        return restmod.model('/rankings').mix('MixinContainable', {});
    }
})();
'use strict';

var cov_24pz7fnk73 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.proposals.services.js',
        hash = '307809c1c600a664e06e014a316a66b6d1e58edb',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.proposals.services.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 12,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 54
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 79
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 12,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_24pz7fnk73.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_24pz7fnk73.f[0]++;
    cov_24pz7fnk73.s[1]++;
    angular.module('app').factory('ProposalServicesTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_24pz7fnk73.f[1]++;
        cov_24pz7fnk73.s[2]++;

        return restmod.model('/proposal-services').mix('MixinContainable', {});
    }
})();
'use strict';

var cov_26tvhk66t3 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.proposals.sections.js',
        hash = 'f63d3042771b6c54edd4171d2a200472d6d3523a',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.proposals.sections.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 22,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 54
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 20,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 22,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 21,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_26tvhk66t3.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_26tvhk66t3.f[0]++;
    cov_26tvhk66t3.s[1]++;
    angular.module('app').factory('ProposalSectionsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_26tvhk66t3.f[1]++;
        cov_26tvhk66t3.s[2]++;

        return restmod.model('/proposal-sections').mix('MixinContainable', {
            $config: {
                contains: {
                    sectionContents: {
                        type: 'hasMany',
                        table: 'ProposalSectionContentsTable',
                        foreignKey: 'section'
                    }
                }
            }
        });
    }
})();
'use strict';

var cov_550xgv2wp = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.proposals.section.contents.js',
        hash = 'a41ee807dd4409761b7a7ca1a299346abb2eb0e7',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.proposals.section.contents.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 12,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 61
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 87
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 12,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_550xgv2wp.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_550xgv2wp.f[0]++;
    cov_550xgv2wp.s[1]++;
    angular.module('app').factory('ProposalSectionContentsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_550xgv2wp.f[1]++;
        cov_550xgv2wp.s[2]++;

        return restmod.model('/proposal-section-contents').mix('MixinContainable', {});
    }
})();
'use strict';

var cov_2ej3aqgido = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.proposals.factory.js',
        hash = '3ba08e8a2eed9534d14862adacb56d0eb830131c',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.proposals.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 65,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 47
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 63,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 51,
                    column: 20
                },
                end: {
                    line: 53,
                    column: 21
                }
            },
            '4': {
                start: {
                    line: 52,
                    column: 24
                },
                end: {
                    line: 52,
                    column: 47
                }
            },
            '5': {
                start: {
                    line: 58,
                    column: 20
                },
                end: {
                    line: 60,
                    column: 21
                }
            },
            '6': {
                start: {
                    line: 59,
                    column: 24
                },
                end: {
                    line: 59,
                    column: 47
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 65,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 64,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 51,
                        column: 20
                    },
                    end: {
                        line: 53,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 51,
                        column: 20
                    },
                    end: {
                        line: 53,
                        column: 21
                    }
                }, {
                    start: {
                        line: 51,
                        column: 20
                    },
                    end: {
                        line: 53,
                        column: 21
                    }
                }],
                line: 51
            },
            '1': {
                loc: {
                    start: {
                        line: 58,
                        column: 20
                    },
                    end: {
                        line: 60,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 58,
                        column: 20
                    },
                    end: {
                        line: 60,
                        column: 21
                    }
                }, {
                    start: {
                        line: 58,
                        column: 20
                    },
                    end: {
                        line: 60,
                        column: 21
                    }
                }],
                line: 58
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2ej3aqgido.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_2ej3aqgido.f[0]++;
    cov_2ej3aqgido.s[1]++;
    angular.module('app').factory('ProposalsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_2ej3aqgido.f[1]++;
        cov_2ej3aqgido.s[2]++;

        return restmod.model('/proposals').mix('MixinContainable', {
            $config: {
                contains: {
                    proposalServices: {
                        type: 'hasMany',
                        table: 'ProposalServicesTable',
                        foreignKey: 'proposal'
                    },
                    proposalSections: {
                        type: 'hasMany',
                        table: 'ProposalSectionsTable',
                        foreignKey: 'proposal'
                    },
                    client: {
                        type: 'belongsTo',
                        table: 'OrganizationsTable',
                        foreignKey: 'client'
                    },
                    files: {
                        type: 'hasMany',
                        table: 'ProposalFilesTable',
                        foreignKey: 'proposal'
                    },
                    comments: {
                        type: 'hasMany',
                        table: 'CommentsTable',
                        foreignKey: 'object_id',
                        filters: {
                            /* eslint-disable camelcase */
                            object_type: 'PROPOSAL'
                        }
                    },
                    userStories: {
                        type: 'hasMany',
                        table: 'UserStoriesTable',
                        foreignKey: 'proposal'
                    }
                }
            },
            date: {
                decode: function decode(value) {
                    cov_2ej3aqgido.s[3]++;

                    if (value !== null) {
                        cov_2ej3aqgido.b[0][0]++;
                        cov_2ej3aqgido.s[4]++;

                        return new Date(value);
                    } else {
                        cov_2ej3aqgido.b[0][1]++;
                    }
                }
            },
            expirationDate: {
                decode: function decode(value) {
                    cov_2ej3aqgido.s[5]++;

                    if (value !== null) {
                        cov_2ej3aqgido.b[1][0]++;
                        cov_2ej3aqgido.s[6]++;

                        return new Date(value);
                    } else {
                        cov_2ej3aqgido.b[1][1]++;
                    }
                }
            }
        });
    }
})();
'use strict';

var cov_twlvzxwtw = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.proposal.files.factory.js',
        hash = '4dbdba391c9769f07d235d870762b0f24d47a78d',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.proposal.files.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 23,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 55
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 21,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 23,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 22,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_twlvzxwtw.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_twlvzxwtw.f[0]++;
    cov_twlvzxwtw.s[1]++;
    angular.module('app').factory('ProposalFilesTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_twlvzxwtw.f[1]++;
        cov_twlvzxwtw.s[2]++;

        return restmod.model('/proposal-files').mix('MixinContainable', {
            $config: {
                contains: {
                    proposal: {
                        type: 'belongsTo',
                        table: 'ProposalsTable',
                        foreignKey: 'proposal'
                    }
                }
            }

        });
    }
})();
'use strict';

var cov_24jkhownuf = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organizations.factory.js',
        hash = '9ca3edee8169e808afff8ee1962c9fdee625244e',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organizations.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 100,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 51
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 98,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 18,
                    column: 20
                },
                end: {
                    line: 20,
                    column: 21
                }
            },
            '4': {
                start: {
                    line: 19,
                    column: 24
                },
                end: {
                    line: 19,
                    column: 41
                }
            },
            '5': {
                start: {
                    line: 21,
                    column: 20
                },
                end: {
                    line: 21,
                    column: 51
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 100,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 99,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 16,
                        column: 37
                    },
                    end: {
                        line: 16,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 16,
                        column: 53
                    },
                    end: {
                        line: 22,
                        column: 17
                    }
                },
                line: 16
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 18,
                        column: 20
                    },
                    end: {
                        line: 20,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 18,
                        column: 20
                    },
                    end: {
                        line: 20,
                        column: 21
                    }
                }, {
                    start: {
                        line: 18,
                        column: 20
                    },
                    end: {
                        line: 20,
                        column: 21
                    }
                }],
                line: 18
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_24jkhownuf.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_24jkhownuf.f[0]++;
    cov_24jkhownuf.s[1]++;
    angular.module('app').factory('OrganizationsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_24jkhownuf.f[1]++;
        cov_24jkhownuf.s[2]++;

        return restmod.model('/organizations').mix('MixinContainable', {
            type: {
                init: 'COLECTIVE'
            },
            $hooks: {
                /* eslint-disable babel/object-shorthand */
                'before-fetch-many': function beforeFetchMany(_req) {
                    cov_24jkhownuf.f[2]++;
                    cov_24jkhownuf.s[3]++;

                    /* eslint-disable no-undef */
                    if (_.isUndefined(_req.params)) {
                        cov_24jkhownuf.b[0][0]++;
                        cov_24jkhownuf.s[4]++;

                        _req.params = {};
                    } else {
                        cov_24jkhownuf.b[0][1]++;
                    }
                    cov_24jkhownuf.s[5]++;
                    _req.params.type = 'COLECTIVE';
                }
            },
            $config: {
                contains: {
                    links: {
                        type: 'hasMany',
                        table: 'LinksTable',
                        foreignKey: 'organization'
                    },
                    comments: {
                        type: 'hasMany',
                        table: 'CommentsTable',
                        foreignKey: 'object_id',
                        filters: {
                            /* eslint-disable camelcase */
                            object_type: 'ORGANIZATION'
                        }
                    },
                    organizationIndividuals: {
                        type: 'hasMany',
                        table: 'OrganizationIndividualsTable',
                        foreignKey: 'organization1'
                    },
                    economicActivities: {
                        type: 'hasMany',
                        table: 'OrganizationEconomicActivitiesTable',
                        foreignKey: 'organization'
                    },
                    files: {
                        type: 'hasMany',
                        table: 'OrganizationFilesTable',
                        foreignKey: 'organization'
                    },
                    tags: {
                        type: 'hasMany',
                        table: 'OrganizationTagsTable',
                        foreignKey: 'organization'
                    },
                    interactions: {
                        type: 'hasMany',
                        table: 'OrganizationInteractionsTable',
                        foreignKey: 'organization'
                    },
                    municipality: {
                        type: 'belongsTo',
                        table: 'MunicipalitiesTable',
                        foreignKey: 'municipality'
                    },
                    emails: {
                        type: 'hasMany',
                        table: 'OrganizationEmailsTable',
                        foreignKey: 'organization'
                    },
                    rankings: {
                        type: 'hasMany',
                        table: 'RankingsTable',
                        foreignKey: 'organization'
                    },
                    emailInteractionReads: {
                        type: 'hasMany',
                        table: 'EmailInteractionReadsTable',
                        foreignKey: 'organization'

                    },
                    siteVisits: {
                        type: 'hasMany',
                        table: 'OrganizationSiteVisitsTable',
                        foreignKey: 'organization'
                    },
                    domains: {
                        type: 'hasMany',
                        table: 'OrganizationDomainsTable',
                        foreignKey: 'organization'
                    }
                }
            }
        });
    }
})();
'use strict';

var cov_vhff0uwk1 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organization.tags.factory.js',
        hash = 'e4e0605584a61c635c2866cacd8fc0990079b2a1',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organization.tags.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 28,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 54
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 26,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 28,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 27,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_vhff0uwk1.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_vhff0uwk1.f[0]++;
    cov_vhff0uwk1.s[1]++;
    angular.module('app').factory('OrganizationTagsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_vhff0uwk1.f[1]++;
        cov_vhff0uwk1.s[2]++;

        return restmod.model('/organization-tags').mix('MixinContainable', {
            $config: {
                contains: {
                    tag: {
                        type: 'belongsTo',
                        table: 'TagsTable',
                        foreignKey: 'tag'
                    },
                    organization: {
                        type: 'belongsTo',
                        table: 'OrganizationsTable',
                        foreignKey: 'organization'
                    }
                }
            }

        });
    }
})();
'use strict';

var cov_yi5nsp29u = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organization.site.visits.js',
        hash = 'e740b48d70f41e2b10bcdc1e0b254269ea783b7d',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organization.site.visits.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 12,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 60
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 86
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 12,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_yi5nsp29u.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_yi5nsp29u.f[0]++;
    cov_yi5nsp29u.s[1]++;
    angular.module('app').factory('OrganizationSiteVisitsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_yi5nsp29u.f[1]++;
        cov_yi5nsp29u.s[2]++;

        return restmod.model('/organization-site-visits').mix('MixinContainable', {});
    }
})();
'use strict';

var cov_3sbgz0oxb = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organization.interactions.factory.js',
        hash = '78c80b9e441fdaf21879f80d461b9b7032370338',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organization.interactions.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 33,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 62
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 31,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 33,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 32,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_3sbgz0oxb.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_3sbgz0oxb.f[0]++;
    cov_3sbgz0oxb.s[1]++;
    angular.module('app').factory('OrganizationInteractionsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_3sbgz0oxb.f[1]++;
        cov_3sbgz0oxb.s[2]++;

        return restmod.model('/organization-interactions').mix('MixinContainable', {
            $config: {
                contains: {
                    tt: {
                        type: 'belongsTo',
                        table: 'InteractionTypesTable',
                        foreignKey: 'interactionType'
                    },
                    email: {
                        type: 'belongsTo',
                        table: 'EmailsTable',
                        foreignKey: 'email'
                    },
                    org: {
                        type: 'belongsTo',
                        table: 'OrganizationsTable',
                        foreignKey: 'organization'

                    }
                }
            }
        });
    }
})();
'use strict';

var cov_1m34fj3qez = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organization.industries.factory.js',
        hash = '9f299ef308d9588fa15305602cf15c1416cfe866',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organization.industries.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 22,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 68
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 20,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 22,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 21,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1m34fj3qez.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_1m34fj3qez.f[0]++;
    cov_1m34fj3qez.s[1]++;
    angular.module('app').factory('OrganizationEconomicActivitiesTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_1m34fj3qez.f[1]++;
        cov_1m34fj3qez.s[2]++;

        return restmod.model('/organization-economic-activities').mix('MixinContainable', {
            $config: {
                contains: {
                    economicActivity: {
                        type: 'belongsTo',
                        table: 'EconomicActivitiesTable',
                        foreignKey: 'economicActivity'
                    }
                }
            }
        });
    }
})();
'use strict';

var cov_tu8mbq4iz = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organization.individuals.factory.js',
        hash = '8b6c0172439f58fde2d664b4fbcb911479443d76',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organization.individuals.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 22,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 61
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 20,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 22,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 21,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_tu8mbq4iz.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_tu8mbq4iz.f[0]++;
    cov_tu8mbq4iz.s[1]++;
    angular.module('app').factory('OrganizationIndividualsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_tu8mbq4iz.f[1]++;
        cov_tu8mbq4iz.s[2]++;

        return restmod.model('/organization-organizations').mix('MixinContainable', {
            $config: {
                contains: {
                    individual: {
                        type: 'belongsTo',
                        table: 'IndividualsTable',
                        foreignKey: 'organization2'
                    }
                }
            }
        });
    }
})();
'use strict';

var cov_2pzlqnusr7 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organization.files.factory.js',
        hash = '9834140a2282e62ed3880490003d5ae1dce35ed1',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organization.files.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 23,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 55
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 21,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 23,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 22,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2pzlqnusr7.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_2pzlqnusr7.f[0]++;
    cov_2pzlqnusr7.s[1]++;
    angular.module('app').factory('OrganizationFilesTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_2pzlqnusr7.f[1]++;
        cov_2pzlqnusr7.s[2]++;

        return restmod.model('/organization-files').mix('MixinContainable', {
            $config: {
                contains: {
                    organization: {
                        type: 'belongsTo',
                        table: 'OrganizationsTable',
                        foreignKey: 'organization'
                    }
                }
            }

        });
    }
})();
'use strict';

var cov_1zt3dy4ysm = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organization.emails.factory.js',
        hash = '3e2409a9ee3d8637157fe1098648e4f883f1f728',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organization.emails.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 23,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 56
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 21,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 23,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 22,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1zt3dy4ysm.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_1zt3dy4ysm.f[0]++;
    cov_1zt3dy4ysm.s[1]++;
    angular.module('app').factory('OrganizationEmailsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_1zt3dy4ysm.f[1]++;
        cov_1zt3dy4ysm.s[2]++;

        return restmod.model('/organization-emails').mix('MixinContainable', {
            $config: {
                contains: {
                    organization: {
                        type: 'belongsTo',
                        table: 'OrganizationsTable',
                        foreignKey: 'organization'
                    }
                }
            }

        });
    }
})();
'use strict';

var cov_ljfg3s5e9 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organization.domains.factory.js',
        hash = 'be37662966303cfadaa401c68f3034e07244e853',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organization.domains.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 12,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 54
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 82
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 12,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_ljfg3s5e9.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_ljfg3s5e9.f[0]++;
    cov_ljfg3s5e9.s[1]++;
    angular.module('app').factory('OrganizationDomainsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_ljfg3s5e9.f[1]++;
        cov_ljfg3s5e9.s[2]++;

        return restmod.model('/organization-domains').mix('MixinContainable', {});
    }
})();
'use strict';

var cov_bkzpffjzq = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organization.autocompletes.factory.js',
        hash = '2283cdfe738cc28d53564cb5904eead124d1dc07',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organization.autocompletes.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 38,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 63
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 36,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 38,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 37,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_bkzpffjzq.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_bkzpffjzq.f[0]++;
    cov_bkzpffjzq.s[1]++;
    angular.module('app').factory('OrganizationAutocompletesTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_bkzpffjzq.f[1]++;
        cov_bkzpffjzq.s[2]++;

        return restmod.model('/organization-autocompletes').mix('MixinContainable', {
            $config: {
                contains: {
                    organizationAutocompleteEconomicActivity: {
                        type: 'hasMany',
                        table: 'OrganizationAutocompleteEconomicActivitiesTable',
                        foreignKey: 'organization_autocomplete'
                    },
                    organizationAutocompletePeople: {
                        type: 'hasMany',
                        table: 'OrganizationAutocompletePeopleTable',
                        foreignKey: 'organization_autocomplete'
                    },
                    organizationAutocompleteLink: {
                        type: 'hasMany',
                        table: 'OrganizationAutocompleteLinkTable',
                        foreignKey: 'organization_autocomplete'
                    },
                    organizationAutocompleteEmail: {
                        type: 'hasMany',
                        table: 'OrganizationAutocompleteEmailTable',
                        foreignKey: 'organization_autocomplete'
                    }
                }
            }

        });
    }
})();
'use strict';

var cov_1v3tj7iyru = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organization.autocomplete.people.factory.js',
        hash = '6b730ab71569ee124e7054f6108b92ecdaffbca8',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organization.autocomplete.people.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 12,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 72
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 94
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 12,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1v3tj7iyru.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_1v3tj7iyru.f[0]++;
    cov_1v3tj7iyru.s[1]++;
    angular.module('app').factory('OrganizationAutocompletePeopleTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_1v3tj7iyru.f[1]++;
        cov_1v3tj7iyru.s[2]++;

        return restmod.model('/organization-autocomplete-people').mix('MixinContainable', {});
    }
})();
'use strict';

var cov_1d2uakbs6s = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organization.autocomplete.link.factory.js',
        hash = 'a1350d40686b6638e2b7ea7f0e5a42fa0c9f6fd4',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organization.autocomplete.link.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 12,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 70
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 93
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 12,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1d2uakbs6s.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_1d2uakbs6s.f[0]++;
    cov_1d2uakbs6s.s[1]++;
    angular.module('app').factory('OrganizationAutocompleteLinkTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_1d2uakbs6s.f[1]++;
        cov_1d2uakbs6s.s[2]++;

        return restmod.model('/organization-autocomplete-links').mix('MixinContainable', {});
    }
})();
'use strict';

var cov_987zu3t2a = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organization.autocomplete.email.factory.js',
        hash = '6c6dc4d1c6357b186b460bb9ec9edc66d28095e4',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organization.autocomplete.email.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 12,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 71
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 94
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 12,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_987zu3t2a.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_987zu3t2a.f[0]++;
    cov_987zu3t2a.s[1]++;
    angular.module('app').factory('OrganizationAutocompleteEmailTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_987zu3t2a.f[1]++;
        cov_987zu3t2a.s[2]++;

        return restmod.model('/organization-autocomplete-emails').mix('MixinContainable', {});
    }
})();
'use strict';

var cov_r4dez7y6q = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organization.autocomplete.economic.activities.factory.js',
        hash = '4e2229520041a3443e635b7293a0d2cdf2b2ed2c',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organization.autocomplete.economic.activities.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 22,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 84
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 20,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 22,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 21,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_r4dez7y6q.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_r4dez7y6q.f[0]++;
    cov_r4dez7y6q.s[1]++;
    angular.module('app').factory('OrganizationAutocompleteEconomicActivitiesTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_r4dez7y6q.f[1]++;
        cov_r4dez7y6q.s[2]++;

        return restmod.model('/organization-autocomplete-economic-activities').mix('MixinContainable', {
            $config: {
                contains: {
                    economicActivity: {
                        type: 'belongsTo',
                        table: 'EconomicActivitiesTable',
                        foreignKey: 'economicActivity'
                    }
                }
            }
        });
    }
})();
'use strict';

var cov_1zli6k8chp = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.municipalities.factory.js',
        hash = 'f6a316f27a7f00a6e0e4dedc63150d06cc9b7eb7',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.municipalities.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 22,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 52
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 20,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 22,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 21,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1zli6k8chp.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_1zli6k8chp.f[0]++;
    cov_1zli6k8chp.s[1]++;
    angular.module('app').factory('MunicipalitiesTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_1zli6k8chp.f[1]++;
        cov_1zli6k8chp.s[2]++;

        return restmod.model('/municipalities').mix('MixinContainable', {
            $config: {
                contains: {
                    district: {
                        type: 'belongsTo',
                        table: 'DistrictsTable',
                        foreignKey: 'district'
                    }
                }
            }
        });
    }
})();
'use strict';

var cov_1kzc8gxpx2 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.mixins.containable.factory.js',
        hash = '3c46502e06cf2183a7c76cda0cd4882637583c59',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.mixins.containable.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 201,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 53
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 11,
                    column: 56
                }
            },
            '3': {
                start: {
                    line: 15,
                    column: 16
                },
                end: {
                    line: 15,
                    column: 49
                }
            },
            '4': {
                start: {
                    line: 17,
                    column: 16
                },
                end: {
                    line: 52,
                    column: 19
                }
            },
            '5': {
                start: {
                    line: 18,
                    column: 32
                },
                end: {
                    line: 18,
                    column: 37
                }
            },
            '6': {
                start: {
                    line: 20,
                    column: 20
                },
                end: {
                    line: 45,
                    column: 21
                }
            },
            '7': {
                start: {
                    line: 22,
                    column: 24
                },
                end: {
                    line: 22,
                    column: 85
                }
            },
            '8': {
                start: {
                    line: 23,
                    column: 24
                },
                end: {
                    line: 25,
                    column: 25
                }
            },
            '9': {
                start: {
                    line: 24,
                    column: 28
                },
                end: {
                    line: 24,
                    column: 54
                }
            },
            '10': {
                start: {
                    line: 26,
                    column: 24
                },
                end: {
                    line: 26,
                    column: 30
                }
            },
            '11': {
                start: {
                    line: 28,
                    column: 24
                },
                end: {
                    line: 28,
                    column: 87
                }
            },
            '12': {
                start: {
                    line: 29,
                    column: 24
                },
                end: {
                    line: 31,
                    column: 25
                }
            },
            '13': {
                start: {
                    line: 30,
                    column: 28
                },
                end: {
                    line: 30,
                    column: 54
                }
            },
            '14': {
                start: {
                    line: 32,
                    column: 24
                },
                end: {
                    line: 32,
                    column: 30
                }
            },
            '15': {
                start: {
                    line: 34,
                    column: 24
                },
                end: {
                    line: 34,
                    column: 87
                }
            },
            '16': {
                start: {
                    line: 35,
                    column: 24
                },
                end: {
                    line: 37,
                    column: 25
                }
            },
            '17': {
                start: {
                    line: 36,
                    column: 28
                },
                end: {
                    line: 36,
                    column: 54
                }
            },
            '18': {
                start: {
                    line: 38,
                    column: 24
                },
                end: {
                    line: 38,
                    column: 30
                }
            },
            '19': {
                start: {
                    line: 40,
                    column: 24
                },
                end: {
                    line: 40,
                    column: 92
                }
            },
            '20': {
                start: {
                    line: 41,
                    column: 24
                },
                end: {
                    line: 43,
                    column: 25
                }
            },
            '21': {
                start: {
                    line: 42,
                    column: 28
                },
                end: {
                    line: 42,
                    column: 54
                }
            },
            '22': {
                start: {
                    line: 44,
                    column: 24
                },
                end: {
                    line: 44,
                    column: 30
                }
            },
            '23': {
                start: {
                    line: 46,
                    column: 20
                },
                end: {
                    line: 51,
                    column: 21
                }
            },
            '24': {
                start: {
                    line: 47,
                    column: 24
                },
                end: {
                    line: 47,
                    column: 74
                }
            },
            '25': {
                start: {
                    line: 48,
                    column: 24
                },
                end: {
                    line: 50,
                    column: 25
                }
            },
            '26': {
                start: {
                    line: 49,
                    column: 28
                },
                end: {
                    line: 49,
                    column: 55
                }
            },
            '27': {
                start: {
                    line: 56,
                    column: 16
                },
                end: {
                    line: 56,
                    column: 73
                }
            },
            '28': {
                start: {
                    line: 57,
                    column: 16
                },
                end: {
                    line: 62,
                    column: 19
                }
            },
            '29': {
                start: {
                    line: 58,
                    column: 20
                },
                end: {
                    line: 61,
                    column: 21
                }
            },
            '30': {
                start: {
                    line: 59,
                    column: 24
                },
                end: {
                    line: 59,
                    column: 82
                }
            },
            '31': {
                start: {
                    line: 60,
                    column: 24
                },
                end: {
                    line: 60,
                    column: 51
                }
            },
            '32': {
                start: {
                    line: 65,
                    column: 25
                },
                end: {
                    line: 65,
                    column: 30
                }
            },
            '33': {
                start: {
                    line: 66,
                    column: 12
                },
                end: {
                    line: 75,
                    column: 13
                }
            },
            '34': {
                start: {
                    line: 68,
                    column: 16
                },
                end: {
                    line: 68,
                    column: 45
                }
            },
            '35': {
                start: {
                    line: 69,
                    column: 16
                },
                end: {
                    line: 69,
                    column: 22
                }
            },
            '36': {
                start: {
                    line: 71,
                    column: 16
                },
                end: {
                    line: 71,
                    column: 43
                }
            },
            '37': {
                start: {
                    line: 72,
                    column: 16
                },
                end: {
                    line: 72,
                    column: 22
                }
            },
            '38': {
                start: {
                    line: 74,
                    column: 16
                },
                end: {
                    line: 74,
                    column: 99
                }
            },
            '39': {
                start: {
                    line: 77,
                    column: 12
                },
                end: {
                    line: 77,
                    column: 44
                }
            },
            '40': {
                start: {
                    line: 78,
                    column: 12
                },
                end: {
                    line: 78,
                    column: 37
                }
            },
            '41': {
                start: {
                    line: 80,
                    column: 12
                },
                end: {
                    line: 80,
                    column: 26
                }
            },
            '42': {
                start: {
                    line: 84,
                    column: 12
                },
                end: {
                    line: 84,
                    column: 56
                }
            },
            '43': {
                start: {
                    line: 87,
                    column: 16
                },
                end: {
                    line: 109,
                    column: 19
                }
            },
            '44': {
                start: {
                    line: 88,
                    column: 33
                },
                end: {
                    line: 90,
                    column: 22
                }
            },
            '45': {
                start: {
                    line: 89,
                    column: 24
                },
                end: {
                    line: 89,
                    column: 54
                }
            },
            '46': {
                start: {
                    line: 93,
                    column: 36
                },
                end: {
                    line: 104,
                    column: 22
                }
            },
            '47': {
                start: {
                    line: 96,
                    column: 41
                },
                end: {
                    line: 96,
                    column: 43
                }
            },
            '48': {
                start: {
                    line: 97,
                    column: 24
                },
                end: {
                    line: 99,
                    column: 27
                }
            },
            '49': {
                start: {
                    line: 98,
                    column: 28
                },
                end: {
                    line: 98,
                    column: 60
                }
            },
            '50': {
                start: {
                    line: 101,
                    column: 24
                },
                end: {
                    line: 103,
                    column: 27
                }
            },
            '51': {
                start: {
                    line: 102,
                    column: 28
                },
                end: {
                    line: 102,
                    column: 80
                }
            },
            '52': {
                start: {
                    line: 105,
                    column: 20
                },
                end: {
                    line: 107,
                    column: 23
                }
            },
            '53': {
                start: {
                    line: 106,
                    column: 24
                },
                end: {
                    line: 106,
                    column: 50
                }
            },
            '54': {
                start: {
                    line: 108,
                    column: 20
                },
                end: {
                    line: 108,
                    column: 52
                }
            },
            '55': {
                start: {
                    line: 113,
                    column: 16
                },
                end: {
                    line: 113,
                    column: 80
                }
            },
            '56': {
                start: {
                    line: 116,
                    column: 25
                },
                end: {
                    line: 116,
                    column: 30
                }
            },
            '57': {
                start: {
                    line: 117,
                    column: 12
                },
                end: {
                    line: 126,
                    column: 13
                }
            },
            '58': {
                start: {
                    line: 119,
                    column: 16
                },
                end: {
                    line: 119,
                    column: 49
                }
            },
            '59': {
                start: {
                    line: 120,
                    column: 16
                },
                end: {
                    line: 120,
                    column: 22
                }
            },
            '60': {
                start: {
                    line: 122,
                    column: 16
                },
                end: {
                    line: 122,
                    column: 47
                }
            },
            '61': {
                start: {
                    line: 123,
                    column: 16
                },
                end: {
                    line: 123,
                    column: 22
                }
            },
            '62': {
                start: {
                    line: 125,
                    column: 16
                },
                end: {
                    line: 125,
                    column: 99
                }
            },
            '63': {
                start: {
                    line: 128,
                    column: 12
                },
                end: {
                    line: 128,
                    column: 44
                }
            },
            '64': {
                start: {
                    line: 129,
                    column: 12
                },
                end: {
                    line: 129,
                    column: 37
                }
            },
            '65': {
                start: {
                    line: 131,
                    column: 12
                },
                end: {
                    line: 131,
                    column: 30
                }
            },
            '66': {
                start: {
                    line: 135,
                    column: 29
                },
                end: {
                    line: 135,
                    column: 64
                }
            },
            '67': {
                start: {
                    line: 136,
                    column: 12
                },
                end: {
                    line: 149,
                    column: 13
                }
            },
            '68': {
                start: {
                    line: 137,
                    column: 31
                },
                end: {
                    line: 137,
                    column: 67
                }
            },
            '69': {
                start: {
                    line: 139,
                    column: 16
                },
                end: {
                    line: 139,
                    column: 60
                }
            },
            '70': {
                start: {
                    line: 140,
                    column: 16
                },
                end: {
                    line: 144,
                    column: 19
                }
            },
            '71': {
                start: {
                    line: 141,
                    column: 20
                },
                end: {
                    line: 143,
                    column: 21
                }
            },
            '72': {
                start: {
                    line: 142,
                    column: 24
                },
                end: {
                    line: 142,
                    column: 54
                }
            },
            '73': {
                start: {
                    line: 145,
                    column: 16
                },
                end: {
                    line: 145,
                    column: 30
                }
            },
            '74': {
                start: {
                    line: 148,
                    column: 16
                },
                end: {
                    line: 148,
                    column: 92
                }
            },
            '75': {
                start: {
                    line: 152,
                    column: 8
                },
                end: {
                    line: 199,
                    column: 11
                }
            },
            '76': {
                start: {
                    line: 158,
                    column: 40
                },
                end: {
                    line: 158,
                    column: 75
                }
            },
            '77': {
                start: {
                    line: 159,
                    column: 24
                },
                end: {
                    line: 159,
                    column: 95
                }
            },
            '78': {
                start: {
                    line: 160,
                    column: 24
                },
                end: {
                    line: 160,
                    column: 94
                }
            },
            '79': {
                start: {
                    line: 164,
                    column: 24
                },
                end: {
                    line: 171,
                    column: 25
                }
            },
            '80': {
                start: {
                    line: 165,
                    column: 28
                },
                end: {
                    line: 170,
                    column: 29
                }
            },
            '81': {
                start: {
                    line: 166,
                    column: 32
                },
                end: {
                    line: 168,
                    column: 33
                }
            },
            '82': {
                start: {
                    line: 167,
                    column: 36
                },
                end: {
                    line: 167,
                    column: 51
                }
            },
            '83': {
                start: {
                    line: 172,
                    column: 24
                },
                end: {
                    line: 172,
                    column: 36
                }
            },
            '84': {
                start: {
                    line: 177,
                    column: 40
                },
                end: {
                    line: 177,
                    column: 75
                }
            },
            '85': {
                start: {
                    line: 178,
                    column: 24
                },
                end: {
                    line: 178,
                    column: 95
                }
            },
            '86': {
                start: {
                    line: 179,
                    column: 24
                },
                end: {
                    line: 179,
                    column: 90
                }
            },
            '87': {
                start: {
                    line: 182,
                    column: 37
                },
                end: {
                    line: 182,
                    column: 55
                }
            },
            '88': {
                start: {
                    line: 183,
                    column: 24
                },
                end: {
                    line: 185,
                    column: 25
                }
            },
            '89': {
                start: {
                    line: 184,
                    column: 28
                },
                end: {
                    line: 184,
                    column: 53
                }
            },
            '90': {
                start: {
                    line: 186,
                    column: 24
                },
                end: {
                    line: 186,
                    column: 42
                }
            },
            '91': {
                start: {
                    line: 193,
                    column: 20
                },
                end: {
                    line: 195,
                    column: 21
                }
            },
            '92': {
                start: {
                    line: 194,
                    column: 24
                },
                end: {
                    line: 194,
                    column: 41
                }
            },
            '93': {
                start: {
                    line: 196,
                    column: 20
                },
                end: {
                    line: 196,
                    column: 93
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 201,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 60
                    },
                    end: {
                        line: 200,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'recordLoad',
                decl: {
                    start: {
                        line: 10,
                        column: 17
                    },
                    end: {
                        line: 10,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 68
                    },
                    end: {
                        line: 81,
                        column: 9
                    }
                },
                line: 10
            },
            '3': {
                name: 'recordLoadBelongsTo',
                decl: {
                    start: {
                        line: 13,
                        column: 21
                    },
                    end: {
                        line: 13,
                        column: 40
                    }
                },
                loc: {
                    start: {
                        line: 13,
                        column: 48
                    },
                    end: {
                        line: 53,
                        column: 13
                    }
                },
                line: 13
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 17,
                        column: 29
                    },
                    end: {
                        line: 17,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 17,
                        column: 41
                    },
                    end: {
                        line: 52,
                        column: 17
                    }
                },
                line: 17
            },
            '5': {
                name: 'recordLoadHasMany',
                decl: {
                    start: {
                        line: 55,
                        column: 21
                    },
                    end: {
                        line: 55,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 55,
                        column: 46
                    },
                    end: {
                        line: 63,
                        column: 13
                    }
                },
                line: 55
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 57,
                        column: 29
                    },
                    end: {
                        line: 57,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 57,
                        column: 41
                    },
                    end: {
                        line: 62,
                        column: 17
                    }
                },
                line: 57
            },
            '7': {
                name: 'collectionLoad',
                decl: {
                    start: {
                        line: 83,
                        column: 17
                    },
                    end: {
                        line: 83,
                        column: 31
                    }
                },
                loc: {
                    start: {
                        line: 83,
                        column: 76
                    },
                    end: {
                        line: 132,
                        column: 9
                    }
                },
                line: 83
            },
            '8': {
                name: 'collectionLoadBelongsTo',
                decl: {
                    start: {
                        line: 86,
                        column: 21
                    },
                    end: {
                        line: 86,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 86,
                        column: 52
                    },
                    end: {
                        line: 110,
                        column: 13
                    }
                },
                line: 86
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 87,
                        column: 33
                    },
                    end: {
                        line: 87,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 87,
                        column: 45
                    },
                    end: {
                        line: 109,
                        column: 17
                    }
                },
                line: 87
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 88,
                        column: 48
                    },
                    end: {
                        line: 88,
                        column: 49
                    }
                },
                loc: {
                    start: {
                        line: 88,
                        column: 63
                    },
                    end: {
                        line: 90,
                        column: 21
                    }
                },
                line: 88
            },
            '11': {
                name: '(anonymous_11)',
                decl: {
                    start: {
                        line: 95,
                        column: 29
                    },
                    end: {
                        line: 95,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 95,
                        column: 45
                    },
                    end: {
                        line: 104,
                        column: 21
                    }
                },
                line: 95
            },
            '12': {
                name: '(anonymous_12)',
                decl: {
                    start: {
                        line: 97,
                        column: 46
                    },
                    end: {
                        line: 97,
                        column: 47
                    }
                },
                loc: {
                    start: {
                        line: 97,
                        column: 65
                    },
                    end: {
                        line: 99,
                        column: 25
                    }
                },
                line: 97
            },
            '13': {
                name: '(anonymous_13)',
                decl: {
                    start: {
                        line: 101,
                        column: 52
                    },
                    end: {
                        line: 101,
                        column: 53
                    }
                },
                loc: {
                    start: {
                        line: 101,
                        column: 68
                    },
                    end: {
                        line: 103,
                        column: 25
                    }
                },
                line: 101
            },
            '14': {
                name: '(anonymous_14)',
                decl: {
                    start: {
                        line: 105,
                        column: 48
                    },
                    end: {
                        line: 105,
                        column: 49
                    }
                },
                loc: {
                    start: {
                        line: 105,
                        column: 64
                    },
                    end: {
                        line: 107,
                        column: 21
                    }
                },
                line: 105
            },
            '15': {
                name: 'collectionLoadHasMany',
                decl: {
                    start: {
                        line: 112,
                        column: 21
                    },
                    end: {
                        line: 112,
                        column: 42
                    }
                },
                loc: {
                    start: {
                        line: 112,
                        column: 45
                    },
                    end: {
                        line: 114,
                        column: 13
                    }
                },
                line: 112
            },
            '16': {
                name: 'getModelConfigs',
                decl: {
                    start: {
                        line: 134,
                        column: 17
                    },
                    end: {
                        line: 134,
                        column: 32
                    }
                },
                loc: {
                    start: {
                        line: 134,
                        column: 54
                    },
                    end: {
                        line: 150,
                        column: 9
                    }
                },
                line: 134
            },
            '17': {
                name: '(anonymous_17)',
                decl: {
                    start: {
                        line: 140,
                        column: 48
                    },
                    end: {
                        line: 140,
                        column: 49
                    }
                },
                loc: {
                    start: {
                        line: 140,
                        column: 70
                    },
                    end: {
                        line: 144,
                        column: 17
                    }
                },
                line: 140
            },
            '18': {
                name: '(anonymous_18)',
                decl: {
                    start: {
                        line: 157,
                        column: 27
                    },
                    end: {
                        line: 157,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 157,
                        column: 70
                    },
                    end: {
                        line: 161,
                        column: 21
                    }
                },
                line: 157
            },
            '19': {
                name: '(anonymous_19)',
                decl: {
                    start: {
                        line: 162,
                        column: 26
                    },
                    end: {
                        line: 162,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 162,
                        column: 40
                    },
                    end: {
                        line: 173,
                        column: 21
                    }
                },
                line: 162
            },
            '20': {
                name: '(anonymous_20)',
                decl: {
                    start: {
                        line: 176,
                        column: 27
                    },
                    end: {
                        line: 176,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 176,
                        column: 70
                    },
                    end: {
                        line: 180,
                        column: 21
                    }
                },
                line: 176
            },
            '21': {
                name: '(anonymous_21)',
                decl: {
                    start: {
                        line: 181,
                        column: 24
                    },
                    end: {
                        line: 181,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 181,
                        column: 48
                    },
                    end: {
                        line: 187,
                        column: 21
                    }
                },
                line: 181
            },
            '22': {
                name: '(anonymous_22)',
                decl: {
                    start: {
                        line: 191,
                        column: 37
                    },
                    end: {
                        line: 191,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 191,
                        column: 53
                    },
                    end: {
                        line: 197,
                        column: 17
                    }
                },
                line: 191
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 11,
                        column: 32
                    },
                    end: {
                        line: 11,
                        column: 55
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 11,
                        column: 32
                    },
                    end: {
                        line: 11,
                        column: 49
                    }
                }, {
                    start: {
                        line: 11,
                        column: 53
                    },
                    end: {
                        line: 11,
                        column: 55
                    }
                }],
                line: 11
            },
            '1': {
                loc: {
                    start: {
                        line: 20,
                        column: 20
                    },
                    end: {
                        line: 45,
                        column: 21
                    }
                },
                type: 'switch',
                locations: [{
                    start: {
                        line: 21,
                        column: 20
                    },
                    end: {
                        line: 26,
                        column: 30
                    }
                }, {
                    start: {
                        line: 27,
                        column: 20
                    },
                    end: {
                        line: 32,
                        column: 30
                    }
                }, {
                    start: {
                        line: 33,
                        column: 20
                    },
                    end: {
                        line: 38,
                        column: 30
                    }
                }, {
                    start: {
                        line: 39,
                        column: 20
                    },
                    end: {
                        line: 44,
                        column: 30
                    }
                }],
                line: 20
            },
            '2': {
                loc: {
                    start: {
                        line: 23,
                        column: 24
                    },
                    end: {
                        line: 25,
                        column: 25
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 23,
                        column: 24
                    },
                    end: {
                        line: 25,
                        column: 25
                    }
                }, {
                    start: {
                        line: 23,
                        column: 24
                    },
                    end: {
                        line: 25,
                        column: 25
                    }
                }],
                line: 23
            },
            '3': {
                loc: {
                    start: {
                        line: 29,
                        column: 24
                    },
                    end: {
                        line: 31,
                        column: 25
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 29,
                        column: 24
                    },
                    end: {
                        line: 31,
                        column: 25
                    }
                }, {
                    start: {
                        line: 29,
                        column: 24
                    },
                    end: {
                        line: 31,
                        column: 25
                    }
                }],
                line: 29
            },
            '4': {
                loc: {
                    start: {
                        line: 35,
                        column: 24
                    },
                    end: {
                        line: 37,
                        column: 25
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 35,
                        column: 24
                    },
                    end: {
                        line: 37,
                        column: 25
                    }
                }, {
                    start: {
                        line: 35,
                        column: 24
                    },
                    end: {
                        line: 37,
                        column: 25
                    }
                }],
                line: 35
            },
            '5': {
                loc: {
                    start: {
                        line: 41,
                        column: 24
                    },
                    end: {
                        line: 43,
                        column: 25
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 41,
                        column: 24
                    },
                    end: {
                        line: 43,
                        column: 25
                    }
                }, {
                    start: {
                        line: 41,
                        column: 24
                    },
                    end: {
                        line: 43,
                        column: 25
                    }
                }],
                line: 41
            },
            '6': {
                loc: {
                    start: {
                        line: 46,
                        column: 20
                    },
                    end: {
                        line: 51,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 46,
                        column: 20
                    },
                    end: {
                        line: 51,
                        column: 21
                    }
                }, {
                    start: {
                        line: 46,
                        column: 20
                    },
                    end: {
                        line: 51,
                        column: 21
                    }
                }],
                line: 46
            },
            '7': {
                loc: {
                    start: {
                        line: 48,
                        column: 24
                    },
                    end: {
                        line: 50,
                        column: 25
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 48,
                        column: 24
                    },
                    end: {
                        line: 50,
                        column: 25
                    }
                }, {
                    start: {
                        line: 48,
                        column: 24
                    },
                    end: {
                        line: 50,
                        column: 25
                    }
                }],
                line: 48
            },
            '8': {
                loc: {
                    start: {
                        line: 58,
                        column: 20
                    },
                    end: {
                        line: 61,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 58,
                        column: 20
                    },
                    end: {
                        line: 61,
                        column: 21
                    }
                }, {
                    start: {
                        line: 58,
                        column: 20
                    },
                    end: {
                        line: 61,
                        column: 21
                    }
                }],
                line: 58
            },
            '9': {
                loc: {
                    start: {
                        line: 66,
                        column: 12
                    },
                    end: {
                        line: 75,
                        column: 13
                    }
                },
                type: 'switch',
                locations: [{
                    start: {
                        line: 67,
                        column: 12
                    },
                    end: {
                        line: 69,
                        column: 22
                    }
                }, {
                    start: {
                        line: 70,
                        column: 12
                    },
                    end: {
                        line: 72,
                        column: 22
                    }
                }, {
                    start: {
                        line: 73,
                        column: 12
                    },
                    end: {
                        line: 74,
                        column: 99
                    }
                }],
                line: 66
            },
            '10': {
                loc: {
                    start: {
                        line: 84,
                        column: 32
                    },
                    end: {
                        line: 84,
                        column: 55
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 84,
                        column: 32
                    },
                    end: {
                        line: 84,
                        column: 49
                    }
                }, {
                    start: {
                        line: 84,
                        column: 53
                    },
                    end: {
                        line: 84,
                        column: 55
                    }
                }],
                line: 84
            },
            '11': {
                loc: {
                    start: {
                        line: 117,
                        column: 12
                    },
                    end: {
                        line: 126,
                        column: 13
                    }
                },
                type: 'switch',
                locations: [{
                    start: {
                        line: 118,
                        column: 12
                    },
                    end: {
                        line: 120,
                        column: 22
                    }
                }, {
                    start: {
                        line: 121,
                        column: 12
                    },
                    end: {
                        line: 123,
                        column: 22
                    }
                }, {
                    start: {
                        line: 124,
                        column: 12
                    },
                    end: {
                        line: 125,
                        column: 99
                    }
                }],
                line: 117
            },
            '12': {
                loc: {
                    start: {
                        line: 136,
                        column: 12
                    },
                    end: {
                        line: 149,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 136,
                        column: 12
                    },
                    end: {
                        line: 149,
                        column: 13
                    }
                }, {
                    start: {
                        line: 136,
                        column: 12
                    },
                    end: {
                        line: 149,
                        column: 13
                    }
                }],
                line: 136
            },
            '13': {
                loc: {
                    start: {
                        line: 136,
                        column: 16
                    },
                    end: {
                        line: 136,
                        column: 50
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 136,
                        column: 16
                    },
                    end: {
                        line: 136,
                        column: 24
                    }
                }, {
                    start: {
                        line: 136,
                        column: 28
                    },
                    end: {
                        line: 136,
                        column: 50
                    }
                }],
                line: 136
            },
            '14': {
                loc: {
                    start: {
                        line: 139,
                        column: 36
                    },
                    end: {
                        line: 139,
                        column: 59
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 139,
                        column: 36
                    },
                    end: {
                        line: 139,
                        column: 53
                    }
                }, {
                    start: {
                        line: 139,
                        column: 57
                    },
                    end: {
                        line: 139,
                        column: 59
                    }
                }],
                line: 139
            },
            '15': {
                loc: {
                    start: {
                        line: 141,
                        column: 20
                    },
                    end: {
                        line: 143,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 141,
                        column: 20
                    },
                    end: {
                        line: 143,
                        column: 21
                    }
                }, {
                    start: {
                        line: 141,
                        column: 20
                    },
                    end: {
                        line: 143,
                        column: 21
                    }
                }],
                line: 141
            },
            '16': {
                loc: {
                    start: {
                        line: 166,
                        column: 32
                    },
                    end: {
                        line: 168,
                        column: 33
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 166,
                        column: 32
                    },
                    end: {
                        line: 168,
                        column: 33
                    }
                }, {
                    start: {
                        line: 166,
                        column: 32
                    },
                    end: {
                        line: 168,
                        column: 33
                    }
                }],
                line: 166
            },
            '17': {
                loc: {
                    start: {
                        line: 183,
                        column: 24
                    },
                    end: {
                        line: 185,
                        column: 25
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 183,
                        column: 24
                    },
                    end: {
                        line: 185,
                        column: 25
                    }
                }, {
                    start: {
                        line: 183,
                        column: 24
                    },
                    end: {
                        line: 185,
                        column: 25
                    }
                }],
                line: 183
            },
            '18': {
                loc: {
                    start: {
                        line: 193,
                        column: 20
                    },
                    end: {
                        line: 195,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 193,
                        column: 20
                    },
                    end: {
                        line: 195,
                        column: 21
                    }
                }, {
                    start: {
                        line: 193,
                        column: 20
                    },
                    end: {
                        line: 195,
                        column: 21
                    }
                }],
                line: 193
            },
            '19': {
                loc: {
                    start: {
                        line: 196,
                        column: 47
                    },
                    end: {
                        line: 196,
                        column: 92
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 196,
                        column: 47
                    },
                    end: {
                        line: 196,
                        column: 71
                    }
                }, {
                    start: {
                        line: 196,
                        column: 75
                    },
                    end: {
                        line: 196,
                        column: 86
                    }
                }, {
                    start: {
                        line: 196,
                        column: 90
                    },
                    end: {
                        line: 196,
                        column: 92
                    }
                }],
                line: 196
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0,
            '30': 0,
            '31': 0,
            '32': 0,
            '33': 0,
            '34': 0,
            '35': 0,
            '36': 0,
            '37': 0,
            '38': 0,
            '39': 0,
            '40': 0,
            '41': 0,
            '42': 0,
            '43': 0,
            '44': 0,
            '45': 0,
            '46': 0,
            '47': 0,
            '48': 0,
            '49': 0,
            '50': 0,
            '51': 0,
            '52': 0,
            '53': 0,
            '54': 0,
            '55': 0,
            '56': 0,
            '57': 0,
            '58': 0,
            '59': 0,
            '60': 0,
            '61': 0,
            '62': 0,
            '63': 0,
            '64': 0,
            '65': 0,
            '66': 0,
            '67': 0,
            '68': 0,
            '69': 0,
            '70': 0,
            '71': 0,
            '72': 0,
            '73': 0,
            '74': 0,
            '75': 0,
            '76': 0,
            '77': 0,
            '78': 0,
            '79': 0,
            '80': 0,
            '81': 0,
            '82': 0,
            '83': 0,
            '84': 0,
            '85': 0,
            '86': 0,
            '87': 0,
            '88': 0,
            '89': 0,
            '90': 0,
            '91': 0,
            '92': 0,
            '93': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0, 0, 0],
            '2': [0, 0],
            '3': [0, 0],
            '4': [0, 0],
            '5': [0, 0],
            '6': [0, 0],
            '7': [0, 0],
            '8': [0, 0],
            '9': [0, 0, 0],
            '10': [0, 0],
            '11': [0, 0, 0],
            '12': [0, 0],
            '13': [0, 0],
            '14': [0, 0],
            '15': [0, 0],
            '16': [0, 0],
            '17': [0, 0],
            '18': [0, 0],
            '19': [0, 0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1kzc8gxpx2.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod", "$injector", "$rootScope"];
    cov_1kzc8gxpx2.f[0]++;
    cov_1kzc8gxpx2.s[1]++;
    angular.module('app').factory('MixinContainable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod, $injector, $rootScope) {
        cov_1kzc8gxpx2.f[1]++;

        function recordLoad(record, key, config, additionalFilters) {
            cov_1kzc8gxpx2.f[2]++;
            cov_1kzc8gxpx2.s[2]++;

            additionalFilters = (cov_1kzc8gxpx2.b[0][0]++, additionalFilters) || (cov_1kzc8gxpx2.b[0][1]++, {});

            function recordLoadBelongsTo(table) {
                cov_1kzc8gxpx2.f[3]++;
                cov_1kzc8gxpx2.s[3]++;

                /* eslint-disable prefer-template */
                record['$' + key] = table.$new();
                /* eslint-disable prefer-arrow-callback */
                cov_1kzc8gxpx2.s[4]++;
                record.$then(function () {
                    cov_1kzc8gxpx2.f[4]++;

                    var found = (cov_1kzc8gxpx2.s[5]++, false);
                    /* eslint-disable default-case */
                    cov_1kzc8gxpx2.s[6]++;
                    switch (config.table) {
                        case 'BrandsTable':
                            cov_1kzc8gxpx2.b[1][0]++;
                            cov_1kzc8gxpx2.s[7]++;

                            found = $rootScope.allBrands.$get(record[config.foreignKey]);
                            cov_1kzc8gxpx2.s[8]++;
                            if (found) {
                                cov_1kzc8gxpx2.b[2][0]++;
                                cov_1kzc8gxpx2.s[9]++;

                                record['$' + key] = found;
                            } else {
                                cov_1kzc8gxpx2.b[2][1]++;
                            }
                            cov_1kzc8gxpx2.s[10]++;
                            break;
                        case 'UsersTable':
                            cov_1kzc8gxpx2.b[1][1]++;
                            cov_1kzc8gxpx2.s[11]++;

                            found = $rootScope.commercials.$get(record[config.foreignKey]);
                            cov_1kzc8gxpx2.s[12]++;
                            if (found) {
                                cov_1kzc8gxpx2.b[3][0]++;
                                cov_1kzc8gxpx2.s[13]++;

                                record['$' + key] = found;
                            } else {
                                cov_1kzc8gxpx2.b[3][1]++;
                            }
                            cov_1kzc8gxpx2.s[14]++;
                            break;
                        case 'SampleTypesTable':
                            cov_1kzc8gxpx2.b[1][2]++;
                            cov_1kzc8gxpx2.s[15]++;

                            found = $rootScope.sampleTypes.$get(record[config.foreignKey]);
                            cov_1kzc8gxpx2.s[16]++;
                            if (found) {
                                cov_1kzc8gxpx2.b[4][0]++;
                                cov_1kzc8gxpx2.s[17]++;

                                record['$' + key] = found;
                            } else {
                                cov_1kzc8gxpx2.b[4][1]++;
                            }
                            cov_1kzc8gxpx2.s[18]++;
                            break;
                        case 'SampleStateTypesTable':
                            cov_1kzc8gxpx2.b[1][3]++;
                            cov_1kzc8gxpx2.s[19]++;

                            found = $rootScope.sampleStateTypes.$get(record[config.foreignKey]);
                            cov_1kzc8gxpx2.s[20]++;
                            if (found) {
                                cov_1kzc8gxpx2.b[5][0]++;
                                cov_1kzc8gxpx2.s[21]++;

                                record['$' + key] = found;
                            } else {
                                cov_1kzc8gxpx2.b[5][1]++;
                            }
                            cov_1kzc8gxpx2.s[22]++;
                            break;
                    }
                    cov_1kzc8gxpx2.s[23]++;
                    if (!found) {
                        cov_1kzc8gxpx2.b[6][0]++;
                        cov_1kzc8gxpx2.s[24]++;

                        record['$' + key].$pk = record[config.foreignKey];
                        cov_1kzc8gxpx2.s[25]++;
                        if (record[config.foreignKey]) {
                            cov_1kzc8gxpx2.b[7][0]++;
                            cov_1kzc8gxpx2.s[26]++;

                            record['$' + key].$fetch();
                        } else {
                            cov_1kzc8gxpx2.b[7][1]++;
                        }
                    } else {
                        cov_1kzc8gxpx2.b[6][1]++;
                    }
                });
            }

            function recordLoadHasMany(table) {
                cov_1kzc8gxpx2.f[5]++;
                cov_1kzc8gxpx2.s[27]++;

                record['$' + key] = table.$collection(additionalFilters);
                cov_1kzc8gxpx2.s[28]++;
                record.$then(function () {
                    cov_1kzc8gxpx2.f[6]++;
                    cov_1kzc8gxpx2.s[29]++;

                    if (record.$pk) {
                        cov_1kzc8gxpx2.b[8][0]++;
                        cov_1kzc8gxpx2.s[30]++;

                        record['$' + key].$params[config.foreignKey] = record.$pk;
                        cov_1kzc8gxpx2.s[31]++;
                        record['$' + key].$fetch();
                    } else {
                        cov_1kzc8gxpx2.b[8][1]++;
                    }
                });
            }

            var loader = (cov_1kzc8gxpx2.s[32]++, false);
            cov_1kzc8gxpx2.s[33]++;
            switch (config.type) {
                case 'belongsTo':
                    cov_1kzc8gxpx2.b[9][0]++;
                    cov_1kzc8gxpx2.s[34]++;

                    loader = recordLoadBelongsTo;
                    cov_1kzc8gxpx2.s[35]++;
                    break;
                case 'hasMany':
                    cov_1kzc8gxpx2.b[9][1]++;
                    cov_1kzc8gxpx2.s[36]++;

                    loader = recordLoadHasMany;
                    cov_1kzc8gxpx2.s[37]++;
                    break;
                default:
                    cov_1kzc8gxpx2.b[9][2]++;
                    cov_1kzc8gxpx2.s[38]++;

                    throw new Error('Unknown contain type "' + config.type + '" for MixinContainable');
            }

            cov_1kzc8gxpx2.s[39]++;
            loader.$inject = [config.table];
            cov_1kzc8gxpx2.s[40]++;
            $injector.invoke(loader);

            cov_1kzc8gxpx2.s[41]++;
            return record;
        }

        function collectionLoad(collection, key, config, additionalFilters) {
            cov_1kzc8gxpx2.f[7]++;
            cov_1kzc8gxpx2.s[42]++;

            additionalFilters = (cov_1kzc8gxpx2.b[10][0]++, additionalFilters) || (cov_1kzc8gxpx2.b[10][1]++, {});

            function collectionLoadBelongsTo(table) {
                cov_1kzc8gxpx2.f[8]++;
                cov_1kzc8gxpx2.s[43]++;

                collection.$then(function () {
                    cov_1kzc8gxpx2.f[9]++;

                    var keys = (cov_1kzc8gxpx2.s[44]++, collection.map(function (obj) {
                        cov_1kzc8gxpx2.f[10]++;
                        cov_1kzc8gxpx2.s[45]++;

                        return obj[config.foreignKey];
                    }));

                    /* eslint-disable camelcase */
                    var request = (cov_1kzc8gxpx2.s[46]++, table.$search({
                        id__in: keys.join(',')
                    }).$then(function (data) {
                        cov_1kzc8gxpx2.f[11]++;

                        var objsById = (cov_1kzc8gxpx2.s[47]++, {});
                        cov_1kzc8gxpx2.s[48]++;
                        angular.forEach(data, function (respObj) {
                            cov_1kzc8gxpx2.f[12]++;
                            cov_1kzc8gxpx2.s[49]++;

                            objsById[respObj.$pk] = respObj;
                        });

                        cov_1kzc8gxpx2.s[50]++;
                        angular.forEach(collection, function (item) {
                            cov_1kzc8gxpx2.f[13]++;
                            cov_1kzc8gxpx2.s[51]++;

                            item['$' + key] = objsById[item[config.foreignKey]];
                        });
                    }));
                    cov_1kzc8gxpx2.s[52]++;
                    angular.forEach(collection, function (item) {
                        cov_1kzc8gxpx2.f[14]++;
                        cov_1kzc8gxpx2.s[53]++;

                        item['$' + key] = request;
                    });
                    cov_1kzc8gxpx2.s[54]++;
                    collection['$' + key] = request;
                });
            }

            function collectionLoadHasMany() {
                cov_1kzc8gxpx2.f[15]++;
                cov_1kzc8gxpx2.s[55]++;

                throw new Error('Collection load has many Not implemented yet');
            }

            var loader = (cov_1kzc8gxpx2.s[56]++, false);
            cov_1kzc8gxpx2.s[57]++;
            switch (config.type) {
                case 'belongsTo':
                    cov_1kzc8gxpx2.b[11][0]++;
                    cov_1kzc8gxpx2.s[58]++;

                    loader = collectionLoadBelongsTo;
                    cov_1kzc8gxpx2.s[59]++;
                    break;
                case 'hasMany':
                    cov_1kzc8gxpx2.b[11][1]++;
                    cov_1kzc8gxpx2.s[60]++;

                    loader = collectionLoadHasMany;
                    cov_1kzc8gxpx2.s[61]++;
                    break;
                default:
                    cov_1kzc8gxpx2.b[11][2]++;
                    cov_1kzc8gxpx2.s[62]++;

                    throw new Error('Unknown contain type "' + config.type + '" for MixinContainable');
            }

            cov_1kzc8gxpx2.s[63]++;
            loader.$inject = [config.table];
            cov_1kzc8gxpx2.s[64]++;
            $injector.invoke(loader);

            cov_1kzc8gxpx2.s[65]++;
            return collection;
        }

        function getModelConfigs(model, relatedModel) {
            cov_1kzc8gxpx2.f[16]++;

            var contains = (cov_1kzc8gxpx2.s[66]++, model.$type.getProperty('contains'));
            cov_1kzc8gxpx2.s[67]++;
            if ((cov_1kzc8gxpx2.b[13][0]++, contains) && (cov_1kzc8gxpx2.b[13][1]++, contains[relatedModel])) {
                cov_1kzc8gxpx2.b[12][0]++;

                var config = (cov_1kzc8gxpx2.s[68]++, angular.copy(contains[relatedModel]));
                /* eslint-disable dot-notation */
                cov_1kzc8gxpx2.s[69]++;
                config['filters'] = (cov_1kzc8gxpx2.b[14][0]++, config['filters']) || (cov_1kzc8gxpx2.b[14][1]++, {});
                cov_1kzc8gxpx2.s[70]++;
                angular.forEach(config.filters, function (value, key) {
                    cov_1kzc8gxpx2.f[17]++;
                    cov_1kzc8gxpx2.s[71]++;

                    if (angular.isFunction(config.filters[key])) {
                        cov_1kzc8gxpx2.b[15][0]++;
                        cov_1kzc8gxpx2.s[72]++;

                        config.filters[key] = value();
                    } else {
                        cov_1kzc8gxpx2.b[15][1]++;
                    }
                });
                cov_1kzc8gxpx2.s[73]++;
                return config;
                /* eslint-disable no-else-return */
            } else {
                cov_1kzc8gxpx2.b[12][1]++;
                cov_1kzc8gxpx2.s[74]++;

                throw new Error('Cannot find MixinContainable configs for ' + relatedModel);
            }
        }

        cov_1kzc8gxpx2.s[75]++;
        return restmod.mixin({
            $extend: {
                Collection: {
                    $limit: 25,
                    /* eslint-disable babel/object-shorthand */
                    $load: function $load(relatedModel, additionalFilters) {
                        cov_1kzc8gxpx2.f[18]++;

                        var configs = (cov_1kzc8gxpx2.s[76]++, getModelConfigs(this, relatedModel));
                        cov_1kzc8gxpx2.s[77]++;
                        additionalFilters = angular.extend(configs.filters, additionalFilters);
                        cov_1kzc8gxpx2.s[78]++;
                        return collectionLoad(this, relatedModel, configs, additionalFilters);
                    },
                    $get: function $get(id) {
                        cov_1kzc8gxpx2.f[19]++;
                        cov_1kzc8gxpx2.s[79]++;

                        /* eslint-disable guard-for-in */
                        for (var i in this) {
                            cov_1kzc8gxpx2.s[80]++;

                            try {
                                cov_1kzc8gxpx2.s[81]++;

                                if (this[i].id === id) {
                                    cov_1kzc8gxpx2.b[16][0]++;
                                    cov_1kzc8gxpx2.s[82]++;

                                    return this[i];
                                } else {
                                    cov_1kzc8gxpx2.b[16][1]++;
                                }
                            } catch (E) {}
                        }
                        cov_1kzc8gxpx2.s[83]++;
                        return null;
                    }
                },
                Record: {
                    $load: function $load(relatedModel, additionalFilters) {
                        cov_1kzc8gxpx2.f[20]++;

                        var configs = (cov_1kzc8gxpx2.s[84]++, getModelConfigs(this, relatedModel));
                        cov_1kzc8gxpx2.s[85]++;
                        additionalFilters = angular.extend(configs.filters, additionalFilters);
                        cov_1kzc8gxpx2.s[86]++;
                        return recordLoad(this, relatedModel, configs, additionalFilters);
                    },
                    $_: function $_(relatedModel) {
                        cov_1kzc8gxpx2.f[21]++;

                        var name = (cov_1kzc8gxpx2.s[87]++, '$' + relatedModel);
                        cov_1kzc8gxpx2.s[88]++;
                        if (!this[name]) {
                            cov_1kzc8gxpx2.b[17][0]++;
                            cov_1kzc8gxpx2.s[89]++;

                            this.$load(relatedModel);
                        } else {
                            cov_1kzc8gxpx2.b[17][1]++;
                        }
                        cov_1kzc8gxpx2.s[90]++;
                        return this[name];
                    }
                }
            },
            $hooks: {
                'before-fetch-many': function beforeFetchMany(_req) {
                    cov_1kzc8gxpx2.f[22]++;
                    cov_1kzc8gxpx2.s[91]++;

                    /* eslint-disable no-undef */
                    if (_.isUndefined(_req.params)) {
                        cov_1kzc8gxpx2.b[18][0]++;
                        cov_1kzc8gxpx2.s[92]++;

                        _req.params = {};
                    } else {
                        cov_1kzc8gxpx2.b[18][1]++;
                    }
                    cov_1kzc8gxpx2.s[93]++;
                    _req.params['page_size'] = (cov_1kzc8gxpx2.b[19][0]++, _req.params['page_size']) || (cov_1kzc8gxpx2.b[19][1]++, this.$limit) || (cov_1kzc8gxpx2.b[19][2]++, 25);
                }
            }
        });
    }
})();
'use strict';

var cov_1edutv5gvg = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.links.factory.js',
        hash = '2a5b9429fa239423eea014292dfdc19a7b6248a9',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.links.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 28,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 43
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 26,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 28,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 27,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1edutv5gvg.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_1edutv5gvg.f[0]++;
    cov_1edutv5gvg.s[1]++;
    angular.module('app').factory('LinksTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_1edutv5gvg.f[1]++;
        cov_1edutv5gvg.s[2]++;

        return restmod.model('/links').mix('MixinContainable', {
            $config: {
                contains: {
                    category: {
                        type: 'belongsTo',
                        table: 'LinkCategoriesTable',
                        foreignKey: 'category'
                    },
                    organization: {
                        type: 'belongsTo',
                        table: 'OrganizationsTable',
                        foreignKey: 'organization'
                    }

                }
            }
        });
    }
})();
'use strict';

var cov_c0pp9aei8 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.links.categories.factory.js',
        hash = 'e11288edfe02554bb03219503134146e50e19fe8',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.links.categories.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 12,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 52
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 49
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 12,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_c0pp9aei8.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_c0pp9aei8.f[0]++;
    cov_c0pp9aei8.s[1]++;
    angular.module('app').factory('LinkCategoriesTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_c0pp9aei8.f[1]++;
        cov_c0pp9aei8.s[2]++;

        return restmod.model('/link-categories');
    }
})();
'use strict';

var cov_9ag5h88qz = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.interaction.types.factory.js',
        hash = '7729250498783b9208d7444808ba17efa010fc22',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.interaction.types.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 12,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 54
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 79
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 12,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_9ag5h88qz.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_9ag5h88qz.f[0]++;
    cov_9ag5h88qz.s[1]++;
    angular.module('app').factory('InteractionTypesTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_9ag5h88qz.f[1]++;
        cov_9ag5h88qz.s[2]++;

        return restmod.model('/interaction-types').mix('MixinContainable', {});
    }
})();
'use strict';

var cov_1pt2cdipyq = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.industry.files.factory.js',
        hash = 'f7b010fc00e34e463e7e676266039105ba933334',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.industry.files.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 23,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 51
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 21,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 23,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 22,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1pt2cdipyq.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_1pt2cdipyq.f[0]++;
    cov_1pt2cdipyq.s[1]++;
    angular.module('app').factory('IndustryFilesTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_1pt2cdipyq.f[1]++;
        cov_1pt2cdipyq.s[2]++;

        return restmod.model('/industry-files').mix('MixinContainable', {
            $config: {
                contains: {
                    industry: {
                        type: 'belongsTo',
                        table: 'IndustrysTable',
                        foreignKey: 'industry'
                    }
                }
            }

        });
    }
})();
'use strict';

var cov_1auz71icl7 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.industries.factory.js',
        hash = 'd81547f22cb58f7e4d8b7a882f04bc01bde5e38e',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.industries.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 12,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 56
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 53
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 12,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1auz71icl7.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_1auz71icl7.f[0]++;
    cov_1auz71icl7.s[1]++;
    angular.module('app').factory('EconomicActivitiesTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_1auz71icl7.f[1]++;
        cov_1auz71icl7.s[2]++;

        return restmod.model('/economic-activities');
    }
})();
'use strict';

var cov_1sw5rkra7j = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.individuals.factory.js',
        hash = 'f0bebd888edbe2ad74c7ac7d6ee0d8d172607ff9',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.individuals.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 64,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 49
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 62,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 56,
                    column: 20
                },
                end: {
                    line: 58,
                    column: 21
                }
            },
            '4': {
                start: {
                    line: 57,
                    column: 24
                },
                end: {
                    line: 57,
                    column: 41
                }
            },
            '5': {
                start: {
                    line: 59,
                    column: 20
                },
                end: {
                    line: 59,
                    column: 50
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 64,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 63,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 54,
                        column: 37
                    },
                    end: {
                        line: 54,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 54,
                        column: 53
                    },
                    end: {
                        line: 60,
                        column: 17
                    }
                },
                line: 54
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 56,
                        column: 20
                    },
                    end: {
                        line: 58,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 56,
                        column: 20
                    },
                    end: {
                        line: 58,
                        column: 21
                    }
                }, {
                    start: {
                        line: 56,
                        column: 20
                    },
                    end: {
                        line: 58,
                        column: 21
                    }
                }],
                line: 56
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1sw5rkra7j.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_1sw5rkra7j.f[0]++;
    cov_1sw5rkra7j.s[1]++;
    angular.module('app').factory('IndividualsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_1sw5rkra7j.f[1]++;
        cov_1sw5rkra7j.s[2]++;

        return restmod.model('/organizations').mix('MixinContainable', {
            type: {
                init: 'SINGULAR'
            },
            $config: {
                contains: {
                    links: {
                        type: 'hasMany',
                        table: 'LinksTable',
                        foreignKey: 'organization'
                    },
                    comments: {
                        type: 'hasMany',
                        table: 'CommentsTable',
                        foreignKey: 'object_id',
                        filters: {
                            /* eslint-disable camelcase */
                            object_type: 'INDIVIDUAL'
                        }
                    },
                    tags: {
                        type: 'hasMany',
                        table: 'OrganizationTagsTable',
                        foreignKey: 'organization'
                    },
                    files: {
                        type: 'hasMany',
                        table: 'OrganizationFilesTable',
                        foreignKey: 'organization'
                    },
                    interactions: {
                        type: 'hasMany',
                        table: 'OrganizationInteractionsTable',
                        foreignKey: 'organization'
                    },
                    emails: {
                        type: 'hasMany',
                        table: 'OrganizationEmailsTable',
                        foreignKey: 'organization'
                    }
                }
            },
            $hooks: {
                /* eslint-disable babel/object-shorthand */
                'before-fetch-many': function beforeFetchMany(_req) {
                    cov_1sw5rkra7j.f[2]++;
                    cov_1sw5rkra7j.s[3]++;

                    /* eslint-disable no-undef */
                    if (_.isUndefined(_req.params)) {
                        cov_1sw5rkra7j.b[0][0]++;
                        cov_1sw5rkra7j.s[4]++;

                        _req.params = {};
                    } else {
                        cov_1sw5rkra7j.b[0][1]++;
                    }
                    cov_1sw5rkra7j.s[5]++;
                    _req.params.type = 'SINGULAR';
                }
            }
        });
    }
})();
'use strict';

var cov_23mf6z5sf2 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.emails.templates.js',
        hash = '33dd51390c8ea4d59778460fbd162be27e347766',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.emails.templates.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 12,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 52
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 77
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 12,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_23mf6z5sf2.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_23mf6z5sf2.f[0]++;
    cov_23mf6z5sf2.s[1]++;
    angular.module('app').factory('EmailTemplatesTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_23mf6z5sf2.f[1]++;
        cov_23mf6z5sf2.s[2]++;

        return restmod.model('/email-templates').mix('MixinContainable', {});
    }
})();
'use strict';

var cov_291a9ofmi7 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.emails.factory.js',
        hash = '5d823a100c1cbeba7c0766f391775c56de87639c',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.emails.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 12,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 44
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 80
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 12,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_291a9ofmi7.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_291a9ofmi7.f[0]++;
    cov_291a9ofmi7.s[1]++;
    angular.module('app').factory('EmailsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_291a9ofmi7.f[1]++;
        cov_291a9ofmi7.s[2]++;

        return restmod.model('/email-interactions').mix('MixinContainable', {});
    }
})();
'use strict';

var cov_23pe25mfut = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.email.verifications.js',
        hash = '93a1b1dd10c78934762532580cf73bebf56555c6',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.email.verifications.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 12,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 56
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 81
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 12,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_23pe25mfut.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_23pe25mfut.f[0]++;
    cov_23pe25mfut.s[1]++;
    angular.module('app').factory('EmailVerificationsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_23pe25mfut.f[1]++;
        cov_23pe25mfut.s[2]++;

        return restmod.model('/email-verifications').mix('MixinContainable', {});
    }
})();
'use strict';

var cov_23ghr16iia = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.email.interaction.reads.js',
        hash = 'dc0f499c0fc9632e1d2a55a44f619f1597b4b8ed',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.email.interaction.reads.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 12,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 59
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 85
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 12,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_23ghr16iia.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_23ghr16iia.f[0]++;
    cov_23ghr16iia.s[1]++;
    angular.module('app').factory('EmailInteractionReadsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_23ghr16iia.f[1]++;
        cov_23ghr16iia.s[2]++;

        return restmod.model('/email-interaction-reads').mix('MixinContainable', {});
    }
})();
'use strict';

var cov_e62y2jkz9 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.economic.activities.factory.js',
        hash = 'ba15de0322be7411874c4af7b4b61cac74a9d526',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.economic.activities.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 12,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 40
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 53
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 12,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_e62y2jkz9.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_e62y2jkz9.f[0]++;
    cov_e62y2jkz9.s[1]++;
    angular.module('app').factory('ECTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_e62y2jkz9.f[1]++;
        cov_e62y2jkz9.s[2]++;

        return restmod.model('/economic-activities');
    }
})();
'use strict';

var cov_qdhdouur6 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.districts.factory.js',
        hash = '7f7ea6a1ff649210e3ad4d764ea84cc7bf396f9e',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.districts.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 12,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 47
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 43
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 12,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_qdhdouur6.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_qdhdouur6.f[0]++;
    cov_qdhdouur6.s[1]++;
    angular.module('app').factory('DistrictsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_qdhdouur6.f[1]++;
        cov_qdhdouur6.s[2]++;

        return restmod.model('/districts');
    }
})();
'use strict';

var cov_2af3lz3tpn = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.currency.conversions.js',
        hash = '0bda27fbdb8a67650c784c3cbfae641c39af6b35',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.currency.conversions.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 12,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 57
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 54
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 12,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2af3lz3tpn.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_2af3lz3tpn.f[0]++;
    cov_2af3lz3tpn.s[1]++;
    angular.module('app').factory('CurrencyConversionsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_2af3lz3tpn.f[1]++;
        cov_2af3lz3tpn.s[2]++;

        return restmod.model('/currency-conversions');
    }
})();
'use strict';

var cov_2phkto3rfl = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.configurations.factory.js',
        hash = 'c40e5584e00bbec2baa63c0cb4671822213336c7',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.configurations.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 12,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 52
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 48
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 12,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2phkto3rfl.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_2phkto3rfl.f[0]++;
    cov_2phkto3rfl.s[1]++;
    angular.module('app').factory('ConfigurationsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_2phkto3rfl.f[1]++;
        cov_2phkto3rfl.s[2]++;

        return restmod.model('/configurations');
    }
})();
'use strict';

var cov_dcd043vf6 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.config.js',
        hash = 'fbc06da60e67540ca3e1fbce953340ac83de1c04',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.config.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 17,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 24
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 15,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 52
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 17,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'Config',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 50
                    },
                    end: {
                        line: 16,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_dcd043vf6.s[0]++;
(function () {
    'use strict';

    Config.$inject = ["restmodProvider", "AppSettings"];
    cov_dcd043vf6.f[0]++;
    cov_dcd043vf6.s[1]++;
    angular.module('app').config(Config);

    /* @ngInject */
    function Config(restmodProvider, AppSettings) {
        cov_dcd043vf6.f[1]++;
        cov_dcd043vf6.s[2]++;

        restmodProvider.rebase({
            $config: {
                urlPrefix: AppSettings.apiUrl
            }
        });
        cov_dcd043vf6.s[3]++;
        restmodProvider.rebase('DjangoDRFPagedApi');
    }
})();
'use strict';

var cov_1qnqgwna0m = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.components.factory.js',
        hash = 'cc7ff3481e2c7747bcd359d63888dfb80eee7cfa',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.components.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 12,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 52
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 44
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 12,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1qnqgwna0m.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_1qnqgwna0m.f[0]++;
    cov_1qnqgwna0m.s[1]++;
    angular.module('app').factory('ComponentsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_1qnqgwna0m.f[1]++;
        cov_1qnqgwna0m.s[2]++;

        return restmod.model('/components');
    }
})();
'use strict';

var cov_v387gr2u7 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.comments.factory.js',
        hash = '03944df88104556d0bbc1c65c93f9fbcdb38850c',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.comments.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 28,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 46
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 26,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 23,
                    column: 20
                },
                end: {
                    line: 23,
                    column: 43
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 28,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 27,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 22,
                        column: 24
                    },
                    end: {
                        line: 22,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 41
                    },
                    end: {
                        line: 24,
                        column: 17
                    }
                },
                line: 22
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_v387gr2u7.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_v387gr2u7.f[0]++;
    cov_v387gr2u7.s[1]++;
    angular.module('app').factory('CommentsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_v387gr2u7.f[1]++;
        cov_v387gr2u7.s[2]++;

        return restmod.model('/comments').mix('MixinContainable', {
            $config: {
                contains: {
                    user: {
                        type: 'belongsTo',
                        table: 'UsersTable',
                        foreignKey: 'user'
                    }
                }
            },
            created: {
                /* eslint-disable babel/object-shorthand */
                decode: function decode(value) {
                    cov_v387gr2u7.f[2]++;
                    cov_v387gr2u7.s[3]++;

                    return new Date(value);
                }
            }
        });
    }
})();
'use strict';

var cov_24qnor96wl = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/media/media.table.factory.js',
        hash = '87727f5f2d401febffe3bf069574b8bc9deb4cd5',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/media/media.table.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 12,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 47
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 67
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 12,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_24qnor96wl.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_24qnor96wl.f[0]++;
    cov_24qnor96wl.s[1]++;
    angular.module('app').factory('MediaTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_24qnor96wl.f[1]++;
        cov_24qnor96wl.s[2]++;

        return restmod.model('/media').mix('MixinContainable', {});
    }
})();
'use strict';

var cov_1a8zakrwtx = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/media/media.service.js',
        hash = '355a48c3fe01f3489f20086dc3f07bf1190746bb',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/media/media.service.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 37,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 42
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 29
                }
            },
            '3': {
                start: {
                    line: 13,
                    column: 12
                },
                end: {
                    line: 13,
                    column: 74
                }
            },
            '4': {
                start: {
                    line: 15,
                    column: 12
                },
                end: {
                    line: 34,
                    column: 13
                }
            },
            '5': {
                start: {
                    line: 16,
                    column: 16
                },
                end: {
                    line: 29,
                    column: 19
                }
            },
            '6': {
                start: {
                    line: 22,
                    column: 20
                },
                end: {
                    line: 22,
                    column: 42
                }
            },
            '7': {
                start: {
                    line: 24,
                    column: 20
                },
                end: {
                    line: 24,
                    column: 71
                }
            },
            '8': {
                start: {
                    line: 25,
                    column: 20
                },
                end: {
                    line: 25,
                    column: 37
                }
            },
            '9': {
                start: {
                    line: 27,
                    column: 47
                },
                end: {
                    line: 27,
                    column: 87
                }
            },
            '10': {
                start: {
                    line: 28,
                    column: 20
                },
                end: {
                    line: 28,
                    column: 90
                }
            },
            '11': {
                start: {
                    line: 32,
                    column: 16
                },
                end: {
                    line: 32,
                    column: 60
                }
            },
            '12': {
                start: {
                    line: 33,
                    column: 16
                },
                end: {
                    line: 33,
                    column: 33
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 37,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'Service',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 52
                    },
                    end: {
                        line: 36,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'upload',
                decl: {
                    start: {
                        line: 12,
                        column: 17
                    },
                    end: {
                        line: 12,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 12,
                        column: 30
                    },
                    end: {
                        line: 35,
                        column: 9
                    }
                },
                line: 12
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 21,
                        column: 24
                    },
                    end: {
                        line: 21,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 40
                    },
                    end: {
                        line: 23,
                        column: 17
                    }
                },
                line: 21
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 23,
                        column: 19
                    },
                    end: {
                        line: 23,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 23,
                        column: 31
                    },
                    end: {
                        line: 26,
                        column: 17
                    }
                },
                line: 23
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 26,
                        column: 19
                    },
                    end: {
                        line: 26,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 34
                    },
                    end: {
                        line: 29,
                        column: 17
                    }
                },
                line: 26
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 15,
                        column: 12
                    },
                    end: {
                        line: 34,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 15,
                        column: 12
                    },
                    end: {
                        line: 34,
                        column: 13
                    }
                }, {
                    start: {
                        line: 15,
                        column: 12
                    },
                    end: {
                        line: 34,
                        column: 13
                    }
                }],
                line: 15
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1a8zakrwtx.s[0]++;
(function () {
    'use strict';

    Service.$inject = ["Upload", "AppSettings", "$mdToast"];
    cov_1a8zakrwtx.f[0]++;
    cov_1a8zakrwtx.s[1]++;
    angular.module('app').service('MediaService', Service);

    /* @ngInject */
    function Service(Upload, AppSettings, $mdToast) {
        cov_1a8zakrwtx.f[1]++;
        cov_1a8zakrwtx.s[2]++;

        this.upload = upload;

        function upload(file) {
            cov_1a8zakrwtx.f[2]++;
            cov_1a8zakrwtx.s[3]++;

            $mdToast.show($mdToast.simple().textContent('Uploading ...'));

            cov_1a8zakrwtx.s[4]++;
            if (file) {
                cov_1a8zakrwtx.b[0][0]++;
                cov_1a8zakrwtx.s[5]++;

                return Upload.upload({
                    url: AppSettings.apiUrl + '/media/',
                    data: {
                        file: file
                    }
                }).then(function (data) {
                    cov_1a8zakrwtx.f[3]++;
                    cov_1a8zakrwtx.s[6]++;

                    return data.data.file;
                }, function () {
                    cov_1a8zakrwtx.f[4]++;
                    cov_1a8zakrwtx.s[7]++;

                    $mdToast.updateTextContent('An error has ocurred');
                    cov_1a8zakrwtx.s[8]++;
                    return undefined;
                }, function (evt) {
                    cov_1a8zakrwtx.f[5]++;

                    var progressPercentage = (cov_1a8zakrwtx.s[9]++, parseInt(100.0 * evt.loaded / evt.total));
                    cov_1a8zakrwtx.s[10]++;
                    $mdToast.updateTextContent('Uploading (' + progressPercentage + '%)');
                });
                /* eslint-disable no-else-return */
            } else {
                cov_1a8zakrwtx.b[0][1]++;
                cov_1a8zakrwtx.s[11]++;

                $mdToast.updateTextContent('Invalid file!');
                cov_1a8zakrwtx.s[12]++;
                return undefined;
            }
        }
    }
})();
'use strict';

var cov_2ofm68ft5k = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/media/media.run.js',
        hash = '0d5368ad22be2864355e66f0684b8c409ce09f98',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/media/media.run.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 11,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 3,
                    column: 4
                },
                end: {
                    line: 5,
                    column: 23
                }
            },
            '2': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 9,
                    column: 41
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 11,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'runBlock',
                decl: {
                    start: {
                        line: 8,
                        column: 13
                    },
                    end: {
                        line: 8,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 8,
                        column: 48
                    },
                    end: {
                        line: 10,
                        column: 5
                    }
                },
                line: 8
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2ofm68ft5k.s[0]++;
(function () {
    'use strict';

    runBlock.$inject = ["$rootScope", "MediaService"];
    cov_2ofm68ft5k.f[0]++;
    cov_2ofm68ft5k.s[1]++;
    angular.module('app').run(runBlock);

    /* @ngInject */
    function runBlock($rootScope, MediaService) {
        cov_2ofm68ft5k.f[1]++;
        cov_2ofm68ft5k.s[2]++;

        $rootScope.$Media = MediaService;
    }
})();
'use strict';

var cov_2cv8z3n4ho = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/media/media.filter.js',
        hash = '327e09f7b4c4c600afb177862635c7a6813d440a',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/media/media.filter.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 19,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 38
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 16,
                    column: 13
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 16
                },
                end: {
                    line: 12,
                    column: 58
                }
            },
            '5': {
                start: {
                    line: 15,
                    column: 16
                },
                end: {
                    line: 15,
                    column: 28
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 19,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'MediaUrl',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 35
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 15
                    },
                    end: {
                        line: 10,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 32
                    },
                    end: {
                        line: 17,
                        column: 9
                    }
                },
                line: 10
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 16,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 16,
                        column: 13
                    }
                }, {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 16,
                        column: 13
                    }
                }],
                line: 11
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2cv8z3n4ho.s[0]++;
(function () {
    'use strict';

    MediaUrl.$inject = ["AppSettings"];
    cov_2cv8z3n4ho.f[0]++;
    cov_2cv8z3n4ho.s[1]++;
    angular.module('app').filter('mediaUrl', MediaUrl);

    /* @ngInject */
    function MediaUrl(AppSettings) {
        cov_2cv8z3n4ho.f[1]++;
        cov_2cv8z3n4ho.s[2]++;

        return function (input) {
            cov_2cv8z3n4ho.f[2]++;
            cov_2cv8z3n4ho.s[3]++;

            if (input) {
                cov_2cv8z3n4ho.b[0][0]++;
                cov_2cv8z3n4ho.s[4]++;

                return AppSettings.mediaUrl + '/' + input;
                /* eslint-disable no-else-return */
            } else {
                cov_2cv8z3n4ho.b[0][1]++;
                cov_2cv8z3n4ho.s[5]++;

                return null;
            }
        };
    }
})();
'use strict';

var cov_t44w63jze = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/media/media.directive.js',
        hash = '5232c3b463c2968a75ff88e777c745cf95ee0c59',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/media/media.directive.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 32,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 54
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 30,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 13,
                    column: 31
                },
                end: {
                    line: 13,
                    column: 57
                }
            },
            '4': {
                start: {
                    line: 14,
                    column: 31
                },
                end: {
                    line: 14,
                    column: 44
                }
            },
            '5': {
                start: {
                    line: 15,
                    column: 31
                },
                end: {
                    line: 15,
                    column: 36
                }
            },
            '6': {
                start: {
                    line: 17,
                    column: 16
                },
                end: {
                    line: 28,
                    column: 19
                }
            },
            '7': {
                start: {
                    line: 18,
                    column: 33
                },
                end: {
                    line: 18,
                    column: 47
                }
            },
            '8': {
                start: {
                    line: 19,
                    column: 20
                },
                end: {
                    line: 27,
                    column: 21
                }
            },
            '9': {
                start: {
                    line: 20,
                    column: 40
                },
                end: {
                    line: 20,
                    column: 72
                }
            },
            '10': {
                start: {
                    line: 21,
                    column: 24
                },
                end: {
                    line: 21,
                    column: 48
                }
            },
            '11': {
                start: {
                    line: 22,
                    column: 24
                },
                end: {
                    line: 26,
                    column: 27
                }
            },
            '12': {
                start: {
                    line: 23,
                    column: 28
                },
                end: {
                    line: 23,
                    column: 49
                }
            },
            '13': {
                start: {
                    line: 25,
                    column: 28
                },
                end: {
                    line: 25,
                    column: 49
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 32,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'MediaDirective',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 36
                    },
                    end: {
                        line: 31,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 17,
                        column: 50
                    },
                    end: {
                        line: 17,
                        column: 51
                    }
                },
                loc: {
                    start: {
                        line: 17,
                        column: 62
                    },
                    end: {
                        line: 28,
                        column: 17
                    }
                },
                line: 17
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 22,
                        column: 37
                    },
                    end: {
                        line: 22,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 53
                    },
                    end: {
                        line: 24,
                        column: 25
                    }
                },
                line: 22
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 24,
                        column: 27
                    },
                    end: {
                        line: 24,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 43
                    },
                    end: {
                        line: 26,
                        column: 25
                    }
                },
                line: 24
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 19,
                        column: 20
                    },
                    end: {
                        line: 27,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 19,
                        column: 20
                    },
                    end: {
                        line: 27,
                        column: 21
                    }
                }, {
                    start: {
                        line: 19,
                        column: 20
                    },
                    end: {
                        line: 27,
                        column: 21
                    }
                }],
                line: 19
            },
            '1': {
                loc: {
                    start: {
                        line: 19,
                        column: 24
                    },
                    end: {
                        line: 19,
                        column: 104
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 19,
                        column: 24
                    },
                    end: {
                        line: 19,
                        column: 28
                    }
                }, {
                    start: {
                        line: 19,
                        column: 32
                    },
                    end: {
                        line: 19,
                        column: 54
                    }
                }, {
                    start: {
                        line: 19,
                        column: 59
                    },
                    end: {
                        line: 19,
                        column: 79
                    }
                }, {
                    start: {
                        line: 19,
                        column: 83
                    },
                    end: {
                        line: 19,
                        column: 103
                    }
                }],
                line: 19
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0, 0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_t44w63jze.s[0]++;
(function () {
    'use strict';

    MediaDirective.$inject = ["$parse"];
    cov_t44w63jze.f[0]++;
    cov_t44w63jze.s[1]++;
    angular.module('app').directive('mediaAutoUpload', MediaDirective);

    /* @ngInject */
    function MediaDirective($parse) {
        cov_t44w63jze.f[1]++;
        cov_t44w63jze.s[2]++;

        return {
            require: '?ngModel',
            link: function link(scope, element, attributes) {
                var getter = (cov_t44w63jze.s[3]++, $parse(attributes.ngModel));
                var setter = (cov_t44w63jze.s[4]++, getter.assign);
                var $scope = (cov_t44w63jze.s[5]++, scope);

                cov_t44w63jze.s[6]++;
                $scope.$watch(attributes.ngModel, function () {
                    cov_t44w63jze.f[2]++;

                    var file = (cov_t44w63jze.s[7]++, getter($scope));
                    cov_t44w63jze.s[8]++;
                    if ((cov_t44w63jze.b[1][0]++, file) && (cov_t44w63jze.b[1][1]++, angular.isObject(file)) && ((cov_t44w63jze.b[1][2]++, file instanceof File) || (cov_t44w63jze.b[1][3]++, file instanceof Blob))) {
                        cov_t44w63jze.b[0][0]++;

                        var promise = (cov_t44w63jze.s[9]++, $scope.$root.$Media.upload(file));
                        cov_t44w63jze.s[10]++;
                        setter($scope, promise);
                        cov_t44w63jze.s[11]++;
                        promise.then(function (data) {
                            cov_t44w63jze.f[3]++;
                            cov_t44w63jze.s[12]++;

                            setter($scope, data);
                        }, function (data) {
                            cov_t44w63jze.f[4]++;
                            cov_t44w63jze.s[13]++;

                            setter($scope, data);
                        });
                    } else {
                        cov_t44w63jze.b[0][1]++;
                    }
                });
            }
        };
    }
})();
'use strict';

var cov_2r3dmfahat = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/html/menuBtn/menuBtn.js',
        hash = '35f2b7a3d6f6983e89f2bdd7921b5c9ef807746f',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/html/menuBtn/menuBtn.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 37
                }
            },
            '1': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 11
                }
            },
            '2': {
                start: {
                    line: 7,
                    column: 12
                },
                end: {
                    line: 7,
                    column: 29
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 39
                }
            },
            '4': {
                start: {
                    line: 16,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 40
                }
            },
            '5': {
                start: {
                    line: 20,
                    column: 0
                },
                end: {
                    line: 25,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 42
                    },
                    end: {
                        line: 9,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 6,
                        column: 33
                    },
                    end: {
                        line: 6,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 6,
                        column: 39
                    },
                    end: {
                        line: 8,
                        column: 9
                    }
                },
                line: 6
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 11,
                        column: 4
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 15
                    },
                    end: {
                        line: 13,
                        column: 5
                    }
                },
                line: 11
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 15,
                        column: 4
                    },
                    end: {
                        line: 15,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 15,
                        column: 16
                    },
                    end: {
                        line: 17,
                        column: 5
                    }
                },
                line: 15
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MenuBtnController = function () {
    MenuBtnController.$inject = ["$mdSidenav", "$transitions"];
    function MenuBtnController($mdSidenav, $transitions) {
        var _this = this;

        _classCallCheck(this, MenuBtnController);

        cov_2r3dmfahat.f[0]++;
        cov_2r3dmfahat.s[0]++;

        this.$mdSidenav = $mdSidenav;

        cov_2r3dmfahat.s[1]++;
        $transitions.onStart({}, function () {
            cov_2r3dmfahat.f[1]++;
            cov_2r3dmfahat.s[2]++;

            _this.closeMenu();
        });
    }

    _createClass(MenuBtnController, [{
        key: 'openMenu',
        value: function openMenu() {
            cov_2r3dmfahat.f[2]++;
            cov_2r3dmfahat.s[3]++;

            this.$mdSidenav('menu').open();
        }
    }, {
        key: 'closeMenu',
        value: function closeMenu() {
            cov_2r3dmfahat.f[3]++;
            cov_2r3dmfahat.s[4]++;

            this.$mdSidenav('menu').close();
        }
    }]);

    return MenuBtnController;
}();

cov_2r3dmfahat.s[5]++;


angular.module('app').component('menuBtn', {
    templateUrl: 'app/shared/html/menuBtn/menuBtn.html',
    controller: MenuBtnController
});
'use strict';

var cov_1dqnlevuu5 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/workspaceDetails/workspaceDetails.js',
        hash = 'a1efa1d31154ac41feca29b7e1451337e7c0bf92',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/workspaceDetails/workspaceDetails.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 31
                }
            },
            '1': {
                start: {
                    line: 8,
                    column: 0
                },
                end: {
                    line: 16,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 20
                    },
                    end: {
                        line: 5,
                        column: 5
                    }
                },
                line: 3
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0
        },
        f: {
            '0': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WorkspaceDetailsController = function () {
    function WorkspaceDetailsController() {
        _classCallCheck(this, WorkspaceDetailsController);
    }

    _createClass(WorkspaceDetailsController, [{
        key: 'saveWorkspace',
        value: function saveWorkspace() {
            cov_1dqnlevuu5.f[0]++;
            cov_1dqnlevuu5.s[0]++;

            this.workspace.$save();
        }
    }]);

    return WorkspaceDetailsController;
}();

cov_1dqnlevuu5.s[1]++;


angular.module('app').component('workspaceDetails', {
    templateUrl: 'app/components/workspaceDetails/workspaceDetails.html',
    controller: WorkspaceDetailsController,
    bindings: {
        workspace: '<'
    }
});
'use strict';

var cov_6zmzyrf47 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/userStorySelector/userStorySelector.js',
        hash = '321c025f11ccad250b89d5735e6c576413620dbb',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/userStorySelector/userStorySelector.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 35,
                    column: 12
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 71
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 16,
                    column: 15
                }
            },
            '4': {
                start: {
                    line: 22,
                    column: 8
                },
                end: {
                    line: 22,
                    column: 38
                }
            },
            '5': {
                start: {
                    line: 24,
                    column: 8
                },
                end: {
                    line: 24,
                    column: 82
                }
            },
            '6': {
                start: {
                    line: 26,
                    column: 8
                },
                end: {
                    line: 28,
                    column: 10
                }
            },
            '7': {
                start: {
                    line: 27,
                    column: 12
                },
                end: {
                    line: 27,
                    column: 31
                }
            },
            '8': {
                start: {
                    line: 30,
                    column: 8
                },
                end: {
                    line: 33,
                    column: 10
                }
            },
            '9': {
                start: {
                    line: 31,
                    column: 12
                },
                end: {
                    line: 31,
                    column: 45
                }
            },
            '10': {
                start: {
                    line: 32,
                    column: 12
                },
                end: {
                    line: 32,
                    column: 53
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 35,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'UserStorySelectorService',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 49
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 23
                    },
                    end: {
                        line: 10,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 35
                    },
                    end: {
                        line: 17,
                        column: 9
                    }
                },
                line: 10
            },
            '3': {
                name: 'UserStorySelectorController',
                decl: {
                    start: {
                        line: 21,
                        column: 13
                    },
                    end: {
                        line: 21,
                        column: 40
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 78
                    },
                    end: {
                        line: 34,
                        column: 5
                    }
                },
                line: 21
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 26,
                        column: 29
                    },
                    end: {
                        line: 26,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 41
                    },
                    end: {
                        line: 28,
                        column: 9
                    }
                },
                line: 26
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 30,
                        column: 31
                    },
                    end: {
                        line: 30,
                        column: 32
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 48
                    },
                    end: {
                        line: 33,
                        column: 9
                    }
                },
                line: 30
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_6zmzyrf47.s[0]++;
(function () {
    'use strict';

    UserStorySelectorService.$inject = ["$mdDialog"];
    UserStorySelectorController.$inject = ["$scope", "$mdDialog", "UserStoriesTable"];
    cov_6zmzyrf47.f[0]++;
    cov_6zmzyrf47.s[1]++;
    angular.module('app').service('UserStorySelectorService', UserStorySelectorService);

    /* @ngInject */
    function UserStorySelectorService($mdDialog) {
        cov_6zmzyrf47.f[1]++;
        cov_6zmzyrf47.s[2]++;

        this.display = function () {
            cov_6zmzyrf47.f[2]++;
            cov_6zmzyrf47.s[3]++;

            return $mdDialog.show({
                templateUrl: 'app/components/userStorySelector/userStorySelector.html',
                controller: UserStorySelectorController,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };
    }

    /* @ngInject */
    function UserStorySelectorController($scope, $mdDialog, UserStoriesTable) {
        cov_6zmzyrf47.f[3]++;
        cov_6zmzyrf47.s[4]++;

        $scope.selectedUserStory = '';
        /* eslint-disable camelcase */
        cov_6zmzyrf47.s[5]++;
        $scope.userStories = UserStoriesTable.$search({ proposal__isnull: 'True' });

        cov_6zmzyrf47.s[6]++;
        $scope.closeDialog = function () {
            cov_6zmzyrf47.f[4]++;
            cov_6zmzyrf47.s[7]++;

            $mdDialog.cancel();
        };

        cov_6zmzyrf47.s[8]++;
        $scope.sendUserStory = function (story) {
            cov_6zmzyrf47.f[5]++;
            cov_6zmzyrf47.s[9]++;

            $scope.selectedUserStory = story;
            cov_6zmzyrf47.s[10]++;
            $mdDialog.hide($scope.selectedUserStory);
        };
    }
})(angular);
'use strict';

var cov_q4sq54caz = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/userStoryDetails/userStoryDetails.js',
        hash = '2d8fb26b3d5dead96ae444f2e2abe8fb0e4cc005',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/userStoryDetails/userStoryDetails.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 36
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 47
                }
            },
            '2': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 16,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 56
                }
            },
            '4': {
                start: {
                    line: 17,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 47
                }
            },
            '5': {
                start: {
                    line: 18,
                    column: 8
                },
                end: {
                    line: 18,
                    column: 49
                }
            },
            '6': {
                start: {
                    line: 19,
                    column: 8
                },
                end: {
                    line: 32,
                    column: 11
                }
            },
            '7': {
                start: {
                    line: 20,
                    column: 12
                },
                end: {
                    line: 31,
                    column: 15
                }
            },
            '8': {
                start: {
                    line: 21,
                    column: 16
                },
                end: {
                    line: 30,
                    column: 19
                }
            },
            '9': {
                start: {
                    line: 22,
                    column: 20
                },
                end: {
                    line: 29,
                    column: 21
                }
            },
            '10': {
                start: {
                    line: 23,
                    column: 24
                },
                end: {
                    line: 28,
                    column: 27
                }
            },
            '11': {
                start: {
                    line: 27,
                    column: 28
                },
                end: {
                    line: 27,
                    column: 52
                }
            },
            '12': {
                start: {
                    line: 33,
                    column: 8
                },
                end: {
                    line: 33,
                    column: 29
                }
            },
            '13': {
                start: {
                    line: 37,
                    column: 8
                },
                end: {
                    line: 40,
                    column: 11
                }
            },
            '14': {
                start: {
                    line: 38,
                    column: 12
                },
                end: {
                    line: 38,
                    column: 34
                }
            },
            '15': {
                start: {
                    line: 39,
                    column: 12
                },
                end: {
                    line: 39,
                    column: 33
                }
            },
            '16': {
                start: {
                    line: 44,
                    column: 8
                },
                end: {
                    line: 49,
                    column: 11
                }
            },
            '17': {
                start: {
                    line: 45,
                    column: 12
                },
                end: {
                    line: 45,
                    column: 38
                }
            },
            '18': {
                start: {
                    line: 46,
                    column: 12
                },
                end: {
                    line: 48,
                    column: 15
                }
            },
            '19': {
                start: {
                    line: 47,
                    column: 16
                },
                end: {
                    line: 47,
                    column: 41
                }
            },
            '20': {
                start: {
                    line: 53,
                    column: 0
                },
                end: {
                    line: 61,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 33
                    },
                    end: {
                        line: 6,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 8,
                        column: 4
                    },
                    end: {
                        line: 8,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 8,
                        column: 20
                    },
                    end: {
                        line: 13,
                        column: 5
                    }
                },
                line: 8
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 15,
                        column: 4
                    },
                    end: {
                        line: 15,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 15,
                        column: 14
                    },
                    end: {
                        line: 34,
                        column: 5
                    }
                },
                line: 15
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 19,
                        column: 45
                    },
                    end: {
                        line: 19,
                        column: 46
                    }
                },
                loc: {
                    start: {
                        line: 19,
                        column: 59
                    },
                    end: {
                        line: 32,
                        column: 9
                    }
                },
                line: 19
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 20,
                        column: 31
                    },
                    end: {
                        line: 20,
                        column: 32
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 44
                    },
                    end: {
                        line: 31,
                        column: 13
                    }
                },
                line: 20
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 21,
                        column: 79
                    },
                    end: {
                        line: 21,
                        column: 80
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 88
                    },
                    end: {
                        line: 30,
                        column: 17
                    }
                },
                line: 21
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 26,
                        column: 33
                    },
                    end: {
                        line: 26,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 41
                    },
                    end: {
                        line: 28,
                        column: 25
                    }
                },
                line: 26
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 36,
                        column: 4
                    },
                    end: {
                        line: 36,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 36,
                        column: 17
                    },
                    end: {
                        line: 41,
                        column: 5
                    }
                },
                line: 36
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 37,
                        column: 38
                    },
                    end: {
                        line: 37,
                        column: 39
                    }
                },
                loc: {
                    start: {
                        line: 37,
                        column: 49
                    },
                    end: {
                        line: 40,
                        column: 9
                    }
                },
                line: 37
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 43,
                        column: 4
                    },
                    end: {
                        line: 43,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 43,
                        column: 19
                    },
                    end: {
                        line: 50,
                        column: 5
                    }
                },
                line: 43
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 44,
                        column: 40
                    },
                    end: {
                        line: 44,
                        column: 41
                    }
                },
                loc: {
                    start: {
                        line: 44,
                        column: 46
                    },
                    end: {
                        line: 49,
                        column: 9
                    }
                },
                line: 44
            },
            '11': {
                name: '(anonymous_11)',
                decl: {
                    start: {
                        line: 46,
                        column: 51
                    },
                    end: {
                        line: 46,
                        column: 52
                    }
                },
                loc: {
                    start: {
                        line: 46,
                        column: 60
                    },
                    end: {
                        line: 48,
                        column: 13
                    }
                },
                line: 46
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 22,
                        column: 20
                    },
                    end: {
                        line: 29,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 22,
                        column: 20
                    },
                    end: {
                        line: 29,
                        column: 21
                    }
                }, {
                    start: {
                        line: 22,
                        column: 20
                    },
                    end: {
                        line: 29,
                        column: 21
                    }
                }],
                line: 22
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserStoryDetailsController = function () {
    UserStoryDetailsController.$inject = ["ComponentsTable"];
    function UserStoryDetailsController(ComponentsTable) {
        _classCallCheck(this, UserStoryDetailsController);

        cov_q4sq54caz.f[0]++;
        cov_q4sq54caz.s[0]++;

        this.currentNav = 'details';
        cov_q4sq54caz.s[1]++;
        this.ComponentsTable = ComponentsTable;
    }

    _createClass(UserStoryDetailsController, [{
        key: '_buildComment',
        value: function _buildComment() {
            cov_q4sq54caz.f[1]++;
            cov_q4sq54caz.s[2]++;

            this.newComment = this.userStory.$comments.$build({
                objectType: 'USER_STORY',
                objectId: this.userStory.id
            });
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            cov_q4sq54caz.f[2]++;
            cov_q4sq54caz.s[3]++;

            this.userStory.$load('comments').$load('costs');
            cov_q4sq54caz.s[4]++;
            this.userStory.$comments.$load('user');
            cov_q4sq54caz.s[5]++;
            this.userStory.$costs.$load('component');
            cov_q4sq54caz.s[6]++;
            this.ComponentsTable.$search().$then(function (components) {
                cov_q4sq54caz.f[3]++;
                cov_q4sq54caz.s[7]++;

                components.forEach(function (component) {
                    cov_q4sq54caz.f[4]++;
                    cov_q4sq54caz.s[8]++;

                    _this.userStory.$costs.$search({ component: component.id }).$then(function (costs) {
                        cov_q4sq54caz.f[5]++;
                        cov_q4sq54caz.s[9]++;

                        if (costs.length === 0) {
                            cov_q4sq54caz.b[0][0]++;
                            cov_q4sq54caz.s[10]++;

                            _this.userStory.$costs.$create({
                                userStory: _this.userStory.id,
                                component: component.id
                            }).$then(function (cost) {
                                cov_q4sq54caz.f[6]++;
                                cov_q4sq54caz.s[11]++;

                                cost.$load('component');
                            });
                        } else {
                            cov_q4sq54caz.b[0][1]++;
                        }
                    });
                });
            });
            cov_q4sq54caz.s[12]++;
            this._buildComment();
        }
    }, {
        key: 'addComment',
        value: function addComment() {
            var _this2 = this;

            cov_q4sq54caz.f[7]++;
            cov_q4sq54caz.s[13]++;

            this.newComment.$save().$then(function (comment) {
                cov_q4sq54caz.f[8]++;
                cov_q4sq54caz.s[14]++;

                comment.$load('user');
                cov_q4sq54caz.s[15]++;
                _this2._buildComment();
            });
        }
    }, {
        key: 'saveCost',
        value: function saveCost(cost) {
            var _this3 = this;

            cov_q4sq54caz.f[9]++;
            cov_q4sq54caz.s[16]++;

            cost.$save(['estimated']).$then(function () {
                cov_q4sq54caz.f[10]++;
                cov_q4sq54caz.s[17]++;

                _this3.userStory.$refresh();
                cov_q4sq54caz.s[18]++;
                _this3.userStory.$costs.$refresh().$then(function (costs) {
                    cov_q4sq54caz.f[11]++;
                    cov_q4sq54caz.s[19]++;

                    costs.$load('component');
                });
            });
        }
    }]);

    return UserStoryDetailsController;
}();

cov_q4sq54caz.s[20]++;


angular.module('app').component('userStoryDetails', {
    templateUrl: 'app/components/userStoryDetails/userStoryDetails.html',
    controller: UserStoryDetailsController,
    bindings: {
        userStory: '<'
    }
});
'use strict';

var cov_13dibo2dmt = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/userStoriesList/userStoriesList.js',
        hash = '55b094a018d03abe0658e3f0038ad8efde1ef884',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/userStoriesList/userStoriesList.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 65
                }
            },
            '1': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 9,
                    column: 11
                }
            },
            '2': {
                start: {
                    line: 7,
                    column: 12
                },
                end: {
                    line: 7,
                    column: 40
                }
            },
            '3': {
                start: {
                    line: 8,
                    column: 12
                },
                end: {
                    line: 8,
                    column: 26
                }
            },
            '4': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 11
                }
            },
            '5': {
                start: {
                    line: 13,
                    column: 12
                },
                end: {
                    line: 13,
                    column: 55
                }
            },
            '6': {
                start: {
                    line: 14,
                    column: 12
                },
                end: {
                    line: 14,
                    column: 26
                }
            },
            '7': {
                start: {
                    line: 19,
                    column: 8
                },
                end: {
                    line: 19,
                    column: 52
                }
            },
            '8': {
                start: {
                    line: 23,
                    column: 8
                },
                end: {
                    line: 25,
                    column: 11
                }
            },
            '9': {
                start: {
                    line: 24,
                    column: 12
                },
                end: {
                    line: 24,
                    column: 45
                }
            },
            '10': {
                start: {
                    line: 29,
                    column: 0
                },
                end: {
                    line: 37,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 54
                    },
                    end: {
                        line: 16,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 6,
                        column: 38
                    },
                    end: {
                        line: 6,
                        column: 39
                    }
                },
                loc: {
                    start: {
                        line: 6,
                        column: 55
                    },
                    end: {
                        line: 9,
                        column: 9
                    }
                },
                line: 6
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 11,
                        column: 37
                    },
                    end: {
                        line: 11,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 54
                    },
                    end: {
                        line: 15,
                        column: 9
                    }
                },
                line: 11
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 18,
                        column: 4
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 18,
                        column: 13
                    },
                    end: {
                        line: 20,
                        column: 5
                    }
                },
                line: 18
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 22,
                        column: 4
                    },
                    end: {
                        line: 22,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 31
                    },
                    end: {
                        line: 26,
                        column: 5
                    }
                },
                line: 22
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 23,
                        column: 53
                    },
                    end: {
                        line: 23,
                        column: 54
                    }
                },
                loc: {
                    start: {
                        line: 23,
                        column: 66
                    },
                    end: {
                        line: 25,
                        column: 9
                    }
                },
                line: 23
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserStoriesListController = function () {
    UserStoriesListController.$inject = ["NewUserStoryModalService", "$rootScope"];
    function UserStoriesListController(NewUserStoryModalService, $rootScope) {
        var _this = this;

        _classCallCheck(this, UserStoriesListController);

        cov_13dibo2dmt.f[0]++;
        cov_13dibo2dmt.s[0]++;

        this.NewUserStoryModalService = NewUserStoryModalService;
        // eslint-disable-next-line angular/on-watch
        cov_13dibo2dmt.s[1]++;
        $rootScope.$on('pageChanged', function (event, data) {
            cov_13dibo2dmt.f[1]++;
            cov_13dibo2dmt.s[2]++;

            _this.proposals.$page = data;
            cov_13dibo2dmt.s[3]++;
            _this.update();
        });
        // eslint-disable-next-line angular/on-watch
        cov_13dibo2dmt.s[4]++;
        $rootScope.$on('searchText', function (event, data) {
            cov_13dibo2dmt.f[2]++;
            cov_13dibo2dmt.s[5]++;

            // eslint-disable-next-line camelcase
            _this.requestData = { name__icontains: data };
            cov_13dibo2dmt.s[6]++;
            _this.update();
        });
    }

    _createClass(UserStoriesListController, [{
        key: 'update',
        value: function update() {
            cov_13dibo2dmt.f[3]++;
            cov_13dibo2dmt.s[7]++;

            this.userStories.$refresh(this.requestData);
        }
    }, {
        key: 'displayNewUserStoryModal',
        value: function displayNewUserStoryModal() {
            var _this2 = this;

            cov_13dibo2dmt.f[4]++;
            cov_13dibo2dmt.s[8]++;

            this.NewUserStoryModalService.display().then(function (userStory) {
                cov_13dibo2dmt.f[5]++;
                cov_13dibo2dmt.s[9]++;

                _this2.userStories.$add(userStory);
            });
        }
    }]);

    return UserStoriesListController;
}();

cov_13dibo2dmt.s[10]++;


angular.module('app').component('userStoriesList', {
    templateUrl: 'app/components/userStoriesList/userStoriesList.html',
    controller: UserStoriesListController,
    bindings: {
        userStories: '<'
    }
});
'use strict';

var cov_20vzoiqxw9 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/userProfile/userProfile.js',
        hash = 'c9f29d7e3306d66cd778b2b399feca27c20be859',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/userProfile/userProfile.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 10
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 16
                },
                end: {
                    line: 5,
                    column: 28
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 31
                },
                end: {
                    line: 10,
                    column: 51
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 29
                },
                end: {
                    line: 11,
                    column: 56
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 16
                },
                end: {
                    line: 12,
                    column: 36
                }
            },
            '5': {
                start: {
                    line: 14,
                    column: 16
                },
                end: {
                    line: 14,
                    column: 38
                }
            },
            '6': {
                start: {
                    line: 21,
                    column: 8
                },
                end: {
                    line: 21,
                    column: 37
                }
            },
            '7': {
                start: {
                    line: 22,
                    column: 8
                },
                end: {
                    line: 22,
                    column: 68
                }
            },
            '8': {
                start: {
                    line: 22,
                    column: 44
                },
                end: {
                    line: 22,
                    column: 66
                }
            },
            '9': {
                start: {
                    line: 26,
                    column: 20
                },
                end: {
                    line: 29,
                    column: 9
                }
            },
            '10': {
                start: {
                    line: 30,
                    column: 8
                },
                end: {
                    line: 32,
                    column: 9
                }
            },
            '11': {
                start: {
                    line: 31,
                    column: 12
                },
                end: {
                    line: 31,
                    column: 38
                }
            },
            '12': {
                start: {
                    line: 33,
                    column: 8
                },
                end: {
                    line: 33,
                    column: 94
                }
            },
            '13': {
                start: {
                    line: 33,
                    column: 71
                },
                end: {
                    line: 33,
                    column: 92
                }
            },
            '14': {
                start: {
                    line: 34,
                    column: 8
                },
                end: {
                    line: 34,
                    column: 30
                }
            },
            '15': {
                start: {
                    line: 38,
                    column: 0
                },
                end: {
                    line: 46,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 18
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 20,
                        column: 4
                    },
                    end: {
                        line: 20,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 14
                    },
                    end: {
                        line: 23,
                        column: 5
                    }
                },
                line: 20
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 22,
                        column: 35
                    },
                    end: {
                        line: 22,
                        column: 36
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 44
                    },
                    end: {
                        line: 22,
                        column: 66
                    }
                },
                line: 22
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 25,
                        column: 4
                    },
                    end: {
                        line: 25,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 25,
                        column: 38
                    },
                    end: {
                        line: 35,
                        column: 5
                    }
                },
                line: 25
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 33,
                        column: 63
                    },
                    end: {
                        line: 33,
                        column: 64
                    }
                },
                loc: {
                    start: {
                        line: 33,
                        column: 71
                    },
                    end: {
                        line: 33,
                        column: 92
                    }
                },
                line: 33
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 30,
                        column: 8
                    },
                    end: {
                        line: 32,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 30,
                        column: 8
                    },
                    end: {
                        line: 32,
                        column: 9
                    }
                }, {
                    start: {
                        line: 30,
                        column: 8
                    },
                    end: {
                        line: 32,
                        column: 9
                    }
                }],
                line: 30
            },
            '1': {
                loc: {
                    start: {
                        line: 30,
                        column: 12
                    },
                    end: {
                        line: 30,
                        column: 49
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 30,
                        column: 12
                    },
                    end: {
                        line: 30,
                        column: 23
                    }
                }, {
                    start: {
                        line: 30,
                        column: 27
                    },
                    end: {
                        line: 30,
                        column: 49
                    }
                }],
                line: 30
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserProfileController = function () {
    function UserProfileController() {
        _classCallCheck(this, UserProfileController);

        cov_20vzoiqxw9.f[0]++;
        cov_20vzoiqxw9.s[0]++;

        this.sortableListeners = {
            accept: function accept() {
                cov_20vzoiqxw9.s[1]++;

                return true;
            },
            itemMoved: function itemMoved() {},
            orderChanged: function orderChanged(event) {
                var newPos = (cov_20vzoiqxw9.s[2]++, event.dest.index + 1);
                var task = (cov_20vzoiqxw9.s[3]++, event.source.itemScope.task);
                cov_20vzoiqxw9.s[4]++;
                task.order = newPos;

                cov_20vzoiqxw9.s[5]++;
                task.$save(['order']);
            },

            placeholder: '<div style="min-height: 60px;"></div>'
        };
    }

    _createClass(UserProfileController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_20vzoiqxw9.f[1]++;
            cov_20vzoiqxw9.s[6]++;

            this.user.$load('openTasks');
            cov_20vzoiqxw9.s[7]++;
            this.user.$openTasks.$then(function (tasks) {
                cov_20vzoiqxw9.f[2]++;
                cov_20vzoiqxw9.s[8]++;
                return tasks.$load('project');
            });
        }
    }, {
        key: 'createTask',
        value: function createTask(taskName, taskProject) {
            cov_20vzoiqxw9.f[3]++;

            var obj = (cov_20vzoiqxw9.s[9]++, {
                name: taskName,
                user: this.user.id
            });
            cov_20vzoiqxw9.s[10]++;
            if ((cov_20vzoiqxw9.b[1][0]++, taskProject) && (cov_20vzoiqxw9.b[1][1]++, taskProject !== 'None')) {
                cov_20vzoiqxw9.b[0][0]++;
                cov_20vzoiqxw9.s[11]++;

                obj.project = taskProject;
            } else {
                cov_20vzoiqxw9.b[0][1]++;
            }
            cov_20vzoiqxw9.s[12]++;
            this.newTask = this.user.$openTasks.$create(obj).$then(function (task) {
                cov_20vzoiqxw9.f[4]++;
                cov_20vzoiqxw9.s[13]++;
                return task.$load('project');
            });
            cov_20vzoiqxw9.s[14]++;
            this.newTaskName = '';
        }
    }]);

    return UserProfileController;
}();

cov_20vzoiqxw9.s[15]++;


angular.module('app').component('userProfile', {
    templateUrl: 'app/components/userProfile/userProfile.html',
    controller: UserProfileController,
    bindings: {
        user: '<'
    }
});
'use strict';

var cov_1g2us5xtjc = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/tagsList/tagsList.js',
        hash = 'efa9baba19362dbadad6254230bce38ded8131e2',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/tagsList/tagsList.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 53
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 10
                }
            },
            '2': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 9,
                    column: 35
                }
            },
            '3': {
                start: {
                    line: 13,
                    column: 8
                },
                end: {
                    line: 13,
                    column: 24
                }
            },
            '4': {
                start: {
                    line: 17,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 75
                }
            },
            '5': {
                start: {
                    line: 17,
                    column: 54
                },
                end: {
                    line: 17,
                    column: 73
                }
            },
            '6': {
                start: {
                    line: 21,
                    column: 8
                },
                end: {
                    line: 21,
                    column: 41
                }
            },
            '7': {
                start: {
                    line: 25,
                    column: 8
                },
                end: {
                    line: 27,
                    column: 9
                }
            },
            '8': {
                start: {
                    line: 26,
                    column: 12
                },
                end: {
                    line: 26,
                    column: 36
                }
            },
            '9': {
                start: {
                    line: 29,
                    column: 8
                },
                end: {
                    line: 33,
                    column: 9
                }
            },
            '10': {
                start: {
                    line: 30,
                    column: 12
                },
                end: {
                    line: 30,
                    column: 40
                }
            },
            '11': {
                start: {
                    line: 32,
                    column: 12
                },
                end: {
                    line: 32,
                    column: 41
                }
            },
            '12': {
                start: {
                    line: 35,
                    column: 8
                },
                end: {
                    line: 35,
                    column: 24
                }
            },
            '13': {
                start: {
                    line: 39,
                    column: 0
                },
                end: {
                    line: 47,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 36
                    },
                    end: {
                        line: 10,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 12,
                        column: 4
                    },
                    end: {
                        line: 12,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 12,
                        column: 14
                    },
                    end: {
                        line: 14,
                        column: 5
                    }
                },
                line: 12
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 16,
                        column: 4
                    },
                    end: {
                        line: 16,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 16,
                        column: 25
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 16
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 17,
                        column: 47
                    },
                    end: {
                        line: 17,
                        column: 48
                    }
                },
                loc: {
                    start: {
                        line: 17,
                        column: 54
                    },
                    end: {
                        line: 17,
                        column: 73
                    }
                },
                line: 17
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 20,
                        column: 4
                    },
                    end: {
                        line: 20,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 15
                    },
                    end: {
                        line: 22,
                        column: 5
                    }
                },
                line: 20
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 24,
                        column: 4
                    },
                    end: {
                        line: 24,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 33
                    },
                    end: {
                        line: 36,
                        column: 5
                    }
                },
                line: 24
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 25,
                        column: 8
                    },
                    end: {
                        line: 27,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 25,
                        column: 8
                    },
                    end: {
                        line: 27,
                        column: 9
                    }
                }, {
                    start: {
                        line: 25,
                        column: 8
                    },
                    end: {
                        line: 27,
                        column: 9
                    }
                }],
                line: 25
            },
            '1': {
                loc: {
                    start: {
                        line: 29,
                        column: 8
                    },
                    end: {
                        line: 33,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 29,
                        column: 8
                    },
                    end: {
                        line: 33,
                        column: 9
                    }
                }, {
                    start: {
                        line: 29,
                        column: 8
                    },
                    end: {
                        line: 33,
                        column: 9
                    }
                }],
                line: 29
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TagsListController = function () {
    TagsListController.$inject = ["NewTagModalService"];
    function TagsListController(NewTagModalService) {
        _classCallCheck(this, TagsListController);

        cov_1g2us5xtjc.f[0]++;
        cov_1g2us5xtjc.s[0]++;

        this.NewTagModalService = NewTagModalService;
        cov_1g2us5xtjc.s[1]++;
        this.filters = {
            /* eslint-disable camelcase */
            is_industry: true
        };
        cov_1g2us5xtjc.s[2]++;
        this.industryFilter = true;
    }

    _createClass(TagsListController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_1g2us5xtjc.f[1]++;
            cov_1g2us5xtjc.s[3]++;

            this._refresh();
        }
    }, {
        key: 'displayNewTagModal',
        value: function displayNewTagModal() {
            var _this = this;

            cov_1g2us5xtjc.f[2]++;
            cov_1g2us5xtjc.s[4]++;

            this.NewTagModalService.display().then(function (tag) {
                cov_1g2us5xtjc.f[3]++;
                cov_1g2us5xtjc.s[5]++;
                return _this.tags.$add(tag);
            });
        }
    }, {
        key: '_refresh',
        value: function _refresh() {
            cov_1g2us5xtjc.f[4]++;
            cov_1g2us5xtjc.s[6]++;

            this.tags.$refresh(this.filters);
        }
    }, {
        key: 'changeFilters',
        value: function changeFilters(filter, value) {
            cov_1g2us5xtjc.f[5]++;
            cov_1g2us5xtjc.s[7]++;

            if (angular.isArray(value)) {
                cov_1g2us5xtjc.b[0][0]++;
                cov_1g2us5xtjc.s[8]++;

                value = value.join(',');
            } else {
                cov_1g2us5xtjc.b[0][1]++;
            }

            cov_1g2us5xtjc.s[9]++;
            if (value === null) {
                cov_1g2us5xtjc.b[1][0]++;
                cov_1g2us5xtjc.s[10]++;

                delete this.filters[filter];
            } else {
                cov_1g2us5xtjc.b[1][1]++;
                cov_1g2us5xtjc.s[11]++;

                this.filters[filter] = value;
            }

            cov_1g2us5xtjc.s[12]++;
            this._refresh();
        }
    }]);

    return TagsListController;
}();

cov_1g2us5xtjc.s[13]++;


angular.module('app').component('tagsList', {
    templateUrl: 'app/components/tagsList/tagsList.html',
    controller: TagsListController,
    bindings: {
        tags: '<'
    }
});
'use strict';

var cov_vg2hlnwaz = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/tagDetails/tagDetails.js',
        hash = '080b7f9d3a90fdd439feff328ef9ffc0854547bc',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/tagDetails/tagDetails.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 53
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 59
                }
            },
            '2': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 6,
                    column: 55
                }
            },
            '3': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 35
                }
            },
            '4': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 32
                }
            },
            '5': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 129
                }
            },
            '6': {
                start: {
                    line: 13,
                    column: 8
                },
                end: {
                    line: 13,
                    column: 65
                }
            },
            '7': {
                start: {
                    line: 17,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 34
                }
            },
            '8': {
                start: {
                    line: 21,
                    column: 8
                },
                end: {
                    line: 27,
                    column: 11
                }
            },
            '9': {
                start: {
                    line: 25,
                    column: 12
                },
                end: {
                    line: 25,
                    column: 45
                }
            },
            '10': {
                start: {
                    line: 26,
                    column: 12
                },
                end: {
                    line: 26,
                    column: 29
                }
            },
            '11': {
                start: {
                    line: 31,
                    column: 8
                },
                end: {
                    line: 34,
                    column: 14
                }
            },
            '12': {
                start: {
                    line: 33,
                    column: 32
                },
                end: {
                    line: 33,
                    column: 64
                }
            },
            '13': {
                start: {
                    line: 38,
                    column: 8
                },
                end: {
                    line: 43,
                    column: 52
                }
            },
            '14': {
                start: {
                    line: 43,
                    column: 23
                },
                end: {
                    line: 43,
                    column: 50
                }
            },
            '15': {
                start: {
                    line: 47,
                    column: 0
                },
                end: {
                    line: 55,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 80
                    },
                    end: {
                        line: 7,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 9,
                        column: 4
                    },
                    end: {
                        line: 9,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 14
                    },
                    end: {
                        line: 14,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 16,
                        column: 4
                    },
                    end: {
                        line: 16,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 16,
                        column: 16
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 16
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 20,
                        column: 4
                    },
                    end: {
                        line: 20,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 32
                    },
                    end: {
                        line: 28,
                        column: 5
                    }
                },
                line: 20
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 24,
                        column: 17
                    },
                    end: {
                        line: 24,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 23
                    },
                    end: {
                        line: 27,
                        column: 9
                    }
                },
                line: 24
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 30,
                        column: 4
                    },
                    end: {
                        line: 30,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 15
                    },
                    end: {
                        line: 35,
                        column: 5
                    }
                },
                line: 30
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 33,
                        column: 16
                    },
                    end: {
                        line: 33,
                        column: 17
                    }
                },
                loc: {
                    start: {
                        line: 33,
                        column: 32
                    },
                    end: {
                        line: 33,
                        column: 64
                    }
                },
                line: 33
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 37,
                        column: 4
                    },
                    end: {
                        line: 37,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 37,
                        column: 20
                    },
                    end: {
                        line: 44,
                        column: 5
                    }
                },
                line: 37
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 43,
                        column: 17
                    },
                    end: {
                        line: 43,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 43,
                        column: 23
                    },
                    end: {
                        line: 43,
                        column: 50
                    }
                },
                line: 43
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TagDetailsController = function () {
    TagDetailsController.$inject = ["OrganizationsTable", "OrganizationTagsTable", "MunicipalitiesTable"];
    function TagDetailsController(OrganizationsTable, OrganizationTagsTable, MunicipalitiesTable) {
        _classCallCheck(this, TagDetailsController);

        cov_vg2hlnwaz.f[0]++;
        cov_vg2hlnwaz.s[0]++;

        this.OrganizationsTable = OrganizationsTable;
        cov_vg2hlnwaz.s[1]++;
        this.OrganizationTagsTable = OrganizationTagsTable;
        cov_vg2hlnwaz.s[2]++;
        this.MunicipalitiesTable = MunicipalitiesTable;
    }

    _createClass(TagDetailsController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_vg2hlnwaz.f[1]++;
            cov_vg2hlnwaz.s[3]++;

            this.tag.$load('comments');
            cov_vg2hlnwaz.s[4]++;
            this.tag.$load('files');
            cov_vg2hlnwaz.s[5]++;
            this.organizationTags = this.OrganizationTagsTable.$search({ tag: this.tag.id, ordering: '-organization__profile_level' });
            cov_vg2hlnwaz.s[6]++;
            this.municipalities = this.MunicipalitiesTable.$search();
        }
    }, {
        key: 'clearForm',
        value: function clearForm() {
            cov_vg2hlnwaz.f[2]++;
            cov_vg2hlnwaz.s[7]++;

            this.newOrganization = {};
        }
    }, {
        key: 'updateWithTag',
        value: function updateWithTag(organization) {
            var _this = this;

            cov_vg2hlnwaz.f[3]++;
            cov_vg2hlnwaz.s[8]++;

            this.OrganizationTagsTable.$create({
                tag: this.tag.id,
                organization: organization.id
            }).$then(function () {
                cov_vg2hlnwaz.f[4]++;
                cov_vg2hlnwaz.s[9]++;

                _this.organizationTags.$refresh();
                cov_vg2hlnwaz.s[10]++;
                _this.clearForm();
            });
        }
    }, {
        key: 'quickAdd',
        value: function quickAdd() {
            var _this2 = this;

            cov_vg2hlnwaz.f[5]++;
            cov_vg2hlnwaz.s[11]++;

            this.OrganizationsTable.$create(this.newOrganization).$then(function (organization) {
                cov_vg2hlnwaz.f[6]++;
                cov_vg2hlnwaz.s[12]++;
                return _this2.updateWithTag(organization);
            });
        }
    }, {
        key: 'createComment',
        value: function createComment() {
            var _this3 = this;

            cov_vg2hlnwaz.f[7]++;
            cov_vg2hlnwaz.s[13]++;

            this.tag.$comments.$create({
                objectId: this.tag.id,
                objectType: 'INDUSTRY',
                content: this.newCommentContent
                /* eslint-disable no-return-assign */
            }).$then(function () {
                cov_vg2hlnwaz.f[8]++;
                cov_vg2hlnwaz.s[14]++;
                return _this3.newCommentContent = '';
            });
        }
    }]);

    return TagDetailsController;
}();

cov_vg2hlnwaz.s[15]++;


angular.module('app').component('tagDetails', {
    templateUrl: 'app/components/tagDetails/tagDetails.html',
    controller: TagDetailsController,
    bindings: {
        tag: '<'
    }
});
'use strict';

var cov_1cxpa7vte8 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/searchableSelector/searchableSelector.js',
        hash = 'b3d3745384b764644d1f5770cc0613b7f7b6d58e',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/searchableSelector/searchableSelector.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 35
                }
            },
            '1': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 46
                }
            },
            '2': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 9,
                    column: 29
                }
            },
            '3': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 26
                }
            },
            '4': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 56
                }
            },
            '5': {
                start: {
                    line: 15,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 56
                }
            },
            '6': {
                start: {
                    line: 19,
                    column: 8
                },
                end: {
                    line: 19,
                    column: 76
                }
            },
            '7': {
                start: {
                    line: 23,
                    column: 24
                },
                end: {
                    line: 30,
                    column: 43
                }
            },
            '8': {
                start: {
                    line: 32,
                    column: 8
                },
                end: {
                    line: 34,
                    column: 11
                }
            },
            '9': {
                start: {
                    line: 33,
                    column: 12
                },
                end: {
                    line: 33,
                    column: 41
                }
            },
            '10': {
                start: {
                    line: 38,
                    column: 0
                },
                end: {
                    line: 71,
                    column: 7
                }
            },
            '11': {
                start: {
                    line: 54,
                    column: 8
                },
                end: {
                    line: 70,
                    column: 10
                }
            },
            '12': {
                start: {
                    line: 58,
                    column: 16
                },
                end: {
                    line: 68,
                    column: 19
                }
            },
            '13': {
                start: {
                    line: 59,
                    column: 39
                },
                end: {
                    line: 59,
                    column: 46
                }
            },
            '14': {
                start: {
                    line: 60,
                    column: 20
                },
                end: {
                    line: 62,
                    column: 21
                }
            },
            '15': {
                start: {
                    line: 61,
                    column: 24
                },
                end: {
                    line: 61,
                    column: 61
                }
            },
            '16': {
                start: {
                    line: 63,
                    column: 20
                },
                end: {
                    line: 63,
                    column: 62
                }
            },
            '17': {
                start: {
                    line: 65,
                    column: 20
                },
                end: {
                    line: 67,
                    column: 21
                }
            },
            '18': {
                start: {
                    line: 66,
                    column: 24
                },
                end: {
                    line: 66,
                    column: 40
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 27
                    },
                    end: {
                        line: 5,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 7,
                        column: 4
                    },
                    end: {
                        line: 7,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 7,
                        column: 22
                    },
                    end: {
                        line: 12,
                        column: 5
                    }
                },
                line: 7
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 14,
                        column: 4
                    },
                    end: {
                        line: 14,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 23
                    },
                    end: {
                        line: 16,
                        column: 5
                    }
                },
                line: 14
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 18,
                        column: 4
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 18,
                        column: 20
                    },
                    end: {
                        line: 20,
                        column: 5
                    }
                },
                line: 18
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 22,
                        column: 4
                    },
                    end: {
                        line: 22,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 17
                    },
                    end: {
                        line: 35,
                        column: 5
                    }
                },
                line: 22
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 32,
                        column: 42
                    },
                    end: {
                        line: 32,
                        column: 43
                    }
                },
                loc: {
                    start: {
                        line: 32,
                        column: 52
                    },
                    end: {
                        line: 34,
                        column: 9
                    }
                },
                line: 32
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 53,
                        column: 35
                    },
                    end: {
                        line: 53,
                        column: 36
                    }
                },
                loc: {
                    start: {
                        line: 53,
                        column: 47
                    },
                    end: {
                        line: 71,
                        column: 5
                    }
                },
                line: 53
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 58,
                        column: 29
                    },
                    end: {
                        line: 58,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 58,
                        column: 41
                    },
                    end: {
                        line: 64,
                        column: 17
                    }
                },
                line: 58
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 64,
                        column: 19
                    },
                    end: {
                        line: 64,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 64,
                        column: 37
                    },
                    end: {
                        line: 68,
                        column: 17
                    }
                },
                line: 64
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 19,
                        column: 15
                    },
                    end: {
                        line: 19,
                        column: 75
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 19,
                        column: 15
                    },
                    end: {
                        line: 19,
                        column: 35
                    }
                }, {
                    start: {
                        line: 19,
                        column: 39
                    },
                    end: {
                        line: 19,
                        column: 62
                    }
                }, {
                    start: {
                        line: 19,
                        column: 66
                    },
                    end: {
                        line: 19,
                        column: 75
                    }
                }],
                line: 19
            },
            '1': {
                loc: {
                    start: {
                        line: 65,
                        column: 20
                    },
                    end: {
                        line: 67,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 65,
                        column: 20
                    },
                    end: {
                        line: 67,
                        column: 21
                    }
                }, {
                    start: {
                        line: 65,
                        column: 20
                    },
                    end: {
                        line: 67,
                        column: 21
                    }
                }],
                line: 65
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0
        },
        b: {
            '0': [0, 0, 0],
            '1': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SearchableSelectorController = function () {
    SearchableSelectorController.$inject = ["$mdDialog"];
    function SearchableSelectorController($mdDialog) {
        _classCallCheck(this, SearchableSelectorController);

        cov_1cxpa7vte8.f[0]++;
        cov_1cxpa7vte8.s[0]++;

        this.$mdDialog = $mdDialog;
    }

    _createClass(SearchableSelectorController, [{
        key: 'selectItemProxy',
        value: function selectItemProxy() {
            cov_1cxpa7vte8.f[1]++;
            cov_1cxpa7vte8.s[1]++;

            this.selectItem({ item: this.ngModel });
            cov_1cxpa7vte8.s[2]++;
            this.searchText = '';
            cov_1cxpa7vte8.s[3]++;
            this.ngModel = '';
            cov_1cxpa7vte8.s[4]++;
            this.searchItems({ searchText: this.searchText });
        }
    }, {
        key: 'searchItemsProxy',
        value: function searchItemsProxy() {
            cov_1cxpa7vte8.f[2]++;
            cov_1cxpa7vte8.s[5]++;

            this.searchItems({ searchText: this.searchText });
        }
    }, {
        key: 'displayTF',
        value: function displayTF(item) {
            cov_1cxpa7vte8.f[3]++;
            cov_1cxpa7vte8.s[6]++;

            return (cov_1cxpa7vte8.b[0][0]++, this.display({ item: item })) || (cov_1cxpa7vte8.b[0][1]++, item[this.displayField]) || (cov_1cxpa7vte8.b[0][2]++, item.name);
        }
    }, {
        key: 'showDialog',
        value: function showDialog() {
            var _this = this;

            cov_1cxpa7vte8.f[4]++;

            var confirm = (cov_1cxpa7vte8.s[7]++, this.$mdDialog.prompt().title('What is the Individual name?').placeholder('Name').ariaLabel('Name').initialValue('').required(true).ok('Add').cancel('Cancel'));

            cov_1cxpa7vte8.s[8]++;
            this.$mdDialog.show(confirm).then(function (result) {
                cov_1cxpa7vte8.f[5]++;
                cov_1cxpa7vte8.s[9]++;

                _this.addItem({ name: result });
            });
        }
    }]);

    return SearchableSelectorController;
}();

cov_1cxpa7vte8.s[10]++;


angular.module('app').component('searchableSelector', {
    controller: SearchableSelectorController,
    templateUrl: 'app/components/searchableSelector/searchableSelector.html',
    bindings: {
        items: '<',
        selectItem: '&',
        searchItems: '&',
        searchPlaceholder: '@',
        addItem: '&',
        displayField: '@',
        display: '&'
    }
}).directive('forceSelectFocus', function () {
    cov_1cxpa7vte8.f[6]++;
    cov_1cxpa7vte8.s[11]++;

    return {
        restrict: 'A',
        require: ['^^mdSelect', '^ngModel'],
        link: function link(scope, element) {
            cov_1cxpa7vte8.s[12]++;

            scope.$watch(function () {
                cov_1cxpa7vte8.f[7]++;

                var foundElement = (cov_1cxpa7vte8.s[13]++, element);
                cov_1cxpa7vte8.s[14]++;
                while (!foundElement.hasClass('md-select-menu-container')) {
                    cov_1cxpa7vte8.s[15]++;

                    foundElement = foundElement.parent();
                }
                cov_1cxpa7vte8.s[16]++;
                return foundElement.hasClass('md-active');
            }, function (newVal) {
                cov_1cxpa7vte8.f[8]++;
                cov_1cxpa7vte8.s[17]++;

                if (newVal) {
                    cov_1cxpa7vte8.b[1][0]++;
                    cov_1cxpa7vte8.s[18]++;

                    element.focus();
                } else {
                    cov_1cxpa7vte8.b[1][1]++;
                }
            });
        }
    };
});
'use strict';

var cov_185515uukl = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/search/search.js',
        hash = '96a834bde82f2839668508677a4107153d6ae7c0',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/search/search.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 37
                }
            },
            '1': {
                start: {
                    line: 8,
                    column: 0
                },
                end: {
                    line: 16,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 28
                    },
                    end: {
                        line: 5,
                        column: 5
                    }
                },
                line: 3
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0
        },
        f: {
            '0': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SearchController = function SearchController($rootScope) {
    _classCallCheck(this, SearchController);

    cov_185515uukl.f[0]++;
    cov_185515uukl.s[0]++;

    this.$rootScope = $rootScope;
};
SearchController.$inject = ["$rootScope"];

cov_185515uukl.s[1]++;


angular.module('app').component('search', {
    templateUrl: 'app/components/search/search.html',
    controller: SearchController,
    bindings: {
        label: '<'
    }
});
'use strict';

var cov_1wshksmqj1 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/remindersList/remindersList.js',
        hash = 'a7e7840fc5f9b618d59992b2fd8f0ddacc66618e',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/remindersList/remindersList.js',
        statementMap: {
            '0': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 68
                }
            },
            '1': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 9,
                    column: 35
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 68
                }
            },
            '3': {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 11
                }
            },
            '4': {
                start: {
                    line: 21,
                    column: 0
                },
                end: {
                    line: 29,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 13
                    },
                    end: {
                        line: 6,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 8,
                        column: 4
                    },
                    end: {
                        line: 8,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 8,
                        column: 16
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                line: 8
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 13,
                        column: 4
                    },
                    end: {
                        line: 13,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 13,
                        column: 21
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 13
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RemindersListController = function () {
    function RemindersListController() {
        _classCallCheck(this, RemindersListController);
    }

    _createClass(RemindersListController, [{
        key: 'search',
        value: function search() {
            cov_1wshksmqj1.f[0]++;
            cov_1wshksmqj1.s[0]++;

            /* eslint-disable camelcase */
            this.reminders.$refresh({ name__icontains: this.searchText });
        }
    }, {
        key: 'display',
        value: function display(to) {
            cov_1wshksmqj1.f[1]++;
            cov_1wshksmqj1.s[1]++;

            this.reminders.$page += to;
            cov_1wshksmqj1.s[2]++;
            this.reminders.$refresh({ name__icontains: this.searchText });
        }
    }, {
        key: 'createReminder',
        value: function createReminder() {
            cov_1wshksmqj1.f[2]++;
            cov_1wshksmqj1.s[3]++;

            this.reminders.$create({
                name: this.newReminder.name,
                remind_at: this.newReminder.remind_at
            });
        }
    }]);

    return RemindersListController;
}();

cov_1wshksmqj1.s[4]++;


angular.module('app').component('remindersList', {
    templateUrl: 'app/components/remindersList/remindersList.html',
    controller: RemindersListController,
    bindings: {
        reminders: '<'
    }
});
'use strict';

var cov_sb3kca1fb = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/relatedLinks/relatedLinks.js',
        hash = '064976bf2921293dcd5e0f9aacb529e3d6c6103e',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/relatedLinks/relatedLinks.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 37
                }
            },
            '1': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 9
                }
            },
            '2': {
                start: {
                    line: 12,
                    column: 12
                },
                end: {
                    line: 12,
                    column: 41
                }
            },
            '3': {
                start: {
                    line: 14,
                    column: 12
                },
                end: {
                    line: 14,
                    column: 41
                }
            },
            '4': {
                start: {
                    line: 18,
                    column: 8
                },
                end: {
                    line: 18,
                    column: 42
                }
            },
            '5': {
                start: {
                    line: 20,
                    column: 8
                },
                end: {
                    line: 20,
                    column: 42
                }
            },
            '6': {
                start: {
                    line: 21,
                    column: 8
                },
                end: {
                    line: 21,
                    column: 24
                }
            },
            '7': {
                start: {
                    line: 25,
                    column: 21
                },
                end: {
                    line: 25,
                    column: 46
                }
            },
            '8': {
                start: {
                    line: 26,
                    column: 25
                },
                end: {
                    line: 26,
                    column: 42
                }
            },
            '9': {
                start: {
                    line: 27,
                    column: 23
                },
                end: {
                    line: 27,
                    column: 38
                }
            },
            '10': {
                start: {
                    line: 30,
                    column: 8
                },
                end: {
                    line: 32,
                    column: 9
                }
            },
            '11': {
                start: {
                    line: 31,
                    column: 12
                },
                end: {
                    line: 31,
                    column: 71
                }
            },
            '12': {
                start: {
                    line: 33,
                    column: 8
                },
                end: {
                    line: 33,
                    column: 22
                }
            },
            '13': {
                start: {
                    line: 37,
                    column: 8
                },
                end: {
                    line: 41,
                    column: 9
                }
            },
            '14': {
                start: {
                    line: 38,
                    column: 12
                },
                end: {
                    line: 38,
                    column: 46
                }
            },
            '15': {
                start: {
                    line: 40,
                    column: 12
                },
                end: {
                    line: 40,
                    column: 40
                }
            },
            '16': {
                start: {
                    line: 45,
                    column: 8
                },
                end: {
                    line: 45,
                    column: 29
                }
            },
            '17': {
                start: {
                    line: 46,
                    column: 8
                },
                end: {
                    line: 46,
                    column: 36
                }
            },
            '18': {
                start: {
                    line: 47,
                    column: 8
                },
                end: {
                    line: 47,
                    column: 37
                }
            },
            '19': {
                start: {
                    line: 51,
                    column: 8
                },
                end: {
                    line: 55,
                    column: 50
                }
            },
            '20': {
                start: {
                    line: 55,
                    column: 23
                },
                end: {
                    line: 55,
                    column: 48
                }
            },
            '21': {
                start: {
                    line: 59,
                    column: 23
                },
                end: {
                    line: 59,
                    column: 54
                }
            },
            '22': {
                start: {
                    line: 60,
                    column: 8
                },
                end: {
                    line: 60,
                    column: 84
                }
            },
            '23': {
                start: {
                    line: 60,
                    column: 56
                },
                end: {
                    line: 60,
                    column: 82
                }
            },
            '24': {
                start: {
                    line: 64,
                    column: 0
                },
                end: {
                    line: 74,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 14
                    },
                    end: {
                        line: 5,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 7,
                        column: 4
                    },
                    end: {
                        line: 7,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 7,
                        column: 25
                    },
                    end: {
                        line: 22,
                        column: 5
                    }
                },
                line: 7
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 24,
                        column: 4
                    },
                    end: {
                        line: 24,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 27
                    },
                    end: {
                        line: 34,
                        column: 5
                    }
                },
                line: 24
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 36,
                        column: 4
                    },
                    end: {
                        line: 36,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 36,
                        column: 26
                    },
                    end: {
                        line: 42,
                        column: 5
                    }
                },
                line: 36
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 44,
                        column: 4
                    },
                    end: {
                        line: 44,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 44,
                        column: 25
                    },
                    end: {
                        line: 48,
                        column: 5
                    }
                },
                line: 44
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 50,
                        column: 4
                    },
                    end: {
                        line: 50,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 50,
                        column: 37
                    },
                    end: {
                        line: 56,
                        column: 5
                    }
                },
                line: 50
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 55,
                        column: 17
                    },
                    end: {
                        line: 55,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 55,
                        column: 23
                    },
                    end: {
                        line: 55,
                        column: 48
                    }
                },
                line: 55
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 58,
                        column: 4
                    },
                    end: {
                        line: 58,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 58,
                        column: 32
                    },
                    end: {
                        line: 61,
                        column: 5
                    }
                },
                line: 58
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 60,
                        column: 48
                    },
                    end: {
                        line: 60,
                        column: 49
                    }
                },
                loc: {
                    start: {
                        line: 60,
                        column: 56
                    },
                    end: {
                        line: 60,
                        column: 82
                    }
                },
                line: 60
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 11,
                        column: 8
                    },
                    end: {
                        line: 15,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 11,
                        column: 8
                    },
                    end: {
                        line: 15,
                        column: 9
                    }
                }, {
                    start: {
                        line: 11,
                        column: 8
                    },
                    end: {
                        line: 15,
                        column: 9
                    }
                }],
                line: 11
            },
            '1': {
                loc: {
                    start: {
                        line: 30,
                        column: 8
                    },
                    end: {
                        line: 32,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 30,
                        column: 8
                    },
                    end: {
                        line: 32,
                        column: 9
                    }
                }, {
                    start: {
                        line: 30,
                        column: 8
                    },
                    end: {
                        line: 32,
                        column: 9
                    }
                }],
                line: 30
            },
            '2': {
                loc: {
                    start: {
                        line: 37,
                        column: 8
                    },
                    end: {
                        line: 41,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 37,
                        column: 8
                    },
                    end: {
                        line: 41,
                        column: 9
                    }
                }, {
                    start: {
                        line: 37,
                        column: 8
                    },
                    end: {
                        line: 41,
                        column: 9
                    }
                }],
                line: 37
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RelatedLinksController = function () {
    function RelatedLinksController() {
        _classCallCheck(this, RelatedLinksController);
    }

    _createClass(RelatedLinksController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_sb3kca1fb.f[0]++;
            cov_sb3kca1fb.s[0]++;

            this.links.$load('category');
        }
    }, {
        key: 'extractHostname',
        value: function extractHostname(url) {
            cov_sb3kca1fb.f[1]++;

            var hostname = void 0;
            // find & remove protocol (http, ftp, etc.) and get hostname

            cov_sb3kca1fb.s[1]++;
            if (url.indexOf("://") > -1) {
                cov_sb3kca1fb.b[0][0]++;
                cov_sb3kca1fb.s[2]++;

                hostname = url.split('/')[2];
            } else {
                cov_sb3kca1fb.b[0][1]++;
                cov_sb3kca1fb.s[3]++;

                hostname = url.split('/')[0];
            }

            // find & remove port number
            cov_sb3kca1fb.s[4]++;
            hostname = hostname.split(':')[0];
            // find & remove "?"
            cov_sb3kca1fb.s[5]++;
            hostname = hostname.split('?')[0];
            cov_sb3kca1fb.s[6]++;
            return hostname;
        }
    }, {
        key: 'extractRootDomain',
        value: function extractRootDomain(url) {
            cov_sb3kca1fb.f[2]++;

            var domain = (cov_sb3kca1fb.s[7]++, this.extractHostname(url));
            var splitArr = (cov_sb3kca1fb.s[8]++, domain.split('.'));
            var arrLen = (cov_sb3kca1fb.s[9]++, splitArr.length);

            // extracting the root domain here
            cov_sb3kca1fb.s[10]++;
            if (arrLen > 2) {
                cov_sb3kca1fb.b[1][0]++;
                cov_sb3kca1fb.s[11]++;

                domain = splitArr[arrLen - 2] + '.' + splitArr[arrLen - 1];
            } else {
                cov_sb3kca1fb.b[1][1]++;
            }
            cov_sb3kca1fb.s[12]++;
            return domain;
        }
    }, {
        key: 'setCategoryLink',
        value: function setCategoryLink(data) {
            cov_sb3kca1fb.f[3]++;
            cov_sb3kca1fb.s[13]++;

            if (data.length === 1) {
                cov_sb3kca1fb.b[2][0]++;
                cov_sb3kca1fb.s[14]++;

                this.newLinkCategory = data[0].id;
            } else {
                cov_sb3kca1fb.b[2][1]++;
                cov_sb3kca1fb.s[15]++;

                this.newLinkCategory = null;
            }
        }
    }, {
        key: 'reloadAndclearForm',
        value: function reloadAndclearForm() {
            cov_sb3kca1fb.f[4]++;
            cov_sb3kca1fb.s[16]++;

            this.newLinkUrl = '';
            cov_sb3kca1fb.s[17]++;
            this.newLinkCategory = null;
            cov_sb3kca1fb.s[18]++;
            this.links.$load('category');
        }
    }, {
        key: 'createNewLink',
        value: function createNewLink(category, newLink) {
            var _this = this;

            cov_sb3kca1fb.f[5]++;
            cov_sb3kca1fb.s[19]++;

            this.links.$create({
                organization: this.organization.id,
                category: category,
                link: newLink
            }).$then(function () {
                cov_sb3kca1fb.f[6]++;
                cov_sb3kca1fb.s[20]++;
                return _this.reloadAndclearForm();
            });
        }
    }, {
        key: 'autoSelectCategory',
        value: function autoSelectCategory(newLink) {
            var _this2 = this;

            cov_sb3kca1fb.f[7]++;

            var domain = (cov_sb3kca1fb.s[21]++, this.extractRootDomain(newLink));
            cov_sb3kca1fb.s[22]++;
            this.categories.$search({ domain: domain }).$then(function (data) {
                cov_sb3kca1fb.f[8]++;
                cov_sb3kca1fb.s[23]++;
                return _this2.setCategoryLink(data);
            });
        }
    }]);

    return RelatedLinksController;
}();

cov_sb3kca1fb.s[24]++;


angular.module('app').component('relatedLinks', {
    templateUrl: 'app/components/relatedLinks/relatedLinks.html',
    controller: RelatedLinksController,
    bindings: {
        organization: '<',
        links: '<',
        categories: '<'
    }
});
'use strict';

var cov_qahatxbtd = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/rankings/rankings.js',
        hash = 'f52931c8f36778e224f56facbfa9fd39ad8298d9',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/rankings/rankings.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 43
                }
            },
            '1': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 44
                }
            },
            '2': {
                start: {
                    line: 12,
                    column: 27
                },
                end: {
                    line: 19,
                    column: 9
                }
            },
            '3': {
                start: {
                    line: 20,
                    column: 8
                },
                end: {
                    line: 20,
                    column: 45
                }
            },
            '4': {
                start: {
                    line: 24,
                    column: 0
                },
                end: {
                    line: 32,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 31
                    },
                    end: {
                        line: 5,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 7,
                        column: 4
                    },
                    end: {
                        line: 7,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 7,
                        column: 14
                    },
                    end: {
                        line: 9,
                        column: 5
                    }
                },
                line: 7
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 11,
                        column: 4
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 29
                    },
                    end: {
                        line: 21,
                        column: 5
                    }
                },
                line: 11
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RankingsController = function () {
    RankingsController.$inject = ["RankingsTable"];
    function RankingsController(RankingsTable) {
        _classCallCheck(this, RankingsController);

        cov_qahatxbtd.f[0]++;
        cov_qahatxbtd.s[0]++;

        this.RankingsTable = RankingsTable;
    }

    _createClass(RankingsController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_qahatxbtd.f[1]++;
            cov_qahatxbtd.s[1]++;

            this.organization.$load('rankings');
        }
    }, {
        key: 'indicatorAbbrev',
        value: function indicatorAbbrev(ranking) {
            cov_qahatxbtd.f[2]++;

            var indicators = (cov_qahatxbtd.s[2]++, {
                TURNOVER: 'T',
                INCOME: 'I',
                RAW_SIZE: 'S',
                RAW_TURNOVER_PER_RAW_SIZE: 'TS',
                RAW_INCOME_PER_RAW_SIZE: 'IS',
                RAW_INCOME_PER_RAW_TURNOVER: 'IT'
            });
            cov_qahatxbtd.s[3]++;
            return indicators[ranking.indicator];
        }
    }]);

    return RankingsController;
}();

cov_qahatxbtd.s[4]++;


angular.module('app').component('rankings', {
    templateUrl: 'app/components/rankings/rankings.html',
    controller: RankingsController,
    bindings: {
        organization: '<'
    }
});
'use strict';

var cov_2mb0e4p6ud = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/proposalsList/proposalsList.js',
        hash = 'aa97274bb4702aaa019e0619636d5bf8c39a6341',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/proposalsList/proposalsList.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 39
                }
            },
            '1': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 63
                }
            },
            '2': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 9,
                    column: 53
                }
            },
            '3': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 33
                }
            },
            '4': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 52
                }
            },
            '5': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 27
                }
            },
            '6': {
                start: {
                    line: 13,
                    column: 8
                },
                end: {
                    line: 13,
                    column: 32
                }
            },
            '7': {
                start: {
                    line: 15,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 77
                }
            },
            '8': {
                start: {
                    line: 18,
                    column: 8
                },
                end: {
                    line: 21,
                    column: 11
                }
            },
            '9': {
                start: {
                    line: 19,
                    column: 12
                },
                end: {
                    line: 19,
                    column: 40
                }
            },
            '10': {
                start: {
                    line: 20,
                    column: 12
                },
                end: {
                    line: 20,
                    column: 26
                }
            },
            '11': {
                start: {
                    line: 23,
                    column: 8
                },
                end: {
                    line: 26,
                    column: 11
                }
            },
            '12': {
                start: {
                    line: 24,
                    column: 12
                },
                end: {
                    line: 24,
                    column: 48
                }
            },
            '13': {
                start: {
                    line: 25,
                    column: 12
                },
                end: {
                    line: 25,
                    column: 26
                }
            },
            '14': {
                start: {
                    line: 28,
                    column: 8
                },
                end: {
                    line: 32,
                    column: 11
                }
            },
            '15': {
                start: {
                    line: 30,
                    column: 12
                },
                end: {
                    line: 30,
                    column: 55
                }
            },
            '16': {
                start: {
                    line: 31,
                    column: 12
                },
                end: {
                    line: 31,
                    column: 26
                }
            },
            '17': {
                start: {
                    line: 36,
                    column: 8
                },
                end: {
                    line: 36,
                    column: 50
                }
            },
            '18': {
                start: {
                    line: 37,
                    column: 8
                },
                end: {
                    line: 37,
                    column: 39
                }
            },
            '19': {
                start: {
                    line: 41,
                    column: 8
                },
                end: {
                    line: 43,
                    column: 11
                }
            },
            '20': {
                start: {
                    line: 42,
                    column: 12
                },
                end: {
                    line: 42,
                    column: 42
                }
            },
            '21': {
                start: {
                    line: 47,
                    column: 8
                },
                end: {
                    line: 54,
                    column: 9
                }
            },
            '22': {
                start: {
                    line: 48,
                    column: 12
                },
                end: {
                    line: 48,
                    column: 69
                }
            },
            '23': {
                start: {
                    line: 49,
                    column: 12
                },
                end: {
                    line: 51,
                    column: 13
                }
            },
            '24': {
                start: {
                    line: 50,
                    column: 16
                },
                end: {
                    line: 50,
                    column: 40
                }
            },
            '25': {
                start: {
                    line: 53,
                    column: 12
                },
                end: {
                    line: 53,
                    column: 41
                }
            },
            '26': {
                start: {
                    line: 58,
                    column: 8
                },
                end: {
                    line: 58,
                    column: 54
                }
            },
            '27': {
                start: {
                    line: 62,
                    column: 8
                },
                end: {
                    line: 62,
                    column: 43
                }
            },
            '28': {
                start: {
                    line: 63,
                    column: 8
                },
                end: {
                    line: 71,
                    column: 9
                }
            },
            '29': {
                start: {
                    line: 64,
                    column: 12
                },
                end: {
                    line: 68,
                    column: 15
                }
            },
            '30': {
                start: {
                    line: 65,
                    column: 16
                },
                end: {
                    line: 67,
                    column: 17
                }
            },
            '31': {
                start: {
                    line: 66,
                    column: 20
                },
                end: {
                    line: 66,
                    column: 49
                }
            },
            '32': {
                start: {
                    line: 70,
                    column: 12
                },
                end: {
                    line: 70,
                    column: 31
                }
            },
            '33': {
                start: {
                    line: 75,
                    column: 8
                },
                end: {
                    line: 75,
                    column: 25
                }
            },
            '34': {
                start: {
                    line: 76,
                    column: 8
                },
                end: {
                    line: 90,
                    column: 9
                }
            },
            '35': {
                start: {
                    line: 77,
                    column: 12
                },
                end: {
                    line: 83,
                    column: 15
                }
            },
            '36': {
                start: {
                    line: 78,
                    column: 16
                },
                end: {
                    line: 78,
                    column: 39
                }
            },
            '37': {
                start: {
                    line: 79,
                    column: 16
                },
                end: {
                    line: 81,
                    column: 19
                }
            },
            '38': {
                start: {
                    line: 80,
                    column: 20
                },
                end: {
                    line: 80,
                    column: 38
                }
            },
            '39': {
                start: {
                    line: 82,
                    column: 16
                },
                end: {
                    line: 82,
                    column: 34
                }
            },
            '40': {
                start: {
                    line: 84,
                    column: 12
                },
                end: {
                    line: 86,
                    column: 13
                }
            },
            '41': {
                start: {
                    line: 85,
                    column: 16
                },
                end: {
                    line: 85,
                    column: 40
                }
            },
            '42': {
                start: {
                    line: 87,
                    column: 12
                },
                end: {
                    line: 87,
                    column: 31
                }
            },
            '43': {
                start: {
                    line: 88,
                    column: 12
                },
                end: {
                    line: 88,
                    column: 101
                }
            },
            '44': {
                start: {
                    line: 89,
                    column: 12
                },
                end: {
                    line: 89,
                    column: 97
                }
            },
            '45': {
                start: {
                    line: 94,
                    column: 8
                },
                end: {
                    line: 94,
                    column: 25
                }
            },
            '46': {
                start: {
                    line: 95,
                    column: 8
                },
                end: {
                    line: 95,
                    column: 27
                }
            },
            '47': {
                start: {
                    line: 96,
                    column: 8
                },
                end: {
                    line: 101,
                    column: 9
                }
            },
            '48': {
                start: {
                    line: 97,
                    column: 12
                },
                end: {
                    line: 97,
                    column: 46
                }
            },
            '49': {
                start: {
                    line: 98,
                    column: 12
                },
                end: {
                    line: 100,
                    column: 15
                }
            },
            '50': {
                start: {
                    line: 99,
                    column: 16
                },
                end: {
                    line: 99,
                    column: 46
                }
            },
            '51': {
                start: {
                    line: 102,
                    column: 8
                },
                end: {
                    line: 107,
                    column: 9
                }
            },
            '52': {
                start: {
                    line: 103,
                    column: 12
                },
                end: {
                    line: 103,
                    column: 47
                }
            },
            '53': {
                start: {
                    line: 104,
                    column: 12
                },
                end: {
                    line: 106,
                    column: 15
                }
            },
            '54': {
                start: {
                    line: 105,
                    column: 16
                },
                end: {
                    line: 105,
                    column: 46
                }
            },
            '55': {
                start: {
                    line: 111,
                    column: 8
                },
                end: {
                    line: 111,
                    column: 28
                }
            },
            '56': {
                start: {
                    line: 112,
                    column: 8
                },
                end: {
                    line: 123,
                    column: 11
                }
            },
            '57': {
                start: {
                    line: 113,
                    column: 12
                },
                end: {
                    line: 113,
                    column: 32
                }
            },
            '58': {
                start: {
                    line: 114,
                    column: 12
                },
                end: {
                    line: 116,
                    column: 13
                }
            },
            '59': {
                start: {
                    line: 115,
                    column: 16
                },
                end: {
                    line: 115,
                    column: 50
                }
            },
            '60': {
                start: {
                    line: 118,
                    column: 12
                },
                end: {
                    line: 118,
                    column: 30
                }
            },
            '61': {
                start: {
                    line: 119,
                    column: 12
                },
                end: {
                    line: 119,
                    column: 32
                }
            },
            '62': {
                start: {
                    line: 120,
                    column: 12
                },
                end: {
                    line: 122,
                    column: 13
                }
            },
            '63': {
                start: {
                    line: 121,
                    column: 16
                },
                end: {
                    line: 121,
                    column: 50
                }
            },
            '64': {
                start: {
                    line: 127,
                    column: 8
                },
                end: {
                    line: 127,
                    column: 27
                }
            },
            '65': {
                start: {
                    line: 128,
                    column: 8
                },
                end: {
                    line: 130,
                    column: 9
                }
            },
            '66': {
                start: {
                    line: 129,
                    column: 12
                },
                end: {
                    line: 129,
                    column: 36
                }
            },
            '67': {
                start: {
                    line: 131,
                    column: 8
                },
                end: {
                    line: 131,
                    column: 34
                }
            },
            '68': {
                start: {
                    line: 132,
                    column: 8
                },
                end: {
                    line: 132,
                    column: 67
                }
            },
            '69': {
                start: {
                    line: 133,
                    column: 8
                },
                end: {
                    line: 133,
                    column: 93
                }
            },
            '70': {
                start: {
                    line: 137,
                    column: 0
                },
                end: {
                    line: 145,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 14
                    },
                    end: {
                        line: 5,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 7,
                        column: 4
                    },
                    end: {
                        line: 7,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 7,
                        column: 96
                    },
                    end: {
                        line: 33,
                        column: 5
                    }
                },
                line: 7
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 18,
                        column: 38
                    },
                    end: {
                        line: 18,
                        column: 39
                    }
                },
                loc: {
                    start: {
                        line: 18,
                        column: 55
                    },
                    end: {
                        line: 21,
                        column: 9
                    }
                },
                line: 18
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 23,
                        column: 39
                    },
                    end: {
                        line: 23,
                        column: 40
                    }
                },
                loc: {
                    start: {
                        line: 23,
                        column: 56
                    },
                    end: {
                        line: 26,
                        column: 9
                    }
                },
                line: 23
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 28,
                        column: 37
                    },
                    end: {
                        line: 28,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 28,
                        column: 54
                    },
                    end: {
                        line: 32,
                        column: 9
                    }
                },
                line: 28
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 35,
                        column: 4
                    },
                    end: {
                        line: 35,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 35,
                        column: 13
                    },
                    end: {
                        line: 38,
                        column: 5
                    }
                },
                line: 35
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 40,
                        column: 4
                    },
                    end: {
                        line: 40,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 40,
                        column: 30
                    },
                    end: {
                        line: 44,
                        column: 5
                    }
                },
                line: 40
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 41,
                        column: 52
                    },
                    end: {
                        line: 41,
                        column: 53
                    }
                },
                loc: {
                    start: {
                        line: 41,
                        column: 64
                    },
                    end: {
                        line: 43,
                        column: 9
                    }
                },
                line: 41
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 46,
                        column: 4
                    },
                    end: {
                        line: 46,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 46,
                        column: 28
                    },
                    end: {
                        line: 55,
                        column: 5
                    }
                },
                line: 46
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 57,
                        column: 4
                    },
                    end: {
                        line: 57,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 57,
                        column: 29
                    },
                    end: {
                        line: 59,
                        column: 5
                    }
                },
                line: 57
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 61,
                        column: 4
                    },
                    end: {
                        line: 61,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 61,
                        column: 24
                    },
                    end: {
                        line: 72,
                        column: 5
                    }
                },
                line: 61
            },
            '11': {
                name: '(anonymous_11)',
                decl: {
                    start: {
                        line: 64,
                        column: 30
                    },
                    end: {
                        line: 64,
                        column: 31
                    }
                },
                loc: {
                    start: {
                        line: 64,
                        column: 42
                    },
                    end: {
                        line: 68,
                        column: 13
                    }
                },
                line: 64
            },
            '12': {
                name: '(anonymous_12)',
                decl: {
                    start: {
                        line: 74,
                        column: 4
                    },
                    end: {
                        line: 74,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 74,
                        column: 27
                    },
                    end: {
                        line: 91,
                        column: 5
                    }
                },
                line: 74
            },
            '13': {
                name: '(anonymous_13)',
                decl: {
                    start: {
                        line: 77,
                        column: 34
                    },
                    end: {
                        line: 77,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 77,
                        column: 46
                    },
                    end: {
                        line: 83,
                        column: 13
                    }
                },
                line: 77
            },
            '14': {
                name: '(anonymous_14)',
                decl: {
                    start: {
                        line: 79,
                        column: 48
                    },
                    end: {
                        line: 79,
                        column: 49
                    }
                },
                loc: {
                    start: {
                        line: 79,
                        column: 60
                    },
                    end: {
                        line: 81,
                        column: 17
                    }
                },
                line: 79
            },
            '15': {
                name: '(anonymous_15)',
                decl: {
                    start: {
                        line: 93,
                        column: 4
                    },
                    end: {
                        line: 93,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 93,
                        column: 28
                    },
                    end: {
                        line: 108,
                        column: 5
                    }
                },
                line: 93
            },
            '16': {
                name: '(anonymous_16)',
                decl: {
                    start: {
                        line: 98,
                        column: 34
                    },
                    end: {
                        line: 98,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 98,
                        column: 46
                    },
                    end: {
                        line: 100,
                        column: 13
                    }
                },
                line: 98
            },
            '17': {
                name: '(anonymous_17)',
                decl: {
                    start: {
                        line: 104,
                        column: 35
                    },
                    end: {
                        line: 104,
                        column: 36
                    }
                },
                loc: {
                    start: {
                        line: 104,
                        column: 47
                    },
                    end: {
                        line: 106,
                        column: 13
                    }
                },
                line: 104
            },
            '18': {
                name: '(anonymous_18)',
                decl: {
                    start: {
                        line: 110,
                        column: 4
                    },
                    end: {
                        line: 110,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 110,
                        column: 29
                    },
                    end: {
                        line: 124,
                        column: 5
                    }
                },
                line: 110
            },
            '19': {
                name: '(anonymous_19)',
                decl: {
                    start: {
                        line: 112,
                        column: 32
                    },
                    end: {
                        line: 112,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 112,
                        column: 38
                    },
                    end: {
                        line: 117,
                        column: 9
                    }
                },
                line: 112
            },
            '20': {
                name: '(anonymous_20)',
                decl: {
                    start: {
                        line: 117,
                        column: 11
                    },
                    end: {
                        line: 117,
                        column: 12
                    }
                },
                loc: {
                    start: {
                        line: 117,
                        column: 17
                    },
                    end: {
                        line: 123,
                        column: 9
                    }
                },
                line: 117
            },
            '21': {
                name: '(anonymous_21)',
                decl: {
                    start: {
                        line: 126,
                        column: 4
                    },
                    end: {
                        line: 126,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 126,
                        column: 28
                    },
                    end: {
                        line: 134,
                        column: 5
                    }
                },
                line: 126
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 47,
                        column: 8
                    },
                    end: {
                        line: 54,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 47,
                        column: 8
                    },
                    end: {
                        line: 54,
                        column: 9
                    }
                }, {
                    start: {
                        line: 47,
                        column: 8
                    },
                    end: {
                        line: 54,
                        column: 9
                    }
                }],
                line: 47
            },
            '1': {
                loc: {
                    start: {
                        line: 49,
                        column: 12
                    },
                    end: {
                        line: 51,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 49,
                        column: 12
                    },
                    end: {
                        line: 51,
                        column: 13
                    }
                }, {
                    start: {
                        line: 49,
                        column: 12
                    },
                    end: {
                        line: 51,
                        column: 13
                    }
                }],
                line: 49
            },
            '2': {
                loc: {
                    start: {
                        line: 63,
                        column: 8
                    },
                    end: {
                        line: 71,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 63,
                        column: 8
                    },
                    end: {
                        line: 71,
                        column: 9
                    }
                }, {
                    start: {
                        line: 63,
                        column: 8
                    },
                    end: {
                        line: 71,
                        column: 9
                    }
                }],
                line: 63
            },
            '3': {
                loc: {
                    start: {
                        line: 65,
                        column: 16
                    },
                    end: {
                        line: 67,
                        column: 17
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 65,
                        column: 16
                    },
                    end: {
                        line: 67,
                        column: 17
                    }
                }, {
                    start: {
                        line: 65,
                        column: 16
                    },
                    end: {
                        line: 67,
                        column: 17
                    }
                }],
                line: 65
            },
            '4': {
                loc: {
                    start: {
                        line: 76,
                        column: 8
                    },
                    end: {
                        line: 90,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 76,
                        column: 8
                    },
                    end: {
                        line: 90,
                        column: 9
                    }
                }, {
                    start: {
                        line: 76,
                        column: 8
                    },
                    end: {
                        line: 90,
                        column: 9
                    }
                }],
                line: 76
            },
            '5': {
                loc: {
                    start: {
                        line: 84,
                        column: 12
                    },
                    end: {
                        line: 86,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 84,
                        column: 12
                    },
                    end: {
                        line: 86,
                        column: 13
                    }
                }, {
                    start: {
                        line: 84,
                        column: 12
                    },
                    end: {
                        line: 86,
                        column: 13
                    }
                }],
                line: 84
            },
            '6': {
                loc: {
                    start: {
                        line: 96,
                        column: 8
                    },
                    end: {
                        line: 101,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 96,
                        column: 8
                    },
                    end: {
                        line: 101,
                        column: 9
                    }
                }, {
                    start: {
                        line: 96,
                        column: 8
                    },
                    end: {
                        line: 101,
                        column: 9
                    }
                }],
                line: 96
            },
            '7': {
                loc: {
                    start: {
                        line: 102,
                        column: 8
                    },
                    end: {
                        line: 107,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 102,
                        column: 8
                    },
                    end: {
                        line: 107,
                        column: 9
                    }
                }, {
                    start: {
                        line: 102,
                        column: 8
                    },
                    end: {
                        line: 107,
                        column: 9
                    }
                }],
                line: 102
            },
            '8': {
                loc: {
                    start: {
                        line: 114,
                        column: 12
                    },
                    end: {
                        line: 116,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 114,
                        column: 12
                    },
                    end: {
                        line: 116,
                        column: 13
                    }
                }, {
                    start: {
                        line: 114,
                        column: 12
                    },
                    end: {
                        line: 116,
                        column: 13
                    }
                }],
                line: 114
            },
            '9': {
                loc: {
                    start: {
                        line: 120,
                        column: 12
                    },
                    end: {
                        line: 122,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 120,
                        column: 12
                    },
                    end: {
                        line: 122,
                        column: 13
                    }
                }, {
                    start: {
                        line: 120,
                        column: 12
                    },
                    end: {
                        line: 122,
                        column: 13
                    }
                }],
                line: 120
            },
            '10': {
                loc: {
                    start: {
                        line: 128,
                        column: 8
                    },
                    end: {
                        line: 130,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 128,
                        column: 8
                    },
                    end: {
                        line: 130,
                        column: 9
                    }
                }, {
                    start: {
                        line: 128,
                        column: 8
                    },
                    end: {
                        line: 130,
                        column: 9
                    }
                }],
                line: 128
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0,
            '30': 0,
            '31': 0,
            '32': 0,
            '33': 0,
            '34': 0,
            '35': 0,
            '36': 0,
            '37': 0,
            '38': 0,
            '39': 0,
            '40': 0,
            '41': 0,
            '42': 0,
            '43': 0,
            '44': 0,
            '45': 0,
            '46': 0,
            '47': 0,
            '48': 0,
            '49': 0,
            '50': 0,
            '51': 0,
            '52': 0,
            '53': 0,
            '54': 0,
            '55': 0,
            '56': 0,
            '57': 0,
            '58': 0,
            '59': 0,
            '60': 0,
            '61': 0,
            '62': 0,
            '63': 0,
            '64': 0,
            '65': 0,
            '66': 0,
            '67': 0,
            '68': 0,
            '69': 0,
            '70': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0],
            '3': [0, 0],
            '4': [0, 0],
            '5': [0, 0],
            '6': [0, 0],
            '7': [0, 0],
            '8': [0, 0],
            '9': [0, 0],
            '10': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProposalsListController = function () {
    ProposalsListController.$inject = ["NewProposalModalService", "OrganizationsTable", "AppSettings", "$rootScope", "$mdToast"];
    _createClass(ProposalsListController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_2mb0e4p6ud.f[0]++;
            cov_2mb0e4p6ud.s[0]++;

            this.proposals.$load('client');
        }
    }]);

    function ProposalsListController(NewProposalModalService, OrganizationsTable, AppSettings, $rootScope, $mdToast) {
        var _this = this;

        _classCallCheck(this, ProposalsListController);

        cov_2mb0e4p6ud.f[1]++;
        cov_2mb0e4p6ud.s[1]++;

        this.NewProposalModalService = NewProposalModalService;
        cov_2mb0e4p6ud.s[2]++;
        this.proposalsApp = AppSettings.proposalsApp;
        cov_2mb0e4p6ud.s[3]++;
        this.$mdToast = $mdToast;
        cov_2mb0e4p6ud.s[4]++;
        this.clients = OrganizationsTable.$search();
        cov_2mb0e4p6ud.s[5]++;
        this.selected = [];
        cov_2mb0e4p6ud.s[6]++;
        this.allChecked = false;
        /* eslint-disable angular/document-service */
        cov_2mb0e4p6ud.s[7]++;
        this.el = angular.element(document.getElementById('list-proposals'));

        // eslint-disable-next-line angular/on-watch
        cov_2mb0e4p6ud.s[8]++;
        $rootScope.$on('pageChanged', function (event, data) {
            cov_2mb0e4p6ud.f[2]++;
            cov_2mb0e4p6ud.s[9]++;

            _this.proposals.$page = data;
            cov_2mb0e4p6ud.s[10]++;
            _this.update();
        });
        // eslint-disable-next-line angular/on-watch
        cov_2mb0e4p6ud.s[11]++;
        $rootScope.$on('orderChanged', function (event, data) {
            cov_2mb0e4p6ud.f[3]++;
            cov_2mb0e4p6ud.s[12]++;

            _this.requestData = { ordering: data };
            cov_2mb0e4p6ud.s[13]++;
            _this.update();
        });
        // eslint-disable-next-line angular/on-watch
        cov_2mb0e4p6ud.s[14]++;
        $rootScope.$on('searchText', function (event, data) {
            cov_2mb0e4p6ud.f[4]++;
            cov_2mb0e4p6ud.s[15]++;

            // eslint-disable-next-line camelcase
            _this.requestData = { name__icontains: data };
            cov_2mb0e4p6ud.s[16]++;
            _this.update();
        });
    }

    _createClass(ProposalsListController, [{
        key: 'update',
        value: function update() {
            cov_2mb0e4p6ud.f[5]++;
            cov_2mb0e4p6ud.s[17]++;

            this.proposals.$refresh(this.requestData);
            cov_2mb0e4p6ud.s[18]++;
            this.proposals.$load('client');
        }
    }, {
        key: 'displayNewProposalModal',
        value: function displayNewProposalModal() {
            var _this2 = this;

            cov_2mb0e4p6ud.f[6]++;
            cov_2mb0e4p6ud.s[19]++;

            this.NewProposalModalService.display().then(function (proposal) {
                cov_2mb0e4p6ud.f[7]++;
                cov_2mb0e4p6ud.s[20]++;

                _this2.proposals.$add(proposal);
            });
        }
    }, {
        key: 'checkProposal',
        value: function checkProposal(proposal) {
            cov_2mb0e4p6ud.f[8]++;
            cov_2mb0e4p6ud.s[21]++;

            if (this.selected.indexOf(proposal) > -1) {
                cov_2mb0e4p6ud.b[0][0]++;
                cov_2mb0e4p6ud.s[22]++;

                this.selected.splice(this.selected.indexOf(proposal), 1);
                cov_2mb0e4p6ud.s[23]++;
                if (this.allChecked) {
                    cov_2mb0e4p6ud.b[1][0]++;
                    cov_2mb0e4p6ud.s[24]++;

                    this.allChecked = false;
                } else {
                    cov_2mb0e4p6ud.b[1][1]++;
                }
            } else {
                cov_2mb0e4p6ud.b[0][1]++;
                cov_2mb0e4p6ud.s[25]++;

                this.selected.push(proposal);
            }
        }
    }, {
        key: 'proposalInList',
        value: function proposalInList(proposal) {
            cov_2mb0e4p6ud.f[9]++;
            cov_2mb0e4p6ud.s[26]++;

            return this.selected.indexOf(proposal) > -1;
        }
    }, {
        key: 'checkAll',
        value: function checkAll(proposals) {
            var _this3 = this;

            cov_2mb0e4p6ud.f[10]++;
            cov_2mb0e4p6ud.s[27]++;

            this.allChecked = !this.allChecked;
            cov_2mb0e4p6ud.s[28]++;
            if (this.allChecked) {
                cov_2mb0e4p6ud.b[2][0]++;
                cov_2mb0e4p6ud.s[29]++;

                proposals.forEach(function (proposal) {
                    cov_2mb0e4p6ud.f[11]++;
                    cov_2mb0e4p6ud.s[30]++;

                    if (!_this3.proposalInList(proposal)) {
                        cov_2mb0e4p6ud.b[3][0]++;
                        cov_2mb0e4p6ud.s[31]++;

                        _this3.selected.push(proposal);
                    } else {
                        cov_2mb0e4p6ud.b[3][1]++;
                    }
                });
            } else {
                cov_2mb0e4p6ud.b[2][1]++;
                cov_2mb0e4p6ud.s[32]++;

                this.selected = [];
            }
        }
    }, {
        key: 'passProposalsTo',
        value: function passProposalsTo(state) {
            var _this4 = this;

            cov_2mb0e4p6ud.f[12]++;
            cov_2mb0e4p6ud.s[33]++;

            this.counter = 0;
            cov_2mb0e4p6ud.s[34]++;
            if (state !== '') {
                cov_2mb0e4p6ud.b[4][0]++;
                cov_2mb0e4p6ud.s[35]++;

                this.selected.forEach(function (proposal) {
                    cov_2mb0e4p6ud.f[13]++;
                    cov_2mb0e4p6ud.s[36]++;

                    proposal.state = state;
                    cov_2mb0e4p6ud.s[37]++;
                    proposal.$save(['state']).$then(function (proposal) {
                        cov_2mb0e4p6ud.f[14]++;
                        cov_2mb0e4p6ud.s[38]++;

                        proposal.$fetch();
                    });
                    cov_2mb0e4p6ud.s[39]++;
                    _this4.counter += 1;
                });
                cov_2mb0e4p6ud.s[40]++;
                if (this.allChecked) {
                    cov_2mb0e4p6ud.b[5][0]++;
                    cov_2mb0e4p6ud.s[41]++;

                    this.allChecked = false;
                } else {
                    cov_2mb0e4p6ud.b[5][1]++;
                }
                cov_2mb0e4p6ud.s[42]++;
                this.selected = [];
                cov_2mb0e4p6ud.s[43]++;
                this.message = this.counter.toString() + ' proposal(s) passed to ' + state.toLowerCase();
                cov_2mb0e4p6ud.s[44]++;
                this.$mdToast.show(this.$mdToast.simple().parent(this.el).textContent(this.message));
            } else {
                cov_2mb0e4p6ud.b[4][1]++;
            }
        }
    }, {
        key: 'deleteProposals',
        value: function deleteProposals(option) {
            var _this5 = this;

            cov_2mb0e4p6ud.f[15]++;
            cov_2mb0e4p6ud.s[45]++;

            this.counter = 0;
            cov_2mb0e4p6ud.s[46]++;
            this.completed = 0;
            cov_2mb0e4p6ud.s[47]++;
            if (option === '1') {
                cov_2mb0e4p6ud.b[6][0]++;
                cov_2mb0e4p6ud.s[48]++;

                this.count = this.selected.length;
                cov_2mb0e4p6ud.s[49]++;
                this.selected.forEach(function (proposal) {
                    cov_2mb0e4p6ud.f[16]++;
                    cov_2mb0e4p6ud.s[50]++;

                    _this5.deleteProposal(proposal);
                });
            } else {
                cov_2mb0e4p6ud.b[6][1]++;
            }
            cov_2mb0e4p6ud.s[51]++;
            if (option === '2') {
                cov_2mb0e4p6ud.b[7][0]++;
                cov_2mb0e4p6ud.s[52]++;

                this.count = this.proposals.length;
                cov_2mb0e4p6ud.s[53]++;
                this.proposals.forEach(function (proposal) {
                    cov_2mb0e4p6ud.f[17]++;
                    cov_2mb0e4p6ud.s[54]++;

                    _this5.deleteProposal(proposal);
                });
            } else {
                cov_2mb0e4p6ud.b[7][1]++;
            }
        }
    }, {
        key: 'deleteProposal',
        value: function deleteProposal(proposal) {
            var _this6 = this;

            cov_2mb0e4p6ud.f[18]++;
            cov_2mb0e4p6ud.s[55]++;

            proposal.$destroy();
            cov_2mb0e4p6ud.s[56]++;
            proposal.$fetch().$then(function () {
                cov_2mb0e4p6ud.f[19]++;
                cov_2mb0e4p6ud.s[57]++;

                _this6.completed += 1;
                cov_2mb0e4p6ud.s[58]++;
                if (_this6.completed === _this6.count) {
                    cov_2mb0e4p6ud.b[8][0]++;
                    cov_2mb0e4p6ud.s[59]++;

                    _this6.messageDeleted(_this6.counter);
                } else {
                    cov_2mb0e4p6ud.b[8][1]++;
                }
            }, function () {
                cov_2mb0e4p6ud.f[20]++;
                cov_2mb0e4p6ud.s[60]++;

                _this6.counter += 1;
                cov_2mb0e4p6ud.s[61]++;
                _this6.completed += 1;
                cov_2mb0e4p6ud.s[62]++;
                if (_this6.completed === _this6.count) {
                    cov_2mb0e4p6ud.b[9][0]++;
                    cov_2mb0e4p6ud.s[63]++;

                    _this6.messageDeleted(_this6.counter);
                } else {
                    cov_2mb0e4p6ud.b[9][1]++;
                }
            });
        }
    }, {
        key: 'messageDeleted',
        value: function messageDeleted(counter) {
            cov_2mb0e4p6ud.f[21]++;
            cov_2mb0e4p6ud.s[64]++;

            this.selected = [];
            cov_2mb0e4p6ud.s[65]++;
            if (this.allChecked) {
                cov_2mb0e4p6ud.b[10][0]++;
                cov_2mb0e4p6ud.s[66]++;

                this.allChecked = false;
            } else {
                cov_2mb0e4p6ud.b[10][1]++;
            }
            cov_2mb0e4p6ud.s[67]++;
            this.proposals.$refresh();
            cov_2mb0e4p6ud.s[68]++;
            this.message = counter.toString() + ' proposal(s) deleted';
            cov_2mb0e4p6ud.s[69]++;
            this.$mdToast.show(this.$mdToast.simple().parent(this.el).textContent(this.message));
        }
    }]);

    return ProposalsListController;
}();

cov_2mb0e4p6ud.s[70]++;


angular.module('app').component('proposalsList', {
    templateUrl: 'app/components/proposalsList/proposalsList.html',
    controller: ProposalsListController,
    bindings: {
        proposals: '<'
    }
});
'use strict';

var cov_28pxhb2vh2 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/proposalSectionDetails/proposalSectionDetails.js',
        hash = '0d7c0116f32bce3a2c8d592f82c0a1ec4abe9ae6',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/proposalSectionDetails/proposalSectionDetails.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 57
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 53
                }
            },
            '2': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 6,
                    column: 33
                }
            },
            '3': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 13,
                    column: 11
                }
            },
            '4': {
                start: {
                    line: 9,
                    column: 12
                },
                end: {
                    line: 12,
                    column: 13
                }
            },
            '5': {
                start: {
                    line: 10,
                    column: 16
                },
                end: {
                    line: 10,
                    column: 54
                }
            },
            '6': {
                start: {
                    line: 11,
                    column: 16
                },
                end: {
                    line: 11,
                    column: 39
                }
            },
            '7': {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 25,
                    column: 10
                }
            },
            '8': {
                start: {
                    line: 16,
                    column: 31
                },
                end: {
                    line: 16,
                    column: 51
                }
            },
            '9': {
                start: {
                    line: 17,
                    column: 32
                },
                end: {
                    line: 17,
                    column: 62
                }
            },
            '10': {
                start: {
                    line: 18,
                    column: 16
                },
                end: {
                    line: 18,
                    column: 39
                }
            },
            '11': {
                start: {
                    line: 20,
                    column: 16
                },
                end: {
                    line: 22,
                    column: 19
                }
            },
            '12': {
                start: {
                    line: 21,
                    column: 20
                },
                end: {
                    line: 21,
                    column: 69
                }
            },
            '13': {
                start: {
                    line: 26,
                    column: 8
                },
                end: {
                    line: 26,
                    column: 43
                }
            },
            '14': {
                start: {
                    line: 29,
                    column: 8
                },
                end: {
                    line: 29,
                    column: 54
                }
            },
            '15': {
                start: {
                    line: 30,
                    column: 8
                },
                end: {
                    line: 30,
                    column: 111
                }
            },
            '16': {
                start: {
                    line: 31,
                    column: 8
                },
                end: {
                    line: 31,
                    column: 33
                }
            },
            '17': {
                start: {
                    line: 32,
                    column: 8
                },
                end: {
                    line: 32,
                    column: 26
                }
            },
            '18': {
                start: {
                    line: 36,
                    column: 8
                },
                end: {
                    line: 39,
                    column: 11
                }
            },
            '19': {
                start: {
                    line: 37,
                    column: 12
                },
                end: {
                    line: 37,
                    column: 55
                }
            },
            '20': {
                start: {
                    line: 38,
                    column: 12
                },
                end: {
                    line: 38,
                    column: 50
                }
            },
            '21': {
                start: {
                    line: 43,
                    column: 8
                },
                end: {
                    line: 43,
                    column: 43
                }
            },
            '22': {
                start: {
                    line: 44,
                    column: 8
                },
                end: {
                    line: 44,
                    column: 57
                }
            },
            '23': {
                start: {
                    line: 45,
                    column: 8
                },
                end: {
                    line: 45,
                    column: 36
                }
            },
            '24': {
                start: {
                    line: 46,
                    column: 8
                },
                end: {
                    line: 46,
                    column: 111
                }
            },
            '25': {
                start: {
                    line: 47,
                    column: 8
                },
                end: {
                    line: 47,
                    column: 33
                }
            },
            '26': {
                start: {
                    line: 48,
                    column: 8
                },
                end: {
                    line: 48,
                    column: 26
                }
            },
            '27': {
                start: {
                    line: 52,
                    column: 0
                },
                end: {
                    line: 63,
                    column: 4
                }
            },
            '28': {
                start: {
                    line: 61,
                    column: 35
                },
                end: {
                    line: 63,
                    column: 1
                }
            },
            '29': {
                start: {
                    line: 62,
                    column: 4
                },
                end: {
                    line: 62,
                    column: 33
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 81
                    },
                    end: {
                        line: 27,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 8,
                        column: 53
                    },
                    end: {
                        line: 8,
                        column: 54
                    }
                },
                loc: {
                    start: {
                        line: 8,
                        column: 63
                    },
                    end: {
                        line: 13,
                        column: 9
                    }
                },
                line: 8
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 15,
                        column: 26
                    },
                    end: {
                        line: 15,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 15,
                        column: 35
                    },
                    end: {
                        line: 23,
                        column: 13
                    }
                },
                line: 15
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 20,
                        column: 47
                    },
                    end: {
                        line: 20,
                        column: 48
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 53
                    },
                    end: {
                        line: 22,
                        column: 17
                    }
                },
                line: 20
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 28,
                        column: 4
                    },
                    end: {
                        line: 28,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 28,
                        column: 14
                    },
                    end: {
                        line: 33,
                        column: 5
                    }
                },
                line: 28
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 35,
                        column: 4
                    },
                    end: {
                        line: 35,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 35,
                        column: 27
                    },
                    end: {
                        line: 40,
                        column: 5
                    }
                },
                line: 35
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 36,
                        column: 49
                    },
                    end: {
                        line: 36,
                        column: 50
                    }
                },
                loc: {
                    start: {
                        line: 36,
                        column: 66
                    },
                    end: {
                        line: 39,
                        column: 9
                    }
                },
                line: 36
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 42,
                        column: 4
                    },
                    end: {
                        line: 42,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 42,
                        column: 41
                    },
                    end: {
                        line: 49,
                        column: 5
                    }
                },
                line: 42
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 61,
                        column: 27
                    },
                    end: {
                        line: 61,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 61,
                        column: 35
                    },
                    end: {
                        line: 63,
                        column: 1
                    }
                },
                line: 61
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 61,
                        column: 35
                    },
                    end: {
                        line: 61,
                        column: 36
                    }
                },
                loc: {
                    start: {
                        line: 61,
                        column: 50
                    },
                    end: {
                        line: 63,
                        column: 1
                    }
                },
                line: 61
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 9,
                        column: 12
                    },
                    end: {
                        line: 12,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 9,
                        column: 12
                    },
                    end: {
                        line: 12,
                        column: 13
                    }
                }, {
                    start: {
                        line: 9,
                        column: 12
                    },
                    end: {
                        line: 12,
                        column: 13
                    }
                }],
                line: 9
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProposalSectionDetailsController = function () {
    ProposalSectionDetailsController.$inject = ["$scope", "MediaTable", "MediaSelectorService", "AppSettings", "$mdToast"];
    function ProposalSectionDetailsController($scope, MediaTable, MediaSelectorService, AppSettings, $mdToast) {
        var _this = this;

        _classCallCheck(this, ProposalSectionDetailsController);

        cov_28pxhb2vh2.f[0]++;
        cov_28pxhb2vh2.s[0]++;

        this.MediaSelectorService = MediaSelectorService;
        cov_28pxhb2vh2.s[1]++;
        this.proposalsApp = AppSettings.proposalsApp;
        cov_28pxhb2vh2.s[2]++;
        this.$mdToast = $mdToast;
        // files
        cov_28pxhb2vh2.s[3]++;
        $scope.$watch('$ctrl.proposalSection.cover', function (newVal) {
            cov_28pxhb2vh2.f[1]++;
            cov_28pxhb2vh2.s[4]++;

            if (angular.isString(newVal)) {
                cov_28pxhb2vh2.b[0][0]++;
                cov_28pxhb2vh2.s[5]++;

                _this.proposalSection.$save(['cover']);
                cov_28pxhb2vh2.s[6]++;
                _this.medias.$refresh();
            } else {
                cov_28pxhb2vh2.b[0][1]++;
            }
        });
        cov_28pxhb2vh2.s[7]++;
        this.sortableContents = {
            orderChanged: function orderChanged(event) {
                cov_28pxhb2vh2.f[2]++;

                var newPos = (cov_28pxhb2vh2.s[8]++, event.dest.index + 1);
                var content = (cov_28pxhb2vh2.s[9]++, event.source.itemScope.content);
                cov_28pxhb2vh2.s[10]++;
                content.order = newPos;

                cov_28pxhb2vh2.s[11]++;
                content.$save(['order']).$then(function () {
                    cov_28pxhb2vh2.f[3]++;
                    cov_28pxhb2vh2.s[12]++;

                    _this.proposalSection.$sectionContents.$refresh();
                });
            },
            placeholder: '<div style="min-height: 60px;"></div>'
        };
        cov_28pxhb2vh2.s[13]++;
        this.medias = MediaTable.$search();
    }

    _createClass(ProposalSectionDetailsController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_28pxhb2vh2.f[4]++;
            cov_28pxhb2vh2.s[14]++;

            this.proposalSection.$load('sectionContents');
            cov_28pxhb2vh2.s[15]++;
            this.editingContent = this.proposalSection.$sectionContents.$build({ section: this.proposalSection.id });
            cov_28pxhb2vh2.s[16]++;
            this.newDescription = '';
            cov_28pxhb2vh2.s[17]++;
            this.newName = '';
        }
    }, {
        key: 'displayMediaSelector',
        value: function displayMediaSelector() {
            var _this2 = this;

            cov_28pxhb2vh2.f[5]++;
            cov_28pxhb2vh2.s[18]++;

            this.MediaSelectorService.display().then(function (selectedMedia) {
                cov_28pxhb2vh2.f[6]++;
                cov_28pxhb2vh2.s[19]++;

                _this2.proposalSection.cover = selectedMedia;
                cov_28pxhb2vh2.s[20]++;
                _this2.proposalSection.$save(['cover']);
            });
        }
    }, {
        key: 'saveContent',
        value: function saveContent(newName, newDescription) {
            cov_28pxhb2vh2.f[7]++;
            cov_28pxhb2vh2.s[21]++;

            this.editingContent.name = newName;
            cov_28pxhb2vh2.s[22]++;
            this.editingContent.description = newDescription;
            cov_28pxhb2vh2.s[23]++;
            this.editingContent.$save();
            cov_28pxhb2vh2.s[24]++;
            this.editingContent = this.proposalSection.$sectionContents.$build({ section: this.proposalSection.id });
            cov_28pxhb2vh2.s[25]++;
            this.newDescription = '';
            cov_28pxhb2vh2.s[26]++;
            this.newName = '';
        }
    }]);

    return ProposalSectionDetailsController;
}();

cov_28pxhb2vh2.s[27]++;


angular.module('app').component('proposalSectionDetails', {
    templateUrl: 'app/components/proposalSectionDetails/proposalSectionDetails.html',
    controller: ProposalSectionDetailsController,
    bindings: {
        proposalSection: '<'
    }
}).filter('unsafe', ['$sce', function ($sce) {
    cov_28pxhb2vh2.f[8]++;
    cov_28pxhb2vh2.s[28]++;
    return function (val) {
        cov_28pxhb2vh2.f[9]++;
        cov_28pxhb2vh2.s[29]++;

        return $sce.trustAsHtml(val);
    };
}]);
'use strict';

var cov_k62wb9q4g = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/proposalDetails/proposalDetails.js',
        hash = '03911717b0c50756b87ce4728c8c4629dd1d372b',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/proposalDetails/proposalDetails.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 57
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 65
                }
            },
            '2': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 6,
                    column: 53
                }
            },
            '3': {
                start: {
                    line: 7,
                    column: 8
                },
                end: {
                    line: 7,
                    column: 49
                }
            },
            '4': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 53
                }
            },
            '5': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 9,
                    column: 36
                }
            },
            '6': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 31
                }
            },
            '7': {
                start: {
                    line: 13,
                    column: 8
                },
                end: {
                    line: 18,
                    column: 11
                }
            },
            '8': {
                start: {
                    line: 15,
                    column: 12
                },
                end: {
                    line: 17,
                    column: 15
                }
            },
            '9': {
                start: {
                    line: 16,
                    column: 16
                },
                end: {
                    line: 16,
                    column: 38
                }
            },
            '10': {
                start: {
                    line: 19,
                    column: 8
                },
                end: {
                    line: 19,
                    column: 62
                }
            },
            '11': {
                start: {
                    line: 20,
                    column: 8
                },
                end: {
                    line: 29,
                    column: 11
                }
            },
            '12': {
                start: {
                    line: 21,
                    column: 12
                },
                end: {
                    line: 28,
                    column: 13
                }
            },
            '13': {
                start: {
                    line: 22,
                    column: 16
                },
                end: {
                    line: 26,
                    column: 29
                }
            },
            '14': {
                start: {
                    line: 27,
                    column: 16
                },
                end: {
                    line: 27,
                    column: 39
                }
            },
            '15': {
                start: {
                    line: 32,
                    column: 8
                },
                end: {
                    line: 41,
                    column: 11
                }
            },
            '16': {
                start: {
                    line: 33,
                    column: 12
                },
                end: {
                    line: 40,
                    column: 13
                }
            },
            '17': {
                start: {
                    line: 34,
                    column: 16
                },
                end: {
                    line: 38,
                    column: 19
                }
            },
            '18': {
                start: {
                    line: 39,
                    column: 16
                },
                end: {
                    line: 39,
                    column: 39
                }
            },
            '19': {
                start: {
                    line: 42,
                    column: 8
                },
                end: {
                    line: 46,
                    column: 11
                }
            },
            '20': {
                start: {
                    line: 43,
                    column: 12
                },
                end: {
                    line: 45,
                    column: 13
                }
            },
            '21': {
                start: {
                    line: 44,
                    column: 16
                },
                end: {
                    line: 44,
                    column: 39
                }
            },
            '22': {
                start: {
                    line: 47,
                    column: 8
                },
                end: {
                    line: 58,
                    column: 10
                }
            },
            '23': {
                start: {
                    line: 49,
                    column: 31
                },
                end: {
                    line: 49,
                    column: 51
                }
            },
            '24': {
                start: {
                    line: 50,
                    column: 32
                },
                end: {
                    line: 50,
                    column: 62
                }
            },
            '25': {
                start: {
                    line: 51,
                    column: 16
                },
                end: {
                    line: 51,
                    column: 39
                }
            },
            '26': {
                start: {
                    line: 53,
                    column: 16
                },
                end: {
                    line: 55,
                    column: 19
                }
            },
            '27': {
                start: {
                    line: 54,
                    column: 20
                },
                end: {
                    line: 54,
                    column: 63
                }
            },
            '28': {
                start: {
                    line: 59,
                    column: 8
                },
                end: {
                    line: 70,
                    column: 10
                }
            },
            '29': {
                start: {
                    line: 61,
                    column: 31
                },
                end: {
                    line: 61,
                    column: 51
                }
            },
            '30': {
                start: {
                    line: 62,
                    column: 32
                },
                end: {
                    line: 62,
                    column: 62
                }
            },
            '31': {
                start: {
                    line: 63,
                    column: 16
                },
                end: {
                    line: 63,
                    column: 39
                }
            },
            '32': {
                start: {
                    line: 65,
                    column: 16
                },
                end: {
                    line: 67,
                    column: 19
                }
            },
            '33': {
                start: {
                    line: 66,
                    column: 20
                },
                end: {
                    line: 66,
                    column: 63
                }
            },
            '34': {
                start: {
                    line: 71,
                    column: 8
                },
                end: {
                    line: 82,
                    column: 10
                }
            },
            '35': {
                start: {
                    line: 73,
                    column: 31
                },
                end: {
                    line: 73,
                    column: 51
                }
            },
            '36': {
                start: {
                    line: 74,
                    column: 30
                },
                end: {
                    line: 74,
                    column: 58
                }
            },
            '37': {
                start: {
                    line: 75,
                    column: 16
                },
                end: {
                    line: 75,
                    column: 37
                }
            },
            '38': {
                start: {
                    line: 77,
                    column: 16
                },
                end: {
                    line: 79,
                    column: 19
                }
            },
            '39': {
                start: {
                    line: 78,
                    column: 20
                },
                end: {
                    line: 78,
                    column: 58
                }
            },
            '40': {
                start: {
                    line: 83,
                    column: 8
                },
                end: {
                    line: 83,
                    column: 43
                }
            },
            '41': {
                start: {
                    line: 87,
                    column: 8
                },
                end: {
                    line: 92,
                    column: 9
                }
            },
            '42': {
                start: {
                    line: 88,
                    column: 22
                },
                end: {
                    line: 88,
                    column: 61
                }
            },
            '43': {
                start: {
                    line: 89,
                    column: 12
                },
                end: {
                    line: 91,
                    column: 13
                }
            },
            '44': {
                start: {
                    line: 90,
                    column: 16
                },
                end: {
                    line: 90,
                    column: 41
                }
            },
            '45': {
                start: {
                    line: 93,
                    column: 8
                },
                end: {
                    line: 93,
                    column: 18
                }
            },
            '46': {
                start: {
                    line: 97,
                    column: 8
                },
                end: {
                    line: 100,
                    column: 11
                }
            },
            '47': {
                start: {
                    line: 104,
                    column: 8
                },
                end: {
                    line: 106,
                    column: 11
                }
            },
            '48': {
                start: {
                    line: 110,
                    column: 8
                },
                end: {
                    line: 112,
                    column: 11
                }
            },
            '49': {
                start: {
                    line: 116,
                    column: 8
                },
                end: {
                    line: 118,
                    column: 11
                }
            },
            '50': {
                start: {
                    line: 122,
                    column: 8
                },
                end: {
                    line: 122,
                    column: 144
                }
            },
            '51': {
                start: {
                    line: 123,
                    column: 8
                },
                end: {
                    line: 125,
                    column: 9
                }
            },
            '52': {
                start: {
                    line: 124,
                    column: 12
                },
                end: {
                    line: 124,
                    column: 63
                }
            },
            '53': {
                start: {
                    line: 126,
                    column: 8
                },
                end: {
                    line: 128,
                    column: 9
                }
            },
            '54': {
                start: {
                    line: 127,
                    column: 12
                },
                end: {
                    line: 127,
                    column: 51
                }
            },
            '55': {
                start: {
                    line: 129,
                    column: 8
                },
                end: {
                    line: 129,
                    column: 34
                }
            },
            '56': {
                start: {
                    line: 130,
                    column: 8
                },
                end: {
                    line: 130,
                    column: 29
                }
            },
            '57': {
                start: {
                    line: 131,
                    column: 8
                },
                end: {
                    line: 131,
                    column: 29
                }
            },
            '58': {
                start: {
                    line: 132,
                    column: 8
                },
                end: {
                    line: 132,
                    column: 29
                }
            },
            '59': {
                start: {
                    line: 133,
                    column: 8
                },
                end: {
                    line: 133,
                    column: 31
                }
            },
            '60': {
                start: {
                    line: 134,
                    column: 8
                },
                end: {
                    line: 134,
                    column: 30
                }
            },
            '61': {
                start: {
                    line: 138,
                    column: 8
                },
                end: {
                    line: 141,
                    column: 11
                }
            },
            '62': {
                start: {
                    line: 139,
                    column: 12
                },
                end: {
                    line: 139,
                    column: 52
                }
            },
            '63': {
                start: {
                    line: 140,
                    column: 12
                },
                end: {
                    line: 140,
                    column: 33
                }
            },
            '64': {
                start: {
                    line: 145,
                    column: 8
                },
                end: {
                    line: 147,
                    column: 11
                }
            },
            '65': {
                start: {
                    line: 146,
                    column: 12
                },
                end: {
                    line: 146,
                    column: 33
                }
            },
            '66': {
                start: {
                    line: 151,
                    column: 8
                },
                end: {
                    line: 153,
                    column: 11
                }
            },
            '67': {
                start: {
                    line: 152,
                    column: 12
                },
                end: {
                    line: 152,
                    column: 35
                }
            },
            '68': {
                start: {
                    line: 157,
                    column: 8
                },
                end: {
                    line: 171,
                    column: 11
                }
            },
            '69': {
                start: {
                    line: 158,
                    column: 12
                },
                end: {
                    line: 158,
                    column: 40
                }
            },
            '70': {
                start: {
                    line: 159,
                    column: 12
                },
                end: {
                    line: 163,
                    column: 15
                }
            },
            '71': {
                start: {
                    line: 160,
                    column: 16
                },
                end: {
                    line: 160,
                    column: 42
                }
            },
            '72': {
                start: {
                    line: 161,
                    column: 16
                },
                end: {
                    line: 161,
                    column: 42
                }
            },
            '73': {
                start: {
                    line: 162,
                    column: 16
                },
                end: {
                    line: 162,
                    column: 39
                }
            },
            '74': {
                start: {
                    line: 165,
                    column: 12
                },
                end: {
                    line: 165,
                    column: 40
                }
            },
            '75': {
                start: {
                    line: 166,
                    column: 12
                },
                end: {
                    line: 168,
                    column: 15
                }
            },
            '76': {
                start: {
                    line: 167,
                    column: 16
                },
                end: {
                    line: 167,
                    column: 44
                }
            },
            '77': {
                start: {
                    line: 169,
                    column: 12
                },
                end: {
                    line: 169,
                    column: 41
                }
            },
            '78': {
                start: {
                    line: 170,
                    column: 12
                },
                end: {
                    line: 170,
                    column: 33
                }
            },
            '79': {
                start: {
                    line: 175,
                    column: 8
                },
                end: {
                    line: 175,
                    column: 80
                }
            },
            '80': {
                start: {
                    line: 176,
                    column: 8
                },
                end: {
                    line: 176,
                    column: 30
                }
            },
            '81': {
                start: {
                    line: 180,
                    column: 8
                },
                end: {
                    line: 184,
                    column: 11
                }
            },
            '82': {
                start: {
                    line: 181,
                    column: 12
                },
                end: {
                    line: 183,
                    column: 15
                }
            },
            '83': {
                start: {
                    line: 182,
                    column: 16
                },
                end: {
                    line: 182,
                    column: 44
                }
            },
            '84': {
                start: {
                    line: 188,
                    column: 8
                },
                end: {
                    line: 190,
                    column: 11
                }
            },
            '85': {
                start: {
                    line: 189,
                    column: 12
                },
                end: {
                    line: 189,
                    column: 50
                }
            },
            '86': {
                start: {
                    line: 194,
                    column: 8
                },
                end: {
                    line: 199,
                    column: 11
                }
            },
            '87': {
                start: {
                    line: 195,
                    column: 12
                },
                end: {
                    line: 198,
                    column: 15
                }
            },
            '88': {
                start: {
                    line: 203,
                    column: 8
                },
                end: {
                    line: 205,
                    column: 11
                }
            },
            '89': {
                start: {
                    line: 204,
                    column: 12
                },
                end: {
                    line: 204,
                    column: 52
                }
            },
            '90': {
                start: {
                    line: 209,
                    column: 8
                },
                end: {
                    line: 211,
                    column: 11
                }
            },
            '91': {
                start: {
                    line: 210,
                    column: 12
                },
                end: {
                    line: 210,
                    column: 52
                }
            },
            '92': {
                start: {
                    line: 215,
                    column: 8
                },
                end: {
                    line: 215,
                    column: 80
                }
            },
            '93': {
                start: {
                    line: 216,
                    column: 8
                },
                end: {
                    line: 216,
                    column: 38
                }
            },
            '94': {
                start: {
                    line: 220,
                    column: 0
                },
                end: {
                    line: 228,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 156
                    },
                    end: {
                        line: 84,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 13,
                        column: 36
                    },
                    end: {
                        line: 13,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 13,
                        column: 53
                    },
                    end: {
                        line: 18,
                        column: 9
                    }
                },
                line: 13
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 15,
                        column: 34
                    },
                    end: {
                        line: 15,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 15,
                        column: 40
                    },
                    end: {
                        line: 17,
                        column: 13
                    }
                },
                line: 15
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 20,
                        column: 42
                    },
                    end: {
                        line: 20,
                        column: 43
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 54
                    },
                    end: {
                        line: 29,
                        column: 9
                    }
                },
                line: 20
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 32,
                        column: 49
                    },
                    end: {
                        line: 32,
                        column: 50
                    }
                },
                loc: {
                    start: {
                        line: 32,
                        column: 59
                    },
                    end: {
                        line: 41,
                        column: 9
                    }
                },
                line: 32
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 42,
                        column: 48
                    },
                    end: {
                        line: 42,
                        column: 49
                    }
                },
                loc: {
                    start: {
                        line: 42,
                        column: 58
                    },
                    end: {
                        line: 46,
                        column: 9
                    }
                },
                line: 42
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 48,
                        column: 26
                    },
                    end: {
                        line: 48,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 48,
                        column: 35
                    },
                    end: {
                        line: 56,
                        column: 13
                    }
                },
                line: 48
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 53,
                        column: 47
                    },
                    end: {
                        line: 53,
                        column: 48
                    }
                },
                loc: {
                    start: {
                        line: 53,
                        column: 53
                    },
                    end: {
                        line: 55,
                        column: 17
                    }
                },
                line: 53
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 60,
                        column: 26
                    },
                    end: {
                        line: 60,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 60,
                        column: 35
                    },
                    end: {
                        line: 68,
                        column: 13
                    }
                },
                line: 60
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 65,
                        column: 47
                    },
                    end: {
                        line: 65,
                        column: 48
                    }
                },
                loc: {
                    start: {
                        line: 65,
                        column: 53
                    },
                    end: {
                        line: 67,
                        column: 17
                    }
                },
                line: 65
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 72,
                        column: 26
                    },
                    end: {
                        line: 72,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 72,
                        column: 35
                    },
                    end: {
                        line: 80,
                        column: 13
                    }
                },
                line: 72
            },
            '11': {
                name: '(anonymous_11)',
                decl: {
                    start: {
                        line: 77,
                        column: 45
                    },
                    end: {
                        line: 77,
                        column: 46
                    }
                },
                loc: {
                    start: {
                        line: 77,
                        column: 51
                    },
                    end: {
                        line: 79,
                        column: 17
                    }
                },
                line: 77
            },
            '12': {
                name: '(anonymous_12)',
                decl: {
                    start: {
                        line: 86,
                        column: 4
                    },
                    end: {
                        line: 86,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 86,
                        column: 20
                    },
                    end: {
                        line: 94,
                        column: 5
                    }
                },
                line: 86
            },
            '13': {
                name: '(anonymous_13)',
                decl: {
                    start: {
                        line: 96,
                        column: 4
                    },
                    end: {
                        line: 96,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 96,
                        column: 20
                    },
                    end: {
                        line: 101,
                        column: 5
                    }
                },
                line: 96
            },
            '14': {
                name: '(anonymous_14)',
                decl: {
                    start: {
                        line: 103,
                        column: 4
                    },
                    end: {
                        line: 103,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 103,
                        column: 20
                    },
                    end: {
                        line: 107,
                        column: 5
                    }
                },
                line: 103
            },
            '15': {
                name: '(anonymous_15)',
                decl: {
                    start: {
                        line: 109,
                        column: 4
                    },
                    end: {
                        line: 109,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 109,
                        column: 20
                    },
                    end: {
                        line: 113,
                        column: 5
                    }
                },
                line: 109
            },
            '16': {
                name: '(anonymous_16)',
                decl: {
                    start: {
                        line: 115,
                        column: 4
                    },
                    end: {
                        line: 115,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 115,
                        column: 22
                    },
                    end: {
                        line: 119,
                        column: 5
                    }
                },
                line: 115
            },
            '17': {
                name: '(anonymous_17)',
                decl: {
                    start: {
                        line: 121,
                        column: 4
                    },
                    end: {
                        line: 121,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 121,
                        column: 14
                    },
                    end: {
                        line: 135,
                        column: 5
                    }
                },
                line: 121
            },
            '18': {
                name: '(anonymous_18)',
                decl: {
                    start: {
                        line: 137,
                        column: 4
                    },
                    end: {
                        line: 137,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 137,
                        column: 25
                    },
                    end: {
                        line: 142,
                        column: 5
                    }
                },
                line: 137
            },
            '19': {
                name: '(anonymous_19)',
                decl: {
                    start: {
                        line: 138,
                        column: 38
                    },
                    end: {
                        line: 138,
                        column: 39
                    }
                },
                loc: {
                    start: {
                        line: 138,
                        column: 44
                    },
                    end: {
                        line: 141,
                        column: 9
                    }
                },
                line: 138
            },
            '20': {
                name: '(anonymous_20)',
                decl: {
                    start: {
                        line: 144,
                        column: 4
                    },
                    end: {
                        line: 144,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 144,
                        column: 25
                    },
                    end: {
                        line: 148,
                        column: 5
                    }
                },
                line: 144
            },
            '21': {
                name: '(anonymous_21)',
                decl: {
                    start: {
                        line: 145,
                        column: 38
                    },
                    end: {
                        line: 145,
                        column: 39
                    }
                },
                loc: {
                    start: {
                        line: 145,
                        column: 44
                    },
                    end: {
                        line: 147,
                        column: 9
                    }
                },
                line: 145
            },
            '22': {
                name: '(anonymous_22)',
                decl: {
                    start: {
                        line: 150,
                        column: 4
                    },
                    end: {
                        line: 150,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 150,
                        column: 19
                    },
                    end: {
                        line: 154,
                        column: 5
                    }
                },
                line: 150
            },
            '23': {
                name: '(anonymous_23)',
                decl: {
                    start: {
                        line: 151,
                        column: 36
                    },
                    end: {
                        line: 151,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 151,
                        column: 42
                    },
                    end: {
                        line: 153,
                        column: 9
                    }
                },
                line: 151
            },
            '24': {
                name: '(anonymous_24)',
                decl: {
                    start: {
                        line: 156,
                        column: 4
                    },
                    end: {
                        line: 156,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 156,
                        column: 17
                    },
                    end: {
                        line: 172,
                        column: 5
                    }
                },
                line: 156
            },
            '25': {
                name: '(anonymous_25)',
                decl: {
                    start: {
                        line: 157,
                        column: 38
                    },
                    end: {
                        line: 157,
                        column: 39
                    }
                },
                loc: {
                    start: {
                        line: 157,
                        column: 49
                    },
                    end: {
                        line: 171,
                        column: 9
                    }
                },
                line: 157
            },
            '26': {
                name: '(anonymous_26)',
                decl: {
                    start: {
                        line: 159,
                        column: 39
                    },
                    end: {
                        line: 159,
                        column: 40
                    }
                },
                loc: {
                    start: {
                        line: 159,
                        column: 47
                    },
                    end: {
                        line: 163,
                        column: 13
                    }
                },
                line: 159
            },
            '27': {
                name: '(anonymous_27)',
                decl: {
                    start: {
                        line: 166,
                        column: 56
                    },
                    end: {
                        line: 166,
                        column: 57
                    }
                },
                loc: {
                    start: {
                        line: 166,
                        column: 67
                    },
                    end: {
                        line: 168,
                        column: 13
                    }
                },
                line: 166
            },
            '28': {
                name: '(anonymous_28)',
                decl: {
                    start: {
                        line: 174,
                        column: 4
                    },
                    end: {
                        line: 174,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 174,
                        column: 27
                    },
                    end: {
                        line: 177,
                        column: 5
                    }
                },
                line: 174
            },
            '29': {
                name: '(anonymous_29)',
                decl: {
                    start: {
                        line: 179,
                        column: 4
                    },
                    end: {
                        line: 179,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 179,
                        column: 21
                    },
                    end: {
                        line: 185,
                        column: 5
                    }
                },
                line: 179
            },
            '30': {
                name: '(anonymous_30)',
                decl: {
                    start: {
                        line: 180,
                        column: 38
                    },
                    end: {
                        line: 180,
                        column: 39
                    }
                },
                loc: {
                    start: {
                        line: 180,
                        column: 50
                    },
                    end: {
                        line: 184,
                        column: 9
                    }
                },
                line: 180
            },
            '31': {
                name: '(anonymous_31)',
                decl: {
                    start: {
                        line: 181,
                        column: 29
                    },
                    end: {
                        line: 181,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 181,
                        column: 40
                    },
                    end: {
                        line: 183,
                        column: 13
                    }
                },
                line: 181
            },
            '32': {
                name: '(anonymous_32)',
                decl: {
                    start: {
                        line: 187,
                        column: 4
                    },
                    end: {
                        line: 187,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 187,
                        column: 27
                    },
                    end: {
                        line: 191,
                        column: 5
                    }
                },
                line: 187
            },
            '33': {
                name: '(anonymous_33)',
                decl: {
                    start: {
                        line: 188,
                        column: 49
                    },
                    end: {
                        line: 188,
                        column: 50
                    }
                },
                loc: {
                    start: {
                        line: 188,
                        column: 66
                    },
                    end: {
                        line: 190,
                        column: 9
                    }
                },
                line: 188
            },
            '34': {
                name: '(anonymous_34)',
                decl: {
                    start: {
                        line: 193,
                        column: 4
                    },
                    end: {
                        line: 193,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 193,
                        column: 31
                    },
                    end: {
                        line: 200,
                        column: 5
                    }
                },
                line: 193
            },
            '35': {
                name: '(anonymous_35)',
                decl: {
                    start: {
                        line: 194,
                        column: 53
                    },
                    end: {
                        line: 194,
                        column: 54
                    }
                },
                loc: {
                    start: {
                        line: 194,
                        column: 74
                    },
                    end: {
                        line: 199,
                        column: 9
                    }
                },
                line: 194
            },
            '36': {
                name: '(anonymous_36)',
                decl: {
                    start: {
                        line: 202,
                        column: 4
                    },
                    end: {
                        line: 202,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 202,
                        column: 30
                    },
                    end: {
                        line: 206,
                        column: 5
                    }
                },
                line: 202
            },
            '37': {
                name: '(anonymous_37)',
                decl: {
                    start: {
                        line: 203,
                        column: 39
                    },
                    end: {
                        line: 203,
                        column: 40
                    }
                },
                loc: {
                    start: {
                        line: 203,
                        column: 45
                    },
                    end: {
                        line: 205,
                        column: 9
                    }
                },
                line: 203
            },
            '38': {
                name: '(anonymous_38)',
                decl: {
                    start: {
                        line: 208,
                        column: 4
                    },
                    end: {
                        line: 208,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 208,
                        column: 27
                    },
                    end: {
                        line: 212,
                        column: 5
                    }
                },
                line: 208
            },
            '39': {
                name: '(anonymous_39)',
                decl: {
                    start: {
                        line: 209,
                        column: 33
                    },
                    end: {
                        line: 209,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 209,
                        column: 39
                    },
                    end: {
                        line: 211,
                        column: 9
                    }
                },
                line: 209
            },
            '40': {
                name: '(anonymous_40)',
                decl: {
                    start: {
                        line: 214,
                        column: 4
                    },
                    end: {
                        line: 214,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 214,
                        column: 19
                    },
                    end: {
                        line: 217,
                        column: 5
                    }
                },
                line: 214
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 21,
                        column: 12
                    },
                    end: {
                        line: 28,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 21,
                        column: 12
                    },
                    end: {
                        line: 28,
                        column: 13
                    }
                }, {
                    start: {
                        line: 21,
                        column: 12
                    },
                    end: {
                        line: 28,
                        column: 13
                    }
                }],
                line: 21
            },
            '1': {
                loc: {
                    start: {
                        line: 33,
                        column: 12
                    },
                    end: {
                        line: 40,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 33,
                        column: 12
                    },
                    end: {
                        line: 40,
                        column: 13
                    }
                }, {
                    start: {
                        line: 33,
                        column: 12
                    },
                    end: {
                        line: 40,
                        column: 13
                    }
                }],
                line: 33
            },
            '2': {
                loc: {
                    start: {
                        line: 43,
                        column: 12
                    },
                    end: {
                        line: 45,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 43,
                        column: 12
                    },
                    end: {
                        line: 45,
                        column: 13
                    }
                }, {
                    start: {
                        line: 43,
                        column: 12
                    },
                    end: {
                        line: 45,
                        column: 13
                    }
                }],
                line: 43
            },
            '3': {
                loc: {
                    start: {
                        line: 87,
                        column: 8
                    },
                    end: {
                        line: 92,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 87,
                        column: 8
                    },
                    end: {
                        line: 92,
                        column: 9
                    }
                }, {
                    start: {
                        line: 87,
                        column: 8
                    },
                    end: {
                        line: 92,
                        column: 9
                    }
                }],
                line: 87
            },
            '4': {
                loc: {
                    start: {
                        line: 89,
                        column: 12
                    },
                    end: {
                        line: 91,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 89,
                        column: 12
                    },
                    end: {
                        line: 91,
                        column: 13
                    }
                }, {
                    start: {
                        line: 89,
                        column: 12
                    },
                    end: {
                        line: 91,
                        column: 13
                    }
                }],
                line: 89
            },
            '5': {
                loc: {
                    start: {
                        line: 89,
                        column: 16
                    },
                    end: {
                        line: 89,
                        column: 33
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 89,
                        column: 16
                    },
                    end: {
                        line: 89,
                        column: 17
                    }
                }, {
                    start: {
                        line: 89,
                        column: 21
                    },
                    end: {
                        line: 89,
                        column: 33
                    }
                }],
                line: 89
            },
            '6': {
                loc: {
                    start: {
                        line: 123,
                        column: 8
                    },
                    end: {
                        line: 125,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 123,
                        column: 8
                    },
                    end: {
                        line: 125,
                        column: 9
                    }
                }, {
                    start: {
                        line: 123,
                        column: 8
                    },
                    end: {
                        line: 125,
                        column: 9
                    }
                }],
                line: 123
            },
            '7': {
                loc: {
                    start: {
                        line: 126,
                        column: 8
                    },
                    end: {
                        line: 128,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 126,
                        column: 8
                    },
                    end: {
                        line: 128,
                        column: 9
                    }
                }, {
                    start: {
                        line: 126,
                        column: 8
                    },
                    end: {
                        line: 128,
                        column: 9
                    }
                }],
                line: 126
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0,
            '30': 0,
            '31': 0,
            '32': 0,
            '33': 0,
            '34': 0,
            '35': 0,
            '36': 0,
            '37': 0,
            '38': 0,
            '39': 0,
            '40': 0,
            '41': 0,
            '42': 0,
            '43': 0,
            '44': 0,
            '45': 0,
            '46': 0,
            '47': 0,
            '48': 0,
            '49': 0,
            '50': 0,
            '51': 0,
            '52': 0,
            '53': 0,
            '54': 0,
            '55': 0,
            '56': 0,
            '57': 0,
            '58': 0,
            '59': 0,
            '60': 0,
            '61': 0,
            '62': 0,
            '63': 0,
            '64': 0,
            '65': 0,
            '66': 0,
            '67': 0,
            '68': 0,
            '69': 0,
            '70': 0,
            '71': 0,
            '72': 0,
            '73': 0,
            '74': 0,
            '75': 0,
            '76': 0,
            '77': 0,
            '78': 0,
            '79': 0,
            '80': 0,
            '81': 0,
            '82': 0,
            '83': 0,
            '84': 0,
            '85': 0,
            '86': 0,
            '87': 0,
            '88': 0,
            '89': 0,
            '90': 0,
            '91': 0,
            '92': 0,
            '93': 0,
            '94': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0,
            '30': 0,
            '31': 0,
            '32': 0,
            '33': 0,
            '34': 0,
            '35': 0,
            '36': 0,
            '37': 0,
            '38': 0,
            '39': 0,
            '40': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0],
            '3': [0, 0],
            '4': [0, 0],
            '5': [0, 0],
            '6': [0, 0],
            '7': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProposalDetailsController = function () {
    ProposalDetailsController.$inject = ["$scope", "MediaTable", "MediaSelectorService", "UserStorySelectorService", "AppSettings", "UserStoriesTable", "ProposalFilesTable", "$filter", "$rootScope"];
    function ProposalDetailsController($scope, MediaTable, MediaSelectorService, UserStorySelectorService, AppSettings, UserStoriesTable, ProposalFilesTable, $filter, $rootScope) {
        var _this = this;

        _classCallCheck(this, ProposalDetailsController);

        cov_k62wb9q4g.f[0]++;
        cov_k62wb9q4g.s[0]++;

        this.MediaSelectorService = MediaSelectorService;
        cov_k62wb9q4g.s[1]++;
        this.UserStorySelectorService = UserStorySelectorService;
        cov_k62wb9q4g.s[2]++;
        this.proposalsApp = AppSettings.proposalsApp;
        cov_k62wb9q4g.s[3]++;
        this.UserStoriesTable = UserStoriesTable;
        cov_k62wb9q4g.s[4]++;
        this.ProposalFilesTable = ProposalFilesTable;
        cov_k62wb9q4g.s[5]++;
        this.currentNav = 'details';
        cov_k62wb9q4g.s[6]++;
        this.$filter = $filter;

        /* eslint-disable angular/on-watch */
        cov_k62wb9q4g.s[7]++;
        $rootScope.$on('fileClose', function (event, file) {
            cov_k62wb9q4g.f[1]++;
            cov_k62wb9q4g.s[8]++;

            // eslint-disable-next-line camelcase
            file.$destroy().$then(function () {
                cov_k62wb9q4g.f[2]++;
                cov_k62wb9q4g.s[9]++;

                _this._parseComments();
            });
        });
        cov_k62wb9q4g.s[10]++;
        this.uploadedFiles = ProposalFilesTable.$collection();
        cov_k62wb9q4g.s[11]++;
        $scope.$watch('$ctrl.fileUpload', function (uploaded) {
            cov_k62wb9q4g.f[3]++;
            cov_k62wb9q4g.s[12]++;

            if (angular.isString(uploaded)) {
                cov_k62wb9q4g.b[0][0]++;
                cov_k62wb9q4g.s[13]++;

                _this.uploadedFiles.$build({
                    proposal: _this.proposal.id,
                    path: uploaded,
                    name: _this.fileToName(_this.fileUpload)
                }).$reveal();
                cov_k62wb9q4g.s[14]++;
                _this.fileUpload = null;
            } else {
                cov_k62wb9q4g.b[0][1]++;
            }
        });

        // files
        cov_k62wb9q4g.s[15]++;
        $scope.$watch('$ctrl.newFileAttachment', function (newVal) {
            cov_k62wb9q4g.f[4]++;
            cov_k62wb9q4g.s[16]++;

            if (angular.isString(newVal)) {
                cov_k62wb9q4g.b[1][0]++;
                cov_k62wb9q4g.s[17]++;

                _this.proposal.$files.$create({
                    proposal: _this.proposal.id,
                    path: newVal,
                    name: _this.fileToName(newVal)
                });
                cov_k62wb9q4g.s[18]++;
                _this.medias.$refresh();
            } else {
                cov_k62wb9q4g.b[1][1]++;
            }
        });
        cov_k62wb9q4g.s[19]++;
        $scope.$watch('$ctrl.newSection.cover', function (newVal) {
            cov_k62wb9q4g.f[5]++;
            cov_k62wb9q4g.s[20]++;

            if (angular.isString(newVal)) {
                cov_k62wb9q4g.b[2][0]++;
                cov_k62wb9q4g.s[21]++;

                _this.medias.$refresh();
            } else {
                cov_k62wb9q4g.b[2][1]++;
            }
        });
        cov_k62wb9q4g.s[22]++;
        this.sortableServices = {
            orderChanged: function orderChanged(event) {
                cov_k62wb9q4g.f[6]++;

                var newPos = (cov_k62wb9q4g.s[23]++, event.dest.index + 1);
                var service = (cov_k62wb9q4g.s[24]++, event.source.itemScope.service);
                cov_k62wb9q4g.s[25]++;
                service.order = newPos;

                cov_k62wb9q4g.s[26]++;
                service.$save(['order']).$then(function () {
                    cov_k62wb9q4g.f[7]++;
                    cov_k62wb9q4g.s[27]++;

                    _this.proposal.$proposalServices.$refresh();
                });
            },
            placeholder: '<div style="min-height: 60px;"></div>'
        };
        cov_k62wb9q4g.s[28]++;
        this.sortableSections = {
            orderChanged: function orderChanged(event) {
                cov_k62wb9q4g.f[8]++;

                var newPos = (cov_k62wb9q4g.s[29]++, event.dest.index + 1);
                var section = (cov_k62wb9q4g.s[30]++, event.source.itemScope.section);
                cov_k62wb9q4g.s[31]++;
                section.order = newPos;

                cov_k62wb9q4g.s[32]++;
                section.$save(['order']).$then(function () {
                    cov_k62wb9q4g.f[9]++;
                    cov_k62wb9q4g.s[33]++;

                    _this.proposal.$proposalSections.$refresh();
                });
            },
            placeholder: '<div style="min-height: 60px;"></div>'
        };
        cov_k62wb9q4g.s[34]++;
        this.sortableStories = {
            orderChanged: function orderChanged(event) {
                cov_k62wb9q4g.f[10]++;

                var newPos = (cov_k62wb9q4g.s[35]++, event.dest.index + 1);
                var story = (cov_k62wb9q4g.s[36]++, event.source.itemScope.story);
                cov_k62wb9q4g.s[37]++;
                story.order = newPos;

                cov_k62wb9q4g.s[38]++;
                story.$save(['order']).$then(function () {
                    cov_k62wb9q4g.f[11]++;
                    cov_k62wb9q4g.s[39]++;

                    _this.proposal.$userStories.$refresh();
                });
            },
            placeholder: '<div style="min-height: 60px;"></div>'
        };
        cov_k62wb9q4g.s[40]++;
        this.medias = MediaTable.$search();
    }

    _createClass(ProposalDetailsController, [{
        key: 'fileToName',
        value: function fileToName(url) {
            cov_k62wb9q4g.f[12]++;
            cov_k62wb9q4g.s[41]++;

            if (url) {
                cov_k62wb9q4g.b[3][0]++;

                var m = (cov_k62wb9q4g.s[42]++, url.toString().match(/.*\/(.+?)\.(.+)/));
                cov_k62wb9q4g.s[43]++;
                if ((cov_k62wb9q4g.b[5][0]++, m) && (cov_k62wb9q4g.b[5][1]++, m.length > 1)) {
                    cov_k62wb9q4g.b[4][0]++;
                    cov_k62wb9q4g.s[44]++;

                    return m[1] + '.' + m[2];
                } else {
                    cov_k62wb9q4g.b[4][1]++;
                }
            } else {
                cov_k62wb9q4g.b[3][1]++;
            }
            cov_k62wb9q4g.s[45]++;
            return "";
        }
    }, {
        key: '_buildComment',
        value: function _buildComment() {
            cov_k62wb9q4g.f[13]++;
            cov_k62wb9q4g.s[46]++;

            this.newComment = this.proposal.$comments.$build({
                objectType: 'PROPOSAL',
                objectId: this.proposal.id
            });
        }
    }, {
        key: '_buildSection',
        value: function _buildSection() {
            cov_k62wb9q4g.f[14]++;
            cov_k62wb9q4g.s[47]++;

            this.newSection = this.proposal.$proposalSections.$build({
                proposal: this.proposal.id
            });
        }
    }, {
        key: '_buildService',
        value: function _buildService() {
            cov_k62wb9q4g.f[15]++;
            cov_k62wb9q4g.s[48]++;

            this.newService = this.proposal.$proposalServices.$build({
                proposal: this.proposal.id
            });
        }
    }, {
        key: '_buildUserStory',
        value: function _buildUserStory() {
            cov_k62wb9q4g.f[16]++;
            cov_k62wb9q4g.s[49]++;

            this.newStory = this.proposal.$userStories.$build({
                proposal: this.proposal.id
            });
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            cov_k62wb9q4g.f[17]++;
            cov_k62wb9q4g.s[50]++;

            this.proposal.$load('proposalServices').$load('proposalSections').$load('client').$load('files').$load('comments').$load('userStories');
            cov_k62wb9q4g.s[51]++;
            if (this.proposal.expirationDate !== null) {
                cov_k62wb9q4g.b[6][0]++;
                cov_k62wb9q4g.s[52]++;

                this.expirationDate = this.proposal.expirationDate;
            } else {
                cov_k62wb9q4g.b[6][1]++;
            }
            cov_k62wb9q4g.s[53]++;
            if (this.proposal.date !== null) {
                cov_k62wb9q4g.b[7][0]++;
                cov_k62wb9q4g.s[54]++;

                this.proposalDate = this.proposal.date;
            } else {
                cov_k62wb9q4g.b[7][1]++;
            }
            cov_k62wb9q4g.s[55]++;
            this.selectedMedia = null;
            cov_k62wb9q4g.s[56]++;
            this._buildComment();
            cov_k62wb9q4g.s[57]++;
            this._buildSection();
            cov_k62wb9q4g.s[58]++;
            this._buildService();
            cov_k62wb9q4g.s[59]++;
            this._buildUserStory();
            cov_k62wb9q4g.s[60]++;
            this._parseComments();
        }
    }, {
        key: 'addProposalService',
        value: function addProposalService() {
            var _this2 = this;

            cov_k62wb9q4g.f[18]++;
            cov_k62wb9q4g.s[61]++;

            this.newService.$save().$then(function () {
                cov_k62wb9q4g.f[19]++;
                cov_k62wb9q4g.s[62]++;

                _this2.proposal.$refresh(['total_price']);
                cov_k62wb9q4g.s[63]++;
                _this2._buildService();
            });
        }
    }, {
        key: 'addProposalSection',
        value: function addProposalSection() {
            var _this3 = this;

            cov_k62wb9q4g.f[20]++;
            cov_k62wb9q4g.s[64]++;

            this.newSection.$save().$then(function () {
                cov_k62wb9q4g.f[21]++;
                cov_k62wb9q4g.s[65]++;

                _this3._buildSection();
            });
        }
    }, {
        key: 'addUserStory',
        value: function addUserStory() {
            var _this4 = this;

            cov_k62wb9q4g.f[22]++;
            cov_k62wb9q4g.s[66]++;

            this.newStory.$save().$then(function () {
                cov_k62wb9q4g.f[23]++;
                cov_k62wb9q4g.s[67]++;

                _this4._buildUserStory();
            });
        }
    }, {
        key: 'addComment',
        value: function addComment() {
            var _this5 = this;

            cov_k62wb9q4g.f[24]++;
            cov_k62wb9q4g.s[68]++;

            this.newComment.$save().$then(function (comment) {
                cov_k62wb9q4g.f[25]++;
                cov_k62wb9q4g.s[69]++;

                _this5._parseComment(comment);
                cov_k62wb9q4g.s[70]++;
                _this5.uploadedFiles.forEach(function (file) {
                    cov_k62wb9q4g.f[26]++;
                    cov_k62wb9q4g.s[71]++;

                    file.comment = comment.id;
                    cov_k62wb9q4g.s[72]++;
                    comment.$files.$add(file);
                    cov_k62wb9q4g.s[73]++;
                    file.$save().$reveal();
                });

                cov_k62wb9q4g.s[74]++;
                _this5.uploadedFiles.$clear();
                cov_k62wb9q4g.s[75]++;
                _this5.proposal.$comments.$add(comment).$then(function (comment) {
                    cov_k62wb9q4g.f[27]++;
                    cov_k62wb9q4g.s[76]++;

                    _this5._parseComment(comment);
                });
                cov_k62wb9q4g.s[77]++;
                _this5.proposal.$load('files');
                cov_k62wb9q4g.s[78]++;
                _this5._buildComment();
            });
        }
    }, {
        key: '_parseComment',
        value: function _parseComment(comment) {
            cov_k62wb9q4g.f[28]++;
            cov_k62wb9q4g.s[79]++;

            comment.$files = this.ProposalFilesTable.$search({ comment: comment.id });
            cov_k62wb9q4g.s[80]++;
            comment.$load('user');
        }
    }, {
        key: '_parseComments',
        value: function _parseComments() {
            var _this6 = this;

            cov_k62wb9q4g.f[29]++;
            cov_k62wb9q4g.s[81]++;

            this.proposal.$comments.$then(function (comments) {
                cov_k62wb9q4g.f[30]++;
                cov_k62wb9q4g.s[82]++;

                comments.forEach(function (comment) {
                    cov_k62wb9q4g.f[31]++;
                    cov_k62wb9q4g.s[83]++;

                    _this6._parseComment(comment);
                });
            });
        }
    }, {
        key: 'displayMediaSelector',
        value: function displayMediaSelector() {
            var _this7 = this;

            cov_k62wb9q4g.f[32]++;
            cov_k62wb9q4g.s[84]++;

            this.MediaSelectorService.display().then(function (selectedMedia) {
                cov_k62wb9q4g.f[33]++;
                cov_k62wb9q4g.s[85]++;

                _this7.newSection.cover = selectedMedia;
            });
        }
    }, {
        key: 'displayUserStorySelector',
        value: function displayUserStorySelector() {
            var _this8 = this;

            cov_k62wb9q4g.f[34]++;
            cov_k62wb9q4g.s[86]++;

            this.UserStorySelectorService.display().then(function (selectedUserStory) {
                cov_k62wb9q4g.f[35]++;
                cov_k62wb9q4g.s[87]++;

                _this8.proposal.$userStories.$create({
                    proposal: _this8.proposal.id,
                    name: selectedUserStory
                });
            });
        }
    }, {
        key: 'saveServicePrice',
        value: function saveServicePrice(service) {
            var _this9 = this;

            cov_k62wb9q4g.f[36]++;
            cov_k62wb9q4g.s[88]++;

            service.$save(['price']).$then(function () {
                cov_k62wb9q4g.f[37]++;
                cov_k62wb9q4g.s[89]++;

                _this9.proposal.$refresh(['total_price']);
            });
        }
    }, {
        key: 'deleteService',
        value: function deleteService(service) {
            var _this10 = this;

            cov_k62wb9q4g.f[38]++;
            cov_k62wb9q4g.s[90]++;

            service.$destroy().$then(function () {
                cov_k62wb9q4g.f[39]++;
                cov_k62wb9q4g.s[91]++;

                _this10.proposal.$refresh(['total_price']);
            });
        }
    }, {
        key: 'saveDate',
        value: function saveDate(date) {
            cov_k62wb9q4g.f[40]++;
            cov_k62wb9q4g.s[92]++;

            this.proposal.date = this.$filter('date')(new Date(date), 'yyyy-MM-dd');
            cov_k62wb9q4g.s[93]++;
            this.proposal.$save(['date']);
        }
    }]);

    return ProposalDetailsController;
}();

cov_k62wb9q4g.s[94]++;


angular.module('app').component('proposalDetails', {
    templateUrl: 'app/components/proposalDetails/proposalDetails.html',
    controller: ProposalDetailsController,
    bindings: {
        proposal: '<'
    }
});
'use strict';

var cov_1z5n2ygse = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/profileLevel/profileLevel.js',
        hash = 'fed890248476a6d3291c3048cd1cf1a3d6e47b36',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/profileLevel/profileLevel.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 8,
                    column: 3
                }
            }
        },
        fnMap: {},
        branchMap: {},
        s: {
            '0': 0
        },
        f: {},
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1z5n2ygse.s[0]++;
angular.module('app').component('profileLevel', {
    templateUrl: 'app/components/profileLevel/profileLevel.html',
    bindings: {
        level: '<'
    }
});
'use strict';

var cov_11ewsvgklc = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/paginator/paginator.js',
        hash = 'e34db71de1b2c96e1c1c2030cd7a1cbe1b1cd136',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/paginator/paginator.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 64
                }
            },
            '1': {
                start: {
                    line: 8,
                    column: 25
                },
                end: {
                    line: 8,
                    column: 65
                }
            },
            '2': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 9,
                    column: 32
                }
            },
            '3': {
                start: {
                    line: 13,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 9
                }
            },
            '4': {
                start: {
                    line: 14,
                    column: 12
                },
                end: {
                    line: 14,
                    column: 38
                }
            },
            '5': {
                start: {
                    line: 16,
                    column: 22
                },
                end: {
                    line: 16,
                    column: 47
                }
            },
            '6': {
                start: {
                    line: 17,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 28
                }
            },
            '7': {
                start: {
                    line: 21,
                    column: 8
                },
                end: {
                    line: 21,
                    column: 37
                }
            },
            '8': {
                start: {
                    line: 22,
                    column: 8
                },
                end: {
                    line: 22,
                    column: 35
                }
            },
            '9': {
                start: {
                    line: 26,
                    column: 0
                },
                end: {
                    line: 34,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 14
                    },
                    end: {
                        line: 5,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 7,
                        column: 4
                    },
                    end: {
                        line: 7,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 7,
                        column: 23
                    },
                    end: {
                        line: 10,
                        column: 5
                    }
                },
                line: 7
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 12,
                        column: 4
                    },
                    end: {
                        line: 12,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 12,
                        column: 19
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 12
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 20,
                        column: 4
                    },
                    end: {
                        line: 20,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 19
                    },
                    end: {
                        line: 23,
                        column: 5
                    }
                },
                line: 20
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 4,
                        column: 24
                    },
                    end: {
                        line: 4,
                        column: 63
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 4,
                        column: 24
                    },
                    end: {
                        line: 4,
                        column: 57
                    }
                }, {
                    start: {
                        line: 4,
                        column: 61
                    },
                    end: {
                        line: 4,
                        column: 63
                    }
                }],
                line: 4
            },
            '1': {
                loc: {
                    start: {
                        line: 13,
                        column: 8
                    },
                    end: {
                        line: 15,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 13,
                        column: 8
                    },
                    end: {
                        line: 15,
                        column: 9
                    }
                }, {
                    start: {
                        line: 13,
                        column: 8
                    },
                    end: {
                        line: 15,
                        column: 9
                    }
                }],
                line: 13
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PaginatorController = function () {
    function PaginatorController() {
        _classCallCheck(this, PaginatorController);
    }

    _createClass(PaginatorController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_11ewsvgklc.f[0]++;
            cov_11ewsvgklc.s[0]++;

            this.pageSize = (cov_11ewsvgklc.b[0][0]++, this.collection.$params.page_size) || (cov_11ewsvgklc.b[0][1]++, 25);
        }
    }, {
        key: 'goToPreviousPage',
        value: function goToPreviousPage() {
            cov_11ewsvgklc.f[1]++;

            var previous = (cov_11ewsvgklc.s[1]++, Math.max(1, this.collection.$page - 1));
            cov_11ewsvgklc.s[2]++;
            this.goToPage(previous);
        }
    }, {
        key: 'goToNextPage',
        value: function goToNextPage() {
            cov_11ewsvgklc.f[2]++;
            cov_11ewsvgklc.s[3]++;

            if (!this.collection.$page) {
                cov_11ewsvgklc.b[1][0]++;
                cov_11ewsvgklc.s[4]++;

                this.collection.$page = 0;
            } else {
                cov_11ewsvgklc.b[1][1]++;
            }
            var next = (cov_11ewsvgklc.s[5]++, this.collection.$page + 1);
            cov_11ewsvgklc.s[6]++;
            this.goToPage(next);
        }
    }, {
        key: 'goToPage',
        value: function goToPage(page) {
            cov_11ewsvgklc.f[3]++;
            cov_11ewsvgklc.s[7]++;

            this.collection.$page = page;
            cov_11ewsvgklc.s[8]++;
            this.collection.$refresh();
        }
    }]);

    return PaginatorController;
}();

cov_11ewsvgklc.s[9]++;


angular.module('app').component('paginator', {
    templateUrl: 'app/components/paginator/paginator.html',
    controller: PaginatorController,
    bindings: {
        collection: '<'
    }
});
'use strict';

var cov_1ono14yl7f = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/pagination/pagination.js',
        hash = '45b5cdec1e6f2b97f1f634373dc2ee948f62fc6a',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/pagination/pagination.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 37
                }
            },
            '1': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 22
                }
            },
            '2': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 9,
                    column: 55
                }
            },
            '3': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 29
                }
            },
            '4': {
                start: {
                    line: 14,
                    column: 0
                },
                end: {
                    line: 23,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 28
                    },
                    end: {
                        line: 5,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 7,
                        column: 4
                    },
                    end: {
                        line: 7,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 7,
                        column: 14
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                line: 7
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PaginationController = function () {
    PaginationController.$inject = ["$rootScope"];
    function PaginationController($rootScope) {
        _classCallCheck(this, PaginationController);

        cov_1ono14yl7f.f[0]++;
        cov_1ono14yl7f.s[0]++;

        this.$rootScope = $rootScope;
    }

    _createClass(PaginationController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_1ono14yl7f.f[1]++;
            cov_1ono14yl7f.s[1]++;

            this.page = 1;
            cov_1ono14yl7f.s[2]++;
            this.links = Math.ceil(this.count / this.size);
            cov_1ono14yl7f.s[3]++;
            this.counter = Array;
        }
    }]);

    return PaginationController;
}();

cov_1ono14yl7f.s[4]++;


angular.module('app').component('pagination', {
    templateUrl: 'app/components/pagination/pagination.html',
    controller: PaginationController,
    bindings: {
        count: '<',
        size: '<'
    }
});
'use strict';

var cov_2dsjyf4vcb = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/organizationsList/organizationsList.js',
        hash = '1aa5eaee59e230c112c718e1327b4658838f6c33',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/organizationsList/organizationsList.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 71
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 55
                }
            },
            '2': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 6,
                    column: 45
                }
            },
            '3': {
                start: {
                    line: 7,
                    column: 8
                },
                end: {
                    line: 7,
                    column: 35
                }
            },
            '4': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 26
                }
            },
            '5': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 9,
                    column: 45
                }
            },
            '6': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 41
                }
            },
            '7': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 35
                }
            },
            '8': {
                start: {
                    line: 15,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 41
                }
            },
            '9': {
                start: {
                    line: 18,
                    column: 8
                },
                end: {
                    line: 18,
                    column: 82
                }
            },
            '10': {
                start: {
                    line: 19,
                    column: 8
                },
                end: {
                    line: 19,
                    column: 55
                }
            },
            '11': {
                start: {
                    line: 20,
                    column: 8
                },
                end: {
                    line: 20,
                    column: 62
                }
            },
            '12': {
                start: {
                    line: 23,
                    column: 8
                },
                end: {
                    line: 23,
                    column: 47
                }
            },
            '13': {
                start: {
                    line: 24,
                    column: 8
                },
                end: {
                    line: 24,
                    column: 65
                }
            },
            '14': {
                start: {
                    line: 25,
                    column: 8
                },
                end: {
                    line: 25,
                    column: 57
                }
            },
            '15': {
                start: {
                    line: 26,
                    column: 8
                },
                end: {
                    line: 26,
                    column: 49
                }
            },
            '16': {
                start: {
                    line: 27,
                    column: 8
                },
                end: {
                    line: 27,
                    column: 71
                }
            },
            '17': {
                start: {
                    line: 28,
                    column: 8
                },
                end: {
                    line: 28,
                    column: 66
                }
            },
            '18': {
                start: {
                    line: 29,
                    column: 8
                },
                end: {
                    line: 29,
                    column: 64
                }
            },
            '19': {
                start: {
                    line: 30,
                    column: 8
                },
                end: {
                    line: 30,
                    column: 59
                }
            },
            '20': {
                start: {
                    line: 31,
                    column: 8
                },
                end: {
                    line: 31,
                    column: 64
                }
            },
            '21': {
                start: {
                    line: 32,
                    column: 8
                },
                end: {
                    line: 32,
                    column: 64
                }
            },
            '22': {
                start: {
                    line: 34,
                    column: 8
                },
                end: {
                    line: 36,
                    column: 10
                }
            },
            '23': {
                start: {
                    line: 38,
                    column: 8
                },
                end: {
                    line: 38,
                    column: 24
                }
            },
            '24': {
                start: {
                    line: 42,
                    column: 8
                },
                end: {
                    line: 44,
                    column: 9
                }
            },
            '25': {
                start: {
                    line: 43,
                    column: 12
                },
                end: {
                    line: 43,
                    column: 36
                }
            },
            '26': {
                start: {
                    line: 46,
                    column: 8
                },
                end: {
                    line: 46,
                    column: 39
                }
            },
            '27': {
                start: {
                    line: 47,
                    column: 8
                },
                end: {
                    line: 47,
                    column: 43
                }
            },
            '28': {
                start: {
                    line: 48,
                    column: 8
                },
                end: {
                    line: 48,
                    column: 43
                }
            },
            '29': {
                start: {
                    line: 50,
                    column: 8
                },
                end: {
                    line: 54,
                    column: 9
                }
            },
            '30': {
                start: {
                    line: 51,
                    column: 12
                },
                end: {
                    line: 51,
                    column: 40
                }
            },
            '31': {
                start: {
                    line: 53,
                    column: 12
                },
                end: {
                    line: 53,
                    column: 41
                }
            },
            '32': {
                start: {
                    line: 56,
                    column: 8
                },
                end: {
                    line: 56,
                    column: 45
                }
            },
            '33': {
                start: {
                    line: 57,
                    column: 8
                },
                end: {
                    line: 57,
                    column: 24
                }
            },
            '34': {
                start: {
                    line: 61,
                    column: 8
                },
                end: {
                    line: 61,
                    column: 50
                }
            },
            '35': {
                start: {
                    line: 65,
                    column: 8
                },
                end: {
                    line: 68,
                    column: 11
                }
            },
            '36': {
                start: {
                    line: 66,
                    column: 12
                },
                end: {
                    line: 66,
                    column: 50
                }
            },
            '37': {
                start: {
                    line: 72,
                    column: 0
                },
                end: {
                    line: 80,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 118
                    },
                    end: {
                        line: 12,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 14,
                        column: 4
                    },
                    end: {
                        line: 14,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 14
                    },
                    end: {
                        line: 39,
                        column: 5
                    }
                },
                line: 14
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 41,
                        column: 4
                    },
                    end: {
                        line: 41,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 41,
                        column: 33
                    },
                    end: {
                        line: 58,
                        column: 5
                    }
                },
                line: 41
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 60,
                        column: 4
                    },
                    end: {
                        line: 60,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 60,
                        column: 15
                    },
                    end: {
                        line: 62,
                        column: 5
                    }
                },
                line: 60
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 64,
                        column: 4
                    },
                    end: {
                        line: 64,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 64,
                        column: 34
                    },
                    end: {
                        line: 69,
                        column: 5
                    }
                },
                line: 64
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 65,
                        column: 56
                    },
                    end: {
                        line: 65,
                        column: 57
                    }
                },
                loc: {
                    start: {
                        line: 65,
                        column: 72
                    },
                    end: {
                        line: 67,
                        column: 9
                    }
                },
                line: 65
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 67,
                        column: 11
                    },
                    end: {
                        line: 67,
                        column: 12
                    }
                },
                loc: {
                    start: {
                        line: 67,
                        column: 23
                    },
                    end: {
                        line: 68,
                        column: 9
                    }
                },
                line: 67
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 42,
                        column: 8
                    },
                    end: {
                        line: 44,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 42,
                        column: 8
                    },
                    end: {
                        line: 44,
                        column: 9
                    }
                }, {
                    start: {
                        line: 42,
                        column: 8
                    },
                    end: {
                        line: 44,
                        column: 9
                    }
                }],
                line: 42
            },
            '1': {
                loc: {
                    start: {
                        line: 50,
                        column: 8
                    },
                    end: {
                        line: 54,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 50,
                        column: 8
                    },
                    end: {
                        line: 54,
                        column: 9
                    }
                }, {
                    start: {
                        line: 50,
                        column: 8
                    },
                    end: {
                        line: 54,
                        column: 9
                    }
                }],
                line: 50
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0,
            '30': 0,
            '31': 0,
            '32': 0,
            '33': 0,
            '34': 0,
            '35': 0,
            '36': 0,
            '37': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrganizationsListController = function () {
    OrganizationsListController.$inject = ["NewOrganizationModalService", "MunicipalitiesTable", "DistrictsTable", "TagsTable", "$stateParams", "$location"];
    function OrganizationsListController(NewOrganizationModalService, MunicipalitiesTable, DistrictsTable, TagsTable, $stateParams, $location) {
        _classCallCheck(this, OrganizationsListController);

        cov_2dsjyf4vcb.f[0]++;
        cov_2dsjyf4vcb.s[0]++;

        this.NewOrganizationModalService = NewOrganizationModalService;
        cov_2dsjyf4vcb.s[1]++;
        this.MunicipalitiesTable = MunicipalitiesTable;
        cov_2dsjyf4vcb.s[2]++;
        this.DistrictsTable = DistrictsTable;
        cov_2dsjyf4vcb.s[3]++;
        this.TagsTable = TagsTable;
        cov_2dsjyf4vcb.s[4]++;
        this.filters = {};
        cov_2dsjyf4vcb.s[5]++;
        this.filterYearFormat = 'foundation';
        cov_2dsjyf4vcb.s[6]++;
        this.$stateParams = $stateParams;
        cov_2dsjyf4vcb.s[7]++;
        this.$location = $location;
    }

    _createClass(OrganizationsListController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_2dsjyf4vcb.f[1]++;
            cov_2dsjyf4vcb.s[8]++;

            this.filters = this.$stateParams;

            /* eslint-disable camelcase */
            cov_2dsjyf4vcb.s[9]++;
            this.municipalities = this.MunicipalitiesTable.$search({ page_size: 9999 });
            cov_2dsjyf4vcb.s[10]++;
            this.districts = this.DistrictsTable.$search();
            cov_2dsjyf4vcb.s[11]++;
            this.tags = this.TagsTable.$search({ page_size: 9999 });

            // gettings filter state from state params
            cov_2dsjyf4vcb.s[12]++;
            this.tagFilter = this.$stateParams.tag;
            cov_2dsjyf4vcb.s[13]++;
            this.municipalityFilter = this.$stateParams.municipality;
            cov_2dsjyf4vcb.s[14]++;
            this.turnoverFilter = this.$stateParams.turnover;
            cov_2dsjyf4vcb.s[15]++;
            this.sizeFilter = this.$stateParams.size;
            cov_2dsjyf4vcb.s[16]++;
            this.districtFilter = this.$stateParams.municipality__district;
            cov_2dsjyf4vcb.s[17]++;
            this.profileLevelFilter = this.$stateParams.profile_level;
            cov_2dsjyf4vcb.s[18]++;
            this.interactionFilter = this.$stateParams.interactions;
            cov_2dsjyf4vcb.s[19]++;
            this.peopleFilter = this.$stateParams.people_count;
            cov_2dsjyf4vcb.s[20]++;
            this.targetStateFilter = this.$stateParams.target_state;
            cov_2dsjyf4vcb.s[21]++;
            this.targetScoreFilter = this.$stateParams.target_score;

            cov_2dsjyf4vcb.s[22]++;
            this.organizations.$params = {
                page_size: 25
            };

            cov_2dsjyf4vcb.s[23]++;
            this._refresh();
        }
    }, {
        key: 'changeFilters',
        value: function changeFilters(filter, value) {
            cov_2dsjyf4vcb.f[2]++;
            cov_2dsjyf4vcb.s[24]++;

            if (angular.isArray(value)) {
                cov_2dsjyf4vcb.b[0][0]++;
                cov_2dsjyf4vcb.s[25]++;

                value = value.join(',');
            } else {
                cov_2dsjyf4vcb.b[0][1]++;
            }

            cov_2dsjyf4vcb.s[26]++;
            delete this.filters.foundation;
            cov_2dsjyf4vcb.s[27]++;
            delete this.filters.foundation__lt;
            cov_2dsjyf4vcb.s[28]++;
            delete this.filters.foundation__gt;

            cov_2dsjyf4vcb.s[29]++;
            if (value === null) {
                cov_2dsjyf4vcb.b[1][0]++;
                cov_2dsjyf4vcb.s[30]++;

                delete this.filters[filter];
            } else {
                cov_2dsjyf4vcb.b[1][1]++;
                cov_2dsjyf4vcb.s[31]++;

                this.filters[filter] = value;
            }

            cov_2dsjyf4vcb.s[32]++;
            this.$location.search(filter, value);
            cov_2dsjyf4vcb.s[33]++;
            this._refresh();
        }
    }, {
        key: '_refresh',
        value: function _refresh() {
            cov_2dsjyf4vcb.f[3]++;
            cov_2dsjyf4vcb.s[34]++;

            this.organizations.$refresh(this.filters);
        }
    }, {
        key: 'displayNewOrganizationModal',
        value: function displayNewOrganizationModal() {
            var _this = this;

            cov_2dsjyf4vcb.f[4]++;
            cov_2dsjyf4vcb.s[35]++;

            this.NewOrganizationModalService.display().then(function (organization) {
                cov_2dsjyf4vcb.f[5]++;
                cov_2dsjyf4vcb.s[36]++;

                _this.organizations.$add(organization);
            }, function () {
                cov_2dsjyf4vcb.f[6]++;
            });
        }
    }]);

    return OrganizationsListController;
}();

cov_2dsjyf4vcb.s[37]++;


angular.module('app').component('organizationsList', {
    templateUrl: 'app/components/organizationsList/organizationsList.html',
    controller: OrganizationsListController,
    bindings: {
        organizations: '<'
    }
});
'use strict';

var cov_10q1dcowm2 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/organizationEmails/organizationEmails.js',
        hash = '83e09011a64498541cd33d95741a8cf7188b0f40',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/organizationEmails/organizationEmails.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 63
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 30
                }
            },
            '2': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 6,
                    column: 34
                }
            },
            '3': {
                start: {
                    line: 10,
                    column: 19
                },
                end: {
                    line: 10,
                    column: 172
                }
            },
            '4': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 52
                }
            },
            '5': {
                start: {
                    line: 15,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 34
                }
            },
            '6': {
                start: {
                    line: 16,
                    column: 8
                },
                end: {
                    line: 23,
                    column: 9
                }
            },
            '7': {
                start: {
                    line: 17,
                    column: 12
                },
                end: {
                    line: 17,
                    column: 33
                }
            },
            '8': {
                start: {
                    line: 18,
                    column: 12
                },
                end: {
                    line: 22,
                    column: 15
                }
            },
            '9': {
                start: {
                    line: 19,
                    column: 16
                },
                end: {
                    line: 19,
                    column: 38
                }
            },
            '10': {
                start: {
                    line: 20,
                    column: 16
                },
                end: {
                    line: 20,
                    column: 53
                }
            },
            '11': {
                start: {
                    line: 21,
                    column: 16
                },
                end: {
                    line: 21,
                    column: 35
                }
            },
            '12': {
                start: {
                    line: 28,
                    column: 0
                },
                end: {
                    line: 37,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 41
                    },
                    end: {
                        line: 7,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 9,
                        column: 4
                    },
                    end: {
                        line: 9,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 28
                    },
                    end: {
                        line: 12,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 14,
                        column: 4
                    },
                    end: {
                        line: 14,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 19
                    },
                    end: {
                        line: 24,
                        column: 5
                    }
                },
                line: 14
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 18,
                        column: 98
                    },
                    end: {
                        line: 18,
                        column: 99
                    }
                },
                loc: {
                    start: {
                        line: 18,
                        column: 110
                    },
                    end: {
                        line: 22,
                        column: 13
                    }
                },
                line: 18
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 16,
                        column: 8
                    },
                    end: {
                        line: 23,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 16,
                        column: 8
                    },
                    end: {
                        line: 23,
                        column: 9
                    }
                }, {
                    start: {
                        line: 16,
                        column: 8
                    },
                    end: {
                        line: 23,
                        column: 9
                    }
                }],
                line: 16
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrganizationEmailsController = function () {
    OrganizationEmailsController.$inject = ["EmailVerificationsTable"];
    function OrganizationEmailsController(EmailVerificationsTable) {
        _classCallCheck(this, OrganizationEmailsController);

        cov_10q1dcowm2.f[0]++;
        cov_10q1dcowm2.s[0]++;

        this.EmailVerificationsTable = EmailVerificationsTable;
        cov_10q1dcowm2.s[1]++;
        this.fetching = false;
        cov_10q1dcowm2.s[2]++;
        this.fetchedResult = null;
    }

    _createClass(OrganizationEmailsController, [{
        key: 'validEmailFormat',
        value: function validEmailFormat(email) {
            cov_10q1dcowm2.f[1]++;

            var re = (cov_10q1dcowm2.s[3]++, /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
            cov_10q1dcowm2.s[4]++;
            return re.test(String(email).toLowerCase());
        }
    }, {
        key: 'emailUpdated',
        value: function emailUpdated() {
            var _this = this;

            cov_10q1dcowm2.f[2]++;
            cov_10q1dcowm2.s[5]++;

            this.fetchedResult = null;
            cov_10q1dcowm2.s[6]++;
            if (this.validEmailFormat(this.newEmail)) {
                cov_10q1dcowm2.b[0][0]++;
                cov_10q1dcowm2.s[7]++;

                this.fetching = true;
                cov_10q1dcowm2.s[8]++;
                this.emails.$create({ email: this.newEmail, organization: this.organization.id }).$then(function (response) {
                    cov_10q1dcowm2.f[3]++;
                    cov_10q1dcowm2.s[9]++;

                    _this.fetching = false;
                    cov_10q1dcowm2.s[10]++;
                    _this.fetchedResult = response.result;
                    cov_10q1dcowm2.s[11]++;
                    _this.newEmail = '';
                });
            } else {
                cov_10q1dcowm2.b[0][1]++;
            }
        }
    }]);

    return OrganizationEmailsController;
}();

cov_10q1dcowm2.s[12]++;


angular.module('app').component('organizationEmails', {
    templateUrl: 'app/components/organizationEmails/organizationEmails.html',
    controller: OrganizationEmailsController,
    bindings: {
        emails: '<',
        organization: '<'
    }
});
'use strict';

var cov_13mb1tye9v = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/organizationEmail/organizationEmail.js',
        hash = '0ffba5c44ec421f28097048ecf9a13db69f23187',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/organizationEmail/organizationEmail.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 51
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 39
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 0
                },
                end: {
                    line: 18,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 21
                    },
                    end: {
                        line: 6,
                        column: 5
                    }
                },
                line: 3
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrganizationEmailController = function () {
    function OrganizationEmailController() {
        _classCallCheck(this, OrganizationEmailController);
    }

    _createClass(OrganizationEmailController, [{
        key: 'toogleVerified',
        value: function toogleVerified() {
            cov_13mb1tye9v.f[0]++;
            cov_13mb1tye9v.s[0]++;

            this.email.verified = !this.email.verified;
            cov_13mb1tye9v.s[1]++;
            this.email.$save(['verified']);
        }
    }]);

    return OrganizationEmailController;
}();

cov_13mb1tye9v.s[2]++;


angular.module('app').component('organizationEmail', {
    controller: OrganizationEmailController,
    templateUrl: 'app/components/organizationEmail/organizationEmail.html',
    bindings: {
        email: '<'
    }
});
'use strict';

var cov_4tcvznqaj = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/organizationDetails/organizationDetails.js',
        hash = '7221c4c6f809047c36245106ff98d294eecc5fdd',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/organizationDetails/organizationDetails.js',
        statementMap: {
            '0': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 6,
                    column: 55
                }
            },
            '1': {
                start: {
                    line: 7,
                    column: 8
                },
                end: {
                    line: 7,
                    column: 59
                }
            },
            '2': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 35
                }
            },
            '3': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 9,
                    column: 49
                }
            },
            '4': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 63
                }
            },
            '5': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 55
                }
            },
            '6': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 43
                }
            },
            '7': {
                start: {
                    line: 13,
                    column: 8
                },
                end: {
                    line: 13,
                    column: 31
                }
            },
            '8': {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 33
                }
            },
            '9': {
                start: {
                    line: 15,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 57
                }
            },
            '10': {
                start: {
                    line: 16,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 39
                }
            },
            '11': {
                start: {
                    line: 17,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 30
                }
            },
            '12': {
                start: {
                    line: 18,
                    column: 8
                },
                end: {
                    line: 18,
                    column: 34
                }
            },
            '13': {
                start: {
                    line: 19,
                    column: 8
                },
                end: {
                    line: 19,
                    column: 65
                }
            },
            '14': {
                start: {
                    line: 20,
                    column: 8
                },
                end: {
                    line: 20,
                    column: 37
                }
            },
            '15': {
                start: {
                    line: 21,
                    column: 8
                },
                end: {
                    line: 21,
                    column: 63
                }
            },
            '16': {
                start: {
                    line: 22,
                    column: 8
                },
                end: {
                    line: 22,
                    column: 65
                }
            },
            '17': {
                start: {
                    line: 23,
                    column: 8
                },
                end: {
                    line: 23,
                    column: 57
                }
            },
            '18': {
                start: {
                    line: 24,
                    column: 8
                },
                end: {
                    line: 24,
                    column: 55
                }
            },
            '19': {
                start: {
                    line: 25,
                    column: 8
                },
                end: {
                    line: 25,
                    column: 77
                }
            },
            '20': {
                start: {
                    line: 26,
                    column: 8
                },
                end: {
                    line: 26,
                    column: 51
                }
            },
            '21': {
                start: {
                    line: 27,
                    column: 8
                },
                end: {
                    line: 27,
                    column: 49
                }
            },
            '22': {
                start: {
                    line: 28,
                    column: 8
                },
                end: {
                    line: 28,
                    column: 75
                }
            },
            '23': {
                start: {
                    line: 29,
                    column: 8
                },
                end: {
                    line: 29,
                    column: 51
                }
            },
            '24': {
                start: {
                    line: 30,
                    column: 8
                },
                end: {
                    line: 30,
                    column: 33
                }
            },
            '25': {
                start: {
                    line: 31,
                    column: 8
                },
                end: {
                    line: 31,
                    column: 35
                }
            },
            '26': {
                start: {
                    line: 34,
                    column: 8
                },
                end: {
                    line: 42,
                    column: 11
                }
            },
            '27': {
                start: {
                    line: 35,
                    column: 12
                },
                end: {
                    line: 41,
                    column: 13
                }
            },
            '28': {
                start: {
                    line: 36,
                    column: 16
                },
                end: {
                    line: 40,
                    column: 19
                }
            },
            '29': {
                start: {
                    line: 46,
                    column: 12
                },
                end: {
                    line: 51,
                    column: 13
                }
            },
            '30': {
                start: {
                    line: 47,
                    column: 26
                },
                end: {
                    line: 47,
                    column: 65
                }
            },
            '31': {
                start: {
                    line: 48,
                    column: 16
                },
                end: {
                    line: 50,
                    column: 17
                }
            },
            '32': {
                start: {
                    line: 49,
                    column: 20
                },
                end: {
                    line: 49,
                    column: 45
                }
            },
            '33': {
                start: {
                    line: 52,
                    column: 12
                },
                end: {
                    line: 52,
                    column: 22
                }
            },
            '34': {
                start: {
                    line: 56,
                    column: 8
                },
                end: {
                    line: 56,
                    column: 209
                }
            },
            '35': {
                start: {
                    line: 57,
                    column: 8
                },
                end: {
                    line: 57,
                    column: 71
                }
            },
            '36': {
                start: {
                    line: 58,
                    column: 8
                },
                end: {
                    line: 58,
                    column: 50
                }
            },
            '37': {
                start: {
                    line: 59,
                    column: 8
                },
                end: {
                    line: 59,
                    column: 41
                }
            },
            '38': {
                start: {
                    line: 61,
                    column: 8
                },
                end: {
                    line: 61,
                    column: 61
                }
            },
            '39': {
                start: {
                    line: 62,
                    column: 8
                },
                end: {
                    line: 62,
                    column: 69
                }
            },
            '40': {
                start: {
                    line: 63,
                    column: 8
                },
                end: {
                    line: 63,
                    column: 45
                }
            },
            '41': {
                start: {
                    line: 64,
                    column: 8
                },
                end: {
                    line: 64,
                    column: 59
                }
            },
            '42': {
                start: {
                    line: 65,
                    column: 8
                },
                end: {
                    line: 65,
                    column: 83
                }
            },
            '43': {
                start: {
                    line: 67,
                    column: 8
                },
                end: {
                    line: 67,
                    column: 81
                }
            },
            '44': {
                start: {
                    line: 71,
                    column: 8
                },
                end: {
                    line: 76,
                    column: 52
                }
            },
            '45': {
                start: {
                    line: 76,
                    column: 23
                },
                end: {
                    line: 76,
                    column: 50
                }
            },
            '46': {
                start: {
                    line: 80,
                    column: 8
                },
                end: {
                    line: 83,
                    column: 42
                }
            },
            '47': {
                start: {
                    line: 83,
                    column: 24
                },
                end: {
                    line: 83,
                    column: 40
                }
            },
            '48': {
                start: {
                    line: 87,
                    column: 8
                },
                end: {
                    line: 90,
                    column: 81
                }
            },
            '49': {
                start: {
                    line: 90,
                    column: 37
                },
                end: {
                    line: 90,
                    column: 79
                }
            },
            '50': {
                start: {
                    line: 94,
                    column: 8
                },
                end: {
                    line: 98,
                    column: 87
                }
            },
            '51': {
                start: {
                    line: 98,
                    column: 43
                },
                end: {
                    line: 98,
                    column: 85
                }
            },
            '52': {
                start: {
                    line: 102,
                    column: 8
                },
                end: {
                    line: 109,
                    column: 53
                }
            },
            '53': {
                start: {
                    line: 109,
                    column: 23
                },
                end: {
                    line: 109,
                    column: 51
                }
            },
            '54': {
                start: {
                    line: 113,
                    column: 8
                },
                end: {
                    line: 114,
                    column: 74
                }
            },
            '55': {
                start: {
                    line: 114,
                    column: 22
                },
                end: {
                    line: 114,
                    column: 72
                }
            },
            '56': {
                start: {
                    line: 118,
                    column: 8
                },
                end: {
                    line: 118,
                    column: 45
                }
            },
            '57': {
                start: {
                    line: 122,
                    column: 8
                },
                end: {
                    line: 122,
                    column: 69
                }
            },
            '58': {
                start: {
                    line: 123,
                    column: 8
                },
                end: {
                    line: 123,
                    column: 48
                }
            },
            '59': {
                start: {
                    line: 127,
                    column: 25
                },
                end: {
                    line: 127,
                    column: 77
                }
            },
            '60': {
                start: {
                    line: 128,
                    column: 23
                },
                end: {
                    line: 142,
                    column: 9
                }
            },
            '61': {
                start: {
                    line: 143,
                    column: 8
                },
                end: {
                    line: 143,
                    column: 35
                }
            },
            '62': {
                start: {
                    line: 147,
                    column: 8
                },
                end: {
                    line: 150,
                    column: 11
                }
            },
            '63': {
                start: {
                    line: 148,
                    column: 12
                },
                end: {
                    line: 148,
                    column: 66
                }
            },
            '64': {
                start: {
                    line: 149,
                    column: 12
                },
                end: {
                    line: 149,
                    column: 51
                }
            },
            '65': {
                start: {
                    line: 155,
                    column: 20
                },
                end: {
                    line: 155,
                    column: 85
                }
            },
            '66': {
                start: {
                    line: 156,
                    column: 8
                },
                end: {
                    line: 156,
                    column: 31
                }
            },
            '67': {
                start: {
                    line: 160,
                    column: 8
                },
                end: {
                    line: 165,
                    column: 10
                }
            },
            '68': {
                start: {
                    line: 162,
                    column: 16
                },
                end: {
                    line: 162,
                    column: 68
                }
            },
            '69': {
                start: {
                    line: 163,
                    column: 16
                },
                end: {
                    line: 163,
                    column: 49
                }
            },
            '70': {
                start: {
                    line: 170,
                    column: 8
                },
                end: {
                    line: 173,
                    column: 11
                }
            },
            '71': {
                start: {
                    line: 171,
                    column: 25
                },
                end: {
                    line: 171,
                    column: 90
                }
            },
            '72': {
                start: {
                    line: 172,
                    column: 12
                },
                end: {
                    line: 172,
                    column: 64
                }
            },
            '73': {
                start: {
                    line: 178,
                    column: 8
                },
                end: {
                    line: 183,
                    column: 11
                }
            },
            '74': {
                start: {
                    line: 179,
                    column: 25
                },
                end: {
                    line: 179,
                    column: 44
                }
            },
            '75': {
                start: {
                    line: 180,
                    column: 12
                },
                end: {
                    line: 182,
                    column: 69
                }
            },
            '76': {
                start: {
                    line: 181,
                    column: 30
                },
                end: {
                    line: 182,
                    column: 67
                }
            },
            '77': {
                start: {
                    line: 188,
                    column: 8
                },
                end: {
                    line: 191,
                    column: 11
                }
            },
            '78': {
                start: {
                    line: 189,
                    column: 25
                },
                end: {
                    line: 189,
                    column: 81
                }
            },
            '79': {
                start: {
                    line: 190,
                    column: 12
                },
                end: {
                    line: 190,
                    column: 52
                }
            },
            '80': {
                start: {
                    line: 196,
                    column: 8
                },
                end: {
                    line: 199,
                    column: 11
                }
            },
            '81': {
                start: {
                    line: 197,
                    column: 25
                },
                end: {
                    line: 197,
                    column: 103
                }
            },
            '82': {
                start: {
                    line: 198,
                    column: 12
                },
                end: {
                    line: 198,
                    column: 51
                }
            },
            '83': {
                start: {
                    line: 203,
                    column: 24
                },
                end: {
                    line: 208,
                    column: 9
                }
            },
            '84': {
                start: {
                    line: 209,
                    column: 8
                },
                end: {
                    line: 209,
                    column: 30
                }
            },
            '85': {
                start: {
                    line: 213,
                    column: 21
                },
                end: {
                    line: 213,
                    column: 44
                }
            },
            '86': {
                start: {
                    line: 214,
                    column: 8
                },
                end: {
                    line: 222,
                    column: 11
                }
            },
            '87': {
                start: {
                    line: 216,
                    column: 12
                },
                end: {
                    line: 221,
                    column: 13
                }
            },
            '88': {
                start: {
                    line: 217,
                    column: 33
                },
                end: {
                    line: 217,
                    column: 67
                }
            },
            '89': {
                start: {
                    line: 218,
                    column: 16
                },
                end: {
                    line: 218,
                    column: 44
                }
            },
            '90': {
                start: {
                    line: 220,
                    column: 16
                },
                end: {
                    line: 220,
                    column: 61
                }
            },
            '91': {
                start: {
                    line: 223,
                    column: 8
                },
                end: {
                    line: 223,
                    column: 38
                }
            },
            '92': {
                start: {
                    line: 227,
                    column: 8
                },
                end: {
                    line: 229,
                    column: 11
                }
            },
            '93': {
                start: {
                    line: 228,
                    column: 12
                },
                end: {
                    line: 228,
                    column: 37
                }
            },
            '94': {
                start: {
                    line: 233,
                    column: 19
                },
                end: {
                    line: 233,
                    column: 23
                }
            },
            '95': {
                start: {
                    line: 234,
                    column: 8
                },
                end: {
                    line: 238,
                    column: 9
                }
            },
            '96': {
                start: {
                    line: 235,
                    column: 12
                },
                end: {
                    line: 235,
                    column: 81
                }
            },
            '97': {
                start: {
                    line: 237,
                    column: 12
                },
                end: {
                    line: 237,
                    column: 54
                }
            },
            '98': {
                start: {
                    line: 239,
                    column: 29
                },
                end: {
                    line: 239,
                    column: 54
                }
            },
            '99': {
                start: {
                    line: 240,
                    column: 20
                },
                end: {
                    line: 240,
                    column: 39
                }
            },
            '100': {
                start: {
                    line: 241,
                    column: 8
                },
                end: {
                    line: 241,
                    column: 31
                }
            },
            '101': {
                start: {
                    line: 245,
                    column: 29
                },
                end: {
                    line: 245,
                    column: 54
                }
            },
            '102': {
                start: {
                    line: 246,
                    column: 20
                },
                end: {
                    line: 246,
                    column: 39
                }
            },
            '103': {
                start: {
                    line: 247,
                    column: 8
                },
                end: {
                    line: 247,
                    column: 31
                }
            },
            '104': {
                start: {
                    line: 251,
                    column: 27
                },
                end: {
                    line: 251,
                    column: 29
                }
            },
            '105': {
                start: {
                    line: 252,
                    column: 26
                },
                end: {
                    line: 262,
                    column: 9
                }
            },
            '106': {
                start: {
                    line: 263,
                    column: 8
                },
                end: {
                    line: 266,
                    column: 9
                }
            },
            '107': {
                start: {
                    line: 264,
                    column: 25
                },
                end: {
                    line: 264,
                    column: 40
                }
            },
            '108': {
                start: {
                    line: 265,
                    column: 12
                },
                end: {
                    line: 265,
                    column: 52
                }
            },
            '109': {
                start: {
                    line: 267,
                    column: 8
                },
                end: {
                    line: 267,
                    column: 28
                }
            },
            '110': {
                start: {
                    line: 271,
                    column: 8
                },
                end: {
                    line: 271,
                    column: 62
                }
            },
            '111': {
                start: {
                    line: 275,
                    column: 22
                },
                end: {
                    line: 275,
                    column: 57
                }
            },
            '112': {
                start: {
                    line: 277,
                    column: 8
                },
                end: {
                    line: 286,
                    column: 9
                }
            },
            '113': {
                start: {
                    line: 279,
                    column: 12
                },
                end: {
                    line: 279,
                    column: 84
                }
            },
            '114': {
                start: {
                    line: 281,
                    column: 12
                },
                end: {
                    line: 281,
                    column: 97
                }
            },
            '115': {
                start: {
                    line: 283,
                    column: 12
                },
                end: {
                    line: 283,
                    column: 103
                }
            },
            '116': {
                start: {
                    line: 285,
                    column: 12
                },
                end: {
                    line: 285,
                    column: 103
                }
            },
            '117': {
                start: {
                    line: 290,
                    column: 26
                },
                end: {
                    line: 290,
                    column: 44
                }
            },
            '118': {
                start: {
                    line: 291,
                    column: 8
                },
                end: {
                    line: 304,
                    column: 10
                }
            },
            '119': {
                start: {
                    line: 293,
                    column: 16
                },
                end: {
                    line: 296,
                    column: 17
                }
            },
            '120': {
                start: {
                    line: 294,
                    column: 20
                },
                end: {
                    line: 294,
                    column: 49
                }
            },
            '121': {
                start: {
                    line: 295,
                    column: 20
                },
                end: {
                    line: 295,
                    column: 39
                }
            },
            '122': {
                start: {
                    line: 297,
                    column: 16
                },
                end: {
                    line: 302,
                    column: 42
                }
            },
            '123': {
                start: {
                    line: 308,
                    column: 26
                },
                end: {
                    line: 308,
                    column: 28
                }
            },
            '124': {
                start: {
                    line: 309,
                    column: 8
                },
                end: {
                    line: 312,
                    column: 11
                }
            },
            '125': {
                start: {
                    line: 310,
                    column: 29
                },
                end: {
                    line: 310,
                    column: 41
                }
            },
            '126': {
                start: {
                    line: 311,
                    column: 12
                },
                end: {
                    line: 311,
                    column: 115
                }
            },
            '127': {
                start: {
                    line: 311,
                    column: 34
                },
                end: {
                    line: 311,
                    column: 113
                }
            },
            '128': {
                start: {
                    line: 313,
                    column: 8
                },
                end: {
                    line: 313,
                    column: 25
                }
            },
            '129': {
                start: {
                    line: 317,
                    column: 30
                },
                end: {
                    line: 317,
                    column: 70
                }
            },
            '130': {
                start: {
                    line: 317,
                    column: 60
                },
                end: {
                    line: 317,
                    column: 69
                }
            },
            '131': {
                start: {
                    line: 318,
                    column: 26
                },
                end: {
                    line: 318,
                    column: 69
                }
            },
            '132': {
                start: {
                    line: 319,
                    column: 8
                },
                end: {
                    line: 319,
                    column: 98
                }
            },
            '133': {
                start: {
                    line: 319,
                    column: 56
                },
                end: {
                    line: 319,
                    column: 96
                }
            },
            '134': {
                start: {
                    line: 320,
                    column: 8
                },
                end: {
                    line: 320,
                    column: 27
                }
            },
            '135': {
                start: {
                    line: 324,
                    column: 27
                },
                end: {
                    line: 324,
                    column: 47
                }
            },
            '136': {
                start: {
                    line: 325,
                    column: 27
                },
                end: {
                    line: 325,
                    column: 48
                }
            },
            '137': {
                start: {
                    line: 326,
                    column: 22
                },
                end: {
                    line: 326,
                    column: 35
                }
            },
            '138': {
                start: {
                    line: 327,
                    column: 21
                },
                end: {
                    line: 327,
                    column: 54
                }
            },
            '139': {
                start: {
                    line: 328,
                    column: 8
                },
                end: {
                    line: 328,
                    column: 29
                }
            },
            '140': {
                start: {
                    line: 332,
                    column: 24
                },
                end: {
                    line: 332,
                    column: 50
                }
            },
            '141': {
                start: {
                    line: 333,
                    column: 8
                },
                end: {
                    line: 333,
                    column: 35
                }
            },
            '142': {
                start: {
                    line: 334,
                    column: 8
                },
                end: {
                    line: 334,
                    column: 83
                }
            },
            '143': {
                start: {
                    line: 334,
                    column: 39
                },
                end: {
                    line: 334,
                    column: 81
                }
            },
            '144': {
                start: {
                    line: 338,
                    column: 0
                },
                end: {
                    line: 346,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 5,
                        column: 74
                    },
                    end: {
                        line: 43,
                        column: 5
                    }
                },
                line: 5
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 34,
                        column: 49
                    },
                    end: {
                        line: 34,
                        column: 50
                    }
                },
                loc: {
                    start: {
                        line: 34,
                        column: 59
                    },
                    end: {
                        line: 42,
                        column: 9
                    }
                },
                line: 34
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 45,
                        column: 4
                    },
                    end: {
                        line: 45,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 45,
                        column: 20
                    },
                    end: {
                        line: 53,
                        column: 9
                    }
                },
                line: 45
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 55,
                        column: 4
                    },
                    end: {
                        line: 55,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 55,
                        column: 14
                    },
                    end: {
                        line: 68,
                        column: 5
                    }
                },
                line: 55
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 70,
                        column: 4
                    },
                    end: {
                        line: 70,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 70,
                        column: 51
                    },
                    end: {
                        line: 77,
                        column: 5
                    }
                },
                line: 70
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 76,
                        column: 17
                    },
                    end: {
                        line: 76,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 76,
                        column: 23
                    },
                    end: {
                        line: 76,
                        column: 50
                    }
                },
                line: 76
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 79,
                        column: 4
                    },
                    end: {
                        line: 79,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 79,
                        column: 36
                    },
                    end: {
                        line: 84,
                        column: 5
                    }
                },
                line: 79
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 83,
                        column: 17
                    },
                    end: {
                        line: 83,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 83,
                        column: 24
                    },
                    end: {
                        line: 83,
                        column: 40
                    }
                },
                line: 83
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 86,
                        column: 4
                    },
                    end: {
                        line: 86,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 86,
                        column: 41
                    },
                    end: {
                        line: 91,
                        column: 5
                    }
                },
                line: 86
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 90,
                        column: 17
                    },
                    end: {
                        line: 90,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 90,
                        column: 37
                    },
                    end: {
                        line: 90,
                        column: 79
                    }
                },
                line: 90
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 93,
                        column: 4
                    },
                    end: {
                        line: 93,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 93,
                        column: 50
                    },
                    end: {
                        line: 99,
                        column: 5
                    }
                },
                line: 93
            },
            '11': {
                name: '(anonymous_11)',
                decl: {
                    start: {
                        line: 98,
                        column: 17
                    },
                    end: {
                        line: 98,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 98,
                        column: 43
                    },
                    end: {
                        line: 98,
                        column: 85
                    }
                },
                line: 98
            },
            '12': {
                name: '(anonymous_12)',
                decl: {
                    start: {
                        line: 101,
                        column: 4
                    },
                    end: {
                        line: 101,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 101,
                        column: 63
                    },
                    end: {
                        line: 110,
                        column: 5
                    }
                },
                line: 101
            },
            '13': {
                name: '(anonymous_13)',
                decl: {
                    start: {
                        line: 109,
                        column: 17
                    },
                    end: {
                        line: 109,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 109,
                        column: 23
                    },
                    end: {
                        line: 109,
                        column: 51
                    }
                },
                line: 109
            },
            '14': {
                name: '(anonymous_14)',
                decl: {
                    start: {
                        line: 112,
                        column: 4
                    },
                    end: {
                        line: 112,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 112,
                        column: 24
                    },
                    end: {
                        line: 115,
                        column: 5
                    }
                },
                line: 112
            },
            '15': {
                name: '(anonymous_15)',
                decl: {
                    start: {
                        line: 114,
                        column: 12
                    },
                    end: {
                        line: 114,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 114,
                        column: 22
                    },
                    end: {
                        line: 114,
                        column: 72
                    }
                },
                line: 114
            },
            '16': {
                name: '(anonymous_16)',
                decl: {
                    start: {
                        line: 117,
                        column: 4
                    },
                    end: {
                        line: 117,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 117,
                        column: 39
                    },
                    end: {
                        line: 119,
                        column: 5
                    }
                },
                line: 117
            },
            '17': {
                name: '(anonymous_17)',
                decl: {
                    start: {
                        line: 121,
                        column: 4
                    },
                    end: {
                        line: 121,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 121,
                        column: 40
                    },
                    end: {
                        line: 124,
                        column: 5
                    }
                },
                line: 121
            },
            '18': {
                name: '(anonymous_18)',
                decl: {
                    start: {
                        line: 126,
                        column: 4
                    },
                    end: {
                        line: 126,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 126,
                        column: 38
                    },
                    end: {
                        line: 144,
                        column: 5
                    }
                },
                line: 126
            },
            '19': {
                name: 'DialogController',
                decl: {
                    start: {
                        line: 129,
                        column: 33
                    },
                    end: {
                        line: 129,
                        column: 49
                    }
                },
                loc: {
                    start: {
                        line: 129,
                        column: 52
                    },
                    end: {
                        line: 129,
                        column: 54
                    }
                },
                line: 129
            },
            '20': {
                name: '(anonymous_20)',
                decl: {
                    start: {
                        line: 146,
                        column: 4
                    },
                    end: {
                        line: 146,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 146,
                        column: 27
                    },
                    end: {
                        line: 151,
                        column: 5
                    }
                },
                line: 146
            },
            '21': {
                name: '(anonymous_21)',
                decl: {
                    start: {
                        line: 147,
                        column: 69
                    },
                    end: {
                        line: 147,
                        column: 70
                    }
                },
                loc: {
                    start: {
                        line: 147,
                        column: 81
                    },
                    end: {
                        line: 150,
                        column: 9
                    }
                },
                line: 147
            },
            '22': {
                name: '(anonymous_22)',
                decl: {
                    start: {
                        line: 154,
                        column: 4
                    },
                    end: {
                        line: 154,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 154,
                        column: 24
                    },
                    end: {
                        line: 157,
                        column: 5
                    }
                },
                line: 154
            },
            '23': {
                name: '(anonymous_23)',
                decl: {
                    start: {
                        line: 159,
                        column: 4
                    },
                    end: {
                        line: 159,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 159,
                        column: 19
                    },
                    end: {
                        line: 166,
                        column: 5
                    }
                },
                line: 159
            },
            '24': {
                name: '(anonymous_24)',
                decl: {
                    start: {
                        line: 161,
                        column: 12
                    },
                    end: {
                        line: 161,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 161,
                        column: 24
                    },
                    end: {
                        line: 164,
                        column: 13
                    }
                },
                line: 161
            },
            '25': {
                name: '(anonymous_25)',
                decl: {
                    start: {
                        line: 168,
                        column: 4
                    },
                    end: {
                        line: 168,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 168,
                        column: 38
                    },
                    end: {
                        line: 174,
                        column: 5
                    }
                },
                line: 168
            },
            '26': {
                name: '(anonymous_26)',
                decl: {
                    start: {
                        line: 170,
                        column: 23
                    },
                    end: {
                        line: 170,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 170,
                        column: 35
                    },
                    end: {
                        line: 173,
                        column: 9
                    }
                },
                line: 170
            },
            '27': {
                name: '(anonymous_27)',
                decl: {
                    start: {
                        line: 176,
                        column: 4
                    },
                    end: {
                        line: 176,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 176,
                        column: 22
                    },
                    end: {
                        line: 184,
                        column: 5
                    }
                },
                line: 176
            },
            '28': {
                name: '(anonymous_28)',
                decl: {
                    start: {
                        line: 178,
                        column: 19
                    },
                    end: {
                        line: 178,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 178,
                        column: 29
                    },
                    end: {
                        line: 183,
                        column: 9
                    }
                },
                line: 178
            },
            '29': {
                name: '(anonymous_29)',
                decl: {
                    start: {
                        line: 181,
                        column: 16
                    },
                    end: {
                        line: 181,
                        column: 17
                    }
                },
                loc: {
                    start: {
                        line: 181,
                        column: 30
                    },
                    end: {
                        line: 182,
                        column: 67
                    }
                },
                line: 181
            },
            '30': {
                name: '(anonymous_30)',
                decl: {
                    start: {
                        line: 186,
                        column: 4
                    },
                    end: {
                        line: 186,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 186,
                        column: 22
                    },
                    end: {
                        line: 192,
                        column: 5
                    }
                },
                line: 186
            },
            '31': {
                name: '(anonymous_31)',
                decl: {
                    start: {
                        line: 188,
                        column: 19
                    },
                    end: {
                        line: 188,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 188,
                        column: 28
                    },
                    end: {
                        line: 191,
                        column: 9
                    }
                },
                line: 188
            },
            '32': {
                name: '(anonymous_32)',
                decl: {
                    start: {
                        line: 194,
                        column: 4
                    },
                    end: {
                        line: 194,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 194,
                        column: 20
                    },
                    end: {
                        line: 200,
                        column: 5
                    }
                },
                line: 194
            },
            '33': {
                name: '(anonymous_33)',
                decl: {
                    start: {
                        line: 196,
                        column: 18
                    },
                    end: {
                        line: 196,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 196,
                        column: 26
                    },
                    end: {
                        line: 199,
                        column: 9
                    }
                },
                line: 196
            },
            '34': {
                name: '(anonymous_34)',
                decl: {
                    start: {
                        line: 202,
                        column: 4
                    },
                    end: {
                        line: 202,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 202,
                        column: 34
                    },
                    end: {
                        line: 210,
                        column: 5
                    }
                },
                line: 202
            },
            '35': {
                name: '(anonymous_35)',
                decl: {
                    start: {
                        line: 212,
                        column: 4
                    },
                    end: {
                        line: 212,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 212,
                        column: 29
                    },
                    end: {
                        line: 224,
                        column: 5
                    }
                },
                line: 212
            },
            '36': {
                name: '(anonymous_36)',
                decl: {
                    start: {
                        line: 214,
                        column: 17
                    },
                    end: {
                        line: 214,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 214,
                        column: 26
                    },
                    end: {
                        line: 222,
                        column: 9
                    }
                },
                line: 214
            },
            '37': {
                name: '(anonymous_37)',
                decl: {
                    start: {
                        line: 226,
                        column: 4
                    },
                    end: {
                        line: 226,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 226,
                        column: 25
                    },
                    end: {
                        line: 230,
                        column: 5
                    }
                },
                line: 226
            },
            '38': {
                name: '(anonymous_38)',
                decl: {
                    start: {
                        line: 227,
                        column: 43
                    },
                    end: {
                        line: 227,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 227,
                        column: 49
                    },
                    end: {
                        line: 229,
                        column: 9
                    }
                },
                line: 227
            },
            '39': {
                name: '(anonymous_39)',
                decl: {
                    start: {
                        line: 232,
                        column: 4
                    },
                    end: {
                        line: 232,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 232,
                        column: 30
                    },
                    end: {
                        line: 242,
                        column: 5
                    }
                },
                line: 232
            },
            '40': {
                name: '(anonymous_40)',
                decl: {
                    start: {
                        line: 244,
                        column: 4
                    },
                    end: {
                        line: 244,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 244,
                        column: 30
                    },
                    end: {
                        line: 248,
                        column: 5
                    }
                },
                line: 244
            },
            '41': {
                name: '(anonymous_41)',
                decl: {
                    start: {
                        line: 250,
                        column: 4
                    },
                    end: {
                        line: 250,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 250,
                        column: 25
                    },
                    end: {
                        line: 268,
                        column: 5
                    }
                },
                line: 250
            },
            '42': {
                name: '(anonymous_42)',
                decl: {
                    start: {
                        line: 270,
                        column: 4
                    },
                    end: {
                        line: 270,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 270,
                        column: 21
                    },
                    end: {
                        line: 272,
                        column: 5
                    }
                },
                line: 270
            },
            '43': {
                name: '(anonymous_43)',
                decl: {
                    start: {
                        line: 274,
                        column: 4
                    },
                    end: {
                        line: 274,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 274,
                        column: 44
                    },
                    end: {
                        line: 287,
                        column: 5
                    }
                },
                line: 274
            },
            '44': {
                name: '(anonymous_44)',
                decl: {
                    start: {
                        line: 289,
                        column: 4
                    },
                    end: {
                        line: 289,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 289,
                        column: 18
                    },
                    end: {
                        line: 305,
                        column: 5
                    }
                },
                line: 289
            },
            '45': {
                name: '(anonymous_45)',
                decl: {
                    start: {
                        line: 292,
                        column: 12
                    },
                    end: {
                        line: 292,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 292,
                        column: 24
                    },
                    end: {
                        line: 303,
                        column: 13
                    }
                },
                line: 292
            },
            '46': {
                name: '(anonymous_46)',
                decl: {
                    start: {
                        line: 307,
                        column: 4
                    },
                    end: {
                        line: 307,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 307,
                        column: 43
                    },
                    end: {
                        line: 314,
                        column: 5
                    }
                },
                line: 307
            },
            '47': {
                name: '(anonymous_47)',
                decl: {
                    start: {
                        line: 309,
                        column: 20
                    },
                    end: {
                        line: 309,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 309,
                        column: 42
                    },
                    end: {
                        line: 312,
                        column: 9
                    }
                },
                line: 309
            },
            '48': {
                name: '(anonymous_48)',
                decl: {
                    start: {
                        line: 311,
                        column: 25
                    },
                    end: {
                        line: 311,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 311,
                        column: 34
                    },
                    end: {
                        line: 311,
                        column: 113
                    }
                },
                line: 311
            },
            '49': {
                name: '(anonymous_49)',
                decl: {
                    start: {
                        line: 316,
                        column: 4
                    },
                    end: {
                        line: 316,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 316,
                        column: 42
                    },
                    end: {
                        line: 321,
                        column: 5
                    }
                },
                line: 316
            },
            '50': {
                name: '(anonymous_50)',
                decl: {
                    start: {
                        line: 317,
                        column: 53
                    },
                    end: {
                        line: 317,
                        column: 54
                    }
                },
                loc: {
                    start: {
                        line: 317,
                        column: 60
                    },
                    end: {
                        line: 317,
                        column: 69
                    }
                },
                line: 317
            },
            '51': {
                name: '(anonymous_51)',
                decl: {
                    start: {
                        line: 319,
                        column: 43
                    },
                    end: {
                        line: 319,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 319,
                        column: 56
                    },
                    end: {
                        line: 319,
                        column: 96
                    }
                },
                line: 319
            },
            '52': {
                name: '(anonymous_52)',
                decl: {
                    start: {
                        line: 323,
                        column: 4
                    },
                    end: {
                        line: 323,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 323,
                        column: 24
                    },
                    end: {
                        line: 329,
                        column: 5
                    }
                },
                line: 323
            },
            '53': {
                name: '(anonymous_53)',
                decl: {
                    start: {
                        line: 331,
                        column: 4
                    },
                    end: {
                        line: 331,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 331,
                        column: 31
                    },
                    end: {
                        line: 335,
                        column: 5
                    }
                },
                line: 331
            },
            '54': {
                name: '(anonymous_54)',
                decl: {
                    start: {
                        line: 334,
                        column: 33
                    },
                    end: {
                        line: 334,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 334,
                        column: 39
                    },
                    end: {
                        line: 334,
                        column: 81
                    }
                },
                line: 334
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 35,
                        column: 12
                    },
                    end: {
                        line: 41,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 35,
                        column: 12
                    },
                    end: {
                        line: 41,
                        column: 13
                    }
                }, {
                    start: {
                        line: 35,
                        column: 12
                    },
                    end: {
                        line: 41,
                        column: 13
                    }
                }],
                line: 35
            },
            '1': {
                loc: {
                    start: {
                        line: 46,
                        column: 12
                    },
                    end: {
                        line: 51,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 46,
                        column: 12
                    },
                    end: {
                        line: 51,
                        column: 13
                    }
                }, {
                    start: {
                        line: 46,
                        column: 12
                    },
                    end: {
                        line: 51,
                        column: 13
                    }
                }],
                line: 46
            },
            '2': {
                loc: {
                    start: {
                        line: 48,
                        column: 16
                    },
                    end: {
                        line: 50,
                        column: 17
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 48,
                        column: 16
                    },
                    end: {
                        line: 50,
                        column: 17
                    }
                }, {
                    start: {
                        line: 48,
                        column: 16
                    },
                    end: {
                        line: 50,
                        column: 17
                    }
                }],
                line: 48
            },
            '3': {
                loc: {
                    start: {
                        line: 48,
                        column: 20
                    },
                    end: {
                        line: 48,
                        column: 37
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 48,
                        column: 20
                    },
                    end: {
                        line: 48,
                        column: 21
                    }
                }, {
                    start: {
                        line: 48,
                        column: 25
                    },
                    end: {
                        line: 48,
                        column: 37
                    }
                }],
                line: 48
            },
            '4': {
                loc: {
                    start: {
                        line: 216,
                        column: 12
                    },
                    end: {
                        line: 221,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 216,
                        column: 12
                    },
                    end: {
                        line: 221,
                        column: 13
                    }
                }, {
                    start: {
                        line: 216,
                        column: 12
                    },
                    end: {
                        line: 221,
                        column: 13
                    }
                }],
                line: 216
            },
            '5': {
                loc: {
                    start: {
                        line: 234,
                        column: 8
                    },
                    end: {
                        line: 238,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 234,
                        column: 8
                    },
                    end: {
                        line: 238,
                        column: 9
                    }
                }, {
                    start: {
                        line: 234,
                        column: 8
                    },
                    end: {
                        line: 238,
                        column: 9
                    }
                }],
                line: 234
            },
            '6': {
                loc: {
                    start: {
                        line: 265,
                        column: 28
                    },
                    end: {
                        line: 265,
                        column: 51
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 265,
                        column: 28
                    },
                    end: {
                        line: 265,
                        column: 43
                    }
                }, {
                    start: {
                        line: 265,
                        column: 47
                    },
                    end: {
                        line: 265,
                        column: 51
                    }
                }],
                line: 265
            },
            '7': {
                loc: {
                    start: {
                        line: 277,
                        column: 8
                    },
                    end: {
                        line: 286,
                        column: 9
                    }
                },
                type: 'switch',
                locations: [{
                    start: {
                        line: 278,
                        column: 8
                    },
                    end: {
                        line: 279,
                        column: 84
                    }
                }, {
                    start: {
                        line: 280,
                        column: 8
                    },
                    end: {
                        line: 281,
                        column: 97
                    }
                }, {
                    start: {
                        line: 282,
                        column: 8
                    },
                    end: {
                        line: 283,
                        column: 103
                    }
                }, {
                    start: {
                        line: 284,
                        column: 8
                    },
                    end: {
                        line: 285,
                        column: 103
                    }
                }],
                line: 277
            },
            '8': {
                loc: {
                    start: {
                        line: 293,
                        column: 16
                    },
                    end: {
                        line: 296,
                        column: 17
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 293,
                        column: 16
                    },
                    end: {
                        line: 296,
                        column: 17
                    }
                }, {
                    start: {
                        line: 293,
                        column: 16
                    },
                    end: {
                        line: 296,
                        column: 17
                    }
                }],
                line: 293
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0,
            '30': 0,
            '31': 0,
            '32': 0,
            '33': 0,
            '34': 0,
            '35': 0,
            '36': 0,
            '37': 0,
            '38': 0,
            '39': 0,
            '40': 0,
            '41': 0,
            '42': 0,
            '43': 0,
            '44': 0,
            '45': 0,
            '46': 0,
            '47': 0,
            '48': 0,
            '49': 0,
            '50': 0,
            '51': 0,
            '52': 0,
            '53': 0,
            '54': 0,
            '55': 0,
            '56': 0,
            '57': 0,
            '58': 0,
            '59': 0,
            '60': 0,
            '61': 0,
            '62': 0,
            '63': 0,
            '64': 0,
            '65': 0,
            '66': 0,
            '67': 0,
            '68': 0,
            '69': 0,
            '70': 0,
            '71': 0,
            '72': 0,
            '73': 0,
            '74': 0,
            '75': 0,
            '76': 0,
            '77': 0,
            '78': 0,
            '79': 0,
            '80': 0,
            '81': 0,
            '82': 0,
            '83': 0,
            '84': 0,
            '85': 0,
            '86': 0,
            '87': 0,
            '88': 0,
            '89': 0,
            '90': 0,
            '91': 0,
            '92': 0,
            '93': 0,
            '94': 0,
            '95': 0,
            '96': 0,
            '97': 0,
            '98': 0,
            '99': 0,
            '100': 0,
            '101': 0,
            '102': 0,
            '103': 0,
            '104': 0,
            '105': 0,
            '106': 0,
            '107': 0,
            '108': 0,
            '109': 0,
            '110': 0,
            '111': 0,
            '112': 0,
            '113': 0,
            '114': 0,
            '115': 0,
            '116': 0,
            '117': 0,
            '118': 0,
            '119': 0,
            '120': 0,
            '121': 0,
            '122': 0,
            '123': 0,
            '124': 0,
            '125': 0,
            '126': 0,
            '127': 0,
            '128': 0,
            '129': 0,
            '130': 0,
            '131': 0,
            '132': 0,
            '133': 0,
            '134': 0,
            '135': 0,
            '136': 0,
            '137': 0,
            '138': 0,
            '139': 0,
            '140': 0,
            '141': 0,
            '142': 0,
            '143': 0,
            '144': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0,
            '30': 0,
            '31': 0,
            '32': 0,
            '33': 0,
            '34': 0,
            '35': 0,
            '36': 0,
            '37': 0,
            '38': 0,
            '39': 0,
            '40': 0,
            '41': 0,
            '42': 0,
            '43': 0,
            '44': 0,
            '45': 0,
            '46': 0,
            '47': 0,
            '48': 0,
            '49': 0,
            '50': 0,
            '51': 0,
            '52': 0,
            '53': 0,
            '54': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0],
            '3': [0, 0],
            '4': [0, 0],
            '5': [0, 0],
            '6': [0, 0],
            '7': [0, 0, 0, 0],
            '8': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrganizationDetailsController = function () {
    OrganizationDetailsController.$inject = ["$scope", "LinkCategoriesTable", "TagsTable", "InteractionTypesTable", "IndividualsTable", "EconomicActivitiesTable", "MunicipalitiesTable", "$window", "$mdPanel", "NewEmailModalService", "AppSettings", "CurrencyConversionsTable", "$rootScope", "OrganizationEmailsTable", "$mdToast", "$document"];
    function OrganizationDetailsController($scope, LinkCategoriesTable, TagsTable, InteractionTypesTable, IndividualsTable, EconomicActivitiesTable, MunicipalitiesTable, $window, $mdPanel, NewEmailModalService, AppSettings, CurrencyConversionsTable, $rootScope, OrganizationEmailsTable, $mdToast, $document) {
        var _this = this;

        _classCallCheck(this, OrganizationDetailsController);

        cov_4tcvznqaj.f[0]++;
        cov_4tcvznqaj.s[0]++;

        this.LinkCategoriesTable = LinkCategoriesTable;
        cov_4tcvznqaj.s[1]++;
        this.InteractionTypesTable = InteractionTypesTable;
        cov_4tcvznqaj.s[2]++;
        this.TagsTable = TagsTable;
        cov_4tcvznqaj.s[3]++;
        this.IndividualsTable = IndividualsTable;
        cov_4tcvznqaj.s[4]++;
        this.EconomicActivitiesTable = EconomicActivitiesTable;
        cov_4tcvznqaj.s[5]++;
        this.MunicipalitiesTable = MunicipalitiesTable;
        cov_4tcvznqaj.s[6]++;
        this.newInteractionAt = new Date();
        cov_4tcvznqaj.s[7]++;
        this.$window = $window;
        cov_4tcvznqaj.s[8]++;
        this.$mdPanel = $mdPanel;
        cov_4tcvznqaj.s[9]++;
        this.NewEmailModalService = NewEmailModalService;
        cov_4tcvznqaj.s[10]++;
        this.AppSettings = AppSettings;
        cov_4tcvznqaj.s[11]++;
        this.fetching = false;
        cov_4tcvznqaj.s[12]++;
        this.fetchedResult = null;
        cov_4tcvznqaj.s[13]++;
        this.CurrencyConversionsTable = CurrencyConversionsTable;
        cov_4tcvznqaj.s[14]++;
        this.$rootScope = $rootScope;
        cov_4tcvznqaj.s[15]++;
        this.OrganizationEmailsTable = OrganizationEmailsTable;
        cov_4tcvznqaj.s[16]++;
        this.createCandidates = this.createCandidates.bind(this);
        cov_4tcvznqaj.s[17]++;
        this.patternBaker = this.patternBaker.bind(this);
        cov_4tcvznqaj.s[18]++;
        this.createEmail = this.createEmail.bind(this);
        cov_4tcvznqaj.s[19]++;
        this.getRelatedAutocomplete = this.getRelatedAutocomplete.bind(this);
        cov_4tcvznqaj.s[20]++;
        this.addEmails = this.addEmails.bind(this);
        cov_4tcvznqaj.s[21]++;
        this.addLinks = this.addLinks.bind(this);
        cov_4tcvznqaj.s[22]++;
        this.addEconomicActivities = this.addEconomicActivities.bind(this);
        cov_4tcvznqaj.s[23]++;
        this.addPeople = this.addPeople.bind(this);
        cov_4tcvznqaj.s[24]++;
        this.$mdToast = $mdToast;
        cov_4tcvznqaj.s[25]++;
        this.$document = $document;

        // files
        cov_4tcvznqaj.s[26]++;
        $scope.$watch('$ctrl.newFileAttachment', function (newVal) {
            cov_4tcvznqaj.f[1]++;
            cov_4tcvznqaj.s[27]++;

            if (angular.isString(newVal)) {
                cov_4tcvznqaj.b[0][0]++;
                cov_4tcvznqaj.s[28]++;

                _this.organization.$files.$create({
                    organization: _this.organization.id,
                    path: newVal,
                    name: _this.fileToName(newVal)
                });
            } else {
                cov_4tcvznqaj.b[0][1]++;
            }
        });
    }

    _createClass(OrganizationDetailsController, [{
        key: 'fileToName',
        value: function fileToName(url) {
            cov_4tcvznqaj.f[2]++;
            cov_4tcvznqaj.s[29]++;

            if (url) {
                cov_4tcvznqaj.b[1][0]++;

                var m = (cov_4tcvznqaj.s[30]++, url.toString().match(/.*\/(.+?)\.(.+)/));
                cov_4tcvznqaj.s[31]++;
                if ((cov_4tcvznqaj.b[3][0]++, m) && (cov_4tcvznqaj.b[3][1]++, m.length > 1)) {
                    cov_4tcvznqaj.b[2][0]++;
                    cov_4tcvznqaj.s[32]++;

                    return m[1] + '.' + m[2];
                } else {
                    cov_4tcvznqaj.b[2][1]++;
                }
            } else {
                cov_4tcvznqaj.b[1][1]++;
            }
            cov_4tcvznqaj.s[33]++;
            return "";
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            cov_4tcvznqaj.f[3]++;
            cov_4tcvznqaj.s[34]++;

            this.organization.$load('links').$load('organizationIndividuals').$load('comments').$load('tags').$load('interactions').$load('economicActivities').$load('emails').$load('siteVisits').$load('domains');
            cov_4tcvznqaj.s[35]++;
            this.organization.$organizationIndividuals.$load('individual');
            cov_4tcvznqaj.s[36]++;
            this.organization.$comments.$load('user');
            cov_4tcvznqaj.s[37]++;
            this.organization.$load('files');

            cov_4tcvznqaj.s[38]++;
            this.categories = this.LinkCategoriesTable.$search();
            cov_4tcvznqaj.s[39]++;
            this.interactionTypes = this.InteractionTypesTable.$search();
            cov_4tcvznqaj.s[40]++;
            this.tags = this.TagsTable.$search();
            cov_4tcvznqaj.s[41]++;
            this.individuals = this.IndividualsTable.$search();
            cov_4tcvznqaj.s[42]++;
            this.economicActivities = this.EconomicActivitiesTable.$search({ level: 5 });
            /* eslint-disable camelcase */
            cov_4tcvznqaj.s[43]++;
            this.municipalities = this.MunicipalitiesTable.$search({ page_size: 999 });
        }
    }, {
        key: 'createComment',
        value: function createComment(organization, newCommentContent) {
            var _this2 = this;

            cov_4tcvznqaj.f[4]++;
            cov_4tcvznqaj.s[44]++;

            this.organization.$comments.$create({
                objectId: organization.id,
                objectType: 'ORGANIZATION',
                content: newCommentContent
                /* eslint-disable no-return-assign */
            }).$then(function () {
                cov_4tcvznqaj.f[5]++;
                cov_4tcvznqaj.s[45]++;
                return _this2.newCommentContent = '';
            });
        }
    }, {
        key: 'onSelectTag',
        value: function onSelectTag(organization, item) {
            cov_4tcvznqaj.f[6]++;
            cov_4tcvznqaj.s[46]++;

            this.organization.$tags.$create({
                organization: organization.id,
                tag: item.id
            }).$then(function (tag) {
                cov_4tcvznqaj.f[7]++;
                cov_4tcvznqaj.s[47]++;
                return tag.$load('tag');
            });
        }
    }, {
        key: 'onSelectIndustry',
        value: function onSelectIndustry(organization, item) {
            cov_4tcvznqaj.f[8]++;
            cov_4tcvznqaj.s[48]++;

            this.organization.$economicActivities.$create({
                organization: organization.id,
                economicActivity: item.id
            }).$then(function (economicActivity) {
                cov_4tcvznqaj.f[9]++;
                cov_4tcvznqaj.s[49]++;
                return economicActivity.$load('economicActivity');
            });
        }
    }, {
        key: 'onSelectIndividual',
        value: function onSelectIndividual(organization, item, title) {
            cov_4tcvznqaj.f[10]++;
            cov_4tcvznqaj.s[50]++;

            this.organization.$organizationIndividuals.$create({
                organization1: organization.id,
                organization2: item.id,
                description: title
            }).$then(function (organizationIndividual) {
                cov_4tcvznqaj.f[11]++;
                cov_4tcvznqaj.s[51]++;
                return organizationIndividual.$load('individual');
            });
        }
    }, {
        key: 'createInteraction',
        value: function createInteraction(interactionType, description, at, email) {
            var _this3 = this;

            cov_4tcvznqaj.f[12]++;
            cov_4tcvznqaj.s[52]++;

            this.organization.$interactions.$create({
                organization: this.organization.id,
                email: email,
                description: description,
                interactedAt: at,
                interactionType: interactionType
                /* eslint-disable no-return-assign */
            }).$then(function () {
                cov_4tcvznqaj.f[13]++;
                cov_4tcvznqaj.s[53]++;
                return _this3.newInteractionName = '';
            });
        }
    }, {
        key: 'addIndividual',
        value: function addIndividual(name) {
            var _this4 = this;

            cov_4tcvznqaj.f[14]++;
            cov_4tcvznqaj.s[54]++;

            this.IndividualsTable.$create({ name: name }).$then(function (result) {
                cov_4tcvznqaj.f[15]++;
                cov_4tcvznqaj.s[55]++;
                return _this4.onSelectIndividual(_this4.organization, result);
            });
        }
    }, {
        key: 'displayForEconomicActivities',
        value: function displayForEconomicActivities(item) {
            cov_4tcvznqaj.f[16]++;
            cov_4tcvznqaj.s[56]++;

            return item.code + ' - ' + item.name;
        }
    }, {
        key: 'toogleFirstInteraction',
        value: function toogleFirstInteraction(interaction) {
            cov_4tcvznqaj.f[17]++;
            cov_4tcvznqaj.s[57]++;

            interaction.firstInteraction = !interaction.firstInteraction;
            cov_4tcvznqaj.s[58]++;
            interaction.$save(['firstInteraction']);
        }
    }, {
        key: 'editOrganizationIndividual',
        value: function editOrganizationIndividual(ev, x) {
            cov_4tcvznqaj.f[18]++;

            var position = (cov_4tcvznqaj.s[59]++, this.$mdPanel.newPanelPosition().absolute().center());
            var config = (cov_4tcvznqaj.s[60]++, {
                controller: function DialogController() {
                    cov_4tcvznqaj.f[19]++;
                },
                controllerAs: '$ctrl',
                templateUrl: 'app/components/organizationDetails/organizationIndividual.tmpl.html',
                hasBackdrop: true,
                position: position,
                trapFocus: true,
                zIndex: 150,
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: true,
                locals: {
                    individual: x
                }
            });
            cov_4tcvznqaj.s[61]++;
            this.$mdPanel.open(config);
        }
    }, {
        key: 'displayNewEmailModal',
        value: function displayNewEmailModal() {
            var _this5 = this;

            cov_4tcvznqaj.f[20]++;
            cov_4tcvznqaj.s[62]++;

            this.NewEmailModalService.display(this.organization.id).then(function (newEmail) {
                cov_4tcvznqaj.f[21]++;
                cov_4tcvznqaj.s[63]++;

                _this5.newInteractionName = 'Email para ' + newEmail.to;
                cov_4tcvznqaj.s[64]++;
                _this5.newInteractionEmail = newEmail.id;
            });
        }

        /* eslint-disable camelcase */

    }, {
        key: 'showEmail',
        value: function showEmail(email_id) {
            cov_4tcvznqaj.f[22]++;

            var url = (cov_4tcvznqaj.s[65]++, this.AppSettings.apiUrl + '/email-interactions/' + email_id + '/');
            cov_4tcvznqaj.s[66]++;
            this.$window.open(url);
        }
    }, {
        key: 'convert',
        value: function convert(field) {
            var _this6 = this;

            cov_4tcvznqaj.f[23]++;
            cov_4tcvznqaj.s[67]++;

            this.CurrencyConversionsTable.$create({ amount: this.organization[field] }).$then(function (response) {
                cov_4tcvznqaj.f[24]++;
                cov_4tcvznqaj.s[68]++;

                _this6.organization[field] = response.convertedAmount;
                cov_4tcvznqaj.s[69]++;
                _this6.organization.$save([field]);
            });
        }
    }, {
        key: 'addEconomicActivities',
        value: function addEconomicActivities(activities) {
            var _this7 = this;

            cov_4tcvznqaj.f[25]++;
            cov_4tcvznqaj.s[70]++;

            /* eslint-disable  array-callback-return*/
            activities.map(function (activity) {
                cov_4tcvznqaj.f[26]++;

                var data = (cov_4tcvznqaj.s[71]++, { organization: _this7.organization.id, economic_activity: activity });
                cov_4tcvznqaj.s[72]++;
                _this7.organization.$economicActivities.$create(data);
            });
        }
    }, {
        key: 'addPeople',
        value: function addPeople(people) {
            var _this8 = this;

            cov_4tcvznqaj.f[27]++;
            cov_4tcvznqaj.s[73]++;

            /* eslint-disable  array-callback-return*/
            people.map(function (person) {
                cov_4tcvznqaj.f[28]++;

                var data = (cov_4tcvznqaj.s[74]++, { name: person.name });
                cov_4tcvznqaj.s[75]++;
                _this8.IndividualsTable.$create(data).$then(function (individual) {
                    cov_4tcvznqaj.f[29]++;
                    cov_4tcvznqaj.s[76]++;
                    return _this8.onSelectIndividual(_this8.organization, individual, person.jobTitle);
                });
            });
        }
    }, {
        key: 'addEmails',
        value: function addEmails(emails) {
            var _this9 = this;

            cov_4tcvznqaj.f[30]++;
            cov_4tcvznqaj.s[77]++;

            /* eslint-disable  array-callback-return*/
            emails.map(function (email) {
                cov_4tcvznqaj.f[31]++;

                var data = (cov_4tcvznqaj.s[78]++, { email: email.email, organization: _this9.organization.id });
                cov_4tcvznqaj.s[79]++;
                _this9.organization.$emails.$create(data);
            });
        }
    }, {
        key: 'addLinks',
        value: function addLinks(links) {
            var _this10 = this;

            cov_4tcvznqaj.f[32]++;
            cov_4tcvznqaj.s[80]++;

            /* eslint-disable  array-callback-return*/
            links.map(function (link) {
                cov_4tcvznqaj.f[33]++;

                var data = (cov_4tcvznqaj.s[81]++, { link: link.link, category: link.category, organization: _this10.organization.id });
                cov_4tcvznqaj.s[82]++;
                _this10.organization.$links.$create(data);
            });
        }
    }, {
        key: 'getRelatedAutocomplete',
        value: function getRelatedAutocomplete(field) {
            cov_4tcvznqaj.f[34]++;

            var related = (cov_4tcvznqaj.s[83]++, {
                people: this.addPeople,
                economicActivities: this.addEconomicActivities,
                emails: this.addEmails,
                links: this.addLinks
            });
            cov_4tcvznqaj.s[84]++;
            return related[field];
        }
    }, {
        key: 'autocomplete',
        value: function autocomplete(completion) {
            var _this11 = this;

            cov_4tcvznqaj.f[35]++;

            var keys = (cov_4tcvznqaj.s[85]++, Object.keys(completion));
            cov_4tcvznqaj.s[86]++;
            keys.map(function (field) {
                cov_4tcvznqaj.f[36]++;
                cov_4tcvznqaj.s[87]++;

                /* eslint-disable angular/typecheck-array */
                if (Array.isArray(completion[field])) {
                    cov_4tcvznqaj.b[4][0]++;

                    var callback = (cov_4tcvznqaj.s[88]++, _this11.getRelatedAutocomplete(field));
                    cov_4tcvznqaj.s[89]++;
                    callback(completion[field]);
                } else {
                    cov_4tcvznqaj.b[4][1]++;
                    cov_4tcvznqaj.s[90]++;

                    _this11.organization[field] = completion[field];
                }
            });
            cov_4tcvznqaj.s[91]++;
            this.organization.$save(keys);
        }
    }, {
        key: 'deleteOrganization',
        value: function deleteOrganization() {
            var _this12 = this;

            cov_4tcvznqaj.f[37]++;
            cov_4tcvznqaj.s[92]++;

            this.organization.$destroy().$then(function () {
                cov_4tcvznqaj.f[38]++;
                cov_4tcvznqaj.s[93]++;

                _this12.$rootScope.goBack();
            });
        }
    }, {
        key: 'googleSearch',
        value: function googleSearch(query, site) {
            cov_4tcvznqaj.f[39]++;

            var base = (cov_4tcvznqaj.s[94]++, null);
            cov_4tcvznqaj.s[95]++;
            if (site) {
                cov_4tcvznqaj.b[5][0]++;
                cov_4tcvznqaj.s[96]++;

                base = 'https://www.google.com/search?as_sitesearch=' + site + '&q=';
            } else {
                cov_4tcvznqaj.b[5][1]++;
                cov_4tcvznqaj.s[97]++;

                base = 'https://www.google.com/search?q=';
            }
            var encodedQuery = (cov_4tcvznqaj.s[98]++, encodeURIComponent(query));
            var url = (cov_4tcvznqaj.s[99]++, base + encodedQuery);
            cov_4tcvznqaj.s[100]++;
            this.$window.open(url);
        }
    }, {
        key: 'openQueryURL',
        value: function openQueryURL(base, query) {
            cov_4tcvznqaj.f[40]++;

            var encodedQuery = (cov_4tcvznqaj.s[101]++, encodeURIComponent(query));
            var url = (cov_4tcvznqaj.s[102]++, base + encodedQuery);
            cov_4tcvznqaj.s[103]++;
            this.$window.open(url);
        }
    }, {
        key: 'accentFolding',
        value: function accentFolding(value) {
            cov_4tcvznqaj.f[41]++;

            var folded_value = (cov_4tcvznqaj.s[104]++, '');
            var accentMap = (cov_4tcvznqaj.s[105]++, {
                á: 'a',
                à: 'a',
                ã: 'a',
                é: 'e',
                õ: 'o',
                ó: 'o',
                ç: 'c',
                ñ: 'n',
                í: 'i'
            });
            cov_4tcvznqaj.s[106]++;
            for (var i = 0; i < value.length; i++) {
                var char = (cov_4tcvznqaj.s[107]++, value.charAt(i));
                cov_4tcvznqaj.s[108]++;
                folded_value += (cov_4tcvznqaj.b[6][0]++, accentMap[char]) || (cov_4tcvznqaj.b[6][1]++, char);
            }
            cov_4tcvznqaj.s[109]++;
            return folded_value;
        }
    }, {
        key: 'normalize',
        value: function normalize(value) {
            cov_4tcvznqaj.f[42]++;
            cov_4tcvznqaj.s[110]++;

            return this.accentFolding(value.trim().toLowerCase());
        }
    }, {
        key: 'patternBaker',
        value: function patternBaker(index, individual, domain) {
            cov_4tcvznqaj.f[43]++;

            var names = (cov_4tcvznqaj.s[111]++, this.decomposeName(individual.name));
            /* eslint-disable default-case */
            cov_4tcvznqaj.s[112]++;
            switch (index) {
                case 1:
                    cov_4tcvznqaj.b[7][0]++;
                    cov_4tcvznqaj.s[113]++;

                    return { email: names.first + '@' + domain, organization: individual.id };
                case 2:
                    cov_4tcvznqaj.b[7][1]++;
                    cov_4tcvznqaj.s[114]++;

                    return { email: names.first + names.last + '@' + domain, organization: individual.id };
                case 3:
                    cov_4tcvznqaj.b[7][2]++;
                    cov_4tcvznqaj.s[115]++;

                    return { email: names.first + '.' + names.last + '@' + domain, organization: individual.id };
                case 4:
                    cov_4tcvznqaj.b[7][3]++;
                    cov_4tcvznqaj.s[116]++;

                    return { email: names.first + '_' + names.last + '@' + domain, organization: individual.id };
            }
        }
    }, {
        key: 'createEmail',
        value: function createEmail() {
            var _this13 = this;

            cov_4tcvznqaj.f[44]++;

            var candidate = (cov_4tcvznqaj.s[117]++, this.candidates[0]);
            cov_4tcvznqaj.s[118]++;
            this.OrganizationEmailsTable.$create({ email: candidate.email, organization: candidate.organization }).$then(function (response) {
                cov_4tcvznqaj.f[45]++;
                cov_4tcvznqaj.s[119]++;

                if (response.validationCode !== 'OK') {
                    cov_4tcvznqaj.b[8][0]++;
                    cov_4tcvznqaj.s[120]++;

                    _this13.candidates.splice(0, 1);
                    cov_4tcvznqaj.s[121]++;
                    _this13.createEmail();
                } else {
                    cov_4tcvznqaj.b[8][1]++;
                }
                cov_4tcvznqaj.s[122]++;
                _this13.$mdToast.show(_this13.$mdToast.simple().textContent('Checked ' + candidate.email).position('bottom right').parent(angular.element(_this13.$document.body)).hideDelay(3000));
            });
        }
    }, {
        key: 'generatePatterned',
        value: function generatePatterned(individual, domains) {
            var _this14 = this;

            cov_4tcvznqaj.f[46]++;

            var generated = (cov_4tcvznqaj.s[123]++, []);
            cov_4tcvznqaj.s[124]++;
            domains.map(function (organizationDomain) {
                cov_4tcvznqaj.f[47]++;

                var patterns = (cov_4tcvznqaj.s[125]++, [1, 2, 3, 4]);
                cov_4tcvznqaj.s[126]++;
                patterns.map(function (index) {
                    cov_4tcvznqaj.f[48]++;
                    cov_4tcvznqaj.s[127]++;
                    return generated.push(_this14.patternBaker(index, individual, organizationDomain.domain));
                });
            });
            cov_4tcvznqaj.s[128]++;
            return generated;
        }
    }, {
        key: 'createCandidates',
        value: function createCandidates(individual, domains) {
            cov_4tcvznqaj.f[49]++;

            var currentEmails = (cov_4tcvznqaj.s[129]++, individual.$emails.map(function (obj) {
                cov_4tcvznqaj.f[50]++;
                cov_4tcvznqaj.s[130]++;
                return obj.email;
            }));
            var generated = (cov_4tcvznqaj.s[131]++, this.generatePatterned(individual, domains));
            cov_4tcvznqaj.s[132]++;
            this.candidates = generated.filter(function (candidate) {
                cov_4tcvznqaj.f[51]++;
                cov_4tcvznqaj.s[133]++;
                return !currentEmails.includes(candidate.email);
            });
            cov_4tcvznqaj.s[134]++;
            this.createEmail();
        }
    }, {
        key: 'decomposeName',
        value: function decomposeName(name) {
            cov_4tcvznqaj.f[52]++;

            var normalized = (cov_4tcvznqaj.s[135]++, this.normalize(name));
            var components = (cov_4tcvznqaj.s[136]++, normalized.split(' '));
            var first = (cov_4tcvznqaj.s[137]++, components[0]);
            var last = (cov_4tcvznqaj.s[138]++, components[components.length - 1]);
            cov_4tcvznqaj.s[139]++;
            return { first: first, last: last };
        }
    }, {
        key: 'generateEmails',
        value: function generateEmails(individual) {
            var _this15 = this;

            cov_4tcvznqaj.f[53]++;

            var domains = (cov_4tcvznqaj.s[140]++, this.organization.$domains);
            cov_4tcvznqaj.s[141]++;
            individual.$load('emails');
            cov_4tcvznqaj.s[142]++;
            individual.$emails.$then(function () {
                cov_4tcvznqaj.f[54]++;
                cov_4tcvznqaj.s[143]++;
                return _this15.createCandidates(individual, domains);
            });
        }
    }]);

    return OrganizationDetailsController;
}();

cov_4tcvznqaj.s[144]++;


angular.module('app').component('organizationDetails', {
    templateUrl: 'app/components/organizationDetails/organizationDetails.html',
    controller: OrganizationDetailsController,
    bindings: {
        organization: '<'
    }
});
'use strict';

var cov_1p7u7yxnay = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/ordering/ordering.js',
        hash = '1c3e34cf1bc6e4b3872c342baf6d5316e83fba19',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/ordering/ordering.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 37
                }
            },
            '1': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 13,
                    column: 9
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 12
                },
                end: {
                    line: 10,
                    column: 42
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 12
                },
                end: {
                    line: 12,
                    column: 36
                }
            },
            '4': {
                start: {
                    line: 15,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 58
                }
            },
            '5': {
                start: {
                    line: 20,
                    column: 0
                },
                end: {
                    line: 29,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 28
                    },
                    end: {
                        line: 5,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 7,
                        column: 4
                    },
                    end: {
                        line: 7,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 7,
                        column: 13
                    },
                    end: {
                        line: 16,
                        column: 5
                    }
                },
                line: 7
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 9,
                        column: 8
                    },
                    end: {
                        line: 13,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 9,
                        column: 8
                    },
                    end: {
                        line: 13,
                        column: 9
                    }
                }, {
                    start: {
                        line: 9,
                        column: 8
                    },
                    end: {
                        line: 13,
                        column: 9
                    }
                }],
                line: 9
            },
            '1': {
                loc: {
                    start: {
                        line: 9,
                        column: 12
                    },
                    end: {
                        line: 9,
                        column: 65
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 9,
                        column: 12
                    },
                    end: {
                        line: 9,
                        column: 36
                    }
                }, {
                    start: {
                        line: 9,
                        column: 40
                    },
                    end: {
                        line: 9,
                        column: 65
                    }
                }],
                line: 9
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderingController = function () {
    OrderingController.$inject = ["$rootScope"];
    function OrderingController($rootScope) {
        _classCallCheck(this, OrderingController);

        cov_1p7u7yxnay.f[0]++;
        cov_1p7u7yxnay.s[0]++;

        this.$rootScope = $rootScope;
    }

    _createClass(OrderingController, [{
        key: 'toogle',
        value: function toogle() {
            cov_1p7u7yxnay.f[1]++;
            cov_1p7u7yxnay.s[1]++;

            // eslint-disable-next-line angular/definedundefined
            if ((cov_1p7u7yxnay.b[1][0]++, this.state === undefined) || (cov_1p7u7yxnay.b[1][1]++, this.state === this.field)) {
                cov_1p7u7yxnay.b[0][0]++;
                cov_1p7u7yxnay.s[2]++;

                this.state = '-' + this.field;
            } else {
                cov_1p7u7yxnay.b[0][1]++;
                cov_1p7u7yxnay.s[3]++;

                this.state = this.field;
            }

            cov_1p7u7yxnay.s[4]++;
            this.$rootScope.$emit('orderChanged', this.state);
        }
    }]);

    return OrderingController;
}();

cov_1p7u7yxnay.s[5]++;


angular.module('app').component('ordering', {
    templateUrl: 'app/components/ordering/ordering.html',
    controller: OrderingController,
    bindings: {
        field: '<',
        label: '<'
    }
});
'use strict';

var cov_13ducq9bh2 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/municipalityDetails/municipalityDetails.js',
        hash = '91fcac34296441839300dc5df4d4e9a9c2a29e0c',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/municipalityDetails/municipalityDetails.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 8,
                    column: 3
                }
            }
        },
        fnMap: {},
        branchMap: {},
        s: {
            '0': 0
        },
        f: {},
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_13ducq9bh2.s[0]++;
angular.module('app').component('municipalityDetails', {
    templateUrl: 'app/components/municipalityDetails/municipalityDetails.html',
    bindings: {
        municipality: '<'
    }
});
'use strict';

var cov_1w32ajqo4q = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/municipalitiesList/municipalitiesList.js',
        hash = '81065bda8567186f9ced93e1bbc3197ebce049f1',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/municipalitiesList/municipalitiesList.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 26
                }
            },
            '1': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 10
                }
            },
            '2': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 24
                }
            },
            '3': {
                start: {
                    line: 16,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 51
                }
            },
            '4': {
                start: {
                    line: 20,
                    column: 0
                },
                end: {
                    line: 28,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 18
                    },
                    end: {
                        line: 5,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 7,
                        column: 4
                    },
                    end: {
                        line: 7,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 7,
                        column: 14
                    },
                    end: {
                        line: 13,
                        column: 5
                    }
                },
                line: 7
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 15,
                        column: 4
                    },
                    end: {
                        line: 15,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 15,
                        column: 15
                    },
                    end: {
                        line: 17,
                        column: 5
                    }
                },
                line: 15
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MunicipalitiesListController = function () {
    function MunicipalitiesListController() {
        _classCallCheck(this, MunicipalitiesListController);

        cov_1w32ajqo4q.f[0]++;
        cov_1w32ajqo4q.s[0]++;

        this.filters = {};
    }

    _createClass(MunicipalitiesListController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_1w32ajqo4q.f[1]++;
            cov_1w32ajqo4q.s[1]++;

            this.municipalities.$params = {
                /* eslint-disable camelcase */
                page_size: 25
            };
            cov_1w32ajqo4q.s[2]++;
            this._refresh();
        }
    }, {
        key: '_refresh',
        value: function _refresh() {
            cov_1w32ajqo4q.f[2]++;
            cov_1w32ajqo4q.s[3]++;

            this.municipalities.$refresh(this.filters);
        }
    }]);

    return MunicipalitiesListController;
}();

cov_1w32ajqo4q.s[4]++;


angular.module('app').component('municipalitiesList', {
    templateUrl: 'app/components/municipalitiesList/municipalitiesList.html',
    controller: MunicipalitiesListController,
    bindings: {
        municipalities: '<'
    }
});
'use strict';

var cov_1q8g17c6g1 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/mediaSelector/mediaSelector.js',
        hash = 'f5e998fb6179b205265f53c45fe0b0de27899f04',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/mediaSelector/mediaSelector.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 37,
                    column: 12
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 63
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 16,
                    column: 15
                }
            },
            '4': {
                start: {
                    line: 22,
                    column: 8
                },
                end: {
                    line: 22,
                    column: 34
                }
            },
            '5': {
                start: {
                    line: 23,
                    column: 8
                },
                end: {
                    line: 23,
                    column: 45
                }
            },
            '6': {
                start: {
                    line: 25,
                    column: 8
                },
                end: {
                    line: 27,
                    column: 10
                }
            },
            '7': {
                start: {
                    line: 26,
                    column: 12
                },
                end: {
                    line: 26,
                    column: 31
                }
            },
            '8': {
                start: {
                    line: 29,
                    column: 8
                },
                end: {
                    line: 31,
                    column: 10
                }
            },
            '9': {
                start: {
                    line: 30,
                    column: 12
                },
                end: {
                    line: 30,
                    column: 41
                }
            },
            '10': {
                start: {
                    line: 33,
                    column: 8
                },
                end: {
                    line: 35,
                    column: 10
                }
            },
            '11': {
                start: {
                    line: 34,
                    column: 12
                },
                end: {
                    line: 34,
                    column: 49
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 37,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'MediaSelectorService',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 45
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 23
                    },
                    end: {
                        line: 10,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 35
                    },
                    end: {
                        line: 17,
                        column: 9
                    }
                },
                line: 10
            },
            '3': {
                name: 'MediaSelectorController',
                decl: {
                    start: {
                        line: 21,
                        column: 13
                    },
                    end: {
                        line: 21,
                        column: 36
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 68
                    },
                    end: {
                        line: 36,
                        column: 5
                    }
                },
                line: 21
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 25,
                        column: 29
                    },
                    end: {
                        line: 25,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 25,
                        column: 41
                    },
                    end: {
                        line: 27,
                        column: 9
                    }
                },
                line: 25
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 29,
                        column: 29
                    },
                    end: {
                        line: 29,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 29,
                        column: 46
                    },
                    end: {
                        line: 31,
                        column: 9
                    }
                },
                line: 29
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 33,
                        column: 35
                    },
                    end: {
                        line: 33,
                        column: 36
                    }
                },
                loc: {
                    start: {
                        line: 33,
                        column: 47
                    },
                    end: {
                        line: 35,
                        column: 9
                    }
                },
                line: 33
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1q8g17c6g1.s[0]++;
(function () {
    'use strict';

    MediaSelectorService.$inject = ["$mdDialog"];
    MediaSelectorController.$inject = ["$scope", "$mdDialog", "MediaTable"];
    cov_1q8g17c6g1.f[0]++;
    cov_1q8g17c6g1.s[1]++;
    angular.module('app').service('MediaSelectorService', MediaSelectorService);

    /* @ngInject */
    function MediaSelectorService($mdDialog) {
        cov_1q8g17c6g1.f[1]++;
        cov_1q8g17c6g1.s[2]++;

        this.display = function () {
            cov_1q8g17c6g1.f[2]++;
            cov_1q8g17c6g1.s[3]++;

            return $mdDialog.show({
                templateUrl: 'app/components/mediaSelector/mediaSelector.html',
                controller: MediaSelectorController,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };
    }

    /* @ngInject */
    function MediaSelectorController($scope, $mdDialog, MediaTable) {
        cov_1q8g17c6g1.f[3]++;
        cov_1q8g17c6g1.s[4]++;

        $scope.selectedMedia = '';
        cov_1q8g17c6g1.s[5]++;
        $scope.medias = MediaTable.$search();

        cov_1q8g17c6g1.s[6]++;
        $scope.closeDialog = function () {
            cov_1q8g17c6g1.f[4]++;
            cov_1q8g17c6g1.s[7]++;

            $mdDialog.cancel();
        };

        cov_1q8g17c6g1.s[8]++;
        $scope.selectMedia = function (media) {
            cov_1q8g17c6g1.f[5]++;
            cov_1q8g17c6g1.s[9]++;

            $scope.selectedMedia = media;
        };

        cov_1q8g17c6g1.s[10]++;
        $scope.sendSelectedMedia = function () {
            cov_1q8g17c6g1.f[6]++;
            cov_1q8g17c6g1.s[11]++;

            $mdDialog.hide($scope.selectedMedia);
        };
    }
})(angular);
'use strict';

var cov_22rpb0klu5 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/mediaList/mediaList.js',
        hash = 'cc2e7fc6d9245f515cd11da7bbf8b36b737e3b91',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/mediaList/mediaList.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 57
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 10
                }
            },
            '2': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 9,
                    column: 28
                }
            },
            '3': {
                start: {
                    line: 13,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 10
                }
            },
            '4': {
                start: {
                    line: 17,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 24
                }
            },
            '5': {
                start: {
                    line: 21,
                    column: 8
                },
                end: {
                    line: 21,
                    column: 43
                }
            },
            '6': {
                start: {
                    line: 25,
                    column: 8
                },
                end: {
                    line: 29,
                    column: 9
                }
            },
            '7': {
                start: {
                    line: 26,
                    column: 12
                },
                end: {
                    line: 26,
                    column: 27
                }
            },
            '8': {
                start: {
                    line: 28,
                    column: 12
                },
                end: {
                    line: 28,
                    column: 25
                }
            },
            '9': {
                start: {
                    line: 30,
                    column: 8
                },
                end: {
                    line: 30,
                    column: 30
                }
            },
            '10': {
                start: {
                    line: 34,
                    column: 23
                },
                end: {
                    line: 38,
                    column: 9
                }
            },
            '11': {
                start: {
                    line: 39,
                    column: 8
                },
                end: {
                    line: 39,
                    column: 43
                }
            },
            '12': {
                start: {
                    line: 43,
                    column: 8
                },
                end: {
                    line: 45,
                    column: 9
                }
            },
            '13': {
                start: {
                    line: 44,
                    column: 12
                },
                end: {
                    line: 44,
                    column: 36
                }
            },
            '14': {
                start: {
                    line: 47,
                    column: 8
                },
                end: {
                    line: 51,
                    column: 9
                }
            },
            '15': {
                start: {
                    line: 48,
                    column: 12
                },
                end: {
                    line: 48,
                    column: 40
                }
            },
            '16': {
                start: {
                    line: 50,
                    column: 12
                },
                end: {
                    line: 50,
                    column: 41
                }
            },
            '17': {
                start: {
                    line: 53,
                    column: 8
                },
                end: {
                    line: 53,
                    column: 24
                }
            },
            '18': {
                start: {
                    line: 57,
                    column: 8
                },
                end: {
                    line: 60,
                    column: 11
                }
            },
            '19': {
                start: {
                    line: 58,
                    column: 12
                },
                end: {
                    line: 58,
                    column: 28
                }
            },
            '20': {
                start: {
                    line: 64,
                    column: 0
                },
                end: {
                    line: 72,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 38
                    },
                    end: {
                        line: 10,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 12,
                        column: 4
                    },
                    end: {
                        line: 12,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 12,
                        column: 14
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 12
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 20,
                        column: 4
                    },
                    end: {
                        line: 20,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 15
                    },
                    end: {
                        line: 22,
                        column: 5
                    }
                },
                line: 20
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 24,
                        column: 4
                    },
                    end: {
                        line: 24,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 22
                    },
                    end: {
                        line: 31,
                        column: 5
                    }
                },
                line: 24
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 33,
                        column: 4
                    },
                    end: {
                        line: 33,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 33,
                        column: 20
                    },
                    end: {
                        line: 40,
                        column: 5
                    }
                },
                line: 33
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 42,
                        column: 4
                    },
                    end: {
                        line: 42,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 42,
                        column: 33
                    },
                    end: {
                        line: 54,
                        column: 5
                    }
                },
                line: 42
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 56,
                        column: 4
                    },
                    end: {
                        line: 56,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 56,
                        column: 32
                    },
                    end: {
                        line: 61,
                        column: 5
                    }
                },
                line: 56
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 57,
                        column: 54
                    },
                    end: {
                        line: 57,
                        column: 55
                    }
                },
                loc: {
                    start: {
                        line: 57,
                        column: 60
                    },
                    end: {
                        line: 59,
                        column: 9
                    }
                },
                line: 57
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 59,
                        column: 11
                    },
                    end: {
                        line: 59,
                        column: 12
                    }
                },
                loc: {
                    start: {
                        line: 59,
                        column: 23
                    },
                    end: {
                        line: 60,
                        column: 9
                    }
                },
                line: 59
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 25,
                        column: 8
                    },
                    end: {
                        line: 29,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 25,
                        column: 8
                    },
                    end: {
                        line: 29,
                        column: 9
                    }
                }, {
                    start: {
                        line: 25,
                        column: 8
                    },
                    end: {
                        line: 29,
                        column: 9
                    }
                }],
                line: 25
            },
            '1': {
                loc: {
                    start: {
                        line: 43,
                        column: 8
                    },
                    end: {
                        line: 45,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 43,
                        column: 8
                    },
                    end: {
                        line: 45,
                        column: 9
                    }
                }, {
                    start: {
                        line: 43,
                        column: 8
                    },
                    end: {
                        line: 45,
                        column: 9
                    }
                }],
                line: 43
            },
            '2': {
                loc: {
                    start: {
                        line: 47,
                        column: 8
                    },
                    end: {
                        line: 51,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 47,
                        column: 8
                    },
                    end: {
                        line: 51,
                        column: 9
                    }
                }, {
                    start: {
                        line: 47,
                        column: 8
                    },
                    end: {
                        line: 51,
                        column: 9
                    }
                }],
                line: 47
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MediaListController = function () {
    MediaListController.$inject = ["NewMediaModalService"];
    function MediaListController(NewMediaModalService) {
        _classCallCheck(this, MediaListController);

        cov_22rpb0klu5.f[0]++;
        cov_22rpb0klu5.s[0]++;

        this.NewMediaModalService = NewMediaModalService;
        cov_22rpb0klu5.s[1]++;
        this.filters = {
            category: 5,
            read: 2
        };
        cov_22rpb0klu5.s[2]++;
        this.readFilter = 2;
    }

    _createClass(MediaListController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_22rpb0klu5.f[1]++;
            cov_22rpb0klu5.s[3]++;

            this.medias.$params = {
                /* eslint-disable camelcase */
                page_size: 25
            };
            cov_22rpb0klu5.s[4]++;
            this._refresh();
        }
    }, {
        key: '_refresh',
        value: function _refresh() {
            cov_22rpb0klu5.f[2]++;
            cov_22rpb0klu5.s[5]++;

            this.medias.$refresh(this.filters);
        }
    }, {
        key: 'toogleRead',
        value: function toogleRead(media) {
            cov_22rpb0klu5.f[3]++;
            cov_22rpb0klu5.s[6]++;

            if (media.read === 2) {
                cov_22rpb0klu5.b[0][0]++;
                cov_22rpb0klu5.s[7]++;

                media.read = 0;
            } else {
                cov_22rpb0klu5.b[0][1]++;
                cov_22rpb0klu5.s[8]++;

                media.read++;
            }
            cov_22rpb0klu5.s[9]++;
            media.$save(['read']);
        }
    }, {
        key: 'getStyle',
        value: function getStyle(media) {
            cov_22rpb0klu5.f[4]++;

            var colors = (cov_22rpb0klu5.s[10]++, {
                0: '#eee',
                1: 'green',
                2: '#f7d342'
            });
            cov_22rpb0klu5.s[11]++;
            return { color: colors[media.read] };
        }
    }, {
        key: 'changeFilters',
        value: function changeFilters(filter, value) {
            cov_22rpb0klu5.f[5]++;
            cov_22rpb0klu5.s[12]++;

            if (angular.isArray(value)) {
                cov_22rpb0klu5.b[1][0]++;
                cov_22rpb0klu5.s[13]++;

                value = value.join(',');
            } else {
                cov_22rpb0klu5.b[1][1]++;
            }

            cov_22rpb0klu5.s[14]++;
            if (value === null) {
                cov_22rpb0klu5.b[2][0]++;
                cov_22rpb0klu5.s[15]++;

                delete this.filters[filter];
            } else {
                cov_22rpb0klu5.b[2][1]++;
                cov_22rpb0klu5.s[16]++;

                this.filters[filter] = value;
            }

            cov_22rpb0klu5.s[17]++;
            this._refresh();
        }
    }, {
        key: 'displayNewMediaModal',
        value: function displayNewMediaModal(media) {
            var _this = this;

            cov_22rpb0klu5.f[6]++;
            cov_22rpb0klu5.s[18]++;

            this.NewMediaModalService.display(media).then(function () {
                cov_22rpb0klu5.f[7]++;
                cov_22rpb0klu5.s[19]++;

                _this._refresh();
            }, function () {
                cov_22rpb0klu5.f[8]++;
            });
        }
    }]);

    return MediaListController;
}();

cov_22rpb0klu5.s[20]++;


angular.module('app').component('mediaList', {
    templateUrl: 'app/components/mediaList/mediaList.html',
    controller: MediaListController,
    bindings: {
        medias: '<'
    }
});
'use strict';

var cov_1fsjzs5pdf = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/mediaDetails/mediaDetails.js',
        hash = '3cfeb24712e1f3bc4a4c34ee3bb3c7a6bf82b174',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/mediaDetails/mediaDetails.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 8,
                    column: 3
                }
            }
        },
        fnMap: {},
        branchMap: {},
        s: {
            '0': 0
        },
        f: {},
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1fsjzs5pdf.s[0]++;
angular.module('app').component('mediaDetails', {
    templateUrl: 'app/components/mediaDetails/mediaDetails.html',
    bindings: {
        media: '<'
    }
});
'use strict';

var cov_qcpez89pa = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/interactionsList/interactionsList.js',
        hash = 'b18ae91efaa0fc34cc9d9fe5d93e95ed82040e69',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/interactionsList/interactionsList.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 26
                }
            },
            '1': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 10
                }
            },
            '2': {
                start: {
                    line: 13,
                    column: 8
                },
                end: {
                    line: 13,
                    column: 24
                }
            },
            '3': {
                start: {
                    line: 17,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 49
                }
            },
            '4': {
                start: {
                    line: 21,
                    column: 8
                },
                end: {
                    line: 23,
                    column: 9
                }
            },
            '5': {
                start: {
                    line: 22,
                    column: 12
                },
                end: {
                    line: 22,
                    column: 36
                }
            },
            '6': {
                start: {
                    line: 25,
                    column: 8
                },
                end: {
                    line: 29,
                    column: 9
                }
            },
            '7': {
                start: {
                    line: 26,
                    column: 12
                },
                end: {
                    line: 26,
                    column: 40
                }
            },
            '8': {
                start: {
                    line: 28,
                    column: 12
                },
                end: {
                    line: 28,
                    column: 41
                }
            },
            '9': {
                start: {
                    line: 31,
                    column: 8
                },
                end: {
                    line: 31,
                    column: 24
                }
            },
            '10': {
                start: {
                    line: 36,
                    column: 0
                },
                end: {
                    line: 44,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 18
                    },
                    end: {
                        line: 5,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 7,
                        column: 4
                    },
                    end: {
                        line: 7,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 7,
                        column: 14
                    },
                    end: {
                        line: 14,
                        column: 5
                    }
                },
                line: 7
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 16,
                        column: 4
                    },
                    end: {
                        line: 16,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 16,
                        column: 15
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 16
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 20,
                        column: 4
                    },
                    end: {
                        line: 20,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 33
                    },
                    end: {
                        line: 32,
                        column: 5
                    }
                },
                line: 20
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 21,
                        column: 8
                    },
                    end: {
                        line: 23,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 21,
                        column: 8
                    },
                    end: {
                        line: 23,
                        column: 9
                    }
                }, {
                    start: {
                        line: 21,
                        column: 8
                    },
                    end: {
                        line: 23,
                        column: 9
                    }
                }],
                line: 21
            },
            '1': {
                loc: {
                    start: {
                        line: 25,
                        column: 8
                    },
                    end: {
                        line: 29,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 25,
                        column: 8
                    },
                    end: {
                        line: 29,
                        column: 9
                    }
                }, {
                    start: {
                        line: 25,
                        column: 8
                    },
                    end: {
                        line: 29,
                        column: 9
                    }
                }],
                line: 25
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InteractionsListController = function () {
    function InteractionsListController() {
        _classCallCheck(this, InteractionsListController);

        cov_qcpez89pa.f[0]++;
        cov_qcpez89pa.s[0]++;

        this.filters = {};
    }

    _createClass(InteractionsListController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_qcpez89pa.f[1]++;
            cov_qcpez89pa.s[1]++;

            this.interactions.$params = {
                /* eslint-disable camelcase */
                page_size: 25,
                ordering: '-interacted_at'
            };
            cov_qcpez89pa.s[2]++;
            this._refresh();
        }
    }, {
        key: '_refresh',
        value: function _refresh() {
            cov_qcpez89pa.f[2]++;
            cov_qcpez89pa.s[3]++;

            this.interactions.$refresh(this.filters);
        }
    }, {
        key: 'changeFilters',
        value: function changeFilters(filter, value) {
            cov_qcpez89pa.f[3]++;
            cov_qcpez89pa.s[4]++;

            if (angular.isArray(value)) {
                cov_qcpez89pa.b[0][0]++;
                cov_qcpez89pa.s[5]++;

                value = value.join(',');
            } else {
                cov_qcpez89pa.b[0][1]++;
            }

            cov_qcpez89pa.s[6]++;
            if (value === null) {
                cov_qcpez89pa.b[1][0]++;
                cov_qcpez89pa.s[7]++;

                delete this.filters[filter];
            } else {
                cov_qcpez89pa.b[1][1]++;
                cov_qcpez89pa.s[8]++;

                this.filters[filter] = value;
            }

            cov_qcpez89pa.s[9]++;
            this._refresh();
        }
    }]);

    return InteractionsListController;
}();

cov_qcpez89pa.s[10]++;


angular.module('app').component('interactionsList', {
    templateUrl: 'app/components/interactionsList/interactionsList.html',
    controller: InteractionsListController,
    bindings: {
        interactions: '<'
    }
});
'use strict';

var cov_1jh6ud8blb = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/interactionTypesList/interactionTypesList.js',
        hash = 'f81259434979d5aacfd003d9c3f04007c255f25b',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/interactionTypesList/interactionTypesList.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 8,
                    column: 3
                }
            }
        },
        fnMap: {},
        branchMap: {},
        s: {
            '0': 0
        },
        f: {},
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1jh6ud8blb.s[0]++;
angular.module('app').component('interactionTypesList', {
    templateUrl: 'app/components/interactionTypesList/interactionTypesList.html',
    bindings: {
        interactionTypes: '<'
    }
});
'use strict';

var cov_2f4ios1ehc = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/individualsList/individualsList.js',
        hash = '19265aa2cc8820d35d8e4165dfebf71206d4210a',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/individualsList/individualsList.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 67
                }
            },
            '1': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 11
                }
            },
            '2': {
                start: {
                    line: 9,
                    column: 12
                },
                end: {
                    line: 9,
                    column: 46
                }
            },
            '3': {
                start: {
                    line: 16,
                    column: 0
                },
                end: {
                    line: 24,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 43
                    },
                    end: {
                        line: 5,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 7,
                        column: 4
                    },
                    end: {
                        line: 7,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 7,
                        column: 32
                    },
                    end: {
                        line: 12,
                        column: 5
                    }
                },
                line: 7
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 8,
                        column: 54
                    },
                    end: {
                        line: 8,
                        column: 55
                    }
                },
                loc: {
                    start: {
                        line: 8,
                        column: 68
                    },
                    end: {
                        line: 10,
                        column: 9
                    }
                },
                line: 8
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 10,
                        column: 11
                    },
                    end: {
                        line: 10,
                        column: 12
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 23
                    },
                    end: {
                        line: 11,
                        column: 9
                    }
                },
                line: 10
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var IndividualsListController = function () {
    IndividualsListController.$inject = ["NewIndividualModalService"];
    function IndividualsListController(NewIndividualModalService) {
        _classCallCheck(this, IndividualsListController);

        cov_2f4ios1ehc.f[0]++;
        cov_2f4ios1ehc.s[0]++;

        this.NewIndividualModalService = NewIndividualModalService;
    }

    _createClass(IndividualsListController, [{
        key: 'displayNewIndividualModal',
        value: function displayNewIndividualModal() {
            var _this = this;

            cov_2f4ios1ehc.f[1]++;
            cov_2f4ios1ehc.s[1]++;

            this.NewIndividualModalService.display().then(function (individual) {
                cov_2f4ios1ehc.f[2]++;
                cov_2f4ios1ehc.s[2]++;

                _this.individuals.$add(individual);
            }, function () {
                cov_2f4ios1ehc.f[3]++;
            });
        }
    }]);

    return IndividualsListController;
}();

cov_2f4ios1ehc.s[3]++;


angular.module('app').component('individualsList', {
    templateUrl: 'app/components/individualsList/individualsList.html',
    controller: IndividualsListController,
    bindings: {
        individuals: '<'
    }
});
'use strict';

var cov_2asg6vt48m = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/individualDetails/individualDetails.js',
        hash = 'd8c94bf3da306448331ff9f9a79d0a44fde7e95b',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/individualDetails/individualDetails.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 35
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 55
                }
            },
            '2': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 6,
                    column: 59
                }
            },
            '3': {
                start: {
                    line: 7,
                    column: 8
                },
                end: {
                    line: 7,
                    column: 43
                }
            },
            '4': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 18,
                    column: 11
                }
            },
            '5': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 17,
                    column: 13
                }
            },
            '6': {
                start: {
                    line: 12,
                    column: 16
                },
                end: {
                    line: 16,
                    column: 19
                }
            },
            '7': {
                start: {
                    line: 22,
                    column: 8
                },
                end: {
                    line: 27,
                    column: 9
                }
            },
            '8': {
                start: {
                    line: 23,
                    column: 22
                },
                end: {
                    line: 23,
                    column: 61
                }
            },
            '9': {
                start: {
                    line: 24,
                    column: 12
                },
                end: {
                    line: 26,
                    column: 13
                }
            },
            '10': {
                start: {
                    line: 25,
                    column: 16
                },
                end: {
                    line: 25,
                    column: 41
                }
            },
            '11': {
                start: {
                    line: 28,
                    column: 8
                },
                end: {
                    line: 28,
                    column: 18
                }
            },
            '12': {
                start: {
                    line: 32,
                    column: 8
                },
                end: {
                    line: 32,
                    column: 45
                }
            },
            '13': {
                start: {
                    line: 33,
                    column: 8
                },
                end: {
                    line: 33,
                    column: 61
                }
            },
            '14': {
                start: {
                    line: 34,
                    column: 8
                },
                end: {
                    line: 34,
                    column: 69
                }
            },
            '15': {
                start: {
                    line: 36,
                    column: 8
                },
                end: {
                    line: 36,
                    column: 124
                }
            },
            '16': {
                start: {
                    line: 37,
                    column: 8
                },
                end: {
                    line: 37,
                    column: 43
                }
            },
            '17': {
                start: {
                    line: 38,
                    column: 8
                },
                end: {
                    line: 38,
                    column: 50
                }
            },
            '18': {
                start: {
                    line: 39,
                    column: 8
                },
                end: {
                    line: 39,
                    column: 48
                }
            },
            '19': {
                start: {
                    line: 43,
                    column: 8
                },
                end: {
                    line: 48,
                    column: 52
                }
            },
            '20': {
                start: {
                    line: 48,
                    column: 23
                },
                end: {
                    line: 48,
                    column: 50
                }
            },
            '21': {
                start: {
                    line: 52,
                    column: 8
                },
                end: {
                    line: 59,
                    column: 53
                }
            },
            '22': {
                start: {
                    line: 59,
                    column: 23
                },
                end: {
                    line: 59,
                    column: 51
                }
            },
            '23': {
                start: {
                    line: 63,
                    column: 8
                },
                end: {
                    line: 66,
                    column: 42
                }
            },
            '24': {
                start: {
                    line: 66,
                    column: 24
                },
                end: {
                    line: 66,
                    column: 40
                }
            },
            '25': {
                start: {
                    line: 73,
                    column: 8
                },
                end: {
                    line: 77,
                    column: 9
                }
            },
            '26': {
                start: {
                    line: 74,
                    column: 12
                },
                end: {
                    line: 74,
                    column: 41
                }
            },
            '27': {
                start: {
                    line: 76,
                    column: 12
                },
                end: {
                    line: 76,
                    column: 41
                }
            },
            '28': {
                start: {
                    line: 80,
                    column: 8
                },
                end: {
                    line: 80,
                    column: 42
                }
            },
            '29': {
                start: {
                    line: 82,
                    column: 8
                },
                end: {
                    line: 82,
                    column: 42
                }
            },
            '30': {
                start: {
                    line: 83,
                    column: 8
                },
                end: {
                    line: 83,
                    column: 24
                }
            },
            '31': {
                start: {
                    line: 87,
                    column: 21
                },
                end: {
                    line: 87,
                    column: 46
                }
            },
            '32': {
                start: {
                    line: 88,
                    column: 25
                },
                end: {
                    line: 88,
                    column: 42
                }
            },
            '33': {
                start: {
                    line: 89,
                    column: 23
                },
                end: {
                    line: 89,
                    column: 38
                }
            },
            '34': {
                start: {
                    line: 92,
                    column: 8
                },
                end: {
                    line: 94,
                    column: 9
                }
            },
            '35': {
                start: {
                    line: 93,
                    column: 12
                },
                end: {
                    line: 93,
                    column: 71
                }
            },
            '36': {
                start: {
                    line: 95,
                    column: 8
                },
                end: {
                    line: 95,
                    column: 22
                }
            },
            '37': {
                start: {
                    line: 99,
                    column: 8
                },
                end: {
                    line: 103,
                    column: 9
                }
            },
            '38': {
                start: {
                    line: 100,
                    column: 12
                },
                end: {
                    line: 100,
                    column: 46
                }
            },
            '39': {
                start: {
                    line: 102,
                    column: 12
                },
                end: {
                    line: 102,
                    column: 40
                }
            },
            '40': {
                start: {
                    line: 107,
                    column: 23
                },
                end: {
                    line: 107,
                    column: 54
                }
            },
            '41': {
                start: {
                    line: 108,
                    column: 8
                },
                end: {
                    line: 108,
                    column: 93
                }
            },
            '42': {
                start: {
                    line: 108,
                    column: 65
                },
                end: {
                    line: 108,
                    column: 91
                }
            },
            '43': {
                start: {
                    line: 113,
                    column: 0
                },
                end: {
                    line: 121,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 79
                    },
                    end: {
                        line: 19,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 10,
                        column: 49
                    },
                    end: {
                        line: 10,
                        column: 50
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 59
                    },
                    end: {
                        line: 18,
                        column: 9
                    }
                },
                line: 10
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 21,
                        column: 4
                    },
                    end: {
                        line: 21,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 20
                    },
                    end: {
                        line: 29,
                        column: 5
                    }
                },
                line: 21
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 31,
                        column: 4
                    },
                    end: {
                        line: 31,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 31,
                        column: 14
                    },
                    end: {
                        line: 40,
                        column: 5
                    }
                },
                line: 31
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 42,
                        column: 4
                    },
                    end: {
                        line: 42,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 42,
                        column: 49
                    },
                    end: {
                        line: 49,
                        column: 5
                    }
                },
                line: 42
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 48,
                        column: 17
                    },
                    end: {
                        line: 48,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 48,
                        column: 23
                    },
                    end: {
                        line: 48,
                        column: 50
                    }
                },
                line: 48
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 51,
                        column: 4
                    },
                    end: {
                        line: 51,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 51,
                        column: 63
                    },
                    end: {
                        line: 60,
                        column: 5
                    }
                },
                line: 51
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 59,
                        column: 17
                    },
                    end: {
                        line: 59,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 59,
                        column: 23
                    },
                    end: {
                        line: 59,
                        column: 51
                    }
                },
                line: 59
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 62,
                        column: 4
                    },
                    end: {
                        line: 62,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 62,
                        column: 34
                    },
                    end: {
                        line: 67,
                        column: 5
                    }
                },
                line: 62
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 66,
                        column: 17
                    },
                    end: {
                        line: 66,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 66,
                        column: 24
                    },
                    end: {
                        line: 66,
                        column: 40
                    }
                },
                line: 66
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 69,
                        column: 4
                    },
                    end: {
                        line: 69,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 69,
                        column: 25
                    },
                    end: {
                        line: 84,
                        column: 5
                    }
                },
                line: 69
            },
            '11': {
                name: '(anonymous_11)',
                decl: {
                    start: {
                        line: 86,
                        column: 4
                    },
                    end: {
                        line: 86,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 86,
                        column: 27
                    },
                    end: {
                        line: 96,
                        column: 5
                    }
                },
                line: 86
            },
            '12': {
                name: '(anonymous_12)',
                decl: {
                    start: {
                        line: 98,
                        column: 4
                    },
                    end: {
                        line: 98,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 98,
                        column: 26
                    },
                    end: {
                        line: 104,
                        column: 5
                    }
                },
                line: 98
            },
            '13': {
                name: '(anonymous_13)',
                decl: {
                    start: {
                        line: 106,
                        column: 4
                    },
                    end: {
                        line: 106,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 106,
                        column: 32
                    },
                    end: {
                        line: 109,
                        column: 5
                    }
                },
                line: 106
            },
            '14': {
                name: '(anonymous_14)',
                decl: {
                    start: {
                        line: 108,
                        column: 57
                    },
                    end: {
                        line: 108,
                        column: 58
                    }
                },
                loc: {
                    start: {
                        line: 108,
                        column: 65
                    },
                    end: {
                        line: 108,
                        column: 91
                    }
                },
                line: 108
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 17,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 17,
                        column: 13
                    }
                }, {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 17,
                        column: 13
                    }
                }],
                line: 11
            },
            '1': {
                loc: {
                    start: {
                        line: 22,
                        column: 8
                    },
                    end: {
                        line: 27,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 22,
                        column: 8
                    },
                    end: {
                        line: 27,
                        column: 9
                    }
                }, {
                    start: {
                        line: 22,
                        column: 8
                    },
                    end: {
                        line: 27,
                        column: 9
                    }
                }],
                line: 22
            },
            '2': {
                loc: {
                    start: {
                        line: 24,
                        column: 12
                    },
                    end: {
                        line: 26,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 24,
                        column: 12
                    },
                    end: {
                        line: 26,
                        column: 13
                    }
                }, {
                    start: {
                        line: 24,
                        column: 12
                    },
                    end: {
                        line: 26,
                        column: 13
                    }
                }],
                line: 24
            },
            '3': {
                loc: {
                    start: {
                        line: 24,
                        column: 16
                    },
                    end: {
                        line: 24,
                        column: 33
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 24,
                        column: 16
                    },
                    end: {
                        line: 24,
                        column: 17
                    }
                }, {
                    start: {
                        line: 24,
                        column: 21
                    },
                    end: {
                        line: 24,
                        column: 33
                    }
                }],
                line: 24
            },
            '4': {
                loc: {
                    start: {
                        line: 73,
                        column: 8
                    },
                    end: {
                        line: 77,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 73,
                        column: 8
                    },
                    end: {
                        line: 77,
                        column: 9
                    }
                }, {
                    start: {
                        line: 73,
                        column: 8
                    },
                    end: {
                        line: 77,
                        column: 9
                    }
                }],
                line: 73
            },
            '5': {
                loc: {
                    start: {
                        line: 92,
                        column: 8
                    },
                    end: {
                        line: 94,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 92,
                        column: 8
                    },
                    end: {
                        line: 94,
                        column: 9
                    }
                }, {
                    start: {
                        line: 92,
                        column: 8
                    },
                    end: {
                        line: 94,
                        column: 9
                    }
                }],
                line: 92
            },
            '6': {
                loc: {
                    start: {
                        line: 99,
                        column: 8
                    },
                    end: {
                        line: 103,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 99,
                        column: 8
                    },
                    end: {
                        line: 103,
                        column: 9
                    }
                }, {
                    start: {
                        line: 99,
                        column: 8
                    },
                    end: {
                        line: 103,
                        column: 9
                    }
                }],
                line: 99
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0,
            '30': 0,
            '31': 0,
            '32': 0,
            '33': 0,
            '34': 0,
            '35': 0,
            '36': 0,
            '37': 0,
            '38': 0,
            '39': 0,
            '40': 0,
            '41': 0,
            '42': 0,
            '43': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0],
            '3': [0, 0],
            '4': [0, 0],
            '5': [0, 0],
            '6': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var IndividualDetailsController = function () {
    IndividualDetailsController.$inject = ["TagsTable", "LinkCategoriesTable", "InteractionTypesTable", "$scope"];
    function IndividualDetailsController(TagsTable, LinkCategoriesTable, InteractionTypesTable, $scope) {
        var _this = this;

        _classCallCheck(this, IndividualDetailsController);

        cov_2asg6vt48m.f[0]++;
        cov_2asg6vt48m.s[0]++;

        this.TagsTable = TagsTable;
        cov_2asg6vt48m.s[1]++;
        this.LinkCategoriesTable = LinkCategoriesTable;
        cov_2asg6vt48m.s[2]++;
        this.InteractionTypesTable = InteractionTypesTable;
        cov_2asg6vt48m.s[3]++;
        this.newInteractionAt = new Date();

        // files
        cov_2asg6vt48m.s[4]++;
        $scope.$watch('$ctrl.newFileAttachment', function (newVal) {
            cov_2asg6vt48m.f[1]++;
            cov_2asg6vt48m.s[5]++;

            if (angular.isString(newVal)) {
                cov_2asg6vt48m.b[0][0]++;
                cov_2asg6vt48m.s[6]++;

                _this.individual.$files.$create({
                    organization: _this.individual.id,
                    path: newVal,
                    name: _this.fileToName(newVal)
                });
            } else {
                cov_2asg6vt48m.b[0][1]++;
            }
        });
    }

    _createClass(IndividualDetailsController, [{
        key: 'fileToName',
        value: function fileToName(url) {
            cov_2asg6vt48m.f[2]++;
            cov_2asg6vt48m.s[7]++;

            if (url) {
                cov_2asg6vt48m.b[1][0]++;

                var m = (cov_2asg6vt48m.s[8]++, url.toString().match(/.*\/(.+?)\.(.+)/));
                cov_2asg6vt48m.s[9]++;
                if ((cov_2asg6vt48m.b[3][0]++, m) && (cov_2asg6vt48m.b[3][1]++, m.length > 1)) {
                    cov_2asg6vt48m.b[2][0]++;
                    cov_2asg6vt48m.s[10]++;

                    return m[1] + '.' + m[2];
                } else {
                    cov_2asg6vt48m.b[2][1]++;
                }
            } else {
                cov_2asg6vt48m.b[1][1]++;
            }
            cov_2asg6vt48m.s[11]++;
            return "";
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            cov_2asg6vt48m.f[3]++;
            cov_2asg6vt48m.s[12]++;

            this.tags = this.TagsTable.$search();
            cov_2asg6vt48m.s[13]++;
            this.categories = this.LinkCategoriesTable.$search();
            cov_2asg6vt48m.s[14]++;
            this.interactionTypes = this.InteractionTypesTable.$search();

            cov_2asg6vt48m.s[15]++;
            this.individual.$load('comments').$load('tags').$load('links').$load('files').$load('interactions').$load('emails');
            cov_2asg6vt48m.s[16]++;
            this.individual.$tags.$load('tag');
            cov_2asg6vt48m.s[17]++;
            this.individual.$interactions.$load('tt');
            cov_2asg6vt48m.s[18]++;
            this.individual.$comments.$load('user');
        }
    }, {
        key: 'createComment',
        value: function createComment(individual, newCommentContent) {
            var _this2 = this;

            cov_2asg6vt48m.f[4]++;
            cov_2asg6vt48m.s[19]++;

            this.individual.$comments.$create({
                objectId: individual.id,
                objectType: 'INDIVIDUAL',
                content: newCommentContent
                /* eslint-disable no-return-assign */
            }).$then(function () {
                cov_2asg6vt48m.f[5]++;
                cov_2asg6vt48m.s[20]++;
                return _this2.newCommentContent = '';
            });
        }
    }, {
        key: 'createInteraction',
        value: function createInteraction(interactionType, description, at, email) {
            var _this3 = this;

            cov_2asg6vt48m.f[6]++;
            cov_2asg6vt48m.s[21]++;

            this.individual.$interactions.$create({
                organization: this.individual.id,
                email: email,
                description: description,
                interactedAt: at,
                interactionType: interactionType
                /* eslint-disable no-return-assign */
            }).$then(function () {
                cov_2asg6vt48m.f[7]++;
                cov_2asg6vt48m.s[22]++;
                return _this3.newInteractionName = '';
            });
        }
    }, {
        key: 'onSelectTag',
        value: function onSelectTag(individual, item) {
            cov_2asg6vt48m.f[8]++;
            cov_2asg6vt48m.s[23]++;

            this.individual.$tags.$create({
                organization: individual.id,
                tag: item.id
            }).$then(function (tag) {
                cov_2asg6vt48m.f[9]++;
                cov_2asg6vt48m.s[24]++;
                return tag.$load('tag');
            });
        }
    }, {
        key: 'extractHostname',
        value: function extractHostname(url) {
            cov_2asg6vt48m.f[10]++;

            var hostname = void 0;
            // find & remove protocol (http, ftp, etc.) and get hostname

            cov_2asg6vt48m.s[25]++;
            if (url.indexOf("://") > -1) {
                cov_2asg6vt48m.b[4][0]++;
                cov_2asg6vt48m.s[26]++;

                hostname = url.split('/')[2];
            } else {
                cov_2asg6vt48m.b[4][1]++;
                cov_2asg6vt48m.s[27]++;

                hostname = url.split('/')[0];
            }

            // find & remove port number
            cov_2asg6vt48m.s[28]++;
            hostname = hostname.split(':')[0];
            // find & remove "?"
            cov_2asg6vt48m.s[29]++;
            hostname = hostname.split('?')[0];
            cov_2asg6vt48m.s[30]++;
            return hostname;
        }
    }, {
        key: 'extractRootDomain',
        value: function extractRootDomain(url) {
            cov_2asg6vt48m.f[11]++;

            var domain = (cov_2asg6vt48m.s[31]++, this.extractHostname(url));
            var splitArr = (cov_2asg6vt48m.s[32]++, domain.split('.'));
            var arrLen = (cov_2asg6vt48m.s[33]++, splitArr.length);

            // extracting the root domain here
            cov_2asg6vt48m.s[34]++;
            if (arrLen > 2) {
                cov_2asg6vt48m.b[5][0]++;
                cov_2asg6vt48m.s[35]++;

                domain = splitArr[arrLen - 2] + '.' + splitArr[arrLen - 1];
            } else {
                cov_2asg6vt48m.b[5][1]++;
            }
            cov_2asg6vt48m.s[36]++;
            return domain;
        }
    }, {
        key: 'setCategoryLink',
        value: function setCategoryLink(data) {
            cov_2asg6vt48m.f[12]++;
            cov_2asg6vt48m.s[37]++;

            if (data.length === 1) {
                cov_2asg6vt48m.b[6][0]++;
                cov_2asg6vt48m.s[38]++;

                this.newLinkCategory = data[0].id;
            } else {
                cov_2asg6vt48m.b[6][1]++;
                cov_2asg6vt48m.s[39]++;

                this.newLinkCategory = null;
            }
        }
    }, {
        key: 'autoSelectCategory',
        value: function autoSelectCategory(newLink) {
            var _this4 = this;

            cov_2asg6vt48m.f[13]++;

            var domain = (cov_2asg6vt48m.s[40]++, this.extractRootDomain(newLink));
            cov_2asg6vt48m.s[41]++;
            this.LinkCategoriesTable.$search({ domain: domain }).$then(function (data) {
                cov_2asg6vt48m.f[14]++;
                cov_2asg6vt48m.s[42]++;
                return _this4.setCategoryLink(data);
            });
        }
    }]);

    return IndividualDetailsController;
}();

cov_2asg6vt48m.s[43]++;


angular.module('app').component('individualDetails', {
    templateUrl: 'app/components/individualDetails/individualDetails.html',
    controller: IndividualDetailsController,
    bindings: {
        individual: '<'
    }
});
'use strict';

var cov_jzrmr9iza = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/filesManager/filesManager.js',
        hash = 'ac9189beed8f5f4a6d697c87b8bf7b665dc5a987',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/filesManager/filesManager.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 11
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 12
                },
                end: {
                    line: 7,
                    column: 13
                }
            },
            '2': {
                start: {
                    line: 6,
                    column: 16
                },
                end: {
                    line: 6,
                    column: 79
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 9
                }
            },
            '4': {
                start: {
                    line: 13,
                    column: 22
                },
                end: {
                    line: 13,
                    column: 61
                }
            },
            '5': {
                start: {
                    line: 14,
                    column: 12
                },
                end: {
                    line: 16,
                    column: 13
                }
            },
            '6': {
                start: {
                    line: 15,
                    column: 16
                },
                end: {
                    line: 15,
                    column: 41
                }
            },
            '7': {
                start: {
                    line: 18,
                    column: 8
                },
                end: {
                    line: 18,
                    column: 18
                }
            },
            '8': {
                start: {
                    line: 22,
                    column: 0
                },
                end: {
                    line: 31,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 24
                    },
                    end: {
                        line: 9,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 4,
                        column: 49
                    },
                    end: {
                        line: 4,
                        column: 50
                    }
                },
                loc: {
                    start: {
                        line: 4,
                        column: 59
                    },
                    end: {
                        line: 8,
                        column: 9
                    }
                },
                line: 4
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 11,
                        column: 4
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 20
                    },
                    end: {
                        line: 19,
                        column: 5
                    }
                },
                line: 11
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 5,
                        column: 12
                    },
                    end: {
                        line: 7,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 5,
                        column: 12
                    },
                    end: {
                        line: 7,
                        column: 13
                    }
                }, {
                    start: {
                        line: 5,
                        column: 12
                    },
                    end: {
                        line: 7,
                        column: 13
                    }
                }],
                line: 5
            },
            '1': {
                loc: {
                    start: {
                        line: 12,
                        column: 8
                    },
                    end: {
                        line: 17,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 12,
                        column: 8
                    },
                    end: {
                        line: 17,
                        column: 9
                    }
                }, {
                    start: {
                        line: 12,
                        column: 8
                    },
                    end: {
                        line: 17,
                        column: 9
                    }
                }],
                line: 12
            },
            '2': {
                loc: {
                    start: {
                        line: 14,
                        column: 12
                    },
                    end: {
                        line: 16,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 14,
                        column: 12
                    },
                    end: {
                        line: 16,
                        column: 13
                    }
                }, {
                    start: {
                        line: 14,
                        column: 12
                    },
                    end: {
                        line: 16,
                        column: 13
                    }
                }],
                line: 14
            },
            '3': {
                loc: {
                    start: {
                        line: 14,
                        column: 16
                    },
                    end: {
                        line: 14,
                        column: 33
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 14,
                        column: 16
                    },
                    end: {
                        line: 14,
                        column: 17
                    }
                }, {
                    start: {
                        line: 14,
                        column: 21
                    },
                    end: {
                        line: 14,
                        column: 33
                    }
                }],
                line: 14
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0],
            '3': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FilesManagerController = function () {
    FilesManagerController.$inject = ["$scope"];
    function FilesManagerController($scope) {
        var _this = this;

        _classCallCheck(this, FilesManagerController);

        cov_jzrmr9iza.f[0]++;
        cov_jzrmr9iza.s[0]++;

        $scope.$watch('$ctrl.newFileAttachment', function (newVal) {
            cov_jzrmr9iza.f[1]++;
            cov_jzrmr9iza.s[1]++;

            if (angular.isString(newVal)) {
                cov_jzrmr9iza.b[0][0]++;
                cov_jzrmr9iza.s[2]++;

                _this.uploadFile({ path: newVal, name: _this.fileToName(newVal) });
            } else {
                cov_jzrmr9iza.b[0][1]++;
            }
        });
    }

    _createClass(FilesManagerController, [{
        key: 'fileToName',
        value: function fileToName(url) {
            cov_jzrmr9iza.f[2]++;
            cov_jzrmr9iza.s[3]++;

            if (url) {
                cov_jzrmr9iza.b[1][0]++;

                var m = (cov_jzrmr9iza.s[4]++, url.toString().match(/.*\/(.+?)\.(.+)/));
                cov_jzrmr9iza.s[5]++;
                if ((cov_jzrmr9iza.b[3][0]++, m) && (cov_jzrmr9iza.b[3][1]++, m.length > 1)) {
                    cov_jzrmr9iza.b[2][0]++;
                    cov_jzrmr9iza.s[6]++;

                    return m[1] + '.' + m[2];
                } else {
                    cov_jzrmr9iza.b[2][1]++;
                }
            } else {
                cov_jzrmr9iza.b[1][1]++;
            }
            cov_jzrmr9iza.s[7]++;
            return "";
        }
    }]);

    return FilesManagerController;
}();

cov_jzrmr9iza.s[8]++;


angular.module('app').component('filesManager', {
    templateUrl: 'app/components/filesManager/filesManager.html',
    controller: FilesManagerController,
    bindings: {
        collection: '=',
        uploadFile: '&'
    }
});
'use strict';

var cov_bxeyphako = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/filesDisplay/filesDisplay.js',
        hash = '6e5d7cd32e1da3792241aed505f92236066a8a62',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/filesDisplay/filesDisplay.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 37
                }
            },
            '1': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 9
                }
            },
            '2': {
                start: {
                    line: 12,
                    column: 22
                },
                end: {
                    line: 12,
                    column: 61
                }
            },
            '3': {
                start: {
                    line: 13,
                    column: 12
                },
                end: {
                    line: 15,
                    column: 13
                }
            },
            '4': {
                start: {
                    line: 14,
                    column: 16
                },
                end: {
                    line: 14,
                    column: 41
                }
            },
            '5': {
                start: {
                    line: 17,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 18
                }
            },
            '6': {
                start: {
                    line: 21,
                    column: 0
                },
                end: {
                    line: 30,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 28
                    },
                    end: {
                        line: 4,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 6,
                        column: 4
                    },
                    end: {
                        line: 6,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 6,
                        column: 14
                    },
                    end: {
                        line: 8,
                        column: 5
                    }
                },
                line: 6
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 4
                    },
                    end: {
                        line: 10,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 20
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 10
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 11,
                        column: 8
                    },
                    end: {
                        line: 16,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 11,
                        column: 8
                    },
                    end: {
                        line: 16,
                        column: 9
                    }
                }, {
                    start: {
                        line: 11,
                        column: 8
                    },
                    end: {
                        line: 16,
                        column: 9
                    }
                }],
                line: 11
            },
            '1': {
                loc: {
                    start: {
                        line: 13,
                        column: 12
                    },
                    end: {
                        line: 15,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 13,
                        column: 12
                    },
                    end: {
                        line: 15,
                        column: 13
                    }
                }, {
                    start: {
                        line: 13,
                        column: 12
                    },
                    end: {
                        line: 15,
                        column: 13
                    }
                }],
                line: 13
            },
            '2': {
                loc: {
                    start: {
                        line: 13,
                        column: 16
                    },
                    end: {
                        line: 13,
                        column: 33
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 13,
                        column: 16
                    },
                    end: {
                        line: 13,
                        column: 17
                    }
                }, {
                    start: {
                        line: 13,
                        column: 21
                    },
                    end: {
                        line: 13,
                        column: 33
                    }
                }],
                line: 13
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FilesDisplayController = function () {
    FilesDisplayController.$inject = ["$rootScope"];
    function FilesDisplayController($rootScope) {
        _classCallCheck(this, FilesDisplayController);

        cov_bxeyphako.f[0]++;
        cov_bxeyphako.s[0]++;

        this.$rootScope = $rootScope;
    }

    _createClass(FilesDisplayController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_bxeyphako.f[1]++;
        }
    }, {
        key: 'fileToName',
        value: function fileToName(url) {
            cov_bxeyphako.f[2]++;
            cov_bxeyphako.s[1]++;

            if (url) {
                cov_bxeyphako.b[0][0]++;

                var m = (cov_bxeyphako.s[2]++, url.toString().match(/.*\/(.+?)\.(.+)/));
                cov_bxeyphako.s[3]++;
                if ((cov_bxeyphako.b[2][0]++, m) && (cov_bxeyphako.b[2][1]++, m.length > 1)) {
                    cov_bxeyphako.b[1][0]++;
                    cov_bxeyphako.s[4]++;

                    return m[1] + '.' + m[2];
                } else {
                    cov_bxeyphako.b[1][1]++;
                }
            } else {
                cov_bxeyphako.b[0][1]++;
            }
            cov_bxeyphako.s[5]++;
            return "";
        }
    }]);

    return FilesDisplayController;
}();

cov_bxeyphako.s[6]++;


angular.module('app').component('filesDisplay', {
    templateUrl: 'app/components/filesDisplay/filesDisplay.html',
    controller: FilesDisplayController,
    bindings: {
        files: '=',
        deletable: '='
    }
});
'use strict';

var cov_29nrk5tzr2 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/fab/fab.js',
        hash = '9d49e770f8444ab1f1218545586f95ba225209b8',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/fab/fab.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 10,
                    column: 3
                }
            }
        },
        fnMap: {},
        branchMap: {},
        s: {
            '0': 0
        },
        f: {},
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_29nrk5tzr2.s[0]++;
angular.module('app').component('fab', {
    templateUrl: 'app/components/fab/fab.html',
    bindings: {
        onAction: '&',
        tooltip: '@',
        icon: '@'
    }
});
'use strict';

var cov_4pfz0f5or = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/economicActivitiesList/economicActivitiesList.js',
        hash = '42b426be4cbfc281da4b071c2a462c8131842e70',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/economicActivitiesList/economicActivitiesList.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 8,
                    column: 3
                }
            }
        },
        fnMap: {},
        branchMap: {},
        s: {
            '0': 0
        },
        f: {},
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_4pfz0f5or.s[0]++;
angular.module('app').component('economicActivitiesList', {
    templateUrl: 'app/components/economicActivitiesList/economicActivitiesList.html',
    bindings: {
        economicActivities: '<'
    }
});
'use strict';

var cov_21k6yqqejb = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/documentsList/documentsList.js',
        hash = '0c4fc44f59e2b091f547f431a551044e4b3a14a4',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/documentsList/documentsList.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 11
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 12
                },
                end: {
                    line: 10,
                    column: 13
                }
            },
            '2': {
                start: {
                    line: 6,
                    column: 16
                },
                end: {
                    line: 9,
                    column: 19
                }
            },
            '3': {
                start: {
                    line: 15,
                    column: 8
                },
                end: {
                    line: 20,
                    column: 9
                }
            },
            '4': {
                start: {
                    line: 16,
                    column: 22
                },
                end: {
                    line: 16,
                    column: 61
                }
            },
            '5': {
                start: {
                    line: 17,
                    column: 12
                },
                end: {
                    line: 19,
                    column: 13
                }
            },
            '6': {
                start: {
                    line: 18,
                    column: 16
                },
                end: {
                    line: 18,
                    column: 41
                }
            },
            '7': {
                start: {
                    line: 21,
                    column: 8
                },
                end: {
                    line: 21,
                    column: 18
                }
            },
            '8': {
                start: {
                    line: 25,
                    column: 8
                },
                end: {
                    line: 25,
                    column: 45
                }
            },
            '9': {
                start: {
                    line: 30,
                    column: 0
                },
                end: {
                    line: 38,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 24
                    },
                    end: {
                        line: 12,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 4,
                        column: 49
                    },
                    end: {
                        line: 4,
                        column: 50
                    }
                },
                loc: {
                    start: {
                        line: 4,
                        column: 59
                    },
                    end: {
                        line: 11,
                        column: 9
                    }
                },
                line: 4
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 14,
                        column: 4
                    },
                    end: {
                        line: 14,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 20
                    },
                    end: {
                        line: 22,
                        column: 5
                    }
                },
                line: 14
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 24,
                        column: 4
                    },
                    end: {
                        line: 24,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 14
                    },
                    end: {
                        line: 26,
                        column: 5
                    }
                },
                line: 24
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 5,
                        column: 12
                    },
                    end: {
                        line: 10,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 5,
                        column: 12
                    },
                    end: {
                        line: 10,
                        column: 13
                    }
                }, {
                    start: {
                        line: 5,
                        column: 12
                    },
                    end: {
                        line: 10,
                        column: 13
                    }
                }],
                line: 5
            },
            '1': {
                loc: {
                    start: {
                        line: 15,
                        column: 8
                    },
                    end: {
                        line: 20,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 15,
                        column: 8
                    },
                    end: {
                        line: 20,
                        column: 9
                    }
                }, {
                    start: {
                        line: 15,
                        column: 8
                    },
                    end: {
                        line: 20,
                        column: 9
                    }
                }],
                line: 15
            },
            '2': {
                loc: {
                    start: {
                        line: 17,
                        column: 12
                    },
                    end: {
                        line: 19,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 17,
                        column: 12
                    },
                    end: {
                        line: 19,
                        column: 13
                    }
                }, {
                    start: {
                        line: 17,
                        column: 12
                    },
                    end: {
                        line: 19,
                        column: 13
                    }
                }],
                line: 17
            },
            '3': {
                loc: {
                    start: {
                        line: 17,
                        column: 16
                    },
                    end: {
                        line: 17,
                        column: 33
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 17,
                        column: 16
                    },
                    end: {
                        line: 17,
                        column: 17
                    }
                }, {
                    start: {
                        line: 17,
                        column: 21
                    },
                    end: {
                        line: 17,
                        column: 33
                    }
                }],
                line: 17
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0],
            '3': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DocumentsListController = function () {
    DocumentsListController.$inject = ["$scope"];
    function DocumentsListController($scope) {
        var _this = this;

        _classCallCheck(this, DocumentsListController);

        cov_21k6yqqejb.f[0]++;
        cov_21k6yqqejb.s[0]++;

        $scope.$watch('$ctrl.newFileAttachment', function (newVal) {
            cov_21k6yqqejb.f[1]++;
            cov_21k6yqqejb.s[1]++;

            if (angular.isString(newVal)) {
                cov_21k6yqqejb.b[0][0]++;
                cov_21k6yqqejb.s[2]++;

                _this.documents.$create({
                    path: newVal,
                    name: _this.fileToName(newVal)
                });
            } else {
                cov_21k6yqqejb.b[0][1]++;
            }
        });
    }

    _createClass(DocumentsListController, [{
        key: 'fileToName',
        value: function fileToName(url) {
            cov_21k6yqqejb.f[2]++;
            cov_21k6yqqejb.s[3]++;

            if (url) {
                cov_21k6yqqejb.b[1][0]++;

                var m = (cov_21k6yqqejb.s[4]++, url.toString().match(/.*\/(.+?)\.(.+)/));
                cov_21k6yqqejb.s[5]++;
                if ((cov_21k6yqqejb.b[3][0]++, m) && (cov_21k6yqqejb.b[3][1]++, m.length > 1)) {
                    cov_21k6yqqejb.b[2][0]++;
                    cov_21k6yqqejb.s[6]++;

                    return m[1] + '.' + m[2];
                } else {
                    cov_21k6yqqejb.b[2][1]++;
                }
            } else {
                cov_21k6yqqejb.b[1][1]++;
            }
            cov_21k6yqqejb.s[7]++;
            return "";
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            cov_21k6yqqejb.f[3]++;
            cov_21k6yqqejb.s[8]++;

            this.documents.$load('organization');
        }
    }]);

    return DocumentsListController;
}();

cov_21k6yqqejb.s[9]++;


angular.module('app').component('documentsList', {
    templateUrl: 'app/components/documentsList/documentsList.html',
    controller: DocumentsListController,
    bindings: {
        documents: '<'
    }
});
'use strict';

var cov_v036q4w3v = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/dashboard/dashboard.js',
        hash = '5d157b6d0120a068fa5eebb7a0958a57cd092c51',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/dashboard/dashboard.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 37
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 55
                }
            },
            '2': {
                start: {
                    line: 7,
                    column: 26
                },
                end: {
                    line: 7,
                    column: 57
                }
            },
            '3': {
                start: {
                    line: 8,
                    column: 24
                },
                end: {
                    line: 8,
                    column: 32
                }
            },
            '4': {
                start: {
                    line: 9,
                    column: 22
                },
                end: {
                    line: 9,
                    column: 76
                }
            },
            '5': {
                start: {
                    line: 10,
                    column: 20
                },
                end: {
                    line: 10,
                    column: 70
                }
            },
            '6': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 10
                }
            },
            '7': {
                start: {
                    line: 18,
                    column: 8
                },
                end: {
                    line: 22,
                    column: 10
                }
            },
            '8': {
                start: {
                    line: 23,
                    column: 8
                },
                end: {
                    line: 26,
                    column: 10
                }
            },
            '9': {
                start: {
                    line: 27,
                    column: 8
                },
                end: {
                    line: 27,
                    column: 27
                }
            },
            '10': {
                start: {
                    line: 31,
                    column: 8
                },
                end: {
                    line: 31,
                    column: 24
                }
            },
            '11': {
                start: {
                    line: 35,
                    column: 22
                },
                end: {
                    line: 35,
                    column: 47
                }
            },
            '12': {
                start: {
                    line: 36,
                    column: 20
                },
                end: {
                    line: 36,
                    column: 43
                }
            },
            '13': {
                start: {
                    line: 38,
                    column: 25
                },
                end: {
                    line: 38,
                    column: 69
                }
            },
            '14': {
                start: {
                    line: 39,
                    column: 25
                },
                end: {
                    line: 39,
                    column: 65
                }
            },
            '15': {
                start: {
                    line: 40,
                    column: 8
                },
                end: {
                    line: 40,
                    column: 92
                }
            },
            '16': {
                start: {
                    line: 44,
                    column: 8
                },
                end: {
                    line: 45,
                    column: 64
                }
            },
            '17': {
                start: {
                    line: 45,
                    column: 23
                },
                end: {
                    line: 45,
                    column: 62
                }
            },
            '18': {
                start: {
                    line: 46,
                    column: 8
                },
                end: {
                    line: 47,
                    column: 67
                }
            },
            '19': {
                start: {
                    line: 47,
                    column: 23
                },
                end: {
                    line: 47,
                    column: 65
                }
            },
            '20': {
                start: {
                    line: 48,
                    column: 8
                },
                end: {
                    line: 49,
                    column: 68
                }
            },
            '21': {
                start: {
                    line: 49,
                    column: 23
                },
                end: {
                    line: 49,
                    column: 66
                }
            },
            '22': {
                start: {
                    line: 50,
                    column: 8
                },
                end: {
                    line: 51,
                    column: 67
                }
            },
            '23': {
                start: {
                    line: 51,
                    column: 23
                },
                end: {
                    line: 51,
                    column: 65
                }
            },
            '24': {
                start: {
                    line: 52,
                    column: 8
                },
                end: {
                    line: 53,
                    column: 59
                }
            },
            '25': {
                start: {
                    line: 53,
                    column: 23
                },
                end: {
                    line: 53,
                    column: 57
                }
            },
            '26': {
                start: {
                    line: 54,
                    column: 8
                },
                end: {
                    line: 54,
                    column: 101
                }
            },
            '27': {
                start: {
                    line: 54,
                    column: 93
                },
                end: {
                    line: 54,
                    column: 99
                }
            },
            '28': {
                start: {
                    line: 59,
                    column: 28
                },
                end: {
                    line: 72,
                    column: 9
                }
            },
            '29': {
                start: {
                    line: 73,
                    column: 30
                },
                end: {
                    line: 86,
                    column: 9
                }
            },
            '30': {
                start: {
                    line: 87,
                    column: 8
                },
                end: {
                    line: 87,
                    column: 40
                }
            },
            '31': {
                start: {
                    line: 91,
                    column: 23
                },
                end: {
                    line: 94,
                    column: 10
                }
            },
            '32': {
                start: {
                    line: 92,
                    column: 22
                },
                end: {
                    line: 92,
                    column: 59
                }
            },
            '33': {
                start: {
                    line: 93,
                    column: 12
                },
                end: {
                    line: 93,
                    column: 89
                }
            },
            '34': {
                start: {
                    line: 95,
                    column: 8
                },
                end: {
                    line: 95,
                    column: 36
                }
            },
            '35': {
                start: {
                    line: 96,
                    column: 8
                },
                end: {
                    line: 96,
                    column: 31
                }
            },
            '36': {
                start: {
                    line: 100,
                    column: 23
                },
                end: {
                    line: 103,
                    column: 10
                }
            },
            '37': {
                start: {
                    line: 101,
                    column: 25
                },
                end: {
                    line: 101,
                    column: 62
                }
            },
            '38': {
                start: {
                    line: 102,
                    column: 12
                },
                end: {
                    line: 102,
                    column: 84
                }
            },
            '39': {
                start: {
                    line: 105,
                    column: 27
                },
                end: {
                    line: 105,
                    column: 47
                }
            },
            '40': {
                start: {
                    line: 106,
                    column: 8
                },
                end: {
                    line: 106,
                    column: 39
                }
            },
            '41': {
                start: {
                    line: 107,
                    column: 8
                },
                end: {
                    line: 107,
                    column: 34
                }
            },
            '42': {
                start: {
                    line: 111,
                    column: 8
                },
                end: {
                    line: 116,
                    column: 10
                }
            },
            '43': {
                start: {
                    line: 120,
                    column: 8
                },
                end: {
                    line: 155,
                    column: 10
                }
            },
            '44': {
                start: {
                    line: 134,
                    column: 20
                },
                end: {
                    line: 134,
                    column: 35
                }
            },
            '45': {
                start: {
                    line: 137,
                    column: 20
                },
                end: {
                    line: 137,
                    column: 35
                }
            },
            '46': {
                start: {
                    line: 141,
                    column: 20
                },
                end: {
                    line: 141,
                    column: 37
                }
            },
            '47': {
                start: {
                    line: 144,
                    column: 20
                },
                end: {
                    line: 144,
                    column: 29
                }
            },
            '48': {
                start: {
                    line: 159,
                    column: 8
                },
                end: {
                    line: 190,
                    column: 10
                }
            },
            '49': {
                start: {
                    line: 179,
                    column: 24
                },
                end: {
                    line: 179,
                    column: 33
                }
            },
            '50': {
                start: {
                    line: 186,
                    column: 24
                },
                end: {
                    line: 186,
                    column: 52
                }
            },
            '51': {
                start: {
                    line: 195,
                    column: 0
                },
                end: {
                    line: 200,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 49
                    },
                    end: {
                        line: 28,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 30,
                        column: 4
                    },
                    end: {
                        line: 30,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 14
                    },
                    end: {
                        line: 32,
                        column: 5
                    }
                },
                line: 30
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 34,
                        column: 4
                    },
                    end: {
                        line: 34,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 34,
                        column: 26
                    },
                    end: {
                        line: 41,
                        column: 5
                    }
                },
                line: 34
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 43,
                        column: 4
                    },
                    end: {
                        line: 43,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 43,
                        column: 15
                    },
                    end: {
                        line: 55,
                        column: 5
                    }
                },
                line: 43
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 45,
                        column: 12
                    },
                    end: {
                        line: 45,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 45,
                        column: 23
                    },
                    end: {
                        line: 45,
                        column: 62
                    }
                },
                line: 45
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 47,
                        column: 12
                    },
                    end: {
                        line: 47,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 47,
                        column: 23
                    },
                    end: {
                        line: 47,
                        column: 65
                    }
                },
                line: 47
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 49,
                        column: 12
                    },
                    end: {
                        line: 49,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 49,
                        column: 23
                    },
                    end: {
                        line: 49,
                        column: 66
                    }
                },
                line: 49
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 51,
                        column: 12
                    },
                    end: {
                        line: 51,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 51,
                        column: 23
                    },
                    end: {
                        line: 51,
                        column: 65
                    }
                },
                line: 51
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 53,
                        column: 12
                    },
                    end: {
                        line: 53,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 53,
                        column: 23
                    },
                    end: {
                        line: 53,
                        column: 57
                    }
                },
                line: 53
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 54,
                        column: 83
                    },
                    end: {
                        line: 54,
                        column: 84
                    }
                },
                loc: {
                    start: {
                        line: 54,
                        column: 93
                    },
                    end: {
                        line: 54,
                        column: 99
                    }
                },
                line: 54
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 57,
                        column: 4
                    },
                    end: {
                        line: 57,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 57,
                        column: 26
                    },
                    end: {
                        line: 88,
                        column: 5
                    }
                },
                line: 57
            },
            '11': {
                name: '(anonymous_11)',
                decl: {
                    start: {
                        line: 90,
                        column: 4
                    },
                    end: {
                        line: 90,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 90,
                        column: 29
                    },
                    end: {
                        line: 97,
                        column: 5
                    }
                },
                line: 90
            },
            '12': {
                name: '(anonymous_12)',
                decl: {
                    start: {
                        line: 91,
                        column: 35
                    },
                    end: {
                        line: 91,
                        column: 36
                    }
                },
                loc: {
                    start: {
                        line: 91,
                        column: 45
                    },
                    end: {
                        line: 94,
                        column: 9
                    }
                },
                line: 91
            },
            '13': {
                name: '(anonymous_13)',
                decl: {
                    start: {
                        line: 99,
                        column: 4
                    },
                    end: {
                        line: 99,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 99,
                        column: 37
                    },
                    end: {
                        line: 108,
                        column: 5
                    }
                },
                line: 99
            },
            '14': {
                name: '(anonymous_14)',
                decl: {
                    start: {
                        line: 100,
                        column: 35
                    },
                    end: {
                        line: 100,
                        column: 36
                    }
                },
                loc: {
                    start: {
                        line: 100,
                        column: 45
                    },
                    end: {
                        line: 103,
                        column: 9
                    }
                },
                line: 100
            },
            '15': {
                name: '(anonymous_15)',
                decl: {
                    start: {
                        line: 110,
                        column: 4
                    },
                    end: {
                        line: 110,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 110,
                        column: 27
                    },
                    end: {
                        line: 117,
                        column: 5
                    }
                },
                line: 110
            },
            '16': {
                name: '(anonymous_16)',
                decl: {
                    start: {
                        line: 119,
                        column: 4
                    },
                    end: {
                        line: 119,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 119,
                        column: 17
                    },
                    end: {
                        line: 156,
                        column: 5
                    }
                },
                line: 119
            },
            '17': {
                name: '(anonymous_17)',
                decl: {
                    start: {
                        line: 133,
                        column: 19
                    },
                    end: {
                        line: 133,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 133,
                        column: 32
                    },
                    end: {
                        line: 135,
                        column: 17
                    }
                },
                line: 133
            },
            '18': {
                name: '(anonymous_18)',
                decl: {
                    start: {
                        line: 136,
                        column: 19
                    },
                    end: {
                        line: 136,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 136,
                        column: 32
                    },
                    end: {
                        line: 138,
                        column: 17
                    }
                },
                line: 136
            },
            '19': {
                name: '(anonymous_19)',
                decl: {
                    start: {
                        line: 140,
                        column: 23
                    },
                    end: {
                        line: 140,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 140,
                        column: 35
                    },
                    end: {
                        line: 142,
                        column: 17
                    }
                },
                line: 140
            },
            '20': {
                name: '(anonymous_20)',
                decl: {
                    start: {
                        line: 143,
                        column: 29
                    },
                    end: {
                        line: 143,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 143,
                        column: 42
                    },
                    end: {
                        line: 145,
                        column: 17
                    }
                },
                line: 143
            },
            '21': {
                name: '(anonymous_21)',
                decl: {
                    start: {
                        line: 158,
                        column: 4
                    },
                    end: {
                        line: 158,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 158,
                        column: 25
                    },
                    end: {
                        line: 191,
                        column: 5
                    }
                },
                line: 158
            },
            '22': {
                name: '(anonymous_22)',
                decl: {
                    start: {
                        line: 178,
                        column: 32
                    },
                    end: {
                        line: 178,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 178,
                        column: 45
                    },
                    end: {
                        line: 180,
                        column: 21
                    }
                },
                line: 178
            },
            '23': {
                name: '(anonymous_23)',
                decl: {
                    start: {
                        line: 185,
                        column: 32
                    },
                    end: {
                        line: 185,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 185,
                        column: 45
                    },
                    end: {
                        line: 187,
                        column: 21
                    }
                },
                line: 185
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0,
            '30': 0,
            '31': 0,
            '32': 0,
            '33': 0,
            '34': 0,
            '35': 0,
            '36': 0,
            '37': 0,
            '38': 0,
            '39': 0,
            '40': 0,
            '41': 0,
            '42': 0,
            '43': 0,
            '44': 0,
            '45': 0,
            '46': 0,
            '47': 0,
            '48': 0,
            '49': 0,
            '50': 0,
            '51': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DashboardController = function () {
    DashboardController.$inject = ["StatsTable", "ConfigurationsTable"];
    function DashboardController(StatsTable, ConfigurationsTable) {
        _classCallCheck(this, DashboardController);

        cov_v036q4w3v.f[0]++;
        cov_v036q4w3v.s[0]++;

        this.StatsTable = StatsTable;
        cov_v036q4w3v.s[1]++;
        this.ConfigurationsTable = ConfigurationsTable;
        /* eslint-disable no-undef */
        var startDate = (cov_v036q4w3v.s[2]++, moment().subtract(12, 'months'));
        var endDate = (cov_v036q4w3v.s[3]++, moment());
        var start = (cov_v036q4w3v.s[4]++, { year: startDate.year(), month: startDate.month() + 2 });
        var end = (cov_v036q4w3v.s[5]++, { year: endDate.year(), month: endDate.month() + 2 });
        cov_v036q4w3v.s[6]++;
        this.filters = {
            organizations: { start: start, end: end },
            meetings: { start: start, end: end },
            proposals: { start: start, end: end },
            invoices: { start: start, end: end },
            contacts: { start: start, end: end }
        };
        cov_v036q4w3v.s[7]++;
        this.data = {
            organizations: [],
            proposals: [],
            invoices: []
        };
        cov_v036q4w3v.s[8]++;
        this.options = {
            organizations: [],
            proposals: []
        };
        cov_v036q4w3v.s[9]++;
        this.multibar = [];
    }

    _createClass(DashboardController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_v036q4w3v.f[1]++;
            cov_v036q4w3v.s[10]++;

            this._refresh();
        }
    }, {
        key: 'prepareFilters',
        value: function prepareFilters(model) {
            cov_v036q4w3v.f[2]++;

            var start = (cov_v036q4w3v.s[11]++, this.filters[model].start);
            var end = (cov_v036q4w3v.s[12]++, this.filters[model].end);
            /* eslint-disable camelcase */
            var date__gt = (cov_v036q4w3v.s[13]++, start.year + '-' + start.month + '-01T00:00');
            var date__lt = (cov_v036q4w3v.s[14]++, end.year + '-' + end.month + '-01T00:00');
            cov_v036q4w3v.s[15]++;
            return { date__gt: date__gt, date__lt: date__lt, type: 'CREATED_' + model.toUpperCase(), page_size: 999 };
        }
    }, {
        key: '_refresh',
        value: function _refresh() {
            var _this = this;

            cov_v036q4w3v.f[3]++;
            cov_v036q4w3v.s[16]++;

            this.StatsTable.$search(this.prepareFilters('organizations')).$then(function (results) {
                cov_v036q4w3v.f[4]++;
                cov_v036q4w3v.s[17]++;
                return _this.setChart('organizations', results);
            });
            cov_v036q4w3v.s[18]++;
            this.StatsTable.$search(this.prepareFilters('contacts')).$then(function (results) {
                cov_v036q4w3v.f[5]++;
                cov_v036q4w3v.s[19]++;
                return _this.setMultibarChart('contacts', results);
            });
            cov_v036q4w3v.s[20]++;
            this.StatsTable.$search(this.prepareFilters('proposals')).$then(function (results) {
                cov_v036q4w3v.f[6]++;
                cov_v036q4w3v.s[21]++;
                return _this.setMultibarChart('proposals', results);
            });
            cov_v036q4w3v.s[22]++;
            this.StatsTable.$search(this.prepareFilters('meetings')).$then(function (results) {
                cov_v036q4w3v.f[7]++;
                cov_v036q4w3v.s[23]++;
                return _this.setMultibarChart('meetings', results);
            });
            cov_v036q4w3v.s[24]++;
            this.StatsTable.$search(this.prepareFilters('invoices')).$then(function (results) {
                cov_v036q4w3v.f[8]++;
                cov_v036q4w3v.s[25]++;
                return _this.setChart('invoices', results);
            });
            cov_v036q4w3v.s[26]++;
            this.lastUpdate = this.ConfigurationsTable.$find('LAST_STAT_UPDATE').$then(function (result) {
                cov_v036q4w3v.f[9]++;
                cov_v036q4w3v.s[27]++;
                return result;
            });
        }
    }, {
        key: 'parseMonth',
        value: function parseMonth(month_int) {
            cov_v036q4w3v.f[10]++;

            /* eslint-disable no-unused-vars */
            var months_full = (cov_v036q4w3v.s[28]++, {
                1: 'January',
                2: 'February',
                3: 'March',
                4: 'April',
                5: 'May',
                6: 'June',
                7: 'July',
                8: 'August',
                9: 'September',
                10: 'October',
                11: 'November',
                12: 'December'
            });
            var months_abbrev = (cov_v036q4w3v.s[29]++, {
                1: 'Jan',
                2: 'Feb',
                3: 'Mar',
                4: 'Apr',
                5: 'May',
                6: 'Jun',
                7: 'Jul',
                8: 'Aug',
                9: 'Sep',
                10: 'Oct',
                11: 'Nov',
                12: 'Dec'
            });
            cov_v036q4w3v.s[30]++;
            return months_abbrev[month_int];
        }
    }, {
        key: 'setChart',
        value: function setChart(model, results) {
            var _this2 = this;

            cov_v036q4w3v.f[11]++;

            var values = (cov_v036q4w3v.s[31]++, results.map(function (result) {
                cov_v036q4w3v.f[12]++;

                var y = (cov_v036q4w3v.s[32]++, result.year.toString(10).substr(2, 2));
                cov_v036q4w3v.s[33]++;
                return { label: _this2.parseMonth(result.month) + ' ' + y, value: result.count };
            }));
            cov_v036q4w3v.s[34]++;
            this.setData(model, values);
            cov_v036q4w3v.s[35]++;
            this.setOptions(model);
        }
    }, {
        key: 'setMultibarChart',
        value: function setMultibarChart(model, results) {
            var _this3 = this;

            cov_v036q4w3v.f[13]++;

            var values = (cov_v036q4w3v.s[36]++, results.map(function (result) {
                cov_v036q4w3v.f[14]++;

                var year = (cov_v036q4w3v.s[37]++, result.year.toString(10).substr(2, 2));
                cov_v036q4w3v.s[38]++;
                return { x: _this3.parseMonth(result.month) + ' ' + year, y: result.count };
            }));

            var collection = (cov_v036q4w3v.s[39]++, { key: model, values: values });
            cov_v036q4w3v.s[40]++;
            this.multibar.push(collection);
            cov_v036q4w3v.s[41]++;
            this.setMultibarOptions();
        }
    }, {
        key: 'setData',
        value: function setData(model, values) {
            cov_v036q4w3v.f[15]++;
            cov_v036q4w3v.s[42]++;

            this.data[model] = [{
                key: "Cumulative Return",
                values: values
            }];
        }
    }, {
        key: 'setOptions',
        value: function setOptions() {
            cov_v036q4w3v.f[16]++;
            cov_v036q4w3v.s[43]++;

            this.options.organizations = {
                chart: {
                    showYAxis: false,
                    type: 'discreteBarChart',
                    width: 1500,
                    height: 300,
                    margin: {
                        top: 20,
                        right: 20,
                        bottom: 50,
                        left: 55
                    },
                    /* eslint-disable babel/object-shorthand */
                    x: function x(d) {
                        cov_v036q4w3v.f[17]++;
                        cov_v036q4w3v.s[44]++;

                        return d.label;
                    },
                    y: function y(d) {
                        cov_v036q4w3v.f[18]++;
                        cov_v036q4w3v.s[45]++;

                        return d.value;
                    },
                    showValues: true,
                    color: function color() {
                        cov_v036q4w3v.f[19]++;
                        cov_v036q4w3v.s[46]++;

                        return '#fc9272';
                    },
                    valueFormat: function valueFormat(d) {
                        cov_v036q4w3v.f[20]++;
                        cov_v036q4w3v.s[47]++;

                        return d;
                    },
                    duration: 500,
                    xAxis: {
                        axisLabel: ''
                    },
                    yAxis: {
                        axisLabel: '',
                        axisLabelDistance: -10
                    }
                }
            };
        }
    }, {
        key: 'setMultibarOptions',
        value: function setMultibarOptions() {
            cov_v036q4w3v.f[21]++;
            cov_v036q4w3v.s[48]++;

            this.multibarOptions = {
                chart: {
                    showYAxis: false,
                    showControls: false,
                    type: 'multiBarChart',
                    width: 1500,
                    height: 300,
                    margin: {
                        top: 20,
                        right: 20,
                        bottom: 50,
                        left: 55
                    },
                    clipEdge: true,
                    duration: 500,
                    stacked: false,
                    xAxis: {
                        axisLabel: '',
                        showMaxMin: false,
                        tickFormat: function tickFormat(d) {
                            cov_v036q4w3v.f[22]++;
                            cov_v036q4w3v.s[49]++;

                            return d;
                        }
                    },
                    yAxis: {
                        axisLabel: '',
                        axisLabelDistance: -20,
                        tickFormat: function tickFormat(d) {
                            cov_v036q4w3v.f[23]++;
                            cov_v036q4w3v.s[50]++;

                            return d3.format(',.1f')(d);
                        }
                    }
                }
            };
        }
    }]);

    return DashboardController;
}();

cov_v036q4w3v.s[51]++;


angular.module('app').component('dashboard', {
    templateUrl: 'app/components/dashboard/dashboard.html',
    controller: DashboardController
});
'use strict';

var cov_j7d3uk0bd = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/createUserStoryModal/createUserStoryModal.js',
        hash = 'e5e32580cf7efff2dd8052066b2b956c35615530',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/createUserStoryModal/createUserStoryModal.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 34,
                    column: 12
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 71
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 16,
                    column: 15
                }
            },
            '4': {
                start: {
                    line: 22,
                    column: 8
                },
                end: {
                    line: 22,
                    column: 56
                }
            },
            '5': {
                start: {
                    line: 24,
                    column: 8
                },
                end: {
                    line: 26,
                    column: 10
                }
            },
            '6': {
                start: {
                    line: 25,
                    column: 12
                },
                end: {
                    line: 25,
                    column: 31
                }
            },
            '7': {
                start: {
                    line: 28,
                    column: 8
                },
                end: {
                    line: 32,
                    column: 10
                }
            },
            '8': {
                start: {
                    line: 29,
                    column: 12
                },
                end: {
                    line: 31,
                    column: 15
                }
            },
            '9': {
                start: {
                    line: 30,
                    column: 16
                },
                end: {
                    line: 30,
                    column: 42
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 34,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'NewUserStoryModalService',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 49
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 23
                    },
                    end: {
                        line: 10,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 35
                    },
                    end: {
                        line: 17,
                        column: 9
                    }
                },
                line: 10
            },
            '3': {
                name: 'CreateUserStoryModalController',
                decl: {
                    start: {
                        line: 21,
                        column: 13
                    },
                    end: {
                        line: 21,
                        column: 43
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 81
                    },
                    end: {
                        line: 33,
                        column: 5
                    }
                },
                line: 21
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 24,
                        column: 29
                    },
                    end: {
                        line: 24,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 41
                    },
                    end: {
                        line: 26,
                        column: 9
                    }
                },
                line: 24
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 28,
                        column: 33
                    },
                    end: {
                        line: 28,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 28,
                        column: 45
                    },
                    end: {
                        line: 32,
                        column: 9
                    }
                },
                line: 28
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 29,
                        column: 46
                    },
                    end: {
                        line: 29,
                        column: 47
                    }
                },
                loc: {
                    start: {
                        line: 29,
                        column: 67
                    },
                    end: {
                        line: 31,
                        column: 13
                    }
                },
                line: 29
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_j7d3uk0bd.s[0]++;
(function () {
    'use strict';

    NewUserStoryModalService.$inject = ["$mdDialog"];
    CreateUserStoryModalController.$inject = ["$scope", "$mdDialog", "UserStoriesTable"];
    cov_j7d3uk0bd.f[0]++;
    cov_j7d3uk0bd.s[1]++;
    angular.module('app').service('NewUserStoryModalService', NewUserStoryModalService);

    /* @ngInject */
    function NewUserStoryModalService($mdDialog) {
        cov_j7d3uk0bd.f[1]++;
        cov_j7d3uk0bd.s[2]++;

        this.display = function () {
            cov_j7d3uk0bd.f[2]++;
            cov_j7d3uk0bd.s[3]++;

            return $mdDialog.show({
                templateUrl: 'app/components/createUserStoryModal/createUserStoryModal.html',
                controller: CreateUserStoryModalController,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };
    }

    /* @ngInject */
    function CreateUserStoryModalController($scope, $mdDialog, UserStoriesTable) {
        cov_j7d3uk0bd.f[3]++;
        cov_j7d3uk0bd.s[4]++;

        $scope.newUserStory = UserStoriesTable.$build();

        cov_j7d3uk0bd.s[5]++;
        $scope.closeDialog = function () {
            cov_j7d3uk0bd.f[4]++;
            cov_j7d3uk0bd.s[6]++;

            $mdDialog.cancel();
        };

        cov_j7d3uk0bd.s[7]++;
        $scope.createUserStory = function () {
            cov_j7d3uk0bd.f[5]++;
            cov_j7d3uk0bd.s[8]++;

            $scope.newUserStory.$save().$then(function (userStory) {
                cov_j7d3uk0bd.f[6]++;
                cov_j7d3uk0bd.s[9]++;

                $mdDialog.hide(userStory);
            });
        };
    }
})(angular);
'use strict';

var cov_149ybq2tl5 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/createTagModal/createTagModal.js',
        hash = 'd0999b40b5da199c3f011b7a2827703ad2886212',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/createTagModal/createTagModal.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 34,
                    column: 12
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 55
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 16,
                    column: 15
                }
            },
            '4': {
                start: {
                    line: 22,
                    column: 8
                },
                end: {
                    line: 22,
                    column: 43
                }
            },
            '5': {
                start: {
                    line: 24,
                    column: 8
                },
                end: {
                    line: 26,
                    column: 10
                }
            },
            '6': {
                start: {
                    line: 25,
                    column: 12
                },
                end: {
                    line: 25,
                    column: 31
                }
            },
            '7': {
                start: {
                    line: 28,
                    column: 8
                },
                end: {
                    line: 32,
                    column: 10
                }
            },
            '8': {
                start: {
                    line: 29,
                    column: 12
                },
                end: {
                    line: 31,
                    column: 15
                }
            },
            '9': {
                start: {
                    line: 30,
                    column: 16
                },
                end: {
                    line: 30,
                    column: 36
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 34,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'NewTagModalService',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 31
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 43
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 23
                    },
                    end: {
                        line: 10,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 35
                    },
                    end: {
                        line: 17,
                        column: 9
                    }
                },
                line: 10
            },
            '3': {
                name: 'CreateTagModalController',
                decl: {
                    start: {
                        line: 21,
                        column: 13
                    },
                    end: {
                        line: 21,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 68
                    },
                    end: {
                        line: 33,
                        column: 5
                    }
                },
                line: 21
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 24,
                        column: 29
                    },
                    end: {
                        line: 24,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 41
                    },
                    end: {
                        line: 26,
                        column: 9
                    }
                },
                line: 24
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 28,
                        column: 27
                    },
                    end: {
                        line: 28,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 28,
                        column: 39
                    },
                    end: {
                        line: 32,
                        column: 9
                    }
                },
                line: 28
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 29,
                        column: 40
                    },
                    end: {
                        line: 29,
                        column: 41
                    }
                },
                loc: {
                    start: {
                        line: 29,
                        column: 55
                    },
                    end: {
                        line: 31,
                        column: 13
                    }
                },
                line: 29
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_149ybq2tl5.s[0]++;
(function () {
    'use strict';

    NewTagModalService.$inject = ["$mdDialog"];
    CreateTagModalController.$inject = ["$scope", "$mdDialog", "TagsTable"];
    cov_149ybq2tl5.f[0]++;
    cov_149ybq2tl5.s[1]++;
    angular.module('app').service('NewTagModalService', NewTagModalService);

    /* @ngInject */
    function NewTagModalService($mdDialog) {
        cov_149ybq2tl5.f[1]++;
        cov_149ybq2tl5.s[2]++;

        this.display = function () {
            cov_149ybq2tl5.f[2]++;
            cov_149ybq2tl5.s[3]++;

            return $mdDialog.show({
                templateUrl: 'app/components/createTagModal/createTagModal.html',
                controller: CreateTagModalController,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };
    }

    /* @ngInject */
    function CreateTagModalController($scope, $mdDialog, TagsTable) {
        cov_149ybq2tl5.f[3]++;
        cov_149ybq2tl5.s[4]++;

        $scope.newTag = TagsTable.$build();

        cov_149ybq2tl5.s[5]++;
        $scope.closeDialog = function () {
            cov_149ybq2tl5.f[4]++;
            cov_149ybq2tl5.s[6]++;

            $mdDialog.cancel();
        };

        cov_149ybq2tl5.s[7]++;
        $scope.createTag = function () {
            cov_149ybq2tl5.f[5]++;
            cov_149ybq2tl5.s[8]++;

            $scope.newTag.$save().$then(function (tag) {
                cov_149ybq2tl5.f[6]++;
                cov_149ybq2tl5.s[9]++;

                $mdDialog.hide(tag);
            });
        };
    }
})(angular);
'use strict';

var cov_1o3d96ftzw = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/createProposalModal/createProposalModal.js',
        hash = '39592a212a7911a4b2122bdbe1416d59b8b2042f',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/createProposalModal/createProposalModal.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 36,
                    column: 12
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 65
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 16,
                    column: 15
                }
            },
            '4': {
                start: {
                    line: 22,
                    column: 8
                },
                end: {
                    line: 22,
                    column: 53
                }
            },
            '5': {
                start: {
                    line: 23,
                    column: 8
                },
                end: {
                    line: 23,
                    column: 54
                }
            },
            '6': {
                start: {
                    line: 25,
                    column: 8
                },
                end: {
                    line: 27,
                    column: 10
                }
            },
            '7': {
                start: {
                    line: 26,
                    column: 12
                },
                end: {
                    line: 26,
                    column: 31
                }
            },
            '8': {
                start: {
                    line: 29,
                    column: 8
                },
                end: {
                    line: 34,
                    column: 10
                }
            },
            '9': {
                start: {
                    line: 30,
                    column: 12
                },
                end: {
                    line: 33,
                    column: 15
                }
            },
            '10': {
                start: {
                    line: 31,
                    column: 16
                },
                end: {
                    line: 31,
                    column: 51
                }
            },
            '11': {
                start: {
                    line: 32,
                    column: 16
                },
                end: {
                    line: 32,
                    column: 41
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 36,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'NewProposalModalService',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 36
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 48
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 23
                    },
                    end: {
                        line: 10,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 35
                    },
                    end: {
                        line: 17,
                        column: 9
                    }
                },
                line: 10
            },
            '3': {
                name: 'CreateProposalModalController',
                decl: {
                    start: {
                        line: 21,
                        column: 13
                    },
                    end: {
                        line: 21,
                        column: 42
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 98
                    },
                    end: {
                        line: 35,
                        column: 5
                    }
                },
                line: 21
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 25,
                        column: 29
                    },
                    end: {
                        line: 25,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 25,
                        column: 41
                    },
                    end: {
                        line: 27,
                        column: 9
                    }
                },
                line: 25
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 29,
                        column: 32
                    },
                    end: {
                        line: 29,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 29,
                        column: 44
                    },
                    end: {
                        line: 34,
                        column: 9
                    }
                },
                line: 29
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 30,
                        column: 45
                    },
                    end: {
                        line: 30,
                        column: 46
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 65
                    },
                    end: {
                        line: 33,
                        column: 13
                    }
                },
                line: 30
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1o3d96ftzw.s[0]++;
(function () {
    'use strict';

    NewProposalModalService.$inject = ["$mdDialog"];
    CreateProposalModalController.$inject = ["$scope", "$mdDialog", "ProposalsTable", "OrganizationsTable"];
    cov_1o3d96ftzw.f[0]++;
    cov_1o3d96ftzw.s[1]++;
    angular.module('app').service('NewProposalModalService', NewProposalModalService);

    /* @ngInject */
    function NewProposalModalService($mdDialog) {
        cov_1o3d96ftzw.f[1]++;
        cov_1o3d96ftzw.s[2]++;

        this.display = function () {
            cov_1o3d96ftzw.f[2]++;
            cov_1o3d96ftzw.s[3]++;

            return $mdDialog.show({
                templateUrl: 'app/components/createProposalModal/createProposalModal.html',
                controller: CreateProposalModalController,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };
    }

    /* @ngInject */
    function CreateProposalModalController($scope, $mdDialog, ProposalsTable, OrganizationsTable) {
        cov_1o3d96ftzw.f[3]++;
        cov_1o3d96ftzw.s[4]++;

        $scope.newProposal = ProposalsTable.$build();
        cov_1o3d96ftzw.s[5]++;
        $scope.clients = OrganizationsTable.$search();

        cov_1o3d96ftzw.s[6]++;
        $scope.closeDialog = function () {
            cov_1o3d96ftzw.f[4]++;
            cov_1o3d96ftzw.s[7]++;

            $mdDialog.cancel();
        };

        cov_1o3d96ftzw.s[8]++;
        $scope.createProposal = function () {
            cov_1o3d96ftzw.f[5]++;
            cov_1o3d96ftzw.s[9]++;

            $scope.newProposal.$save().$then(function (proposal) {
                cov_1o3d96ftzw.f[6]++;
                cov_1o3d96ftzw.s[10]++;

                $scope.newProposal.$load('client');
                cov_1o3d96ftzw.s[11]++;
                $mdDialog.hide(proposal);
            });
        };
    }
})(angular);
'use strict';

var cov_10xnej6uae = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/createOrganizationModal/createOrganizationModal.js',
        hash = 'b9cac1ed7c0ac09eb7278507b3b8904502e2be22',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/createOrganizationModal/createOrganizationModal.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 35,
                    column: 12
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 73
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 16,
                    column: 15
                }
            },
            '4': {
                start: {
                    line: 22,
                    column: 8
                },
                end: {
                    line: 22,
                    column: 61
                }
            },
            '5': {
                start: {
                    line: 24,
                    column: 8
                },
                end: {
                    line: 26,
                    column: 10
                }
            },
            '6': {
                start: {
                    line: 25,
                    column: 12
                },
                end: {
                    line: 25,
                    column: 31
                }
            },
            '7': {
                start: {
                    line: 28,
                    column: 8
                },
                end: {
                    line: 33,
                    column: 10
                }
            },
            '8': {
                start: {
                    line: 29,
                    column: 12
                },
                end: {
                    line: 32,
                    column: 15
                }
            },
            '9': {
                start: {
                    line: 30,
                    column: 16
                },
                end: {
                    line: 30,
                    column: 45
                }
            },
            '10': {
                start: {
                    line: 31,
                    column: 16
                },
                end: {
                    line: 31,
                    column: 72
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 35,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'NewOrganizationModalService',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 40
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 52
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 23
                    },
                    end: {
                        line: 10,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 35
                    },
                    end: {
                        line: 17,
                        column: 9
                    }
                },
                line: 10
            },
            '3': {
                name: 'CreateOrganizationModalController',
                decl: {
                    start: {
                        line: 21,
                        column: 13
                    },
                    end: {
                        line: 21,
                        column: 46
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 94
                    },
                    end: {
                        line: 34,
                        column: 5
                    }
                },
                line: 21
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 24,
                        column: 29
                    },
                    end: {
                        line: 24,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 41
                    },
                    end: {
                        line: 26,
                        column: 9
                    }
                },
                line: 24
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 28,
                        column: 36
                    },
                    end: {
                        line: 28,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 28,
                        column: 48
                    },
                    end: {
                        line: 33,
                        column: 9
                    }
                },
                line: 28
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 29,
                        column: 49
                    },
                    end: {
                        line: 29,
                        column: 50
                    }
                },
                loc: {
                    start: {
                        line: 29,
                        column: 73
                    },
                    end: {
                        line: 32,
                        column: 13
                    }
                },
                line: 29
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_10xnej6uae.s[0]++;
(function () {
    'use strict';

    NewOrganizationModalService.$inject = ["$mdDialog"];
    CreateOrganizationModalController.$inject = ["$scope", "$mdDialog", "OrganizationsTable", "$state"];
    cov_10xnej6uae.f[0]++;
    cov_10xnej6uae.s[1]++;
    angular.module('app').service('NewOrganizationModalService', NewOrganizationModalService);

    /* @ngInject */
    function NewOrganizationModalService($mdDialog) {
        cov_10xnej6uae.f[1]++;
        cov_10xnej6uae.s[2]++;

        this.display = function () {
            cov_10xnej6uae.f[2]++;
            cov_10xnej6uae.s[3]++;

            return $mdDialog.show({
                templateUrl: 'app/components/createOrganizationModal/createOrganizationModal.html',
                controller: CreateOrganizationModalController,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };
    }

    /* @ngInject */
    function CreateOrganizationModalController($scope, $mdDialog, OrganizationsTable, $state) {
        cov_10xnej6uae.f[3]++;
        cov_10xnej6uae.s[4]++;

        $scope.newOrganization = OrganizationsTable.$build();

        cov_10xnej6uae.s[5]++;
        $scope.closeDialog = function () {
            cov_10xnej6uae.f[4]++;
            cov_10xnej6uae.s[6]++;

            $mdDialog.cancel();
        };

        cov_10xnej6uae.s[7]++;
        $scope.createOrganization = function () {
            cov_10xnej6uae.f[5]++;
            cov_10xnej6uae.s[8]++;

            $scope.newOrganization.$save().$then(function (organization) {
                cov_10xnej6uae.f[6]++;
                cov_10xnej6uae.s[9]++;

                $mdDialog.hide(organization);
                cov_10xnej6uae.s[10]++;
                $state.go('organizationDetails', { id: organization.id });
            });
        };
    }
})(angular);
'use strict';

var cov_1ebu68u0gl = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/createMediaModal/createMediaModal.js',
        hash = '75796e2781a46c25495b8845cbcbca14647e0a3a',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/createMediaModal/createMediaModal.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 45,
                    column: 12
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 59
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 20,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 19,
                    column: 15
                }
            },
            '4': {
                start: {
                    line: 26,
                    column: 8
                },
                end: {
                    line: 26,
                    column: 77
                }
            },
            '5': {
                start: {
                    line: 27,
                    column: 8
                },
                end: {
                    line: 33,
                    column: 9
                }
            },
            '6': {
                start: {
                    line: 28,
                    column: 12
                },
                end: {
                    line: 28,
                    column: 43
                }
            },
            '7': {
                start: {
                    line: 29,
                    column: 12
                },
                end: {
                    line: 29,
                    column: 36
                }
            },
            '8': {
                start: {
                    line: 31,
                    column: 12
                },
                end: {
                    line: 31,
                    column: 72
                }
            },
            '9': {
                start: {
                    line: 32,
                    column: 12
                },
                end: {
                    line: 32,
                    column: 43
                }
            },
            '10': {
                start: {
                    line: 35,
                    column: 8
                },
                end: {
                    line: 37,
                    column: 10
                }
            },
            '11': {
                start: {
                    line: 36,
                    column: 12
                },
                end: {
                    line: 36,
                    column: 31
                }
            },
            '12': {
                start: {
                    line: 39,
                    column: 8
                },
                end: {
                    line: 43,
                    column: 10
                }
            },
            '13': {
                start: {
                    line: 40,
                    column: 12
                },
                end: {
                    line: 42,
                    column: 15
                }
            },
            '14': {
                start: {
                    line: 41,
                    column: 16
                },
                end: {
                    line: 41,
                    column: 38
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 45,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'NewMediaModalService',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 45
                    },
                    end: {
                        line: 21,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 23
                    },
                    end: {
                        line: 10,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 40
                    },
                    end: {
                        line: 20,
                        column: 9
                    }
                },
                line: 10
            },
            '3': {
                name: 'CreateMediaModalController',
                decl: {
                    start: {
                        line: 24,
                        column: 13
                    },
                    end: {
                        line: 24,
                        column: 39
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 98
                    },
                    end: {
                        line: 44,
                        column: 5
                    }
                },
                line: 24
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 35,
                        column: 29
                    },
                    end: {
                        line: 35,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 35,
                        column: 41
                    },
                    end: {
                        line: 37,
                        column: 9
                    }
                },
                line: 35
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 39,
                        column: 29
                    },
                    end: {
                        line: 39,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 39,
                        column: 41
                    },
                    end: {
                        line: 43,
                        column: 9
                    }
                },
                line: 39
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 40,
                        column: 42
                    },
                    end: {
                        line: 40,
                        column: 43
                    }
                },
                loc: {
                    start: {
                        line: 40,
                        column: 59
                    },
                    end: {
                        line: 42,
                        column: 13
                    }
                },
                line: 40
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 27,
                        column: 8
                    },
                    end: {
                        line: 33,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 27,
                        column: 8
                    },
                    end: {
                        line: 33,
                        column: 9
                    }
                }, {
                    start: {
                        line: 27,
                        column: 8
                    },
                    end: {
                        line: 33,
                        column: 9
                    }
                }],
                line: 27
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1ebu68u0gl.s[0]++;
(function () {
    'use strict';

    NewMediaModalService.$inject = ["$mdDialog"];
    CreateMediaModalController.$inject = ["$scope", "$mdDialog", "LinksTable", "OrganizationsTable", "media"];
    cov_1ebu68u0gl.f[0]++;
    cov_1ebu68u0gl.s[1]++;
    angular.module('app').service('NewMediaModalService', NewMediaModalService);

    /* @ngInject */
    function NewMediaModalService($mdDialog) {
        cov_1ebu68u0gl.f[1]++;
        cov_1ebu68u0gl.s[2]++;

        this.display = function (media) {
            cov_1ebu68u0gl.f[2]++;
            cov_1ebu68u0gl.s[3]++;

            return $mdDialog.show({
                templateUrl: 'app/components/createMediaModal/createMediaModal.html',
                controller: CreateMediaModalController,
                clickOutsideToClose: true,
                escapeToClose: true,
                locals: {
                    media: media
                }
            });
        };
    }

    /* @ngInject */
    function CreateMediaModalController($scope, $mdDialog, LinksTable, OrganizationsTable, media) {
        cov_1ebu68u0gl.f[3]++;
        cov_1ebu68u0gl.s[4]++;

        /* eslint-disable camelcase */
        $scope.organizations = OrganizationsTable.$search({ page_size: 9999 });
        cov_1ebu68u0gl.s[5]++;
        if (media) {
            cov_1ebu68u0gl.b[0][0]++;
            cov_1ebu68u0gl.s[6]++;

            $scope.action = 'Update Media';
            cov_1ebu68u0gl.s[7]++;
            $scope.newMedia = media;
        } else {
            cov_1ebu68u0gl.b[0][1]++;
            cov_1ebu68u0gl.s[8]++;

            $scope.newMedia = LinksTable.$build({ category: 5, read: 2 });
            cov_1ebu68u0gl.s[9]++;
            $scope.action = 'Create Media';
        }

        cov_1ebu68u0gl.s[10]++;
        $scope.closeDialog = function () {
            cov_1ebu68u0gl.f[4]++;
            cov_1ebu68u0gl.s[11]++;

            $mdDialog.cancel();
        };

        cov_1ebu68u0gl.s[12]++;
        $scope.createMedia = function () {
            cov_1ebu68u0gl.f[5]++;
            cov_1ebu68u0gl.s[13]++;

            $scope.newMedia.$save().$then(function (media) {
                cov_1ebu68u0gl.f[6]++;
                cov_1ebu68u0gl.s[14]++;

                $mdDialog.hide(media);
            });
        };
    }
})(angular);
'use strict';

var cov_17r267zgjh = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/createIndividualModal/createIndividualModal.js',
        hash = '3b49a9da78260fb710d8cda0ef2c5e8d4558cc71',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/createIndividualModal/createIndividualModal.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 34,
                    column: 12
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 69
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 16,
                    column: 15
                }
            },
            '4': {
                start: {
                    line: 22,
                    column: 8
                },
                end: {
                    line: 22,
                    column: 57
                }
            },
            '5': {
                start: {
                    line: 24,
                    column: 8
                },
                end: {
                    line: 26,
                    column: 10
                }
            },
            '6': {
                start: {
                    line: 25,
                    column: 12
                },
                end: {
                    line: 25,
                    column: 31
                }
            },
            '7': {
                start: {
                    line: 28,
                    column: 8
                },
                end: {
                    line: 32,
                    column: 10
                }
            },
            '8': {
                start: {
                    line: 29,
                    column: 12
                },
                end: {
                    line: 31,
                    column: 15
                }
            },
            '9': {
                start: {
                    line: 30,
                    column: 16
                },
                end: {
                    line: 30,
                    column: 43
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 34,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'NewIndividualModalService',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 50
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 23
                    },
                    end: {
                        line: 10,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 35
                    },
                    end: {
                        line: 17,
                        column: 9
                    }
                },
                line: 10
            },
            '3': {
                name: 'CreateIndividualModalController',
                decl: {
                    start: {
                        line: 21,
                        column: 13
                    },
                    end: {
                        line: 21,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 82
                    },
                    end: {
                        line: 33,
                        column: 5
                    }
                },
                line: 21
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 24,
                        column: 29
                    },
                    end: {
                        line: 24,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 41
                    },
                    end: {
                        line: 26,
                        column: 9
                    }
                },
                line: 24
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 28,
                        column: 34
                    },
                    end: {
                        line: 28,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 28,
                        column: 46
                    },
                    end: {
                        line: 32,
                        column: 9
                    }
                },
                line: 28
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 29,
                        column: 47
                    },
                    end: {
                        line: 29,
                        column: 48
                    }
                },
                loc: {
                    start: {
                        line: 29,
                        column: 69
                    },
                    end: {
                        line: 31,
                        column: 13
                    }
                },
                line: 29
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_17r267zgjh.s[0]++;
(function () {
    'use strict';

    NewIndividualModalService.$inject = ["$mdDialog"];
    CreateIndividualModalController.$inject = ["$scope", "$mdDialog", "IndividualsTable"];
    cov_17r267zgjh.f[0]++;
    cov_17r267zgjh.s[1]++;
    angular.module('app').service('NewIndividualModalService', NewIndividualModalService);

    /* @ngInject */
    function NewIndividualModalService($mdDialog) {
        cov_17r267zgjh.f[1]++;
        cov_17r267zgjh.s[2]++;

        this.display = function () {
            cov_17r267zgjh.f[2]++;
            cov_17r267zgjh.s[3]++;

            return $mdDialog.show({
                templateUrl: 'app/components/createIndividualModal/createIndividualModal.html',
                controller: CreateIndividualModalController,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };
    }

    /* @ngInject */
    function CreateIndividualModalController($scope, $mdDialog, IndividualsTable) {
        cov_17r267zgjh.f[3]++;
        cov_17r267zgjh.s[4]++;

        $scope.newIndividual = IndividualsTable.$build();

        cov_17r267zgjh.s[5]++;
        $scope.closeDialog = function () {
            cov_17r267zgjh.f[4]++;
            cov_17r267zgjh.s[6]++;

            $mdDialog.cancel();
        };

        cov_17r267zgjh.s[7]++;
        $scope.createIndividual = function () {
            cov_17r267zgjh.f[5]++;
            cov_17r267zgjh.s[8]++;

            $scope.newIndividual.$save().$then(function (individual) {
                cov_17r267zgjh.f[6]++;
                cov_17r267zgjh.s[9]++;

                $mdDialog.hide(individual);
            });
        };
    }
})(angular);
'use strict';

var cov_2m95ziytod = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/createEmailModal/createEmailModal.js',
        hash = 'b2d38c4e7d51fde389281c4f85d33098f77ea05a',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/createEmailModal/createEmailModal.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 96,
                    column: 12
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 59
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 20,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 19,
                    column: 15
                }
            },
            '4': {
                start: {
                    line: 25,
                    column: 8
                },
                end: {
                    line: 25,
                    column: 25
                }
            },
            '5': {
                start: {
                    line: 27,
                    column: 8
                },
                end: {
                    line: 30,
                    column: 10
                }
            },
            '6': {
                start: {
                    line: 32,
                    column: 8
                },
                end: {
                    line: 32,
                    column: 66
                }
            },
            '7': {
                start: {
                    line: 34,
                    column: 8
                },
                end: {
                    line: 37,
                    column: 10
                }
            },
            '8': {
                start: {
                    line: 35,
                    column: 12
                },
                end: {
                    line: 35,
                    column: 42
                }
            },
            '9': {
                start: {
                    line: 36,
                    column: 12
                },
                end: {
                    line: 36,
                    column: 80
                }
            },
            '10': {
                start: {
                    line: 39,
                    column: 8
                },
                end: {
                    line: 46,
                    column: 15
                }
            },
            '11': {
                start: {
                    line: 41,
                    column: 16
                },
                end: {
                    line: 45,
                    column: 17
                }
            },
            '12': {
                start: {
                    line: 42,
                    column: 20
                },
                end: {
                    line: 42,
                    column: 52
                }
            },
            '13': {
                start: {
                    line: 44,
                    column: 20
                },
                end: {
                    line: 44,
                    column: 74
                }
            },
            '14': {
                start: {
                    line: 48,
                    column: 8
                },
                end: {
                    line: 56,
                    column: 10
                }
            },
            '15': {
                start: {
                    line: 49,
                    column: 12
                },
                end: {
                    line: 55,
                    column: 19
                }
            },
            '16': {
                start: {
                    line: 51,
                    column: 20
                },
                end: {
                    line: 51,
                    column: 79
                }
            },
            '17': {
                start: {
                    line: 52,
                    column: 20
                },
                end: {
                    line: 52,
                    column: 73
                }
            },
            '18': {
                start: {
                    line: 53,
                    column: 20
                },
                end: {
                    line: 53,
                    column: 35
                }
            },
            '19': {
                start: {
                    line: 54,
                    column: 20
                },
                end: {
                    line: 54,
                    column: 44
                }
            },
            '20': {
                start: {
                    line: 58,
                    column: 8
                },
                end: {
                    line: 62,
                    column: 10
                }
            },
            '21': {
                start: {
                    line: 59,
                    column: 12
                },
                end: {
                    line: 59,
                    column: 60
                }
            },
            '22': {
                start: {
                    line: 60,
                    column: 12
                },
                end: {
                    line: 60,
                    column: 54
                }
            },
            '23': {
                start: {
                    line: 61,
                    column: 12
                },
                end: {
                    line: 61,
                    column: 36
                }
            },
            '24': {
                start: {
                    line: 64,
                    column: 8
                },
                end: {
                    line: 66,
                    column: 10
                }
            },
            '25': {
                start: {
                    line: 65,
                    column: 12
                },
                end: {
                    line: 65,
                    column: 31
                }
            },
            '26': {
                start: {
                    line: 68,
                    column: 8
                },
                end: {
                    line: 78,
                    column: 10
                }
            },
            '27': {
                start: {
                    line: 69,
                    column: 24
                },
                end: {
                    line: 69,
                    column: 91
                }
            },
            '28': {
                start: {
                    line: 70,
                    column: 30
                },
                end: {
                    line: 70,
                    column: 64
                }
            },
            '29': {
                start: {
                    line: 71,
                    column: 26
                },
                end: {
                    line: 71,
                    column: 177
                }
            },
            '30': {
                start: {
                    line: 72,
                    column: 24
                },
                end: {
                    line: 72,
                    column: 116
                }
            },
            '31': {
                start: {
                    line: 73,
                    column: 23
                },
                end: {
                    line: 73,
                    column: 41
                }
            },
            '32': {
                start: {
                    line: 74,
                    column: 28
                },
                end: {
                    line: 74,
                    column: 71
                }
            },
            '33': {
                start: {
                    line: 75,
                    column: 25
                },
                end: {
                    line: 75,
                    column: 91
                }
            },
            '34': {
                start: {
                    line: 76,
                    column: 27
                },
                end: {
                    line: 76,
                    column: 83
                }
            },
            '35': {
                start: {
                    line: 77,
                    column: 12
                },
                end: {
                    line: 77,
                    column: 43
                }
            },
            '36': {
                start: {
                    line: 80,
                    column: 8
                },
                end: {
                    line: 83,
                    column: 10
                }
            },
            '37': {
                start: {
                    line: 81,
                    column: 12
                },
                end: {
                    line: 81,
                    column: 43
                }
            },
            '38': {
                start: {
                    line: 82,
                    column: 12
                },
                end: {
                    line: 82,
                    column: 81
                }
            },
            '39': {
                start: {
                    line: 82,
                    column: 48
                },
                end: {
                    line: 82,
                    column: 79
                }
            },
            '40': {
                start: {
                    line: 85,
                    column: 8
                },
                end: {
                    line: 87,
                    column: 10
                }
            },
            '41': {
                start: {
                    line: 86,
                    column: 12
                },
                end: {
                    line: 86,
                    column: 61
                }
            },
            '42': {
                start: {
                    line: 89,
                    column: 8
                },
                end: {
                    line: 94,
                    column: 10
                }
            },
            '43': {
                start: {
                    line: 90,
                    column: 12
                },
                end: {
                    line: 90,
                    column: 36
                }
            },
            '44': {
                start: {
                    line: 91,
                    column: 12
                },
                end: {
                    line: 91,
                    column: 41
                }
            },
            '45': {
                start: {
                    line: 92,
                    column: 12
                },
                end: {
                    line: 92,
                    column: 38
                }
            },
            '46': {
                start: {
                    line: 93,
                    column: 12
                },
                end: {
                    line: 93,
                    column: 36
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 96,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'NewEmailModalService',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 45
                    },
                    end: {
                        line: 21,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 23
                    },
                    end: {
                        line: 10,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 47
                    },
                    end: {
                        line: 20,
                        column: 9
                    }
                },
                line: 10
            },
            '3': {
                name: 'CreateEmailModalController',
                decl: {
                    start: {
                        line: 24,
                        column: 13
                    },
                    end: {
                        line: 24,
                        column: 39
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 129
                    },
                    end: {
                        line: 95,
                        column: 5
                    }
                },
                line: 24
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 34,
                        column: 31
                    },
                    end: {
                        line: 34,
                        column: 32
                    }
                },
                loc: {
                    start: {
                        line: 34,
                        column: 55
                    },
                    end: {
                        line: 37,
                        column: 9
                    }
                },
                line: 34
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 40,
                        column: 12
                    },
                    end: {
                        line: 40,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 40,
                        column: 26
                    },
                    end: {
                        line: 46,
                        column: 13
                    }
                },
                line: 40
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 48,
                        column: 24
                    },
                    end: {
                        line: 48,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 48,
                        column: 36
                    },
                    end: {
                        line: 56,
                        column: 9
                    }
                },
                line: 48
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 50,
                        column: 16
                    },
                    end: {
                        line: 50,
                        column: 17
                    }
                },
                loc: {
                    start: {
                        line: 50,
                        column: 30
                    },
                    end: {
                        line: 55,
                        column: 17
                    }
                },
                line: 50
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 58,
                        column: 36
                    },
                    end: {
                        line: 58,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 58,
                        column: 61
                    },
                    end: {
                        line: 62,
                        column: 9
                    }
                },
                line: 58
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 64,
                        column: 29
                    },
                    end: {
                        line: 64,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 64,
                        column: 41
                    },
                    end: {
                        line: 66,
                        column: 9
                    }
                },
                line: 64
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 68,
                        column: 28
                    },
                    end: {
                        line: 68,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 68,
                        column: 40
                    },
                    end: {
                        line: 78,
                        column: 9
                    }
                },
                line: 68
            },
            '11': {
                name: '(anonymous_11)',
                decl: {
                    start: {
                        line: 80,
                        column: 22
                    },
                    end: {
                        line: 80,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 80,
                        column: 34
                    },
                    end: {
                        line: 83,
                        column: 9
                    }
                },
                line: 80
            },
            '12': {
                name: '(anonymous_12)',
                decl: {
                    start: {
                        line: 82,
                        column: 42
                    },
                    end: {
                        line: 82,
                        column: 43
                    }
                },
                loc: {
                    start: {
                        line: 82,
                        column: 48
                    },
                    end: {
                        line: 82,
                        column: 79
                    }
                },
                line: 82
            },
            '13': {
                name: '(anonymous_13)',
                decl: {
                    start: {
                        line: 85,
                        column: 22
                    },
                    end: {
                        line: 85,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 85,
                        column: 34
                    },
                    end: {
                        line: 87,
                        column: 9
                    }
                },
                line: 85
            },
            '14': {
                name: '(anonymous_14)',
                decl: {
                    start: {
                        line: 89,
                        column: 23
                    },
                    end: {
                        line: 89,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 89,
                        column: 35
                    },
                    end: {
                        line: 94,
                        column: 9
                    }
                },
                line: 89
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 41,
                        column: 16
                    },
                    end: {
                        line: 45,
                        column: 17
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 41,
                        column: 16
                    },
                    end: {
                        line: 45,
                        column: 17
                    }
                }, {
                    start: {
                        line: 41,
                        column: 16
                    },
                    end: {
                        line: 45,
                        column: 17
                    }
                }],
                line: 41
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0,
            '30': 0,
            '31': 0,
            '32': 0,
            '33': 0,
            '34': 0,
            '35': 0,
            '36': 0,
            '37': 0,
            '38': 0,
            '39': 0,
            '40': 0,
            '41': 0,
            '42': 0,
            '43': 0,
            '44': 0,
            '45': 0,
            '46': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2m95ziytod.s[0]++;
(function () {
    'use strict';

    NewEmailModalService.$inject = ["$mdDialog"];
    CreateEmailModalController.$inject = ["$scope", "$mdDialog", "EmailsTable", "$window", "AppSettings", "organization", "EmailTemplatesTable"];
    cov_2m95ziytod.f[0]++;
    cov_2m95ziytod.s[1]++;
    angular.module('app').service('NewEmailModalService', NewEmailModalService);

    /* @ngInject */
    function NewEmailModalService($mdDialog) {
        cov_2m95ziytod.f[1]++;
        cov_2m95ziytod.s[2]++;

        this.display = function (organization) {
            cov_2m95ziytod.f[2]++;
            cov_2m95ziytod.s[3]++;

            return $mdDialog.show({
                templateUrl: 'app/components/createEmailModal/createEmailModal.html',
                controller: CreateEmailModalController,
                clickOutsideToClose: true,
                escapeToClose: true,
                locals: {
                    organization: organization
                }
            });
        };
    }

    /* @ngInject */
    function CreateEmailModalController($scope, $mdDialog, EmailsTable, $window, AppSettings, organization, EmailTemplatesTable) {
        cov_2m95ziytod.f[3]++;
        cov_2m95ziytod.s[4]++;

        $scope.index = 0;

        cov_2m95ziytod.s[5]++;
        $scope.filters = {
            /* eslint-disable camelcase */
            page_size: 1
        };

        cov_2m95ziytod.s[6]++;
        $scope.emailTemplates = EmailTemplatesTable.$collection();

        cov_2m95ziytod.s[7]++;
        $scope.changeFilters = function (field, value) {
            cov_2m95ziytod.f[4]++;
            cov_2m95ziytod.s[8]++;

            $scope.filters[field] = value;
            cov_2m95ziytod.s[9]++;
            $scope.emailTemplates = EmailTemplatesTable.$search($scope.filters);
        };

        cov_2m95ziytod.s[10]++;
        EmailsTable.$search({ organization: organization, state: 'DRAFT', ordering: '-id' }).$then(function (collection) {
            cov_2m95ziytod.f[5]++;
            cov_2m95ziytod.s[11]++;

            if (collection.length > 0) {
                cov_2m95ziytod.b[0][0]++;
                cov_2m95ziytod.s[12]++;

                $scope.newEmail = collection[0];
            } else {
                cov_2m95ziytod.b[0][1]++;
                cov_2m95ziytod.s[13]++;

                $scope.newEmail = EmailsTable.$create({ organization: organization });
            }
        });

        cov_2m95ziytod.s[14]++;
        $scope.import = function () {
            cov_2m95ziytod.f[6]++;
            cov_2m95ziytod.s[15]++;

            EmailsTable.$search({ state: 'SENT', ordering: '-id' }).$then(function (collection) {
                cov_2m95ziytod.f[7]++;
                cov_2m95ziytod.s[16]++;

                $scope.newEmail.subject = collection[$scope.index].subject;
                cov_2m95ziytod.s[17]++;
                $scope.newEmail.body = collection[$scope.index].body;
                cov_2m95ziytod.s[18]++;
                $scope.index++;
                cov_2m95ziytod.s[19]++;
                $scope.newEmail.$save();
            });
        };

        cov_2m95ziytod.s[20]++;
        $scope.importFromTemplate = function (emailTemplate) {
            cov_2m95ziytod.f[8]++;
            cov_2m95ziytod.s[21]++;

            $scope.newEmail.subject = emailTemplate.subject;
            cov_2m95ziytod.s[22]++;
            $scope.newEmail.body = emailTemplate.body;
            cov_2m95ziytod.s[23]++;
            $scope.newEmail.$save();
        };

        cov_2m95ziytod.s[24]++;
        $scope.closeDialog = function () {
            cov_2m95ziytod.f[9]++;
            cov_2m95ziytod.s[25]++;

            $mdDialog.cancel();
        };

        cov_2m95ziytod.s[26]++;
        $scope.openClient = function () {
            cov_2m95ziytod.f[10]++;

            var url = (cov_2m95ziytod.s[27]++, AppSettings.apiUrl + '/images/?p=' + $scope.newEmail.pixel + '.png');
            var signature = (cov_2m95ziytod.s[28]++, '<p><img src="' + url + '" /><p/>');
            var links = (cov_2m95ziytod.s[29]++, '<p style="color: #666; font-size: 13px">--<br/>www.solo.com.pt<br/>www.linkedin.com/in/ricardo-lobo/<br/>www.facebook.com/ricardo.lopes.lobo<br/></p>');
            var ref = (cov_2m95ziytod.s[30]++, '<p style="font-size: 8px; color: transparent">email ref #' + $scope.newEmail.pixel + '</p>');
            var to = (cov_2m95ziytod.s[31]++, $scope.newEmail.to);
            var subject = (cov_2m95ziytod.s[32]++, encodeURIComponent($scope.newEmail.subject));
            var body = (cov_2m95ziytod.s[33]++, encodeURIComponent($scope.newEmail.body + signature + links + ref));
            var mailto = (cov_2m95ziytod.s[34]++, "mailto:" + to + "?subject=" + subject + "&body=" + body);
            cov_2m95ziytod.s[35]++;
            $window.location.href = mailto;
        };

        cov_2m95ziytod.s[36]++;
        $scope.save = function () {
            cov_2m95ziytod.f[11]++;
            cov_2m95ziytod.s[37]++;

            $scope.newEmail.state = 'SENT';
            cov_2m95ziytod.s[38]++;
            $scope.newEmail.$save().$then(function () {
                cov_2m95ziytod.f[12]++;
                cov_2m95ziytod.s[39]++;
                return $mdDialog.hide($scope.newEmail);
            });
        };

        cov_2m95ziytod.s[40]++;
        $scope.send = function () {
            cov_2m95ziytod.f[13]++;
            cov_2m95ziytod.s[41]++;

            $scope.newEmail.$save().$then($scope.openClient);
        };

        cov_2m95ziytod.s[42]++;
        $scope.clear = function () {
            cov_2m95ziytod.f[14]++;
            cov_2m95ziytod.s[43]++;

            $scope.newEmail.to = '';
            cov_2m95ziytod.s[44]++;
            $scope.newEmail.subject = '';
            cov_2m95ziytod.s[45]++;
            $scope.newEmail.body = '';
            cov_2m95ziytod.s[46]++;
            $scope.newEmail.$save();
        };
    }
})(angular);
'use strict';

var cov_1obg5mper4 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/createComponentModal/createComponentModal.js',
        hash = 'fe97fae7a30782e993958e5dde15f2c1ae97cea5',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/createComponentModal/createComponentModal.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 34,
                    column: 12
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 67
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 16,
                    column: 15
                }
            },
            '4': {
                start: {
                    line: 22,
                    column: 8
                },
                end: {
                    line: 22,
                    column: 55
                }
            },
            '5': {
                start: {
                    line: 24,
                    column: 8
                },
                end: {
                    line: 26,
                    column: 10
                }
            },
            '6': {
                start: {
                    line: 25,
                    column: 12
                },
                end: {
                    line: 25,
                    column: 31
                }
            },
            '7': {
                start: {
                    line: 28,
                    column: 8
                },
                end: {
                    line: 32,
                    column: 10
                }
            },
            '8': {
                start: {
                    line: 29,
                    column: 12
                },
                end: {
                    line: 31,
                    column: 15
                }
            },
            '9': {
                start: {
                    line: 30,
                    column: 16
                },
                end: {
                    line: 30,
                    column: 42
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 34,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'NewComponentModalService',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 49
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 23
                    },
                    end: {
                        line: 10,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 35
                    },
                    end: {
                        line: 17,
                        column: 9
                    }
                },
                line: 10
            },
            '3': {
                name: 'CreateComponentModalController',
                decl: {
                    start: {
                        line: 21,
                        column: 13
                    },
                    end: {
                        line: 21,
                        column: 43
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 80
                    },
                    end: {
                        line: 33,
                        column: 5
                    }
                },
                line: 21
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 24,
                        column: 29
                    },
                    end: {
                        line: 24,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 41
                    },
                    end: {
                        line: 26,
                        column: 9
                    }
                },
                line: 24
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 28,
                        column: 33
                    },
                    end: {
                        line: 28,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 28,
                        column: 45
                    },
                    end: {
                        line: 32,
                        column: 9
                    }
                },
                line: 28
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 29,
                        column: 46
                    },
                    end: {
                        line: 29,
                        column: 47
                    }
                },
                loc: {
                    start: {
                        line: 29,
                        column: 67
                    },
                    end: {
                        line: 31,
                        column: 13
                    }
                },
                line: 29
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1obg5mper4.s[0]++;
(function () {
    'use strict';

    NewComponentModalService.$inject = ["$mdDialog"];
    CreateComponentModalController.$inject = ["$scope", "$mdDialog", "ComponentsTable"];
    cov_1obg5mper4.f[0]++;
    cov_1obg5mper4.s[1]++;
    angular.module('app').service('NewComponentModalService', NewComponentModalService);

    /* @ngInject */
    function NewComponentModalService($mdDialog) {
        cov_1obg5mper4.f[1]++;
        cov_1obg5mper4.s[2]++;

        this.display = function () {
            cov_1obg5mper4.f[2]++;
            cov_1obg5mper4.s[3]++;

            return $mdDialog.show({
                templateUrl: 'app/components/createComponentModal/createComponentModal.html',
                controller: CreateComponentModalController,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };
    }

    /* @ngInject */
    function CreateComponentModalController($scope, $mdDialog, ComponentsTable) {
        cov_1obg5mper4.f[3]++;
        cov_1obg5mper4.s[4]++;

        $scope.newComponent = ComponentsTable.$build();

        cov_1obg5mper4.s[5]++;
        $scope.closeDialog = function () {
            cov_1obg5mper4.f[4]++;
            cov_1obg5mper4.s[6]++;

            $mdDialog.cancel();
        };

        cov_1obg5mper4.s[7]++;
        $scope.createComponent = function () {
            cov_1obg5mper4.f[5]++;
            cov_1obg5mper4.s[8]++;

            $scope.newComponent.$save().$then(function (component) {
                cov_1obg5mper4.f[6]++;
                cov_1obg5mper4.s[9]++;

                $mdDialog.hide(component);
            });
        };
    }
})(angular);
'use strict';

var cov_d80am8t4y = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/componentsList/componentsList.js',
        hash = 'dac86369119d813a704e0b7133100d2260db29cc',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/componentsList/componentsList.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 65
                }
            },
            '1': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 9,
                    column: 11
                }
            },
            '2': {
                start: {
                    line: 7,
                    column: 12
                },
                end: {
                    line: 7,
                    column: 40
                }
            },
            '3': {
                start: {
                    line: 8,
                    column: 12
                },
                end: {
                    line: 8,
                    column: 26
                }
            },
            '4': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 11
                }
            },
            '5': {
                start: {
                    line: 13,
                    column: 12
                },
                end: {
                    line: 13,
                    column: 55
                }
            },
            '6': {
                start: {
                    line: 14,
                    column: 12
                },
                end: {
                    line: 14,
                    column: 26
                }
            },
            '7': {
                start: {
                    line: 19,
                    column: 8
                },
                end: {
                    line: 19,
                    column: 51
                }
            },
            '8': {
                start: {
                    line: 23,
                    column: 8
                },
                end: {
                    line: 25,
                    column: 11
                }
            },
            '9': {
                start: {
                    line: 24,
                    column: 12
                },
                end: {
                    line: 24,
                    column: 44
                }
            },
            '10': {
                start: {
                    line: 29,
                    column: 0
                },
                end: {
                    line: 37,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 54
                    },
                    end: {
                        line: 16,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 6,
                        column: 38
                    },
                    end: {
                        line: 6,
                        column: 39
                    }
                },
                loc: {
                    start: {
                        line: 6,
                        column: 55
                    },
                    end: {
                        line: 9,
                        column: 9
                    }
                },
                line: 6
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 11,
                        column: 37
                    },
                    end: {
                        line: 11,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 54
                    },
                    end: {
                        line: 15,
                        column: 9
                    }
                },
                line: 11
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 18,
                        column: 4
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 18,
                        column: 13
                    },
                    end: {
                        line: 20,
                        column: 5
                    }
                },
                line: 18
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 22,
                        column: 4
                    },
                    end: {
                        line: 22,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 31
                    },
                    end: {
                        line: 26,
                        column: 5
                    }
                },
                line: 22
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 23,
                        column: 53
                    },
                    end: {
                        line: 23,
                        column: 54
                    }
                },
                loc: {
                    start: {
                        line: 23,
                        column: 66
                    },
                    end: {
                        line: 25,
                        column: 9
                    }
                },
                line: 23
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ComponentsListController = function () {
    ComponentsListController.$inject = ["NewComponentModalService", "$rootScope"];
    function ComponentsListController(NewComponentModalService, $rootScope) {
        var _this = this;

        _classCallCheck(this, ComponentsListController);

        cov_d80am8t4y.f[0]++;
        cov_d80am8t4y.s[0]++;

        this.NewComponentModalService = NewComponentModalService;
        // eslint-disable-next-line angular/on-watch
        cov_d80am8t4y.s[1]++;
        $rootScope.$on('pageChanged', function (event, data) {
            cov_d80am8t4y.f[1]++;
            cov_d80am8t4y.s[2]++;

            _this.proposals.$page = data;
            cov_d80am8t4y.s[3]++;
            _this.update();
        });
        // eslint-disable-next-line angular/on-watch
        cov_d80am8t4y.s[4]++;
        $rootScope.$on('searchText', function (event, data) {
            cov_d80am8t4y.f[2]++;
            cov_d80am8t4y.s[5]++;

            // eslint-disable-next-line camelcase
            _this.requestData = { name__icontains: data };
            cov_d80am8t4y.s[6]++;
            _this.update();
        });
    }

    _createClass(ComponentsListController, [{
        key: 'update',
        value: function update() {
            cov_d80am8t4y.f[3]++;
            cov_d80am8t4y.s[7]++;

            this.components.$refresh(this.requestData);
        }
    }, {
        key: 'displayNewComponentModal',
        value: function displayNewComponentModal() {
            var _this2 = this;

            cov_d80am8t4y.f[4]++;
            cov_d80am8t4y.s[8]++;

            this.NewComponentModalService.display().then(function (component) {
                cov_d80am8t4y.f[5]++;
                cov_d80am8t4y.s[9]++;

                _this2.components.$add(component);
            });
        }
    }]);

    return ComponentsListController;
}();

cov_d80am8t4y.s[10]++;


angular.module('app').component('componentsList', {
    templateUrl: 'app/components/componentsList/componentsList.html',
    controller: ComponentsListController,
    bindings: {
        components: '<'
    }
});
'use strict';

var cov_3m72418o2 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/comment/comment.js',
        hash = '72ed07ab5f54ed09c2480b193474428556cdae88',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/comment/comment.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 30
                }
            },
            '1': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 37
                }
            },
            '2': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 9,
                    column: 30
                }
            },
            '3': {
                start: {
                    line: 13,
                    column: 0
                },
                end: {
                    line: 21,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 18
                    },
                    end: {
                        line: 5,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 7,
                        column: 4
                    },
                    end: {
                        line: 7,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 7,
                        column: 11
                    },
                    end: {
                        line: 10,
                        column: 5
                    }
                },
                line: 7
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CommentController = function () {
    function CommentController() {
        _classCallCheck(this, CommentController);

        cov_3m72418o2.f[0]++;
        cov_3m72418o2.s[0]++;

        this.editable = false;
    }

    _createClass(CommentController, [{
        key: 'save',
        value: function save() {
            cov_3m72418o2.f[1]++;
            cov_3m72418o2.s[1]++;

            this.data.$save(['content']);
            cov_3m72418o2.s[2]++;
            this.editable = false;
        }
    }]);

    return CommentController;
}();

cov_3m72418o2.s[3]++;


angular.module('app').component('comment', {
    templateUrl: 'app/components/comment/comment.html',
    controller: CommentController,
    bindings: {
        data: '<'
    }
});
'use strict';

var cov_14yh4fexku = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/auth/auth.set.password.controller.js',
        hash = '25c79bbfd620230c7989059683221a198d578152',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/auth/auth.set.password.controller.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 50,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 76
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 19
                },
                end: {
                    line: 10,
                    column: 23
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 30
                }
            },
            '4': {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 37
                }
            },
            '5': {
                start: {
                    line: 16,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 19
                }
            },
            '6': {
                start: {
                    line: 19,
                    column: 12
                },
                end: {
                    line: 21,
                    column: 13
                }
            },
            '7': {
                start: {
                    line: 20,
                    column: 16
                },
                end: {
                    line: 20,
                    column: 35
                }
            },
            '8': {
                start: {
                    line: 25,
                    column: 12
                },
                end: {
                    line: 47,
                    column: 15
                }
            },
            '9': {
                start: {
                    line: 34,
                    column: 16
                },
                end: {
                    line: 38,
                    column: 18
                }
            },
            '10': {
                start: {
                    line: 39,
                    column: 16
                },
                end: {
                    line: 39,
                    column: 35
                }
            },
            '11': {
                start: {
                    line: 41,
                    column: 16
                },
                end: {
                    line: 45,
                    column: 18
                }
            },
            '12': {
                start: {
                    line: 46,
                    column: 16
                },
                end: {
                    line: 46,
                    column: 42
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 50,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'AuthSetPasswordController',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 91
                    },
                    end: {
                        line: 49,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'activate',
                decl: {
                    start: {
                        line: 18,
                        column: 17
                    },
                    end: {
                        line: 18,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 18,
                        column: 28
                    },
                    end: {
                        line: 22,
                        column: 9
                    }
                },
                line: 18
            },
            '3': {
                name: 'setPassword',
                decl: {
                    start: {
                        line: 24,
                        column: 17
                    },
                    end: {
                        line: 24,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 31
                    },
                    end: {
                        line: 48,
                        column: 9
                    }
                },
                line: 24
            },
            '4': {
                name: 'successCallback',
                decl: {
                    start: {
                        line: 33,
                        column: 29
                    },
                    end: {
                        line: 33,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 33,
                        column: 47
                    },
                    end: {
                        line: 40,
                        column: 13
                    }
                },
                line: 33
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 40,
                        column: 15
                    },
                    end: {
                        line: 40,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 40,
                        column: 27
                    },
                    end: {
                        line: 47,
                        column: 13
                    }
                },
                line: 40
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 19,
                        column: 12
                    },
                    end: {
                        line: 21,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 19,
                        column: 12
                    },
                    end: {
                        line: 21,
                        column: 13
                    }
                }, {
                    start: {
                        line: 19,
                        column: 12
                    },
                    end: {
                        line: 21,
                        column: 13
                    }
                }],
                line: 19
            },
            '1': {
                loc: {
                    start: {
                        line: 19,
                        column: 16
                    },
                    end: {
                        line: 19,
                        column: 58
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 19,
                        column: 16
                    },
                    end: {
                        line: 19,
                        column: 35
                    }
                }, {
                    start: {
                        line: 19,
                        column: 39
                    },
                    end: {
                        line: 19,
                        column: 58
                    }
                }],
                line: 19
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_14yh4fexku.s[0]++;
(function () {
    'use strict';

    AuthSetPasswordController.$inject = ["$state", "$http", "AppSettings", "$stateParams", "$mdToast"];
    cov_14yh4fexku.f[0]++;
    cov_14yh4fexku.s[1]++;
    angular.module('app').controller('AuthSetPasswordController', AuthSetPasswordController);

    /* @ngInject */
    function AuthSetPasswordController($state, $http, AppSettings, $stateParams, $mdToast) {
        cov_14yh4fexku.f[1]++;

        var vm = (cov_14yh4fexku.s[2]++, this);

        cov_14yh4fexku.s[3]++;
        vm.requestStatus = {};

        cov_14yh4fexku.s[4]++;
        vm.setPassword = setPassword;

        cov_14yh4fexku.s[5]++;
        activate();

        function activate() {
            cov_14yh4fexku.f[2]++;
            cov_14yh4fexku.s[6]++;

            if ((cov_14yh4fexku.b[1][0]++, !$stateParams.email) || (cov_14yh4fexku.b[1][1]++, !$stateParams.token)) {
                cov_14yh4fexku.b[0][0]++;
                cov_14yh4fexku.s[7]++;

                $state.go('login');
            } else {
                cov_14yh4fexku.b[0][1]++;
            }
        }

        function setPassword() {
            cov_14yh4fexku.f[3]++;
            cov_14yh4fexku.s[8]++;

            vm.requestStatus = $http({
                method: 'POST',
                url: AppSettings.apiUrl + '/users/set_password/',
                data: {
                    email: $stateParams.email,
                    token: $stateParams.token,
                    password: vm.password
                }
            }).then(function successCallback() {
                cov_14yh4fexku.f[4]++;
                cov_14yh4fexku.s[9]++;

                $mdToast.show($mdToast.simple().textContent('A tua password foi alterada.').hideDelay(3000));
                cov_14yh4fexku.s[10]++;
                $state.go('login');
            }, function () {
                cov_14yh4fexku.f[5]++;
                cov_14yh4fexku.s[11]++;

                $mdToast.show($mdToast.simple().textContent('Ocorreu um erro.').hideDelay(3000));
                cov_14yh4fexku.s[12]++;
                $state.go('projectsList');
            });
        }
    }
})();
'use strict';

var cov_196wmridhh = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/auth/auth.service.js',
        hash = 'e711456938e66f62f7c41c58b4efc69255081373',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/auth/auth.service.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 47,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 41
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 28
                },
                end: {
                    line: 10,
                    column: 32
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 21,
                    column: 10
                }
            },
            '4': {
                start: {
                    line: 13,
                    column: 33
                },
                end: {
                    line: 13,
                    column: 63
                }
            },
            '5': {
                start: {
                    line: 14,
                    column: 12
                },
                end: {
                    line: 18,
                    column: 15
                }
            },
            '6': {
                start: {
                    line: 15,
                    column: 16
                },
                end: {
                    line: 15,
                    column: 62
                }
            },
            '7': {
                start: {
                    line: 17,
                    column: 16
                },
                end: {
                    line: 17,
                    column: 29
                }
            },
            '8': {
                start: {
                    line: 20,
                    column: 12
                },
                end: {
                    line: 20,
                    column: 32
                }
            },
            '9': {
                start: {
                    line: 23,
                    column: 8
                },
                end: {
                    line: 27,
                    column: 10
                }
            },
            '10': {
                start: {
                    line: 24,
                    column: 12
                },
                end: {
                    line: 26,
                    column: 15
                }
            },
            '11': {
                start: {
                    line: 25,
                    column: 16
                },
                end: {
                    line: 25,
                    column: 62
                }
            },
            '12': {
                start: {
                    line: 29,
                    column: 8
                },
                end: {
                    line: 36,
                    column: 10
                }
            },
            '13': {
                start: {
                    line: 30,
                    column: 12
                },
                end: {
                    line: 33,
                    column: 15
                }
            },
            '14': {
                start: {
                    line: 31,
                    column: 16
                },
                end: {
                    line: 31,
                    column: 53
                }
            },
            '15': {
                start: {
                    line: 32,
                    column: 16
                },
                end: {
                    line: 32,
                    column: 37
                }
            },
            '16': {
                start: {
                    line: 35,
                    column: 12
                },
                end: {
                    line: 35,
                    column: 42
                }
            },
            '17': {
                start: {
                    line: 38,
                    column: 8
                },
                end: {
                    line: 45,
                    column: 10
                }
            },
            '18': {
                start: {
                    line: 39,
                    column: 34
                },
                end: {
                    line: 39,
                    column: 48
                }
            },
            '19': {
                start: {
                    line: 40,
                    column: 12
                },
                end: {
                    line: 43,
                    column: 15
                }
            },
            '20': {
                start: {
                    line: 41,
                    column: 16
                },
                end: {
                    line: 41,
                    column: 38
                }
            },
            '21': {
                start: {
                    line: 42,
                    column: 16
                },
                end: {
                    line: 42,
                    column: 40
                }
            },
            '22': {
                start: {
                    line: 44,
                    column: 12
                },
                end: {
                    line: 44,
                    column: 33
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 47,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'service',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 60
                    },
                    end: {
                        line: 46,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 12,
                        column: 21
                    },
                    end: {
                        line: 12,
                        column: 22
                    }
                },
                loc: {
                    start: {
                        line: 12,
                        column: 48
                    },
                    end: {
                        line: 21,
                        column: 9
                    }
                },
                line: 12
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 14,
                        column: 30
                    },
                    end: {
                        line: 14,
                        column: 31
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 42
                    },
                    end: {
                        line: 16,
                        column: 13
                    }
                },
                line: 14
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 16,
                        column: 15
                    },
                    end: {
                        line: 16,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 16,
                        column: 32
                    },
                    end: {
                        line: 18,
                        column: 13
                    }
                },
                line: 16
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 23,
                        column: 29
                    },
                    end: {
                        line: 23,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 23,
                        column: 41
                    },
                    end: {
                        line: 27,
                        column: 9
                    }
                },
                line: 23
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 24,
                        column: 55
                    },
                    end: {
                        line: 24,
                        column: 56
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 67
                    },
                    end: {
                        line: 26,
                        column: 13
                    }
                },
                line: 24
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 29,
                        column: 40
                    },
                    end: {
                        line: 29,
                        column: 41
                    }
                },
                loc: {
                    start: {
                        line: 29,
                        column: 52
                    },
                    end: {
                        line: 36,
                        column: 9
                    }
                },
                line: 29
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 30,
                        column: 57
                    },
                    end: {
                        line: 30,
                        column: 58
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 69
                    },
                    end: {
                        line: 33,
                        column: 13
                    }
                },
                line: 30
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 38,
                        column: 22
                    },
                    end: {
                        line: 38,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 38,
                        column: 34
                    },
                    end: {
                        line: 45,
                        column: 9
                    }
                },
                line: 38
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 40,
                        column: 31
                    },
                    end: {
                        line: 40,
                        column: 32
                    }
                },
                loc: {
                    start: {
                        line: 40,
                        column: 43
                    },
                    end: {
                        line: 43,
                        column: 13
                    }
                },
                line: 40
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_196wmridhh.s[0]++;
(function () {
    'use strict';

    service.$inject = ["$auth", "$rootScope", "$state", "UsersTable"];
    cov_196wmridhh.f[0]++;
    cov_196wmridhh.s[1]++;
    angular.module('app').service('AuthService', service);

    /* @ngInject */
    function service($auth, $rootScope, $state, UsersTable) {
        cov_196wmridhh.f[1]++;

        var AuthService = (cov_196wmridhh.s[2]++, this);

        cov_196wmridhh.s[3]++;
        this.login = function (email, password) {
            cov_196wmridhh.f[2]++;

            var loginPromise = (cov_196wmridhh.s[4]++, $auth.login({ email: email, password: password }));
            cov_196wmridhh.s[5]++;
            loginPromise.then(function () {
                cov_196wmridhh.f[3]++;
                cov_196wmridhh.s[6]++;

                return AuthService.refreshAuthenticatedInfo();
            }, function (error) {
                cov_196wmridhh.f[4]++;
                cov_196wmridhh.s[7]++;

                return error;
            });

            cov_196wmridhh.s[8]++;
            return loginPromise;
        };

        cov_196wmridhh.s[9]++;
        this.loginFacebook = function () {
            cov_196wmridhh.f[5]++;
            cov_196wmridhh.s[10]++;

            return $auth.authenticate('facebook').then(function () {
                cov_196wmridhh.f[6]++;
                cov_196wmridhh.s[11]++;

                return AuthService.refreshAuthenticatedInfo();
            });
        };

        cov_196wmridhh.s[12]++;
        this.refreshAuthenticatedInfo = function () {
            cov_196wmridhh.f[7]++;
            cov_196wmridhh.s[13]++;

            $rootScope.me = UsersTable.$find('me').$then(function () {
                cov_196wmridhh.f[8]++;
                cov_196wmridhh.s[14]++;

                $rootScope.me.$pk = $rootScope.me.id;
                cov_196wmridhh.s[15]++;
                return $rootScope.me;
            });

            cov_196wmridhh.s[16]++;
            return $rootScope.me.$promise;
        };

        cov_196wmridhh.s[17]++;
        this.logout = function () {
            cov_196wmridhh.f[9]++;

            var logoutPromise = (cov_196wmridhh.s[18]++, $auth.logout());
            cov_196wmridhh.s[19]++;
            logoutPromise.then(function () {
                cov_196wmridhh.f[10]++;
                cov_196wmridhh.s[20]++;

                $rootScope.me = false;
                cov_196wmridhh.s[21]++;
                $rootScope.cart = false;
            });
            cov_196wmridhh.s[22]++;
            return logoutPromise;
        };
    }
})();
'use strict';

var cov_2jpyxg49db = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/auth/auth.run.js',
        hash = 'e2e586a7921ec3c02d67901cfe7b2572309fc1bd',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/auth/auth.run.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 24,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 23
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 13,
                    column: 13
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 16
                },
                end: {
                    line: 12,
                    column: 35
                }
            },
            '5': {
                start: {
                    line: 16,
                    column: 8
                },
                end: {
                    line: 22,
                    column: 9
                }
            },
            '6': {
                start: {
                    line: 17,
                    column: 12
                },
                end: {
                    line: 21,
                    column: 15
                }
            },
            '7': {
                start: {
                    line: 18,
                    column: 16
                },
                end: {
                    line: 18,
                    column: 47
                }
            },
            '8': {
                start: {
                    line: 20,
                    column: 16
                },
                end: {
                    line: 20,
                    column: 62
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 24,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'runBlock',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 76
                    },
                    end: {
                        line: 23,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 33
                    },
                    end: {
                        line: 10,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 50
                    },
                    end: {
                        line: 14,
                        column: 9
                    }
                },
                line: 10
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 17,
                        column: 56
                    },
                    end: {
                        line: 17,
                        column: 57
                    }
                },
                loc: {
                    start: {
                        line: 17,
                        column: 68
                    },
                    end: {
                        line: 19,
                        column: 13
                    }
                },
                line: 17
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 19,
                        column: 15
                    },
                    end: {
                        line: 19,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 19,
                        column: 27
                    },
                    end: {
                        line: 21,
                        column: 13
                    }
                },
                line: 19
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 13,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 13,
                        column: 13
                    }
                }, {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 13,
                        column: 13
                    }
                }],
                line: 11
            },
            '1': {
                loc: {
                    start: {
                        line: 11,
                        column: 16
                    },
                    end: {
                        line: 11,
                        column: 133
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 11,
                        column: 16
                    },
                    end: {
                        line: 11,
                        column: 30
                    }
                }, {
                    start: {
                        line: 11,
                        column: 35
                    },
                    end: {
                        line: 11,
                        column: 62
                    }
                }, {
                    start: {
                        line: 11,
                        column: 66
                    },
                    end: {
                        line: 11,
                        column: 94
                    }
                }, {
                    start: {
                        line: 11,
                        column: 98
                    },
                    end: {
                        line: 11,
                        column: 132
                    }
                }],
                line: 11
            },
            '2': {
                loc: {
                    start: {
                        line: 16,
                        column: 8
                    },
                    end: {
                        line: 22,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 16,
                        column: 8
                    },
                    end: {
                        line: 22,
                        column: 9
                    }
                }, {
                    start: {
                        line: 16,
                        column: 8
                    },
                    end: {
                        line: 22,
                        column: 9
                    }
                }],
                line: 16
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0, 0, 0],
            '2': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2jpyxg49db.s[0]++;
(function () {
    'use strict';

    runBlock.$inject = ["$rootScope", "$state", "$auth", "AuthService", "$transitions"];
    cov_2jpyxg49db.f[0]++;
    cov_2jpyxg49db.s[1]++;
    angular.module('app').run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $state, $auth, AuthService, $transitions) {
        cov_2jpyxg49db.f[1]++;
        cov_2jpyxg49db.s[2]++;

        $transitions.onStart({}, function (trans) {
            cov_2jpyxg49db.f[2]++;
            cov_2jpyxg49db.s[3]++;

            if ((cov_2jpyxg49db.b[1][0]++, !$rootScope.me) && (cov_2jpyxg49db.b[1][1]++, trans.to().name !== 'login') && (cov_2jpyxg49db.b[1][2]++, trans.to().name !== 'forgot') && (cov_2jpyxg49db.b[1][3]++, trans.to().name !== 'set_password')) {
                cov_2jpyxg49db.b[0][0]++;
                cov_2jpyxg49db.s[4]++;

                $state.go("login");
            } else {
                cov_2jpyxg49db.b[0][1]++;
            }
        });

        cov_2jpyxg49db.s[5]++;
        if ($auth.isAuthenticated()) {
            cov_2jpyxg49db.b[2][0]++;
            cov_2jpyxg49db.s[6]++;

            AuthService.refreshAuthenticatedInfo().then(function () {
                cov_2jpyxg49db.f[3]++;
                cov_2jpyxg49db.s[7]++;

                $rootScope.refreshMeTaskData();
            }, function () {
                cov_2jpyxg49db.f[4]++;
                cov_2jpyxg49db.s[8]++;

                AuthService.logout().then($state.go('login'));
            });
        } else {
            cov_2jpyxg49db.b[2][1]++;
        }
    }
})();
'use strict';

var cov_19u8wzgkma = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/auth/auth.logout.controller.js',
        hash = 'a7f72bef34a36b34ed025147d7751af61ca592d2',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/auth/auth.logout.controller.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 27,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 56
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 19
                },
                end: {
                    line: 10,
                    column: 23
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 28
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 27
                }
            },
            '5': {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 19
                }
            },
            '6': {
                start: {
                    line: 17,
                    column: 12
                },
                end: {
                    line: 17,
                    column: 24
                }
            },
            '7': {
                start: {
                    line: 21,
                    column: 12
                },
                end: {
                    line: 24,
                    column: 15
                }
            },
            '8': {
                start: {
                    line: 22,
                    column: 16
                },
                end: {
                    line: 22,
                    column: 57
                }
            },
            '9': {
                start: {
                    line: 23,
                    column: 16
                },
                end: {
                    line: 23,
                    column: 35
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 27,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'Controller',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 57
                    },
                    end: {
                        line: 26,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'activate',
                decl: {
                    start: {
                        line: 16,
                        column: 17
                    },
                    end: {
                        line: 16,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 16,
                        column: 28
                    },
                    end: {
                        line: 18,
                        column: 9
                    }
                },
                line: 16
            },
            '3': {
                name: 'logout',
                decl: {
                    start: {
                        line: 20,
                        column: 17
                    },
                    end: {
                        line: 20,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 26
                    },
                    end: {
                        line: 25,
                        column: 9
                    }
                },
                line: 20
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 21,
                        column: 38
                    },
                    end: {
                        line: 21,
                        column: 39
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 50
                    },
                    end: {
                        line: 24,
                        column: 13
                    }
                },
                line: 21
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_19u8wzgkma.s[0]++;
(function () {
    'use strict';

    Controller.$inject = ["$rootScope", "$state", "AuthService"];
    cov_19u8wzgkma.f[0]++;
    cov_19u8wzgkma.s[1]++;
    angular.module('app').controller('AuthLogoutController', Controller);

    /* @ngInject */
    function Controller($rootScope, $state, AuthService) {
        cov_19u8wzgkma.f[1]++;

        var vm = (cov_19u8wzgkma.s[2]++, this);
        cov_19u8wzgkma.s[3]++;
        vm.title = 'Logout';
        cov_19u8wzgkma.s[4]++;
        vm.logout = logout;

        cov_19u8wzgkma.s[5]++;
        activate();

        function activate() {
            cov_19u8wzgkma.f[2]++;
            cov_19u8wzgkma.s[6]++;

            vm.logout();
        }

        function logout() {
            cov_19u8wzgkma.f[3]++;
            cov_19u8wzgkma.s[7]++;

            AuthService.logout().then(function () {
                cov_19u8wzgkma.f[4]++;
                cov_19u8wzgkma.s[8]++;

                $rootScope.profileMenuPageActive = false;
                cov_19u8wzgkma.s[9]++;
                $state.go('login');
            });
        }
    }
})();
'use strict';

var cov_23sabtvnex = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/auth/auth.login.controller.js',
        hash = '4d301ebc3e1d309a283735cfcab6357bd6c30c44',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/auth/auth.login.controller.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 47,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 51
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 19
                },
                end: {
                    line: 10,
                    column: 23
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 25
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 41
                }
            },
            '5': {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 30
                }
            },
            '6': {
                start: {
                    line: 16,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 19
                }
            },
            '7': {
                start: {
                    line: 22,
                    column: 12
                },
                end: {
                    line: 26,
                    column: 15
                }
            },
            '8': {
                start: {
                    line: 23,
                    column: 16
                },
                end: {
                    line: 23,
                    column: 29
                }
            },
            '9': {
                start: {
                    line: 25,
                    column: 16
                },
                end: {
                    line: 25,
                    column: 34
                }
            },
            '10': {
                start: {
                    line: 30,
                    column: 12
                },
                end: {
                    line: 34,
                    column: 15
                }
            },
            '11': {
                start: {
                    line: 31,
                    column: 16
                },
                end: {
                    line: 31,
                    column: 29
                }
            },
            '12': {
                start: {
                    line: 33,
                    column: 16
                },
                end: {
                    line: 33,
                    column: 34
                }
            },
            '13': {
                start: {
                    line: 42,
                    column: 12
                },
                end: {
                    line: 44,
                    column: 15
                }
            },
            '14': {
                start: {
                    line: 43,
                    column: 16
                },
                end: {
                    line: 43,
                    column: 47
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 47,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'Controller',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 57
                    },
                    end: {
                        line: 46,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'activate',
                decl: {
                    start: {
                        line: 18,
                        column: 17
                    },
                    end: {
                        line: 18,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 18,
                        column: 28
                    },
                    end: {
                        line: 19,
                        column: 9
                    }
                },
                line: 18
            },
            '3': {
                name: 'login',
                decl: {
                    start: {
                        line: 21,
                        column: 17
                    },
                    end: {
                        line: 21,
                        column: 22
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 25
                    },
                    end: {
                        line: 27,
                        column: 9
                    }
                },
                line: 21
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 22,
                        column: 58
                    },
                    end: {
                        line: 22,
                        column: 59
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 70
                    },
                    end: {
                        line: 24,
                        column: 13
                    }
                },
                line: 22
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 24,
                        column: 15
                    },
                    end: {
                        line: 24,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 32
                    },
                    end: {
                        line: 26,
                        column: 13
                    }
                },
                line: 24
            },
            '6': {
                name: 'loginFacebook',
                decl: {
                    start: {
                        line: 29,
                        column: 17
                    },
                    end: {
                        line: 29,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 29,
                        column: 33
                    },
                    end: {
                        line: 35,
                        column: 9
                    }
                },
                line: 29
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 30,
                        column: 45
                    },
                    end: {
                        line: 30,
                        column: 46
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 57
                    },
                    end: {
                        line: 32,
                        column: 13
                    }
                },
                line: 30
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 32,
                        column: 15
                    },
                    end: {
                        line: 32,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 32,
                        column: 32
                    },
                    end: {
                        line: 34,
                        column: 13
                    }
                },
                line: 32
            },
            '9': {
                name: 'afterLogin',
                decl: {
                    start: {
                        line: 41,
                        column: 17
                    },
                    end: {
                        line: 41,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 41,
                        column: 30
                    },
                    end: {
                        line: 45,
                        column: 9
                    }
                },
                line: 41
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 42,
                        column: 32
                    },
                    end: {
                        line: 42,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 42,
                        column: 44
                    },
                    end: {
                        line: 44,
                        column: 13
                    }
                },
                line: 42
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_23sabtvnex.s[0]++;
(function () {
    'use strict';

    Controller.$inject = ["$state", "AuthService", "$rootScope"];
    cov_23sabtvnex.f[0]++;
    cov_23sabtvnex.s[1]++;
    angular.module('app').controller('AuthLoginController', Controller);

    /* @ngInject */
    function Controller($state, AuthService, $rootScope) {
        cov_23sabtvnex.f[1]++;

        var vm = (cov_23sabtvnex.s[2]++, this);
        cov_23sabtvnex.s[3]++;
        vm.login = login;
        cov_23sabtvnex.s[4]++;
        vm.loginFacebook = loginFacebook;

        cov_23sabtvnex.s[5]++;
        vm.authenticated = {};

        cov_23sabtvnex.s[6]++;
        activate();

        function activate() {
            cov_23sabtvnex.f[2]++;
        }

        function login() {
            cov_23sabtvnex.f[3]++;
            cov_23sabtvnex.s[7]++;

            AuthService.login(vm.email, vm.password).then(function () {
                cov_23sabtvnex.f[4]++;
                cov_23sabtvnex.s[8]++;

                afterLogin();
            }, function (error) {
                cov_23sabtvnex.f[5]++;
                cov_23sabtvnex.s[9]++;

                vm.member = error;
            });
        }

        function loginFacebook() {
            cov_23sabtvnex.f[6]++;
            cov_23sabtvnex.s[10]++;

            AuthService.loginFacebook().then(function () {
                cov_23sabtvnex.f[7]++;
                cov_23sabtvnex.s[11]++;

                afterLogin();
            }, function (error) {
                cov_23sabtvnex.f[8]++;
                cov_23sabtvnex.s[12]++;

                vm.member = error;
            });
        }

        // function logout () {
        //     AuthService.logout();
        // }

        function afterLogin() {
            cov_23sabtvnex.f[9]++;
            cov_23sabtvnex.s[13]++;

            $rootScope.me.$then(function () {
                cov_23sabtvnex.f[10]++;
                cov_23sabtvnex.s[14]++;

                $state.go('organizationsList');
            });
        }
    }
})();
'use strict';

var cov_1x8o3we1ez = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/auth/auth.forgot.controller.js',
        hash = 'd410a94cdda5aa2a14785dc4a07c2d0bebcf3602',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/auth/auth.forgot.controller.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 35,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 66
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 19
                },
                end: {
                    line: 10,
                    column: 23
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 30
                }
            },
            '4': {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 41
                }
            },
            '5': {
                start: {
                    line: 16,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 19
                }
            },
            '6': {
                start: {
                    line: 22,
                    column: 12
                },
                end: {
                    line: 32,
                    column: 15
                }
            },
            '7': {
                start: {
                    line: 29,
                    column: 16
                },
                end: {
                    line: 29,
                    column: 32
                }
            },
            '8': {
                start: {
                    line: 31,
                    column: 16
                },
                end: {
                    line: 31,
                    column: 32
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 35,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'AuthForgotController',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 54
                    },
                    end: {
                        line: 34,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'activate',
                decl: {
                    start: {
                        line: 18,
                        column: 17
                    },
                    end: {
                        line: 18,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 18,
                        column: 28
                    },
                    end: {
                        line: 19,
                        column: 9
                    }
                },
                line: 18
            },
            '3': {
                name: 'requestChange',
                decl: {
                    start: {
                        line: 21,
                        column: 17
                    },
                    end: {
                        line: 21,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 33
                    },
                    end: {
                        line: 33,
                        column: 9
                    }
                },
                line: 21
            },
            '4': {
                name: 'successCallback',
                decl: {
                    start: {
                        line: 28,
                        column: 29
                    },
                    end: {
                        line: 28,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 28,
                        column: 55
                    },
                    end: {
                        line: 30,
                        column: 13
                    }
                },
                line: 28
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 30,
                        column: 15
                    },
                    end: {
                        line: 30,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 35
                    },
                    end: {
                        line: 32,
                        column: 13
                    }
                },
                line: 30
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1x8o3we1ez.s[0]++;
(function () {
    'use strict';

    AuthForgotController.$inject = ["$http", "AppSettings"];
    cov_1x8o3we1ez.f[0]++;
    cov_1x8o3we1ez.s[1]++;
    angular.module('app').controller('AuthForgotController', AuthForgotController);

    /* @ngInject */
    function AuthForgotController($http, AppSettings) {
        cov_1x8o3we1ez.f[1]++;

        var vm = (cov_1x8o3we1ez.s[2]++, this);

        cov_1x8o3we1ez.s[3]++;
        vm.requestStatus = {};

        cov_1x8o3we1ez.s[4]++;
        vm.requestChange = requestChange;

        cov_1x8o3we1ez.s[5]++;
        activate();

        function activate() {
            cov_1x8o3we1ez.f[2]++;
        }

        function requestChange() {
            cov_1x8o3we1ez.f[3]++;
            cov_1x8o3we1ez.s[6]++;

            vm.requestStatus = $http({
                method: 'POST',
                url: AppSettings.apiUrl + '/users/reset_password/',
                data: {
                    email: vm.email
                }
            }).then(function successCallback(response) {
                cov_1x8o3we1ez.f[4]++;
                cov_1x8o3we1ez.s[7]++;

                return response;
            }, function (response) {
                cov_1x8o3we1ez.f[5]++;
                cov_1x8o3we1ez.s[8]++;

                return response;
            });
        }
    }
})();
'use strict';

var cov_1sbrag3he0 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/auth/auth.config.js',
        hash = '65dc2a867844b616f8c5354c69b92602370b8775',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/auth/auth.config.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 19,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 24
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 51
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 52
                }
            },
            '4': {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 19,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'Config',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 48
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1sbrag3he0.s[0]++;
(function () {
    'use strict';

    Config.$inject = ["$authProvider", "AppSettings"];
    cov_1sbrag3he0.f[0]++;
    cov_1sbrag3he0.s[1]++;
    angular.module('app').config(Config);

    /* @ngInject */
    function Config($authProvider, AppSettings) {
        cov_1sbrag3he0.f[1]++;
        cov_1sbrag3he0.s[2]++;

        $authProvider.baseUrl = AppSettings.apiUrl;

        cov_1sbrag3he0.s[3]++;
        $authProvider.loginUrl = '/api-token-auth/';

        cov_1sbrag3he0.s[4]++;
        $authProvider.facebook({
            clientId: AppSettings.facebookAppId,
            url: '/auth/facebook/'
        });
    }
})();
'use strict';

var cov_1k8w68wv96 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/autocompletes/autocompletes.js',
        hash = '38e0fd9048bf7b64180e3b3ee4ed9130509f38ee',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/autocompletes/autocompletes.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 38
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 121
                }
            },
            '2': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 6,
                    column: 27
                }
            },
            '3': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 76
                }
            },
            '4': {
                start: {
                    line: 10,
                    column: 52
                },
                end: {
                    line: 10,
                    column: 74
                }
            },
            '5': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 44
                }
            },
            '6': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 42
                }
            },
            '7': {
                start: {
                    line: 16,
                    column: 25
                },
                end: {
                    line: 16,
                    column: 27
                }
            },
            '8': {
                start: {
                    line: 18,
                    column: 8
                },
                end: {
                    line: 18,
                    column: 77
                }
            },
            '9': {
                start: {
                    line: 18,
                    column: 35
                },
                end: {
                    line: 18,
                    column: 75
                }
            },
            '10': {
                start: {
                    line: 19,
                    column: 8
                },
                end: {
                    line: 19,
                    column: 24
                }
            },
            '11': {
                start: {
                    line: 23,
                    column: 8
                },
                end: {
                    line: 23,
                    column: 104
                }
            },
            '12': {
                start: {
                    line: 23,
                    column: 83
                },
                end: {
                    line: 23,
                    column: 102
                }
            },
            '13': {
                start: {
                    line: 27,
                    column: 8
                },
                end: {
                    line: 32,
                    column: 11
                }
            },
            '14': {
                start: {
                    line: 28,
                    column: 12
                },
                end: {
                    line: 31,
                    column: 14
                }
            },
            '15': {
                start: {
                    line: 36,
                    column: 8
                },
                end: {
                    line: 40,
                    column: 11
                }
            },
            '16': {
                start: {
                    line: 37,
                    column: 12
                },
                end: {
                    line: 39,
                    column: 14
                }
            },
            '17': {
                start: {
                    line: 44,
                    column: 8
                },
                end: {
                    line: 49,
                    column: 11
                }
            },
            '18': {
                start: {
                    line: 45,
                    column: 12
                },
                end: {
                    line: 48,
                    column: 14
                }
            },
            '19': {
                start: {
                    line: 53,
                    column: 27
                },
                end: {
                    line: 53,
                    column: 50
                }
            },
            '20': {
                start: {
                    line: 54,
                    column: 8
                },
                end: {
                    line: 54,
                    column: 66
                }
            },
            '21': {
                start: {
                    line: 55,
                    column: 8
                },
                end: {
                    line: 55,
                    column: 42
                }
            },
            '22': {
                start: {
                    line: 56,
                    column: 8
                },
                end: {
                    line: 56,
                    column: 42
                }
            },
            '23': {
                start: {
                    line: 57,
                    column: 8
                },
                end: {
                    line: 57,
                    column: 40
                }
            },
            '24': {
                start: {
                    line: 58,
                    column: 8
                },
                end: {
                    line: 58,
                    column: 36
                }
            },
            '25': {
                start: {
                    line: 59,
                    column: 8
                },
                end: {
                    line: 59,
                    column: 27
                }
            },
            '26': {
                start: {
                    line: 63,
                    column: 25
                },
                end: {
                    line: 63,
                    column: 41
                }
            },
            '27': {
                start: {
                    line: 64,
                    column: 8
                },
                end: {
                    line: 66,
                    column: 11
                }
            },
            '28': {
                start: {
                    line: 65,
                    column: 12
                },
                end: {
                    line: 65,
                    column: 31
                }
            },
            '29': {
                start: {
                    line: 70,
                    column: 8
                },
                end: {
                    line: 70,
                    column: 34
                }
            },
            '30': {
                start: {
                    line: 74,
                    column: 8
                },
                end: {
                    line: 74,
                    column: 69
                }
            },
            '31': {
                start: {
                    line: 74,
                    column: 53
                },
                end: {
                    line: 74,
                    column: 67
                }
            },
            '32': {
                start: {
                    line: 81,
                    column: 8
                },
                end: {
                    line: 81,
                    column: 77
                }
            },
            '33': {
                start: {
                    line: 82,
                    column: 8
                },
                end: {
                    line: 82,
                    column: 33
                }
            },
            '34': {
                start: {
                    line: 83,
                    column: 8
                },
                end: {
                    line: 83,
                    column: 77
                }
            },
            '35': {
                start: {
                    line: 84,
                    column: 8
                },
                end: {
                    line: 84,
                    column: 65
                }
            },
            '36': {
                start: {
                    line: 86,
                    column: 8
                },
                end: {
                    line: 88,
                    column: 17
                }
            },
            '37': {
                start: {
                    line: 87,
                    column: 12
                },
                end: {
                    line: 87,
                    column: 36
                }
            },
            '38': {
                start: {
                    line: 93,
                    column: 21
                },
                end: {
                    line: 93,
                    column: 97
                }
            },
            '39': {
                start: {
                    line: 94,
                    column: 8
                },
                end: {
                    line: 99,
                    column: 15
                }
            },
            '40': {
                start: {
                    line: 96,
                    column: 16
                },
                end: {
                    line: 98,
                    column: 17
                }
            },
            '41': {
                start: {
                    line: 97,
                    column: 20
                },
                end: {
                    line: 97,
                    column: 52
                }
            },
            '42': {
                start: {
                    line: 103,
                    column: 23
                },
                end: {
                    line: 120,
                    column: 9
                }
            },
            '43': {
                start: {
                    line: 121,
                    column: 8
                },
                end: {
                    line: 121,
                    column: 35
                }
            },
            '44': {
                start: {
                    line: 125,
                    column: 27
                },
                end: {
                    line: 125,
                    column: 41
                }
            },
            '45': {
                start: {
                    line: 126,
                    column: 8
                },
                end: {
                    line: 126,
                    column: 73
                }
            },
            '46': {
                start: {
                    line: 127,
                    column: 8
                },
                end: {
                    line: 127,
                    column: 63
                }
            },
            '47': {
                start: {
                    line: 128,
                    column: 8
                },
                end: {
                    line: 128,
                    column: 62
                }
            },
            '48': {
                start: {
                    line: 129,
                    column: 8
                },
                end: {
                    line: 129,
                    column: 61
                }
            },
            '49': {
                start: {
                    line: 130,
                    column: 8
                },
                end: {
                    line: 130,
                    column: 48
                }
            },
            '50': {
                start: {
                    line: 135,
                    column: 0
                },
                end: {
                    line: 143,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 28
                    },
                    end: {
                        line: 7,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 9,
                        column: 4
                    },
                    end: {
                        line: 9,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 14
                    },
                    end: {
                        line: 13,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 43
                    },
                    end: {
                        line: 10,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 52
                    },
                    end: {
                        line: 10,
                        column: 74
                    }
                },
                line: 10
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 15,
                        column: 4
                    },
                    end: {
                        line: 15,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 15,
                        column: 23
                    },
                    end: {
                        line: 20,
                        column: 5
                    }
                },
                line: 15
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 18,
                        column: 26
                    },
                    end: {
                        line: 18,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 18,
                        column: 35
                    },
                    end: {
                        line: 18,
                        column: 75
                    }
                },
                line: 18
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 22,
                        column: 4
                    },
                    end: {
                        line: 22,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 25
                    },
                    end: {
                        line: 24,
                        column: 5
                    }
                },
                line: 22
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 23,
                        column: 77
                    },
                    end: {
                        line: 23,
                        column: 78
                    }
                },
                loc: {
                    start: {
                        line: 23,
                        column: 83
                    },
                    end: {
                        line: 23,
                        column: 102
                    }
                },
                line: 23
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 26,
                        column: 4
                    },
                    end: {
                        line: 26,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 13
                    },
                    end: {
                        line: 33,
                        column: 5
                    }
                },
                line: 26
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 27,
                        column: 67
                    },
                    end: {
                        line: 27,
                        column: 68
                    }
                },
                loc: {
                    start: {
                        line: 27,
                        column: 77
                    },
                    end: {
                        line: 32,
                        column: 9
                    }
                },
                line: 27
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 35,
                        column: 4
                    },
                    end: {
                        line: 35,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 35,
                        column: 13
                    },
                    end: {
                        line: 41,
                        column: 5
                    }
                },
                line: 35
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 36,
                        column: 66
                    },
                    end: {
                        line: 36,
                        column: 67
                    }
                },
                loc: {
                    start: {
                        line: 36,
                        column: 75
                    },
                    end: {
                        line: 40,
                        column: 9
                    }
                },
                line: 36
            },
            '11': {
                name: '(anonymous_11)',
                decl: {
                    start: {
                        line: 43,
                        column: 4
                    },
                    end: {
                        line: 43,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 43,
                        column: 12
                    },
                    end: {
                        line: 50,
                        column: 5
                    }
                },
                line: 43
            },
            '12': {
                name: '(anonymous_12)',
                decl: {
                    start: {
                        line: 44,
                        column: 65
                    },
                    end: {
                        line: 44,
                        column: 66
                    }
                },
                loc: {
                    start: {
                        line: 44,
                        column: 73
                    },
                    end: {
                        line: 49,
                        column: 9
                    }
                },
                line: 44
            },
            '13': {
                name: '(anonymous_13)',
                decl: {
                    start: {
                        line: 52,
                        column: 4
                    },
                    end: {
                        line: 52,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 52,
                        column: 21
                    },
                    end: {
                        line: 60,
                        column: 5
                    }
                },
                line: 52
            },
            '14': {
                name: '(anonymous_14)',
                decl: {
                    start: {
                        line: 62,
                        column: 4
                    },
                    end: {
                        line: 62,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 62,
                        column: 18
                    },
                    end: {
                        line: 67,
                        column: 5
                    }
                },
                line: 62
            },
            '15': {
                name: '(anonymous_15)',
                decl: {
                    start: {
                        line: 64,
                        column: 30
                    },
                    end: {
                        line: 64,
                        column: 31
                    }
                },
                loc: {
                    start: {
                        line: 64,
                        column: 36
                    },
                    end: {
                        line: 66,
                        column: 9
                    }
                },
                line: 64
            },
            '16': {
                name: '(anonymous_16)',
                decl: {
                    start: {
                        line: 69,
                        column: 4
                    },
                    end: {
                        line: 69,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 69,
                        column: 18
                    },
                    end: {
                        line: 71,
                        column: 5
                    }
                },
                line: 69
            },
            '17': {
                name: '(anonymous_17)',
                decl: {
                    start: {
                        line: 73,
                        column: 4
                    },
                    end: {
                        line: 73,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 73,
                        column: 20
                    },
                    end: {
                        line: 75,
                        column: 5
                    }
                },
                line: 73
            },
            '18': {
                name: '(anonymous_18)',
                decl: {
                    start: {
                        line: 74,
                        column: 45
                    },
                    end: {
                        line: 74,
                        column: 46
                    }
                },
                loc: {
                    start: {
                        line: 74,
                        column: 53
                    },
                    end: {
                        line: 74,
                        column: 67
                    }
                },
                line: 74
            },
            '19': {
                name: '(anonymous_19)',
                decl: {
                    start: {
                        line: 80,
                        column: 4
                    },
                    end: {
                        line: 80,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 80,
                        column: 69
                    },
                    end: {
                        line: 89,
                        column: 5
                    }
                },
                line: 80
            },
            '20': {
                name: '(anonymous_20)',
                decl: {
                    start: {
                        line: 86,
                        column: 18
                    },
                    end: {
                        line: 86,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 86,
                        column: 24
                    },
                    end: {
                        line: 88,
                        column: 9
                    }
                },
                line: 86
            },
            '21': {
                name: '(anonymous_21)',
                decl: {
                    start: {
                        line: 91,
                        column: 4
                    },
                    end: {
                        line: 91,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 91,
                        column: 23
                    },
                    end: {
                        line: 100,
                        column: 5
                    }
                },
                line: 91
            },
            '22': {
                name: '(anonymous_22)',
                decl: {
                    start: {
                        line: 95,
                        column: 12
                    },
                    end: {
                        line: 95,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 95,
                        column: 23
                    },
                    end: {
                        line: 99,
                        column: 13
                    }
                },
                line: 95
            },
            '23': {
                name: '(anonymous_23)',
                decl: {
                    start: {
                        line: 102,
                        column: 4
                    },
                    end: {
                        line: 102,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 102,
                        column: 39
                    },
                    end: {
                        line: 122,
                        column: 5
                    }
                },
                line: 102
            },
            '24': {
                name: '(anonymous_24)',
                decl: {
                    start: {
                        line: 124,
                        column: 4
                    },
                    end: {
                        line: 124,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 124,
                        column: 35
                    },
                    end: {
                        line: 131,
                        column: 5
                    }
                },
                line: 124
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 96,
                        column: 16
                    },
                    end: {
                        line: 98,
                        column: 17
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 96,
                        column: 16
                    },
                    end: {
                        line: 98,
                        column: 17
                    }
                }, {
                    start: {
                        line: 96,
                        column: 16
                    },
                    end: {
                        line: 98,
                        column: 17
                    }
                }],
                line: 96
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0,
            '30': 0,
            '31': 0,
            '32': 0,
            '33': 0,
            '34': 0,
            '35': 0,
            '36': 0,
            '37': 0,
            '38': 0,
            '39': 0,
            '40': 0,
            '41': 0,
            '42': 0,
            '43': 0,
            '44': 0,
            '45': 0,
            '46': 0,
            '47': 0,
            '48': 0,
            '49': 0,
            '50': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CompletionDialogController = function () {
    CompletionDialogController.$inject = ["mdPanelRef"];
    function CompletionDialogController(mdPanelRef) {
        _classCallCheck(this, CompletionDialogController);

        cov_1k8w68wv96.f[0]++;
        cov_1k8w68wv96.s[0]++;

        this._mdPanelRef = mdPanelRef;
        cov_1k8w68wv96.s[1]++;
        this.fields = ['nif', 'foundation', 'municipality', 'rawSize', 'rawTurnover', 'rawIncome', 'phone', 'legalForm'];
        cov_1k8w68wv96.s[2]++;
        this.selected = [];
    }

    _createClass(CompletionDialogController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            cov_1k8w68wv96.f[1]++;
            cov_1k8w68wv96.s[3]++;

            this.selected = this.fields.filter(function (field) {
                cov_1k8w68wv96.f[2]++;
                cov_1k8w68wv96.s[4]++;
                return _this.completion[field];
            });
            cov_1k8w68wv96.s[5]++;
            this.completion.readAt = new Date();
            cov_1k8w68wv96.s[6]++;
            this.completion.$save(['readAt']);
        }
    }, {
        key: 'filterCompletion',
        value: function filterCompletion() {
            var _this2 = this;

            cov_1k8w68wv96.f[3]++;

            var filtered = (cov_1k8w68wv96.s[7]++, {});
            /* eslint-disable no-return-assign */
            cov_1k8w68wv96.s[8]++;
            this.selected.map(function (field) {
                cov_1k8w68wv96.f[4]++;
                cov_1k8w68wv96.s[9]++;
                return filtered[field] = _this2.completion[field];
            });
            cov_1k8w68wv96.s[10]++;
            return filtered;
        }
    }, {
        key: 'economicActivities',
        value: function economicActivities() {
            cov_1k8w68wv96.f[5]++;
            cov_1k8w68wv96.s[11]++;

            return this.completion.$organizationAutocompleteEconomicActivity.map(function (ec) {
                cov_1k8w68wv96.f[6]++;
                cov_1k8w68wv96.s[12]++;
                return ec.economicActivity;
            });
        }
    }, {
        key: 'people',
        value: function people() {
            cov_1k8w68wv96.f[7]++;
            cov_1k8w68wv96.s[13]++;

            return this.completion.$organizationAutocompletePeople.map(function (person) {
                cov_1k8w68wv96.f[8]++;
                cov_1k8w68wv96.s[14]++;

                return {
                    name: person.name,
                    jobTitle: person.jobTitle
                };
            });
        }
    }, {
        key: 'emails',
        value: function emails() {
            cov_1k8w68wv96.f[9]++;
            cov_1k8w68wv96.s[15]++;

            return this.completion.$organizationAutocompleteEmail.map(function (email) {
                cov_1k8w68wv96.f[10]++;
                cov_1k8w68wv96.s[16]++;

                return {
                    email: email.email
                };
            });
        }
    }, {
        key: 'links',
        value: function links() {
            cov_1k8w68wv96.f[11]++;
            cov_1k8w68wv96.s[17]++;

            return this.completion.$organizationAutocompleteLink.map(function (link) {
                cov_1k8w68wv96.f[12]++;
                cov_1k8w68wv96.s[18]++;

                return {
                    link: link.link,
                    category: link.category
                };
            });
        }
    }, {
        key: 'handleComplete',
        value: function handleComplete() {
            cov_1k8w68wv96.f[13]++;

            var completion = (cov_1k8w68wv96.s[19]++, this.filterCompletion());
            cov_1k8w68wv96.s[20]++;
            completion.economicActivities = this.economicActivities();
            cov_1k8w68wv96.s[21]++;
            completion.people = this.people();
            cov_1k8w68wv96.s[22]++;
            completion.emails = this.emails();
            cov_1k8w68wv96.s[23]++;
            completion.links = this.links();
            cov_1k8w68wv96.s[24]++;
            this.complete({ completion: completion });
            cov_1k8w68wv96.s[25]++;
            this.closeDialog();
        }
    }, {
        key: 'closeDialog',
        value: function closeDialog() {
            cov_1k8w68wv96.f[14]++;

            var panelRef = (cov_1k8w68wv96.s[26]++, this._mdPanelRef);
            cov_1k8w68wv96.s[27]++;
            panelRef.close().then(function () {
                cov_1k8w68wv96.f[15]++;
                cov_1k8w68wv96.s[28]++;

                panelRef.destroy();
            });
        }
    }, {
        key: 'select',
        value: function select(field) {
            cov_1k8w68wv96.f[16]++;
            cov_1k8w68wv96.s[29]++;

            this.selected.push(field);
        }
    }, {
        key: 'deselect',
        value: function deselect(field) {
            cov_1k8w68wv96.f[17]++;
            cov_1k8w68wv96.s[30]++;

            this.selected = this.selected.filter(function (item) {
                cov_1k8w68wv96.f[18]++;
                cov_1k8w68wv96.s[31]++;
                return item !== field;
            });
        }
    }]);

    return CompletionDialogController;
}();

var AutocompletesController = function () {
    AutocompletesController.$inject = ["OrganizationAutocompletesTable", "$mdPanel", "$interval"];
    function AutocompletesController(OrganizationAutocompletesTable, $mdPanel, $interval) {
        var _this3 = this;

        _classCallCheck(this, AutocompletesController);

        cov_1k8w68wv96.f[19]++;
        cov_1k8w68wv96.s[32]++;

        this.OrganizationAutocompletesTable = OrganizationAutocompletesTable;
        cov_1k8w68wv96.s[33]++;
        this.$mdPanel = $mdPanel;
        cov_1k8w68wv96.s[34]++;
        this.position = this.$mdPanel.newPanelPosition().absolute().center();
        cov_1k8w68wv96.s[35]++;
        this.fetchCompletions = this.fetchCompletions.bind(this);

        cov_1k8w68wv96.s[36]++;
        $interval(function () {
            cov_1k8w68wv96.f[20]++;
            cov_1k8w68wv96.s[37]++;

            _this3.fetchCompletions();
        }, 1000);
    }

    _createClass(AutocompletesController, [{
        key: 'fetchCompletions',
        value: function fetchCompletions() {
            var _this4 = this;

            cov_1k8w68wv96.f[21]++;

            /* eslint-disable camelcase */
            var data = (cov_1k8w68wv96.s[38]++, { read_at__isnull: 'True', organization: this.organization.id, state: 'DONE' });
            cov_1k8w68wv96.s[39]++;
            this.OrganizationAutocompletesTable.$search(data).$then(function (results) {
                cov_1k8w68wv96.f[22]++;
                cov_1k8w68wv96.s[40]++;

                if (results.length > 0) {
                    cov_1k8w68wv96.b[0][0]++;
                    cov_1k8w68wv96.s[41]++;

                    _this4.displayCompletion(results);
                } else {
                    cov_1k8w68wv96.b[0][1]++;
                }
            });
        }
    }, {
        key: 'createCompletionDialog',
        value: function createCompletionDialog(completion) {
            cov_1k8w68wv96.f[23]++;

            var config = (cov_1k8w68wv96.s[42]++, {
                /** @ngInject */
                controller: CompletionDialogController,
                controllerAs: '$ctrl',
                templateUrl: 'app/components/autocompletes/autocompletes.html',
                hasBackdrop: true,
                panelClass: 'autocompletes-dialog',
                position: this.position,
                trapFocus: true,
                zIndex: 150,
                clickOutsideToClose: false,
                escapeToClose: false,
                focusOnOpen: true,
                locals: {
                    completion: completion,
                    complete: this.complete
                }
            });
            cov_1k8w68wv96.s[43]++;
            this.$mdPanel.open(config);
        }
    }, {
        key: 'displayCompletion',
        value: function displayCompletion(completions) {
            cov_1k8w68wv96.f[24]++;

            var completion = (cov_1k8w68wv96.s[44]++, completions[0]);
            cov_1k8w68wv96.s[45]++;
            completions[0].$load('organizationAutocompleteEconomicActivity');
            cov_1k8w68wv96.s[46]++;
            completions[0].$load('organizationAutocompletePeople');
            cov_1k8w68wv96.s[47]++;
            completions[0].$load('organizationAutocompleteEmail');
            cov_1k8w68wv96.s[48]++;
            completions[0].$load('organizationAutocompleteLink');
            cov_1k8w68wv96.s[49]++;
            this.createCompletionDialog(completion);
        }
    }]);

    return AutocompletesController;
}();

cov_1k8w68wv96.s[50]++;


angular.module('app').component('autocompletes', {
    controller: AutocompletesController,
    bindings: {
        organization: '<',
        complete: '&'
    }
});
'use strict';

var cov_1530ca7l7e = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/unique.js',
        hash = 'd9ddeca8643a2aba9d0a51a2517dc02afd7d5dd4',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/unique.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 33,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 34
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 31,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 27
                },
                end: {
                    line: 12,
                    column: 29
                }
            },
            '4': {
                start: {
                    line: 13,
                    column: 25
                },
                end: {
                    line: 13,
                    column: 27
                }
            },
            '5': {
                start: {
                    line: 17,
                    column: 12
                },
                end: {
                    line: 27,
                    column: 15
                }
            },
            '6': {
                start: {
                    line: 19,
                    column: 28
                },
                end: {
                    line: 19,
                    column: 41
                }
            },
            '7': {
                start: {
                    line: 21,
                    column: 16
                },
                end: {
                    line: 26,
                    column: 17
                }
            },
            '8': {
                start: {
                    line: 23,
                    column: 20
                },
                end: {
                    line: 23,
                    column: 35
                }
            },
            '9': {
                start: {
                    line: 25,
                    column: 20
                },
                end: {
                    line: 25,
                    column: 38
                }
            },
            '10': {
                start: {
                    line: 30,
                    column: 12
                },
                end: {
                    line: 30,
                    column: 26
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 33,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'unique',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 22
                    },
                    end: {
                        line: 32,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 15
                    },
                    end: {
                        line: 10,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 46
                    },
                    end: {
                        line: 31,
                        column: 9
                    }
                },
                line: 10
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 17,
                        column: 40
                    },
                    end: {
                        line: 17,
                        column: 41
                    }
                },
                loc: {
                    start: {
                        line: 17,
                        column: 56
                    },
                    end: {
                        line: 27,
                        column: 13
                    }
                },
                line: 17
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 21,
                        column: 16
                    },
                    end: {
                        line: 26,
                        column: 17
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 21,
                        column: 16
                    },
                    end: {
                        line: 26,
                        column: 17
                    }
                }, {
                    start: {
                        line: 21,
                        column: 16
                    },
                    end: {
                        line: 26,
                        column: 17
                    }
                }],
                line: 21
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1530ca7l7e.s[0]++;
(function () {
    'use strict';

    cov_1530ca7l7e.f[0]++;
    cov_1530ca7l7e.s[1]++;
    angular.module('app').filter('unique', unique);

    /* @ngInject */
    function unique() {
        cov_1530ca7l7e.f[1]++;
        cov_1530ca7l7e.s[2]++;

        return function (collection, keyname) {
            cov_1530ca7l7e.f[2]++;

            // we define our output and keys array;
            var output = (cov_1530ca7l7e.s[3]++, []);
            var keys = (cov_1530ca7l7e.s[4]++, []);

            // we utilize angular's foreach function
            // this takes in our original collection and an iterator function
            cov_1530ca7l7e.s[5]++;
            angular.forEach(collection, function (item) {
                cov_1530ca7l7e.f[3]++;

                // we check to see whether our object exists
                var key = (cov_1530ca7l7e.s[6]++, item[keyname]);
                // if it's not already part of our keys array
                cov_1530ca7l7e.s[7]++;
                if (keys.indexOf(key) === -1) {
                    cov_1530ca7l7e.b[0][0]++;
                    cov_1530ca7l7e.s[8]++;

                    // add it to our keys array
                    keys.push(key);
                    // push this item to our final output array
                    cov_1530ca7l7e.s[9]++;
                    output.push(item);
                } else {
                    cov_1530ca7l7e.b[0][1]++;
                }
            });
            // return our array which should be devoid of
            // any duplicates
            cov_1530ca7l7e.s[10]++;
            return output;
        };
    }
})();
'use strict';

var cov_a4qwsbvl = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/strings.js',
        hash = 'b5631603d612cde883651a45ad324e89d89dff28',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/strings.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 3,
                    column: 2
                }
            },
            '1': {
                start: {
                    line: 2,
                    column: 4
                },
                end: {
                    line: 2,
                    column: 42
                }
            },
            '2': {
                start: {
                    line: 6,
                    column: 0
                },
                end: {
                    line: 10,
                    column: 2
                }
            },
            '3': {
                start: {
                    line: 7,
                    column: 4
                },
                end: {
                    line: 9,
                    column: 7
                }
            },
            '4': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 49
                }
            },
            '5': {
                start: {
                    line: 13,
                    column: 0
                },
                end: {
                    line: 17,
                    column: 2
                }
            },
            '6': {
                start: {
                    line: 14,
                    column: 4
                },
                end: {
                    line: 16,
                    column: 7
                }
            },
            '7': {
                start: {
                    line: 15,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 38
                }
            },
            '8': {
                start: {
                    line: 20,
                    column: 0
                },
                end: {
                    line: 24,
                    column: 2
                }
            },
            '9': {
                start: {
                    line: 21,
                    column: 4
                },
                end: {
                    line: 23,
                    column: 7
                }
            },
            '10': {
                start: {
                    line: 22,
                    column: 8
                },
                end: {
                    line: 22,
                    column: 38
                }
            },
            '11': {
                start: {
                    line: 26,
                    column: 0
                },
                end: {
                    line: 38,
                    column: 2
                }
            },
            '12': {
                start: {
                    line: 27,
                    column: 19
                },
                end: {
                    line: 27,
                    column: 37
                }
            },
            '13': {
                start: {
                    line: 28,
                    column: 16
                },
                end: {
                    line: 28,
                    column: 41
                }
            },
            '14': {
                start: {
                    line: 29,
                    column: 18
                },
                end: {
                    line: 29,
                    column: 60
                }
            },
            '15': {
                start: {
                    line: 31,
                    column: 4
                },
                end: {
                    line: 33,
                    column: 5
                }
            },
            '16': {
                start: {
                    line: 32,
                    column: 8
                },
                end: {
                    line: 32,
                    column: 28
                }
            },
            '17': {
                start: {
                    line: 34,
                    column: 4
                },
                end: {
                    line: 36,
                    column: 5
                }
            },
            '18': {
                start: {
                    line: 35,
                    column: 8
                },
                end: {
                    line: 35,
                    column: 32
                }
            },
            '19': {
                start: {
                    line: 37,
                    column: 4
                },
                end: {
                    line: 37,
                    column: 33
                }
            },
            '20': {
                start: {
                    line: 40,
                    column: 0
                },
                end: {
                    line: 56,
                    column: 2
                }
            },
            '21': {
                start: {
                    line: 41,
                    column: 19
                },
                end: {
                    line: 41,
                    column: 37
                }
            },
            '22': {
                start: {
                    line: 42,
                    column: 16
                },
                end: {
                    line: 42,
                    column: 41
                }
            },
            '23': {
                start: {
                    line: 43,
                    column: 18
                },
                end: {
                    line: 43,
                    column: 60
                }
            },
            '24': {
                start: {
                    line: 44,
                    column: 18
                },
                end: {
                    line: 44,
                    column: 58
                }
            },
            '25': {
                start: {
                    line: 46,
                    column: 4
                },
                end: {
                    line: 48,
                    column: 5
                }
            },
            '26': {
                start: {
                    line: 47,
                    column: 8
                },
                end: {
                    line: 47,
                    column: 28
                }
            },
            '27': {
                start: {
                    line: 49,
                    column: 4
                },
                end: {
                    line: 51,
                    column: 5
                }
            },
            '28': {
                start: {
                    line: 50,
                    column: 8
                },
                end: {
                    line: 50,
                    column: 32
                }
            },
            '29': {
                start: {
                    line: 52,
                    column: 4
                },
                end: {
                    line: 54,
                    column: 5
                }
            },
            '30': {
                start: {
                    line: 53,
                    column: 8
                },
                end: {
                    line: 53,
                    column: 32
                }
            },
            '31': {
                start: {
                    line: 55,
                    column: 4
                },
                end: {
                    line: 55,
                    column: 49
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 24
                    },
                    end: {
                        line: 1,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 36
                    },
                    end: {
                        line: 3,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 6,
                        column: 27
                    },
                    end: {
                        line: 6,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 6,
                        column: 39
                    },
                    end: {
                        line: 10,
                        column: 1
                    }
                },
                line: 6
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 7,
                        column: 38
                    },
                    end: {
                        line: 7,
                        column: 39
                    }
                },
                loc: {
                    start: {
                        line: 7,
                        column: 52
                    },
                    end: {
                        line: 9,
                        column: 5
                    }
                },
                line: 7
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 13,
                        column: 26
                    },
                    end: {
                        line: 13,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 13,
                        column: 38
                    },
                    end: {
                        line: 17,
                        column: 1
                    }
                },
                line: 13
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 14,
                        column: 36
                    },
                    end: {
                        line: 14,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 50
                    },
                    end: {
                        line: 16,
                        column: 5
                    }
                },
                line: 14
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 20,
                        column: 32
                    },
                    end: {
                        line: 20,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 44
                    },
                    end: {
                        line: 24,
                        column: 1
                    }
                },
                line: 20
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 21,
                        column: 36
                    },
                    end: {
                        line: 21,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 50
                    },
                    end: {
                        line: 23,
                        column: 5
                    }
                },
                line: 21
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 26,
                        column: 26
                    },
                    end: {
                        line: 26,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 38
                    },
                    end: {
                        line: 38,
                        column: 1
                    }
                },
                line: 26
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 40,
                        column: 28
                    },
                    end: {
                        line: 40,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 40,
                        column: 40
                    },
                    end: {
                        line: 56,
                        column: 1
                    }
                },
                line: 40
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 31,
                        column: 4
                    },
                    end: {
                        line: 33,
                        column: 5
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 31,
                        column: 4
                    },
                    end: {
                        line: 33,
                        column: 5
                    }
                }, {
                    start: {
                        line: 31,
                        column: 4
                    },
                    end: {
                        line: 33,
                        column: 5
                    }
                }],
                line: 31
            },
            '1': {
                loc: {
                    start: {
                        line: 34,
                        column: 4
                    },
                    end: {
                        line: 36,
                        column: 5
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 34,
                        column: 4
                    },
                    end: {
                        line: 36,
                        column: 5
                    }
                }, {
                    start: {
                        line: 34,
                        column: 4
                    },
                    end: {
                        line: 36,
                        column: 5
                    }
                }],
                line: 34
            },
            '2': {
                loc: {
                    start: {
                        line: 46,
                        column: 4
                    },
                    end: {
                        line: 48,
                        column: 5
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 46,
                        column: 4
                    },
                    end: {
                        line: 48,
                        column: 5
                    }
                }, {
                    start: {
                        line: 46,
                        column: 4
                    },
                    end: {
                        line: 48,
                        column: 5
                    }
                }],
                line: 46
            },
            '3': {
                loc: {
                    start: {
                        line: 49,
                        column: 4
                    },
                    end: {
                        line: 51,
                        column: 5
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 49,
                        column: 4
                    },
                    end: {
                        line: 51,
                        column: 5
                    }
                }, {
                    start: {
                        line: 49,
                        column: 4
                    },
                    end: {
                        line: 51,
                        column: 5
                    }
                }],
                line: 49
            },
            '4': {
                loc: {
                    start: {
                        line: 52,
                        column: 4
                    },
                    end: {
                        line: 54,
                        column: 5
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 52,
                        column: 4
                    },
                    end: {
                        line: 54,
                        column: 5
                    }
                }, {
                    start: {
                        line: 52,
                        column: 4
                    },
                    end: {
                        line: 54,
                        column: 5
                    }
                }],
                line: 52
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0,
            '30': 0,
            '31': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0],
            '3': [0, 0],
            '4': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_a4qwsbvl.s[0]++;
String.prototype.trim = function () {
    cov_a4qwsbvl.f[0]++;
    cov_a4qwsbvl.s[1]++;

    return this.replace(/^\s+|\s+$/g, "");
};

// To Camel Case
cov_a4qwsbvl.s[2]++;
String.prototype.toCamel = function () {
    cov_a4qwsbvl.f[1]++;
    cov_a4qwsbvl.s[3]++;

    return this.replace(/(\-[a-z])/g, function ($1) {
        cov_a4qwsbvl.f[2]++;
        cov_a4qwsbvl.s[4]++;

        return $1.toUpperCase().replace('-', '');
    });
};

// To Dashed from Camel Case
cov_a4qwsbvl.s[5]++;
String.prototype.toDash = function () {
    cov_a4qwsbvl.f[3]++;
    cov_a4qwsbvl.s[6]++;

    return this.replace(/([A-Z])/g, function ($1) {
        cov_a4qwsbvl.f[4]++;
        cov_a4qwsbvl.s[7]++;

        return "-" + $1.toLowerCase();
    });
};

// To Underscore from Camel Case
cov_a4qwsbvl.s[8]++;
String.prototype.toUnderscore = function () {
    cov_a4qwsbvl.f[5]++;
    cov_a4qwsbvl.s[9]++;

    return this.replace(/([A-Z])/g, function ($1) {
        cov_a4qwsbvl.f[6]++;
        cov_a4qwsbvl.s[10]++;

        return "_" + $1.toLowerCase();
    });
};

cov_a4qwsbvl.s[11]++;
String.prototype.toHHMM = function () {
    cov_a4qwsbvl.f[7]++;

    var secNum = (cov_a4qwsbvl.s[12]++, parseInt(this, 10)); // don't forget the second param
    var hours = (cov_a4qwsbvl.s[13]++, Math.floor(secNum / 3600));
    var minutes = (cov_a4qwsbvl.s[14]++, Math.floor((secNum - hours * 3600) / 60));

    cov_a4qwsbvl.s[15]++;
    if (hours < 10) {
        cov_a4qwsbvl.b[0][0]++;
        cov_a4qwsbvl.s[16]++;

        hours = "0" + hours;
    } else {
        cov_a4qwsbvl.b[0][1]++;
    }
    cov_a4qwsbvl.s[17]++;
    if (minutes < 10) {
        cov_a4qwsbvl.b[1][0]++;
        cov_a4qwsbvl.s[18]++;

        minutes = "0" + minutes;
    } else {
        cov_a4qwsbvl.b[1][1]++;
    }
    cov_a4qwsbvl.s[19]++;
    return hours + ':' + minutes;
};

cov_a4qwsbvl.s[20]++;
String.prototype.toHHMMSS = function () {
    cov_a4qwsbvl.f[8]++;

    var secNum = (cov_a4qwsbvl.s[21]++, parseInt(this, 10)); // don't forget the second param
    var hours = (cov_a4qwsbvl.s[22]++, Math.floor(secNum / 3600));
    var minutes = (cov_a4qwsbvl.s[23]++, Math.floor((secNum - hours * 3600) / 60));
    var seconds = (cov_a4qwsbvl.s[24]++, secNum - hours * 3600 - minutes * 60);

    cov_a4qwsbvl.s[25]++;
    if (hours < 10) {
        cov_a4qwsbvl.b[2][0]++;
        cov_a4qwsbvl.s[26]++;

        hours = "0" + hours;
    } else {
        cov_a4qwsbvl.b[2][1]++;
    }
    cov_a4qwsbvl.s[27]++;
    if (minutes < 10) {
        cov_a4qwsbvl.b[3][0]++;
        cov_a4qwsbvl.s[28]++;

        minutes = "0" + minutes;
    } else {
        cov_a4qwsbvl.b[3][1]++;
    }
    cov_a4qwsbvl.s[29]++;
    if (seconds < 10) {
        cov_a4qwsbvl.b[4][0]++;
        cov_a4qwsbvl.s[30]++;

        seconds = "0" + seconds;
    } else {
        cov_a4qwsbvl.b[4][1]++;
    }
    cov_a4qwsbvl.s[31]++;
    return hours + ':' + minutes + ':' + seconds;
};
'use strict';

var cov_23ebfbl6ka = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/nl2br.filter.js',
        hash = 'ae284cf27bd67ff219744385674233628138211b',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/nl2br.filter.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 16,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 32
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 13,
                    column: 13
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 16
                },
                end: {
                    line: 12,
                    column: 52
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 16,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'nl2br',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 21
                    },
                    end: {
                        line: 15,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 15
                    },
                    end: {
                        line: 10,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 32
                    },
                    end: {
                        line: 14,
                        column: 9
                    }
                },
                line: 10
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 13,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 13,
                        column: 13
                    }
                }, {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 13,
                        column: 13
                    }
                }],
                line: 11
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_23ebfbl6ka.s[0]++;
(function () {
    'use strict';

    cov_23ebfbl6ka.f[0]++;
    cov_23ebfbl6ka.s[1]++;
    angular.module('app').filter('nl2br', nl2br);

    /* @ngInject */
    function nl2br() {
        cov_23ebfbl6ka.f[1]++;
        cov_23ebfbl6ka.s[2]++;

        return function (input) {
            cov_23ebfbl6ka.f[2]++;
            cov_23ebfbl6ka.s[3]++;

            if (input) {
                cov_23ebfbl6ka.b[0][0]++;
                cov_23ebfbl6ka.s[4]++;

                return input.replace(/\n/g, '<br>');
            } else {
                cov_23ebfbl6ka.b[0][1]++;
            }
        };
    }
})();
'use strict';

var cov_kpocyeexw = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/municipalities.js',
        hash = '28fc60a43d2ab7a28ef66c83dfec96da9b2bc61e',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/municipalities.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 17,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 50
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 14,
                    column: 13
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 18
                },
                end: {
                    line: 12,
                    column: 77
                }
            },
            '5': {
                start: {
                    line: 12,
                    column: 59
                },
                end: {
                    line: 12,
                    column: 76
                }
            },
            '6': {
                start: {
                    line: 13,
                    column: 16
                },
                end: {
                    line: 13,
                    column: 39
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 17,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'municipalities',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 40
                    },
                    end: {
                        line: 16,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 15
                    },
                    end: {
                        line: 10,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 32
                    },
                    end: {
                        line: 15,
                        column: 9
                    }
                },
                line: 10
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 12,
                        column: 51
                    },
                    end: {
                        line: 12,
                        column: 52
                    }
                },
                loc: {
                    start: {
                        line: 12,
                        column: 59
                    },
                    end: {
                        line: 12,
                        column: 76
                    }
                },
                line: 12
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 14,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 14,
                        column: 13
                    }
                }, {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 14,
                        column: 13
                    }
                }],
                line: 11
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_kpocyeexw.s[0]++;
(function () {
    'use strict';

    municipalities.$inject = ["$rootScope"];
    cov_kpocyeexw.f[0]++;
    cov_kpocyeexw.s[1]++;
    angular.module('app').filter('municipalities', municipalities);

    /* @ngInject */
    function municipalities($rootScope) {
        cov_kpocyeexw.f[1]++;
        cov_kpocyeexw.s[2]++;

        return function (input) {
            cov_kpocyeexw.f[2]++;
            cov_kpocyeexw.s[3]++;

            if (input) {
                cov_kpocyeexw.b[0][0]++;

                var matches = (cov_kpocyeexw.s[4]++, $rootScope.municipalities.filter(function (item) {
                    cov_kpocyeexw.f[3]++;
                    cov_kpocyeexw.s[5]++;
                    return item.id === input;
                }));
                cov_kpocyeexw.s[6]++;
                return matches[0].name;
            } else {
                cov_kpocyeexw.b[0][1]++;
            }
        };
    }
})();
'use strict';

var cov_1jasfoxau = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/contenteditable.directive.js',
        hash = '9a6e49014a37b3cd52bbd06a1d930efa97c201a4',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/contenteditable.directive.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 24,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 3,
                    column: 4
                },
                end: {
                    line: 23,
                    column: 7
                }
            },
            '2': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 22,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 20
                },
                end: {
                    line: 11,
                    column: 58
                }
            },
            '4': {
                start: {
                    line: 14,
                    column: 16
                },
                end: {
                    line: 16,
                    column: 18
                }
            },
            '5': {
                start: {
                    line: 15,
                    column: 20
                },
                end: {
                    line: 15,
                    column: 59
                }
            },
            '6': {
                start: {
                    line: 18,
                    column: 16
                },
                end: {
                    line: 20,
                    column: 19
                }
            },
            '7': {
                start: {
                    line: 19,
                    column: 20
                },
                end: {
                    line: 19,
                    column: 39
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 24,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 5,
                        column: 34
                    },
                    end: {
                        line: 5,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 5,
                        column: 46
                    },
                    end: {
                        line: 23,
                        column: 5
                    }
                },
                line: 5
            },
            '2': {
                name: 'read',
                decl: {
                    start: {
                        line: 10,
                        column: 25
                    },
                    end: {
                        line: 10,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 32
                    },
                    end: {
                        line: 12,
                        column: 17
                    }
                },
                line: 10
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 14,
                        column: 34
                    },
                    end: {
                        line: 14,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 46
                    },
                    end: {
                        line: 16,
                        column: 17
                    }
                },
                line: 14
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 18,
                        column: 50
                    },
                    end: {
                        line: 18,
                        column: 51
                    }
                },
                loc: {
                    start: {
                        line: 18,
                        column: 62
                    },
                    end: {
                        line: 20,
                        column: 17
                    }
                },
                line: 18
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 15,
                        column: 33
                    },
                    end: {
                        line: 15,
                        column: 57
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 15,
                        column: 33
                    },
                    end: {
                        line: 15,
                        column: 51
                    }
                }, {
                    start: {
                        line: 15,
                        column: 55
                    },
                    end: {
                        line: 15,
                        column: 57
                    }
                }],
                line: 15
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1jasfoxau.s[0]++;
(function () {
    'use strict';

    cov_1jasfoxau.f[0]++;
    cov_1jasfoxau.s[1]++;
    angular.module('app').directive("contenteditable", function () {
        cov_1jasfoxau.f[1]++;
        cov_1jasfoxau.s[2]++;

        return {
            restrict: "A",
            require: "ngModel",
            link: function link(scope, element, attrs, ngModel) {
                function read() {
                    cov_1jasfoxau.f[2]++;
                    cov_1jasfoxau.s[3]++;

                    ngModel.$setViewValue(element.html());
                }

                cov_1jasfoxau.s[4]++;
                ngModel.$render = function () {
                    cov_1jasfoxau.f[3]++;
                    cov_1jasfoxau.s[5]++;

                    element.html((cov_1jasfoxau.b[0][0]++, ngModel.$viewValue) || (cov_1jasfoxau.b[0][1]++, ""));
                };

                cov_1jasfoxau.s[6]++;
                element.bind("blur keyup change", function () {
                    cov_1jasfoxau.f[4]++;
                    cov_1jasfoxau.s[7]++;

                    scope.$apply(read);
                });
            }
        };
    });
})();
'use strict';

var cov_2025ghv8qe = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/companyTurnovers.js',
        hash = '89967c5e090e3eaf7a8607f7daf1025edde133e2',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/companyTurnovers.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 26,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 54
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 24,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 23,
                    column: 13
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 30
                },
                end: {
                    line: 21,
                    column: 17
                }
            },
            '5': {
                start: {
                    line: 22,
                    column: 16
                },
                end: {
                    line: 22,
                    column: 36
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 26,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'companyTurnovers',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 32
                    },
                    end: {
                        line: 25,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 15
                    },
                    end: {
                        line: 10,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 32
                    },
                    end: {
                        line: 24,
                        column: 9
                    }
                },
                line: 10
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 23,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 23,
                        column: 13
                    }
                }, {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 23,
                        column: 13
                    }
                }],
                line: 11
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2025ghv8qe.s[0]++;
(function () {
    'use strict';

    cov_2025ghv8qe.f[0]++;
    cov_2025ghv8qe.s[1]++;
    angular.module('app').filter('companyTurnovers', companyTurnovers);

    /* @ngInject */
    function companyTurnovers() {
        cov_2025ghv8qe.f[1]++;
        cov_2025ghv8qe.s[2]++;

        return function (input) {
            cov_2025ghv8qe.f[2]++;
            cov_2025ghv8qe.s[3]++;

            if (input) {
                cov_2025ghv8qe.b[0][0]++;

                var tiers = (cov_2025ghv8qe.s[4]++, {
                    A: '< 100K',
                    B: '100K-500K',
                    C: '500K-1M',
                    D: '1M-5M',
                    E: '5M-10M',
                    F: '10M-50M',
                    G: '50M-100M',
                    H: '> 100M'
                });
                cov_2025ghv8qe.s[5]++;
                return tiers[input];
            } else {
                cov_2025ghv8qe.b[0][1]++;
            }
        };
    }
})();
'use strict';

var cov_d1ahqmhf = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/companySizes.js',
        hash = '8e463c52439c0040c38b945c16543d2c55ec3824',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/companySizes.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 26,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 46
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 24,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 23,
                    column: 13
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 30
                },
                end: {
                    line: 21,
                    column: 17
                }
            },
            '5': {
                start: {
                    line: 22,
                    column: 16
                },
                end: {
                    line: 22,
                    column: 36
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 26,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'companySizes',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 28
                    },
                    end: {
                        line: 25,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 15
                    },
                    end: {
                        line: 10,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 32
                    },
                    end: {
                        line: 24,
                        column: 9
                    }
                },
                line: 10
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 23,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 23,
                        column: 13
                    }
                }, {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 23,
                        column: 13
                    }
                }],
                line: 11
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_d1ahqmhf.s[0]++;
(function () {
    'use strict';

    cov_d1ahqmhf.f[0]++;
    cov_d1ahqmhf.s[1]++;
    angular.module('app').filter('companySizes', companySizes);

    /* @ngInject */
    function companySizes() {
        cov_d1ahqmhf.f[1]++;
        cov_d1ahqmhf.s[2]++;

        return function (input) {
            cov_d1ahqmhf.f[2]++;
            cov_d1ahqmhf.s[3]++;

            if (input) {
                cov_d1ahqmhf.b[0][0]++;

                var sizes = (cov_d1ahqmhf.s[4]++, {
                    B: '1-10',
                    C: '11-50',
                    D: '51-200',
                    E: '201-500',
                    F: '501-1000',
                    G: '1001-5000',
                    H: '5001-10000',
                    I: '10001+'
                });
                cov_d1ahqmhf.s[5]++;
                return sizes[input];
            } else {
                cov_d1ahqmhf.b[0][1]++;
            }
        };
    }
})();
'use strict';

var cov_2fmf3psmic = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ceil.js',
        hash = '4023cf03c9047c7da277c84ce3377b4f948c2024',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ceil.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 14,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 30
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 11,
                    column: 36
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 14,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'ceil',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 17
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 20
                    },
                    end: {
                        line: 13,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 15
                    },
                    end: {
                        line: 10,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 32
                    },
                    end: {
                        line: 12,
                        column: 9
                    }
                },
                line: 10
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2fmf3psmic.s[0]++;
(function () {
    'use strict';

    cov_2fmf3psmic.f[0]++;
    cov_2fmf3psmic.s[1]++;
    angular.module('app').filter('ceil', ceil);

    /* @ngInject */
    function ceil() {
        cov_2fmf3psmic.f[1]++;
        cov_2fmf3psmic.s[2]++;

        return function (input) {
            cov_2fmf3psmic.f[2]++;
            cov_2fmf3psmic.s[3]++;

            return Math.ceil(input);
        };
    }
})();
angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/autocompletes/autocompletes.html","<div role=\"dialog\" aria-label=\"Autocomplete\" layout=\"column\" layout-align=\"center center\">\n\n    <div class=\"name\">\n	<h4>Completion</h4>\n    </div>\n\n    <table style=\"width: 80%\">\n	<tr>\n	    <td></td>\n	    <td width=\"20%\">Field</td>\n	    <td width=\"40%\">Value</td>\n	    <td width=\"20%\">Source</td>\n	</tr>\n	<tr ng-if=\"$ctrl.completion[field]\" ng-repeat=\"field in $ctrl.fields\">\n	    <td>\n		<md-button class=\"md-button-icon\" ng-if=\"$ctrl.selected.includes(field)\" ng-click=\"$ctrl.deselect(field)\">\n		    <md-icon>\n			check\n		    </md-icon>\n		</md-button>\n		<md-button class=\"md-button-icon\" ng-if=\"!$ctrl.selected.includes(field)\" ng-click=\"$ctrl.select(field)\">\n		    <md-icon>\n			remove\n		    </md-icon>\n		</md-button>\n	    </td>\n	    <td>{{field}}</td>\n	    <td ng-if=\"field != \'municipality\'\">{{$ctrl.completion[field]}}</td>\n	    <td ng-if=\"field == \'municipality\'\">{{$ctrl.completion[field] | municipalities}}</td>\n	    <td>{{$ctrl.completion.source}}</td>\n	</tr>\n    </table>\n\n    <hr>\n\n    <h3>Economic Activities</h3>\n\n    <div ng-if=\"!$ctrl.completion.$organizationAutocompleteEconomicActivity.length > 0\" style=\"color: #4a4a4a; font-size: 12px\">\n	No Economic Activities Found\n    </div>\n\n    <table style=\"width: 80%\" ng-if=\"$ctrl.completion.$organizationAutocompleteEconomicActivity.length > 0\">\n	<tr>\n	    <td width=\"20%\">Code</td>\n	    <td width=\"60%\">Name</td>\n	</tr>\n	<tr ng-repeat=\"activity in $ctrl.completion.$organizationAutocompleteEconomicActivity\">\n	    <td>{{activity.$_(\'economicActivity\').code}}</td>\n	    <td style=\"white-space: nowrap; text-overflow:ellipsis; overflow: hidden; max-width:1px\">\n		{{activity.$_(\'economicActivity\').name}}\n		<md-tooltip md-z-index=\"10000\">\n		    {{activity.$_(\'economicActivity\').name}}\n		</md-tooltip>\n	    </td>\n	</tr>\n    </table>\n\n\n    <h3>People</h3>\n\n    <div ng-if=\"!$ctrl.completion.$organizationAutocompletePeople.length > 0\" style=\"color: #4a4a4a; font-size: 12px\">\n	No People Found\n    </div>\n\n\n    <table style=\"width: 80%\" ng-if=\"$ctrl.completion.$organizationAutocompletePeople.length > 0\">\n	<tr>\n	    <td width=\"60%\">Name</td>\n	    <td width=\"20%\">Job Title</td>\n	</tr>\n	<tr ng-repeat=\"person in $ctrl.completion.$organizationAutocompletePeople\">\n	    <td>{{person.name}}</td>\n	    <td>{{person.jobTitle}}</td>\n	</tr>\n    </table>\n\n    <!-- emails -->\n    <h3>Emails</h3>\n\n    <div ng-if=\"!$ctrl.completion.$organizationAutocompleteEmail.length > 0\" style=\"color: #4a4a4a; font-size: 12px\">\n	No Email Found\n    </div>\n\n\n    <table style=\"width: 80%\" ng-if=\"$ctrl.completion.$organizationAutocompleteEmail.length > 0\">\n	<tr>\n	    <td width=\"60%\">Email</td>\n	</tr>\n	<tr ng-repeat=\"email in $ctrl.completion.$organizationAutocompleteEmail\">\n	    <td>{{email.email}}</td>\n	</tr>\n    </table>\n\n    <!-- links -->\n    <h3>Links</h3>\n\n    <div ng-if=\"!$ctrl.completion.$organizationAutocompleteLink.length > 0\" style=\"color: #4a4a4a; font-size: 12px\">\n	No Link Found\n    </div>\n\n\n    <table style=\"width: 80%\" ng-if=\"$ctrl.completion.$organizationAutocompleteLink.length > 0\">\n	<tr>\n	    <td width=\"60%\">Link</td>\n	</tr>\n	<tr ng-repeat=\"link in $ctrl.completion.$organizationAutocompleteLink\">\n	    <td>{{link.link}}</td>\n	    <td>{{link.category}}</td>\n	</tr>\n    </table>\n\n\n    <div layout=\"row\">\n	<md-button class=\"md-secondary\" ng-click=\"$ctrl.closeDialog()\">\n	    Ignore\n	</md-button>\n\n	<md-button class=\"md-primary\" ng-click=\"$ctrl.handleComplete()\" ng-disabled=\"$ctrl.selected.length == 0\">\n	    Complete\n	</md-button>\n    </div>\n</div>\n");
$templateCache.put("app/components/comment/comment.html","<div ng-if=\"!$ctrl.editable\" class=\"comment\">\n    <div class=\"comment-content\">{{$ctrl.data.content}}</div>\n    <div>\n	<md-icon>\n	    access_time\n	    <md-tooltip>Criado em {{$ctrl.data.created | amDateFormat:\'MMMM DD YYYY, HH:mm\'}} e atualizado em {{$ctrl.data.updated | amDateFormat:\'MMMM DD YYYY, HH:mm\'}}</md-tooltip>\n	</md-icon>\n\n	<md-button class=\"md-icon-button md-accent\" aria-label=\"editar\" ng-click=\"$ctrl.editable = true\">\n            <md-icon>edit</md-icon>\n	</md-button>\n\n	<md-button class=\"md-icon-button md-accent\" aria-label=\"remover\" ng-click=\"$ctrl.data.$destroy()\">\n            <md-icon>delete</md-icon>\n	</md-button>\n    </div>\n</div>\n\n<div ng-if=\"$ctrl.editable\">\n    <md-input-container ng-if=\"$ctrl.editable\" style=\"width: 100%\">\n        <textarea ng-model=\"$ctrl.data.content\" required md-maxlength=\"1024\" aria-label=\"comment content\" style=\"width: 100%; font-size: 12px; line-height: 18px; color: #999; padding: 0 15px\"></textarea>\n    </md-input-container>\n    <div flex layout=\"row\">\n	<md-button class=\"md-icon-button md-accent\" aria-label=\"guardar\" ng-click=\"$ctrl.editable = false;\">\n            <md-icon>cancel</md-icon>\n	</md-button>\n	<md-button class=\"md-icon-button md-accent\" aria-label=\"guardar\" ng-click=\"$ctrl.save()\">\n            <md-icon>save</md-icon>\n	</md-button>\n    </div>\n</div>\n");
$templateCache.put("app/components/componentsList/componentsList.html","<md-content class=\"page-list\" flex>\n    <div class=\"padding\">\n        <div layout=\"row\" layout-align=\"center center\">\n            <h1>Components</h1>\n            <span flex></span>\n            <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.displayNewComponentModal()\">\n                <md-icon>add</md-icon>\n                Add Component\n            </md-button>\n        </div>\n\n        <div layout=\"row\" class=\"filters-bar\">\n            <div layout=\"column\" layout-align=\"center center\">\n                <md-icon>search</md-icon>\n            </div>\n            <search label=\"\'Search Components\'\"></search>\n        </div>\n        <br>\n        <md-list>\n            <md-list-item ng-repeat=\"component in $ctrl.components\" style=\"padding: 5px; margin-bottom: 10px\" class=\"proposal-client\">\n                <div layout=\"row\" style=\"margin-left: 15px\" flex>\n                    <md-input-container flex>\n                        <input type=\"text\" placeholder=\"name\" ng-model=\"component.name\" ng-change=\"component.$save([\'name\'])\" aria-label=\"Component Name\">\n                    </md-input-container>\n                </div>\n                <div layout=\"column\" layout-align=\"center end\" style=\"margin-left: 10px\">\n                    <md-button class=\"md-icon-button\" ng-click=\"component.$destroy()\">\n                        <md-icon>delete</md-icon>\n                    </md-button>\n                </div>\n            </md-list-item>\n        </md-list>\n    </div>\n</md-content>\n");
$templateCache.put("app/components/createComponentModal/createComponentModal.html","<md-dialog aria-label=\"List dialog\">\n    <md-dialog-content class=\"md-dialog-content\" cg-busy=\"newComponent.$promise\">\n\n        <div layout=\"row\" layout-align=\"center center\" style=\"margin-bottom: 20px\">\n            <h1 style=\"margin: 0\">Add Component</h1>\n            <span flex></span>\n            <md-button ng-click=\"closeDialog()\" class=\"md-icon-button\" style=\"margin-left: 20px\">\n                <md-icon>close</md-icon>\n            </md-button>\n        </div>\n\n        <md-input-container class=\"md-block\">\n            <label>Component Name</label>\n            <input type=\"text\" ng-model=\"newComponent.name\" maxlength=\"10\">\n        </md-input-container>\n\n        <div layout=\"row\" layout-align=\"center center\">\n            <md-button class=\"md-raised md-accent\" ng-click=\"createComponent()\">Create Component</md-button>\n        </div>\n\n    </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/components/createEmailModal/createEmailModal.html","<md-dialog aria-label=\"List dialog\" ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 300, \'blur\': 0}, updateOnDefault: true}\">\n    <md-dialog-content class=\"md-dialog-content\" style=\"width: 1250px; height: 800px; max-height: 800px\" cg-busy=\"newEmail\">\n\n	<div layout=\"row\" layout-align=\"start start\">\n	    <div flex=\"60\">\n\n		<div layout=\"row\" layout-align=\"center center\" style=\"margin-bottom: 20px\">\n		    <h1 style=\"margin: 0\">New Email</h1>\n		    <span flex></span>\n		    <md-button ng-click=\"import()\" class=\"md-icon-button\" style=\"margin-left: 20px\">\n			<md-icon>import_export</md-icon>\n		    </md-button>\n		    <span>{{index}}</span>\n		    <md-button ng-click=\"closeDialog()\" class=\"md-icon-button\" style=\"margin-left: 0\">\n			<md-icon>close</md-icon>\n		    </md-button>\n		</div>\n\n		<md-input-container class=\"md-block\">\n		    <label>To</label>\n		    <input type=\"text\" ng-model=\"newEmail.to\" required md-autofocus ng-change=\"newEmail.$save([\'to\'])\">\n		</md-input-container>\n\n		<md-input-container class=\"md-block\" style=\"margin-top: 25px\">\n		    <label>Subject</label>\n		    <input type=\"text\" ng-model=\"newEmail.subject\" required ng-change=\"newEmail.$save([\'subject\'])\">\n		</md-input-container>\n\n		<md-input-container class=\"md-block\" style=\"margin-top: 25px\">\n		    <label>Body</label>\n		    <textarea ng-model=\"newEmail.body\" rows=\"7\" required ng-change=\"newEmail.$save([\'body\'])\"></textarea>\n		</md-input-container>\n\n		<div layout=\"row\" layout-align=\"center center\">\n		    <md-button class=\"md-raised md-accent\" ng-click=\"send()\">Open Client</md-button>\n		    <md-button class=\"md-raised md-accent\" ng-click=\"save()\">Save</md-button>\n		    <md-button class=\"md-raised md-accent\" ng-click=\"clear()\">Clear</md-button>\n		</div>\n	    </div>\n	    <div flex=\"40\" style=\"padding: 0 10px\">\n\n		<md-input-container class=\"md-block organization-detail\">\n                    <label>Email Sequence</label>\n		    <md-select placeholder=\"Email Sequence\" ng-model=\"sequence\" ng-change=\"changeFilters(\'sequence\', sequence)\">\n			<md-option value=\"GENERAL_EMAIL_SEQUENCE\">General Email Sequence</md-option>\n			<md-option value=\"MANAGER_EMAIL_SEQUENCE\">Manager Email Sequence</md-option>\n		    </md-select>\n		</md-input-container>\n\n		<md-input-container class=\"md-block organization-detail\">\n                    <label>Sequence Step</label>\n		    <md-select placeholder=\"Sequence Step\" ng-model=\"step\" ng-change=\"changeFilters(\'step\', step)\">\n			<md-option value=\"A\">A</md-option>\n			<md-option value=\"B\">B</md-option>\n			<md-option value=\"C\">C</md-option>\n			<md-option value=\"D\">D</md-option>\n			<md-option value=\"E\">E</md-option>\n		    </md-select>\n		</md-input-container>\n\n		<md-input-container class=\"md-block organization-detail\">\n                    <label>Step Variant</label>\n		    <md-select placeholder=\"Step Variant\" ng-model=\"variant\" ng-change=\"changeFilters(\'variant\', variant)\">\n			<md-option value=\"1\">1</md-option>\n			<md-option value=\"2\">2</md-option>\n			<md-option value=\"3\">3</md-option>\n			<md-option value=\"4\">4</md-option>\n			<md-option value=\"5\">5</md-option>\n		    </md-select>\n		</md-input-container>\n\n		<div ng-repeat=\"emailTemplate in emailTemplates\">\n		    <p>{{emailTemplate.subject}}</p>\n		    <p ng-bind-html=\"emailTemplate.body | nl2br\"></p>\n		    <p style=\"background-color: red\">\n			<md-button ng-click=\"importFromTemplate(emailTemplate)\" class=\"md-icon-button\" style=\"float: right\">\n			    <md-icon>keyboard_return</md-icon>\n			</md-button>\n		    </p>\n		</div>\n\n	</div>\n\n\n    </div></md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/components/createIndividualModal/createIndividualModal.html","<md-dialog aria-label=\"List dialog\">\n    <md-dialog-content class=\"md-dialog-content\" cg-busy=\"newIndividual.$promise\">\n\n        <div layout=\"row\" layout-align=\"center center\" style=\"margin-bottom: 20px\">\n            <h1 style=\"margin: 0\">Add Individual</h1>\n            <span flex></span>\n            <md-button ng-click=\"closeDialog()\" class=\"md-icon-button\" style=\"margin-left: 20px\">\n                <md-icon>close</md-icon>\n            </md-button>\n        </div>\n\n        <md-input-container class=\"md-block\">\n            <label>Name</label>\n            <input type=\"text\" ng-model=\"newIndividual.name\" maxlength=\"50\">\n        </md-input-container>\n\n        <div layout=\"row\" layout-align=\"center center\">\n            <md-button class=\"md-raised md-accent\" ng-click=\"createIndividual()\">Create Individual</md-button>\n        </div>\n\n    </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/components/createMediaModal/createMediaModal.html","<md-dialog aria-label=\"List dialog\" style=\"width: 450px\">\n    <md-dialog-content class=\"md-dialog-content\" cg-busy=\"newOrganization.$promise\">\n\n        <div layout=\"row\" layout-align=\"center center\" style=\"margin-bottom: 20px\">\n            <h1 style=\"margin: 0\">Add Media</h1>\n            <span flex></span>\n            <md-button ng-click=\"closeDialog()\" class=\"md-icon-button\" style=\"margin-left: 20px\">\n                <md-icon>close</md-icon>\n            </md-button>\n        </div>\n\n	<md-input-container class=\"md-block\" style=\"margin-bottom: 25px\">\n            <label>Title</label>\n            <input type=\"text\" ng-model=\"newMedia.title\">\n        </md-input-container>\n\n\n        <md-input-container class=\"md-block\">\n            <label>Link</label>\n            <input type=\"text\" ng-model=\"newMedia.link\">\n        </md-input-container>\n\n	<md-input-container class=\"project-select\" style=\"margin: 25px 0; width: 100%; text-align: left\">\n            <md-select ng-model=\"newMedia.organization\" class=\"md-no-underline\">\n                <md-select-header>\n                    <input ng-model=\"searchText\" type=\"search\" placeholder=\"Search Organizations\" class=\"md-text task-project-select-search\" ng-change=\"organizations.$refresh({name__icontains: searchText})\" ng-keydown=\"$event.stopPropagation();\" force-select-focus ng-model-options=\"{updateOnDefault: True, debounce: {\'default\': 500}}\">\n                </md-select-header>\n                <md-option ng-value=\"organization.id\" ng-repeat=\"organization in organizations\" class=\"hide-icons\">\n                    <div layout=\"row\" layout-align=\"center center\">\n                        <span>{{organization.name}}</span>\n                    </div>\n                </md-option>\n            </md-select>\n        </md-input-container>\n\n\n        <div layout=\"row\" layout-align=\"center center\">\n            <md-button class=\"md-raised md-accent\" ng-click=\"createMedia()\">{{action}}</md-button>\n        </div>\n\n    </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/components/createOrganizationModal/createOrganizationModal.html","<md-dialog aria-label=\"List dialog\">\n    <md-dialog-content class=\"md-dialog-content\" cg-busy=\"newOrganization.$promise\">\n	<form ng-submit=\"createOrganization()\" autocomplete=\"off\">\n            <div layout=\"row\" layout-align=\"center center\" style=\"margin-bottom: 20px\">\n		<h1 style=\"margin: 0\">Add Organization</h1>\n		<span flex></span>\n		<md-button ng-click=\"closeDialog()\" class=\"md-icon-button\" style=\"margin-left: 20px\">\n                    <md-icon>close</md-icon>\n		</md-button>\n            </div>\n\n            <md-input-container class=\"md-block\">\n		<label>Name</label>\n		<input type=\"text\" ng-model=\"newOrganization.name\" maxlength=\"50\" md-autofocus>\n            </md-input-container>\n\n            <div layout=\"row\" layout-align=\"center center\">\n		<md-button type=\"submit\" class=\"md-raised md-accent\">Create Organization</md-button>\n            </div>\n	</form>\n    </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/components/createProposalModal/createProposalModal.html","<md-dialog aria-label=\"List dialog\">\n    <md-dialog-content class=\"md-dialog-content\" cg-busy=\"newProposal.$promise\">\n\n        <div layout=\"row\" layout-align=\"center center\" style=\"margin-bottom: 20px\">\n            <h1 style=\"margin: 0\">Add Proposal</h1>\n            <span flex></span>\n            <md-button ng-click=\"closeDialog()\" class=\"md-icon-button\" style=\"margin-left: 20px\">\n                <md-icon>close</md-icon>\n            </md-button>\n        </div>\n\n        <md-input-container class=\"md-block\">\n            <label>Name</label>\n            <input type=\"text\" ng-model=\"newProposal.name\" maxlength=\"50\">\n        </md-input-container>\n\n        <md-input-container class=\"md-block\">\n            <label>Slug</label>\n            <input type=\"text\" ng-model=\"newProposal.slug\" maxlength=\"50\">\n        </md-input-container>\n\n        <md-input-container class=\"project-select\">\n            <md-select ng-model=\"newProposal.client\" class=\"md-no-underline\">\n                <md-select-header>\n                    <input ng-model=\"$ctrl.searchText\" type=\"search\" placeholder=\"Search Clients\" class=\"md-text task-project-select-search\" ng-change=\"clients.$refresh({name__icontains: $ctrl.searchText})\" ng-keydown=\"$event.stopPropagation();\" force-select-focus ng-model-options=\"{updateOnDefault: True, debounce: {\'default\': 500}}\">\n                </md-select-header>\n                <md-option ng-value=\"client.id\" ng-repeat=\"client in clients\" class=\"hide-icons\">\n                    <div layout=\"row\" layout-align=\"center center\">\n                        <span>{{client.name}}</span>\n                    </div>\n                </md-option>\n            </md-select>\n        </md-input-container>\n\n\n        <div layout=\"row\" layout-align=\"center center\">\n            <md-button class=\"md-raised md-accent\" ng-click=\"createProposal()\">Create Proposal</md-button>\n        </div>\n\n    </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/components/createTagModal/createTagModal.html","<md-dialog aria-label=\"List dialog\">\n    <md-dialog-content class=\"md-dialog-content\" cg-busy=\"newTag.$promise\">\n	<form>\n            <div layout=\"row\" layout-align=\"center center\" style=\"margin-bottom: 20px\">\n		<h1 style=\"margin: 0\">Add Tag</h1>\n		<span flex></span>\n		<md-button ng-click=\"closeDialog()\" class=\"md-icon-button\" style=\"margin-left: 20px\">\n                    <md-icon>close</md-icon>\n		</md-button>\n            </div>\n\n            <md-input-container class=\"md-block\">\n		<label>Tag Name</label>\n		<input type=\"text\" ng-model=\"newTag.name\" maxlength=\"50\" md-autofocus>\n            </md-input-container>\n\n            <div layout=\"row\" layout-align=\"center center\">\n		<md-button type=\"submit\" class=\"md-raised md-accent\" ng-click=\"createTag()\">Create Tag</md-button>\n            </div>\n	</form>\n    </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/components/createUserStoryModal/createUserStoryModal.html","<md-dialog aria-label=\"List dialog\" style=\"min-width: 500px\">\n    <md-dialog-content class=\"md-dialog-content\" cg-busy=\"newUserStory.$promise\">\n\n        <div layout=\"row\" layout-align=\"center center\" style=\"margin-bottom: 20px\">\n            <h1 style=\"margin: 0\">Add User Story</h1>\n            <span flex></span>\n            <md-button ng-click=\"closeDialog()\" class=\"md-icon-button\" style=\"margin-left: 20px\">\n                <md-icon>close</md-icon>\n            </md-button>\n        </div>\n\n        <md-input-container class=\"md-block\">\n            <label>Name</label>\n            <textarea ng-model=\"newUserStory.name\" maxlength=\"150\"></textarea>\n        </md-input-container>\n\n        <div layout=\"row\" layout-align=\"center center\">\n            <md-button class=\"md-raised md-accent\" ng-click=\"createUserStory()\">Create User Story</md-button>\n        </div>\n\n    </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/components/dashboard/dashboard.html","<md-content>\n    <div class=\"padding\">\n	<div layout=\"row\" style=\"flex-wrap: wrap\">\n	    <md-card flex=\"100\" layout=\"column\" layout-align=\"center center\">\n		<md-card-header>\n		    <md-card-title>\n			Organizations Created\n		    </md-card-title>\n		</md-card-header>\n		<nvd3 options=\"$ctrl.options.organizations\" data=\"$ctrl.data.organizations\"></nvd3>\n		<div layout=\"row\" layout-align=\"center center\">\n		    <span style=\"margin: 0 25px\">Start: </span>\n		    <md-select ng-model=\"$ctrl.filters.organizations.start.month\" ng-change=\"$ctrl._refresh()\" aria-label=\"filter month\">\n			<md-option value=\"1\">Jan</md-option>\n			<md-option value=\"2\">Feb</md-option>\n			<md-option value=\"3\">Mar</md-option>\n			<md-option value=\"4\">Apr</md-option>\n			<md-option value=\"5\">May</md-option>\n			<md-option value=\"6\">Jun</md-option>\n			<md-option value=\"7\">Jul</md-option>\n			<md-option value=\"8\">Aug</md-option>\n			<md-option value=\"9\">Sep</md-option>\n			<md-option value=\"10\">Oct</md-option>\n			<md-option value=\"11\">Nov</md-option>\n			<md-option value=\"12\">Dec</md-option>\n		    </md-select>\n		    <md-select ng-model=\"$ctrl.filters.organizations.start.year\" ng-change=\"$ctrl._refresh()\" aria-label=\"filter year\">\n			<md-option value=\"2017\">2017</md-option>\n			<md-option value=\"2018\">2018</md-option>\n			<md-option value=\"2019\">2019</md-option>\n		    </md-select>\n		    <span style=\"margin: 0 25px\">End: </span>\n		    <md-select ng-model=\"$ctrl.filters.organizations.end.month\" ng-change=\"$ctrl._refresh()\" aria-label=\"filter month\">\n			<md-option value=\"1\">Jan</md-option>\n			<md-option value=\"2\">Feb</md-option>\n			<md-option value=\"3\">Mar</md-option>\n			<md-option value=\"4\">Apr</md-option>\n			<md-option value=\"5\">May</md-option>\n			<md-option value=\"6\">Jun</md-option>\n			<md-option value=\"7\">Jul</md-option>\n			<md-option value=\"8\">Aug</md-option>\n			<md-option value=\"9\">Sep</md-option>\n			<md-option value=\"10\">Oct</md-option>\n			<md-option value=\"11\">Nov</md-option>\n			<md-option value=\"12\">Dec</md-option>\n		    </md-select>\n		    <md-select ng-model=\"$ctrl.filters.organizations.end.year\" ng-change=\"$ctrl._refresh()\" aria-label=\"filter year\">\n			<md-option value=\"2017\">2017</md-option>\n			<md-option value=\"2018\">2018</md-option>\n			<md-option value=\"2019\">2019</md-option>\n		    </md-select>\n		</div>\n		<div layout=\"row\" layout-align=\"end center\" style=\"width: 100%\">\n		    <div style=\"margin: 25px; font-size: 12px; color: #4a4a4a\">\n			Last Update: {{$ctrl.lastUpdate.value | amDateFormat: \'DD-MM-YYYY HH:mm\'}} (<span am-time-ago=\"$ctrl.lastUpdate.value\"></span>)\n		    </div>\n		</div>\n	    </md-card>\n\n	    <md-card flex=\"100\" layout=\"column\" layout-align=\"center center\">\n		<md-card-header>\n		    <md-card-title>\n			Sales Metrics\n		    </md-card-title>\n		</md-card-header>\n		<nvd3 options=\"$ctrl.multibarOptions\" data=\"$ctrl.multibar\"></nvd3>\n		<div layout=\"row\" layout-align=\"end center\" style=\"width: 100%\">\n		    <div style=\"margin: 25px; font-size: 12px; color: #4a4a4a\">\n			Last Update: {{$ctrl.lastUpdate.value | amDateFormat: \'DD-MM-YYYY HH:mm\'}} (<span am-time-ago=\"$ctrl.lastUpdate.value\"></span>)\n		    </div>\n		</div>\n	    </md-card>\n\n	    <md-card flex=\"100\" layout=\"column\" layout-align=\"center center\">\n		<md-card-header>\n		    <md-card-title>\n			Invoices Created\n		    </md-card-title>\n		</md-card-header>\n		<nvd3 options=\"$ctrl.options.organizations\" data=\"$ctrl.data.invoices\"></nvd3>\n		<div layout=\"row\" layout-align=\"center center\">\n		    <span style=\"margin: 0 25px\">Start: </span>\n		    <md-select ng-model=\"$ctrl.filters.invoices.start.month\" ng-change=\"$ctrl._refresh()\" aria-label=\"filter month\">\n			<md-option value=\"1\">Jan</md-option>\n			<md-option value=\"2\">Feb</md-option>\n			<md-option value=\"3\">Mar</md-option>\n			<md-option value=\"4\">Apr</md-option>\n			<md-option value=\"5\">May</md-option>\n			<md-option value=\"6\">Jun</md-option>\n			<md-option value=\"7\">Jul</md-option>\n			<md-option value=\"8\">Aug</md-option>\n			<md-option value=\"9\">Sep</md-option>\n			<md-option value=\"10\">Oct</md-option>\n			<md-option value=\"11\">Nov</md-option>\n			<md-option value=\"12\">Dec</md-option>\n		    </md-select>\n		    <md-select ng-model=\"$ctrl.filters.invoices.start.year\" ng-change=\"$ctrl._refresh()\" aria-label=\"filter year\">\n			<md-option value=\"2017\">2017</md-option>\n			<md-option value=\"2018\">2018</md-option>\n			<md-option value=\"2019\">2019</md-option>\n		    </md-select>\n		    <span style=\"margin: 0 25px\">End: </span>\n		    <md-select ng-model=\"$ctrl.filters.invoices.end.month\" ng-change=\"$ctrl._refresh()\" aria-label=\"filter month\">\n			<md-option value=\"1\">Jan</md-option>\n			<md-option value=\"2\">Feb</md-option>\n			<md-option value=\"3\">Mar</md-option>\n			<md-option value=\"4\">Apr</md-option>\n			<md-option value=\"5\">May</md-option>\n			<md-option value=\"6\">Jun</md-option>\n			<md-option value=\"7\">Jul</md-option>\n			<md-option value=\"8\">Aug</md-option>\n			<md-option value=\"9\">Sep</md-option>\n			<md-option value=\"10\">Oct</md-option>\n			<md-option value=\"11\">Nov</md-option>\n			<md-option value=\"12\">Dec</md-option>\n		    </md-select>\n		    <md-select ng-model=\"$ctrl.filters.invoices.end.year\" ng-change=\"$ctrl._refresh()\" aria-label=\"filter year\">\n			<md-option value=\"2017\">2017</md-option>\n			<md-option value=\"2018\">2018</md-option>\n			<md-option value=\"2019\">2019</md-option>\n		    </md-select>\n		</div>\n		<div layout=\"row\" layout-align=\"end center\" style=\"width: 100%\">\n		    <div style=\"margin: 25px; font-size: 12px; color: #4a4a4a\">\n			Last Update: {{$ctrl.lastUpdate.value | amDateFormat: \'DD-MM-YYYY HH:mm\'}} (<span am-time-ago=\"$ctrl.lastUpdate.value\"></span>)\n		    </div>\n		</div>\n	    </md-card>\n\n	</div>\n    </div>\n</md-content>\n");
$templateCache.put("app/components/documentsList/documentsList.html","<md-content>\n\n    <div class=\"padding\">\n        <div layout=\"row\" layout-align=\"center center\">\n            <h1>Documents</h1>\n            <span flex></span>\n        </div>\n\n        <input type=\"text\" ng-model=\"$ctrl.searchText\" class=\"title-input\" placeholder=\"search\" ng-change=\"$ctrl.documents.$refresh({name__icontains: $ctrl.searchText})\">\n\n        <md-card>\n            <md-list>\n                <md-list-item ng-repeat=\"document in $ctrl.documents | orderBy: \'name\'\">\n\n                    <div layout=\"row\">\n                        <span flex>\n                            {{document.name}}\n                            {{document.$organization.name}}\n                            <a href=\"{{document.path | mediaUrl}}\" target=\"_blank\" class=\"md-button md-icon-button\">\n                                <md-icon>file_download</md-icon>\n                            </a>\n                            <a ng-click=\"document.$destroy()\" class=\"md-button md-icon-button\">\n                                <md-icon>delete</md-icon>\n                            </a>\n                        </span>\n                    </div>\n\n                </md-list-item>\n            </md-list>\n        </md-card>\n    </div>\n\n    <div flex=\"100\">\n        <md-card cg-busy=\"$ctrl.organization.$files.$promise\">\n            <table class=\"multi-table editable\">\n                <tr>\n                    <td colspan=\"99\">\n                        <md-button ngf-select media-auto-upload ng-model=\"$ctrl.newFileAttachment\" ngf-model-invalid=\"$ctrl.invalidUploadedFiles\">\n                            <md-icon>file_upload</md-icon>\n                            adicionar documento\n                        </md-button>\n                    </td>\n                </tr>\n            </table>\n        </md-card>\n\n    </div>\n\n    <div>\n        <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.documents.$page=$ctrl.documents.$page - 1; $ctrl.documents.$refresh()\">\n            Previous\n        </md-button>\n        <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.documents.$page = $ctrl.documents.$page +1; $ctrl.documents.$refresh()\">\n            Next\n        </md-button>\n\n</div></md-content>\n");
$templateCache.put("app/components/economicActivitiesList/economicActivitiesList.html","<md-content>\n\n    <div class=\"padding\">\n        <div layout=\"row\" layout-align=\"center center\">\n            <h1>Economic Activities</h1>\n            <span flex></span>\n        </div>\n\n        <input type=\"text\" ng-model=\"$ctrl.searchText\" class=\"title-input\" placeholder=\"search\" ng-change=\"$ctrl.economicActivities.$refresh({name__icontains: $ctrl.searchText})\">\n\n	<md-card class=\"prospector-table\">\n	    <div flex layout=\"row\" class=\"header\">\n		<div flex=\"10\" class=\"flush-left\">Code</div>\n		<div flex=\"10\" class=\"flush-left\">Level</div>\n		<div flex=\"80\" class=\"flush-left\">Name</div>\n	    </div>\n\n\n	    <div flex layout=\"row\" ng-repeat=\"economicActivity in $ctrl.economicActivities | orderBy: \'code\'\" class=\"body\">\n		<div flex=\"10\" class=\"flush-left\">{{economicActivity.code}}</div>\n		<div flex=\"10\" class=\"flush-left\">{{economicActivity.level}}</div>\n		<div flex=\"80\" class=\"flush-left\">{{economicActivity.name}}</div>\n	    </div>\n	</md-card>\n\n    </div>\n\n    <div>\n        <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.economicActivities.$page=$ctrl.economicActivities.$page - 1; $ctrl.economicActivities.$refresh()\">\n            Previous\n        </md-button>\n        <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.economicActivities.$page = $ctrl.economicActivities.$page +1; $ctrl.economicActivities.$refresh()\">\n            Next\n        </md-button>\n    </div>\n</md-content>\n");
$templateCache.put("app/components/filesDisplay/filesDisplay.html","<div layout=\"row\" class=\"file-preview\" ng-repeat=\"file in $ctrl.files\">\n    <a href=\"{{file.path | mediaUrl}}\" target=\"_blank\" flex>\n        {{::$ctrl.fileToName(file.path)}}\n    </a>\n    <a href=\"{{file.path | mediaUrl}}\" target=\"_blank\" download>\n        <md-icon>file_download</md-icon>\n    </a>\n    <div layout=\"column\" layout-align=\"center center\" ng-if=\"$ctrl.deletable\">\n        <md-button class=\"md-icon-button\" style=\"margin: 0px !important; padding:0px !important\" ng-click=\"$ctrl.$rootScope.$emit(\'fileClose\', file);\">\n            <md-icon style=\"font-size: 20px\">close</md-icon>\n        </md-button>\n    </div>\n</div>");
$templateCache.put("app/components/fab/fab.html","<md-fab-speed-dial md-direction=\"up\" class=\"md-fling md-fab-bottom-right\">\n    <md-fab-trigger>\n        <md-button aria-label=\"$ctrl.tooltip\" class=\"md-fab\" ng-click=\"$ctrl.onAction()\">\n            <md-tooltip ng-if=\"$ctrl.tooltip\" md-direction=\"left\">{{::$ctrl.tooltip}}</md-tooltip>\n            <md-icon ng-if=\"$ctrl.icon\">{{::$ctrl.icon}}</md-icon>\n        </md-button>\n    </md-fab-trigger>\n</md-fab-speed-dial>\n");
$templateCache.put("app/components/filesManager/filesManager.html","<md-card>\n    <md-card-header>\n	<md-card-title>\n	    Ficheiros (Files Manager)\n	</md-card-title>\n    </md-card-header>\n    <md-card-content>\n	<div cg-busy=\"$ctrl.collection.$promise\">\n            <h3 class=\"text-center text-fade\" ng-if=\"!$ctrl.collection.length\">\n		Nenhum documento adicionado\n            </h3>\n\n            <table style=\"width: 100%\">\n		<tr ng-repeat=\"file in $ctrl.collection\" cg-busy=\"file.$promise\">\n                    <td style=\"width: 80%\">\n			<input type=\"text\" ng-model=\"file.name\" ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 1000, \'blur\': 0}, updateOnDefault: true}\" ng-change=\"file.$save()\" style=\"background-color: transparent; outline: none; border: none; font-size: 13px; width: 100%\">\n                    </td>\n                    <td class=\"minimun\">\n			<a download href=\"{{::file.path | mediaUrl}}\" target=\"_blank\" class=\"md-button md-icon-button\" style=\"padding-top: 8px\">\n                            <md-icon aria-label=\"Download\">file_download</md-icon>\n			</a>\n                    </td>\n                    <td class=\"minimun\">\n			<md-button class=\"md-icon-button\" ng-click=\"file.$destroy()\">\n                            <md-icon>delete</md-icon>\n			</md-button>\n                    </td>\n		</tr>\n            </table>\n	</div>\n    </md-card-content>\n    <md-card-footer>\n	<md-button ngf-select media-auto-upload ng-model=\"$ctrl.newFileAttachment\" ngf-model-invalid=\"$ctrl.invalidUploadedFiles\">\n            <md-icon>file_upload</md-icon>\n            adicionar documento\n	</md-button>\n    </md-card-footer>\n</md-card>\n");
$templateCache.put("app/components/individualDetails/individualDetails.html","<md-content ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 1000, \'blur\': 0}, updateOnDefault: true}\" layout=\"row\" layout-wrap layout-align=\"space-around stretch\">\n\n	<h1 class=\"md-block\" flex=\"95\">\n	    <md-button class=\"md-icon-button\" aria-label=\"Back\" ng-click=\"$root.goBack();\">\n		<md-icon>arrow_back</md-icon>\n	    </md-button>\n	    {{$ctrl.individual.name}}\n	</h1>\n\n\n	<md-card flex=\"30\">\n	    <md-card-header>\n		<md-card-title>\n		    Detalhes\n		</md-card-title>\n	    </md-card-header>\n	    <md-card-content>\n		<md-input-container class=\"md-block organization-detail\">\n                    <label>Name</label>\n                    <textarea ng-model=\"$ctrl.individual.name\" ng-change=\"$ctrl.individual.$save([\'name\'])\" md-maxlength=\"1024\"></textarea>\n                </md-input-container>\n                <md-input-container class=\"md-block organization-detail\">\n                    <label>Phone</label>\n                    <input type=\"text\" ng-model=\"$ctrl.individual.phone\" ng-change=\"$ctrl.individual.$save([\'phone\'])\">\n                </md-input-container>\n		<div style=\"margin-bottom: 25px; color: #ccc\">\n		    {{$ctrl.individual.email}}\n		    <md-tooltip>This is Temporary</md-tooltip>\n		</div>\n		<organization-emails organization=\"$ctrl.individual\" emails=\"$ctrl.individual.$emails\"></organization-emails>\n\n	    </md-card-content>\n	</md-card>\n\n	<md-card flex=\"30\">\n	    <md-card-header>\n		<md-card-title>\n		    Card\n		</md-card-title>\n	    </md-card-header>\n	    <md-card-content>\n		TODO\n	    </md-card-content>\n	</md-card>\n\n\n	<md-card flex=\"30\">\n	    <md-card-header>\n		<md-card-title>\n		    Notes\n		</md-card-title>\n	    </md-card-header>\n	    <md-card-content>\n		<div>\n		    <div ng-repeat=\"comment in $ctrl.individual.$comments\">\n			<comment data=\"comment\"></comment>\n		    </div>\n\n		</div>\n	    </md-card-content>\n	    <md-card-footer>\n		<md-input-container style=\"width: 80%\">\n		    <label>Nota</label>\n		    <textarea ng-model=\"$ctrl.newCommentContent\" required md-maxlength=\"1024\"></textarea>\n		</md-input-container>\n		<md-button class=\"md-icon-button\" ng-click=\"$ctrl.createComment($ctrl.individual, $ctrl.newCommentContent)\">\n		    <md-icon>\n			add\n			<md-tooltip>Adicionar Nota</md-tooltip>\n		    </md-icon>\n		</md-button>\n	    </md-card-footer>\n	</md-card>\n\n	<!--\n             <div layout=\"row\" layout-align=\"center center\">\n             <div flex>\n             <input type=\"text\" ng-model=\"$ctrl.individual.name\" class=\"title-input\" ng-change=\"$ctrl.individual.$save([\'name\'])\" /><br>\n             <md-input-container>\n             <label>Description</label>\n             <textarea ng-model=\"$ctrl.individual.description\" ng-change=\"$ctrl.individual.$save([\'description\'])\" md-maxlength=\"1024\"></textarea>\n             </md-input-container>\n             <br>\n             <md-input-container>\n             <label>NIF</label>\n             <input type=\"text\" ng-model=\"$ctrl.individual.nif\" ng-change=\"$ctrl.individual.$save([\'nif\'])\" />\n             </md-input-container>\n             <br>\n             <md-input-container>\n             <label>Phone</label>\n             <input type=\"text\" ng-model=\"$ctrl.individual.phone\" ng-change=\"$ctrl.individual.$save([\'phone\'])\" />\n             </md-input-container>\n             <br>\n             <md-input-container>\n             <label>Email</label>\n             <input type=\"text\" ng-model=\"$ctrl.individual.email\" ng-change=\"$ctrl.individual.$save([\'email\'])\" />\n             </md-input-container>\n             </div>\n             </div>\n\n	     <organization-emails organization=\"$ctrl.organization\" emails=\"$ctrl.organization.$emails\"></organization-emails>\n	-->\n\n	<md-card flex=\"30\">\n	    <md-card-title>\n		Links\n	    </md-card-title>\n	    <md-card-content>\n		<related-links organization=\"$ctrl.individual\" links=\"$ctrl.individual.$links\" categories=\"$ctrl.categories\">\n	    </md-card-content>\n	</md-card>\n\n	<md-card flex=\"30\">\n	    <md-card-header>\n		<md-card-title>\n		    Card\n		</md-card-title>\n	    </md-card-header>\n	    <md-card-content>\n		TODO\n	    </md-card-content>\n	</md-card>\n\n	<md-card flex=\"30\">\n	    <md-card-header>\n		<md-card-title>\n		    Card\n		</md-card-title>\n	    </md-card-header>\n	    <md-card-content>\n		TODO\n	    </md-card-content>\n	</md-card>\n\n\n	<md-card flex=\"30\">\n	    <md-card-header>\n		<md-card-title>\n		    Interações\n		</md-card-title>\n	    </md-card-header>\n	    <md-card-content>\n		<md-list>\n                    <md-list-item ng-repeat=\"interaction in $ctrl.individual.$interactions\" layout=\"column\" layout-align=\"center start\" class=\"organization-interaction\">\n			<div>\n			    <input type=\"text\" ng-model=\"interaction.description\" ng-change=\"interaction.$save([\'description\'])\" ng-if=\"interaction.editing\">\n			    <p ng-if=\"!interaction.editing\">{{interaction.description}}</p>\n			    <div layout=\"row\">\n				<span>\n				    {{interaction.$_(\'tt\').name}} | {{interaction.interactedAt | amDateFormat:\'DD-MM-YYYY\'}}\n				    <md-icon ng-if=\"interaction.firstInteraction\" style=\"cursor: pointer; margin: 7px 0 0 5px;font-size: 15px !important; color: #F7D342; outline: none\" ng-click=\"$ctrl.toogleFirstInteraction(interaction)\">\n					star\n					<md-tooltip>This is the first interaction</md-tooltip>\n				    </md-icon>\n				    <md-icon ng-if=\"!interaction.firstInteraction\" style=\"cursor: pointer; margin: 7px 0 0 5px;font-size: 15px !important; color: #ccc; outline: none\" ng-click=\"$ctrl.toogleFirstInteraction(interaction)\">\n					star\n					<md-tooltip>This is a follow up interaction</md-tooltip>\n				    </md-icon>\n				    <md-icon style=\"cursor: pointer; margin: 7px 0 0 0; font-size: 15px !important; color: #ccc; outline: none\" ng-if=\"interaction.email && !interaction.$_(\'email\').isOpen\">\n					check\n					<md-tooltip>Not Opened Yet</md-tooltip>\n				    </md-icon>\n				    <md-icon style=\"cursor: pointer; margin: 7px 0 0 0; font-size: 15px !important; color: green; outline: none\" ng-if=\"interaction.email && interaction.$_(\'email\').isOpen\">\n					check\n					<md-tooltip>\n					    Opened {{interaction.$_(\'email\').count}} times. First opened at {{interaction.$_(\'email\').openAt | amDateFormat:\'DD-MM-YYYY HH:mm:ss\'}}\n					</md-tooltip>\n				    </md-icon>\n				    <md-icon style=\"cursor: pointer; margin: 7px 0 0 0; font-size: 15px !important; color: #ccc; outline: none\" ng-if=\"interaction.email\" ng-click=\"$ctrl.showEmail(interaction.email)\">\n					more_horiz\n					<md-tooltip>\n					    More\n					</md-tooltip>\n				    </md-icon>\n				</span>\n				<span class=\"actions\">\n				    <a href=\"#\" ng-click=\"interaction.editing = true\" class=\"md-button md-icon-button\" ng-if=\"!interaction.editing\"><md-icon>edit</md-icon></a>\n				    <a href=\"#\" ng-click=\"interaction.editing = false\" class=\"md-button md-icon-button\" ng-if=\"interaction.editing\"><md-icon>cancel</md-icon></a>\n				    <a href=\"#\" ng-click=\"interaction.$destroy()\" class=\"md-button md-icon-button\"><md-icon>delete</md-icon></a>\n				</span>\n			    </div>\n			</div>\n                    </md-list-item>\n		</md-list>\n\n\n\n\n	    </md-card-content>\n	    <md-card-footer>\n		<md-input-container class=\"md-block\">\n                    <md-select ng-model=\"newInteractionType\" class=\"md-no-underline\">\n			<md-select-header>\n                            <input ng-model=\"$ctrl.searchText\" type=\"search\" placeholder=\"Tipo Interação\" class=\"md-text task-project-select-search\" ng-change=\"$ctrl.interactionTypes.$refresh({name__icontains: $ctrl.searchText})\" ng-keydown=\"$event.stopPropagation();\" force-select-focus ng-model-options=\"{updateOnDefault: True, debounce: {\'default\': 500}}\">\n			</md-select-header>\n			<md-option ng-value=\"interactionType.id\" ng-repeat=\"interactionType in $ctrl.interactionTypes\" class=\"hide-icons\">\n                            <div layout=\"row\" layout-align=\"center center\">\n				<span>{{interactionType.name}}</span>\n                            </div>\n			</md-option>\n                    </md-select>\n		</md-input-container>\n\n\n		<md-input-container class=\"md-block\">\n                    <label>Descrição</label>\n                    <textarea ng-model=\"$ctrl.newInteractionName\" required md-maxlength=\"1024\"></textarea>\n		</md-input-container>\n		<md-button class=\"md-accent md-raised\" ng-click=\"$ctrl.createInteraction(newInteractionType, $ctrl.newInteractionName, $ctrl.newInteractionAt, $ctrl.newInteractionEmail)\" style=\"margin-bottom: 25px\">\n                    Create Interaction\n		</md-button>\n		<md-button class=\"md-accent md-raised\" style=\"margin-bottom: 25px\" ng-if=\"newInteractionType === 1\" ng-click=\"$ctrl.displayNewEmailModal()\">\n                    Compose Email\n		</md-button>\n		<div style=\"width: 100%\">\n		    <mdp-date-picker mdp-placeholder=\"Date\" ng-model=\"$ctrl.newInteractionAt\"></mdp-date-picker>\n		</div>\n\n	    </md-card-footer>\n	</md-card>\n\n\n	<md-card flex=\"30\">\n	    <md-card-header>\n		<md-card-title>\n		    Card\n		</md-card-title>\n	    </md-card-header>\n	    <md-card-content>\n		TODO\n	    </md-card-content>\n	</md-card>\n\n	<md-card flex=\"30\">\n	    <md-card-header>\n		<md-card-title>\n		    Card\n		</md-card-title>\n	    </md-card-header>\n	    <md-card-content>\n		TODO\n	    </md-card-content>\n	</md-card>\n\n\n	<!--\n\n             <h1>Tags</h1>\n             <div>\n             <md-list>\n             <md-list-item ng-repeat=\"tag in $ctrl.individual.$tags\">\n             {{tag.$tag.name}}\n             <a ng-click=\"tag.$destroy()\" class=\"md-button md-icon-button\"><md-icon>delete</md-icon></a>\n             </md-list-item>\n             </md-list>\n             <searchable-selector\n             items=\"$ctrl.tags\"\n             search-items=\"$ctrl.tags.$refresh({name__icontains: searchText});\"\n             select-item=\"$ctrl.onSelectTag($ctrl.individual, item)\">\n             </searchable-selector>\n             </div>\n\n             <h1>Comments</h1>\n             <div>\n             <md-list>\n             <md-list-item ng-repeat=\"comment in $ctrl.individual.$comments\" layout=\"column\"\n             layout-align=\"center start\">\n             <p>{{comment.content}}</p>\n             <p>{{comment.$user.name}}</p>\n             <p>{{comment.created | amDateFormat:\'MMMM DD YYYY, HH:mm\'}}</p>\n             <p><md-button ng-click=\"comment.$destroy()\">DELETE</md-button></p>\n             <br><br>\n             </md-list-item>\n             </md-list>\n\n             <md-input-container>\n             <label>New Comment</label>\n             <textarea ng-model=\"$ctrl.newCommentContent\" required md-maxlength=\"1024\"></textarea>\n             <md-button ng-click=\"$ctrl.createComment($ctrl.individual, $ctrl.newCommentContent)\">\n             Create Comment\n             </md-button>\n             </md-input-container>\n             </div>\n\n             <h1>Interactions</h1>\n             <div>\n             <md-list>\n             <md-list-item ng-repeat=\"interaction in $ctrl.individual.$interactions\" layout=\"column\"\n             layout-align=\"center start\">\n             <p>{{interaction.interactedAt | amDateFormat:\'MMMM DD YYYY\'}} [{{interaction.$tt.name}}] - {{interaction.description}}\n	     <a href=\"#\" ng-click=\"interaction.$destroy()\" class=\"md-button md-icon-button\"><md-icon>delete</md-icon></a></p>\n             </md-list-item>\n             </md-list>\n\n\n             <md-input-container class=\"project-select\">\n             <md-select ng-model=\"newInteractionType\" class=\"md-no-underline\">\n             <md-select-header>\n             <input ng-model=\"$ctrl.searchText\"\n             type=\"search\"\n             placeholder=\"Search Interaction Types\"\n             class=\"md-text task-project-select-search\"\n             ng-change=\"$ctrl.interactionTypes.$refresh({name__icontains: $ctrl.searchText})\"\n             ng-keydown=\"$event.stopPropagation();\"\n             force-select-focus\n             ng-model-options=\"{updateOnDefault: True, debounce: {\'default\': 500}}\"\n             />\n             </md-select-header>\n             <md-option ng-value=\"interactionType.id\" ng-repeat=\"interactionType in $ctrl.interactionTypes\" class=\"hide-icons\">\n             <div layout=\"row\" layout-align=\"center center\">\n             <span>{{interactionType.name}}</span>\n             </div>\n             </md-option>\n             </md-select>\n             </md-input-container>\n\n             <mdp-date-picker mdp-placeholder=\"Date\" ng-model=\"$ctrl.newInteractionAt\"></mdp-date-picker>\n\n             <md-input-container>\n             <label>New Interaction</label>\n             <textarea ng-model=\"$ctrl.newInteractionName\" required md-maxlength=\"1024\"></textarea>\n             <md-button ng-click=\"$ctrl.createInteraction($ctrl.individual, newInteractionType, $ctrl.newInteractionName, $ctrl.newInteractionAt)\">\n             Create Interaction\n             </md-button>\n             </md-input-container>\n             </div>\n\n\n\n             <h1>Files</h1>\n             <div flex=\"30\">\n             <p class=\"text-fade\">\n             Max. File Size 100MB\n             </p>\n             <md-card cg-busy=\"$ctrl.individual.$files.$promise\">\n             <h3 class=\"text-center text-fade\" ng-if=\"!$ctrl.individual.$files.length\">\n             Nenhum documento adicionado\n             </h3>\n\n             <table class=\"multi-table editable\">\n             <tr ng-repeat=\"file in $ctrl.individual.$files\" cg-busy=\"file.$promise\">\n             <td>\n             <input type=\"text\" ng-model=\"file.name\"\n             ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 1000, \'blur\': 0}, updateOnDefault: true}\"\n             ng-change=\"file.$save()\"/>\n             </td>\n             <td class=\"minimun\">\n             <a download href=\"{{::file.path | mediaUrl}}\" target=\"_blank\"\n             class=\"md-button md-icon-button\" style=\"padding-top: 8px\">\n             <md-icon aria-label=\"Download\">file_download</md-icon>\n             </a>\n             </td>\n             <td class=\"minimun\">\n             <md-button class=\"md-icon-button\" ng-click=\"file.$destroy()\">\n             <md-icon>delete</md-icon>\n             </md-button>\n             </td>\n             </tr>\n             <tr>\n             <td colspan=\"99\">\n             <md-button ngf-select\n             media-auto-upload\n             ng-model=\"$ctrl.newFileAttachment\"\n             ngf-model-invalid=\"$ctrl.invalidUploadedFiles\">\n             <md-icon>file_upload</md-icon>\n             adicionar documento\n             </md-button>\n             </td>\n             </tr>\n             </table>\n             </md-card>\n             </div> -->\n\n</md-content>\n");
$templateCache.put("app/components/individualsList/individualsList.html","<md-content>\n\n    <div class=\"padding\">\n        <div layout=\"row\" layout-align=\"center center\">\n            <h1>Individuals</h1>\n            <span flex></span>\n            <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.displayNewIndividualModal()\">\n                <md-icon>add</md-icon>\n                Add Individual\n            </md-button>\n        </div>\n\n        <input type=\"text\" ng-model=\"$ctrl.searchText\" class=\"title-input\" placeholder=\"search\" ng-change=\"$ctrl.individuals.$refresh({name__icontains: $ctrl.searchText})\">\n\n	<md-card class=\"prospector-table\">\n	    <div flex layout=\"row\" class=\"header\">\n		<div flex=\"25\" class=\"flush-left\">Name</div>\n		<div flex=\"30\" class=\"center\">Email</div>\n		<div flex=\"10\" class=\"center\">Phone</div>\n	    </div>\n\n	    <div flex layout=\"row\" ng-repeat=\"individual in $ctrl.individuals | orderBy: \'firstName\'\" ui-sref=\"individualDetails({id: individual.id})\" class=\"body\">\n		<div flex=\"25\" class=\"truncate\">{{individual.name}}</div>\n		<div flex=\"30\" class=\"center\">{{individual.email}}</div>\n		<div flex=\"10\" class=\"center\">{{individual.phone}}</div>\n	    </div>\n	</md-card>\n    </div>\n    <div><md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.individuals.$page=$ctrl.individuals.$page - 1; $ctrl.individuals.$refresh()\">Previous</md-button><md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.individuals.$page = $ctrl.individuals.$page +1; $ctrl.individuals.$refresh()\">Next</md-button>\n</div></md-content>\n");
$templateCache.put("app/components/interactionTypesList/interactionTypesList.html","<md-content>\n\n    <div class=\"padding\">\n        <div layout=\"row\" layout-align=\"center center\">\n            <h1>Interaction Types</h1>\n            <span flex></span>\n        </div>\n\n        <md-card>\n            <md-list>\n                <md-list-item ng-repeat=\"interactionType in $ctrl.interactionTypes | orderBy: \'name\'\">\n                    <div layout=\"row\">\n                        <span flex>{{interactionType.name}}</span>\n                    </div>\n\n                </md-list-item>\n            </md-list>\n        </md-card>\n    </div>\n</md-content>\n");
$templateCache.put("app/components/interactionsList/interactionsList.html","<md-content>\n\n    <div class=\"padding\">\n        <div layout=\"row\" layout-align=\"center center\">\n            <h1>Organization Interactions</h1>\n            <span flex></span>\n        </div>\n	<md-input-container>\n            <input type=\"text\" ng-model=\"$ctrl.searchText\" class=\"search\" placeholder=\"Name\" ng-change=\"$ctrl.interactions.$refresh({organization__name__icontains: $ctrl.searchText})\" autocomplete=\"off\">\n	</md-input-container>\n	<md-input-container>\n	    <label>Type</label>\n	    <md-select ng-model=\"$ctrl.interactionTypeFilter\" ng-change=\"$ctrl.changeFilters(\'interaction_type\', $ctrl.interactionTypeFilter)\" placeholder=\"Type\" aria-label=\"interaction type filter\">\n		<md-option value=\"\">ALL</md-option>\n		<md-option value=\"1\">Email</md-option>\n		<md-option value=\"2\">Facebook</md-option>\n		<md-option value=\"3\">LinkedIn</md-option>\n		<md-option value=\"4\">Twitter</md-option>\n		<md-option value=\"5\">Meeting</md-option>\n		<md-option value=\"6\">Event</md-option>\n		<md-option value=\"7\">Phone</md-option>\n		<md-option value=\"8\">Skype</md-option>\n	    </md-select>\n	</md-input-container>\n	<md-input-container>\n	    <label>First Interaction</label>\n	    <md-select ng-model=\"$ctrl.firstFilter\" ng-change=\"$ctrl.changeFilters(\'first_interaction\', $ctrl.firstFilter)\" placeholder=\"First Interaction\" aria-label=\"first interaction filter\">\n		<md-option value=\"\">ALL</md-option>\n		<md-option value=\"1\">First Interaction</md-option>\n		<md-option value=\"0\">Follow Up</md-option>\n	    </md-select>\n	</md-input-container>\n\n	<md-input-container>\n	    <label>Email Read</label>\n	    <md-select ng-model=\"$ctrl.isOpenFilter\" ng-change=\"$ctrl.changeFilters(\'email__is_open\', $ctrl.isOpenFilter)\" placeholder=\"Email Read\" aria-label=\"email read filter\">\n		<md-option value=\"\">ALL</md-option>\n		<md-option value=\"0\">Email Unread</md-option>\n		<md-option value=\"1\">Email Read</md-option>\n	    </md-select>\n	</md-input-container>\n	<md-input-container>\n            <input type=\"text\" ng-model=\"$ctrl.searchEmailTo\" class=\"search\" placeholder=\"Email To\" ng-change=\"$ctrl.interactions.$refresh({email__to__icontains: $ctrl.searchEmailTo})\" autocomplete=\"off\">\n	</md-input-container>\n	<md-input-container>\n            <input type=\"text\" ng-model=\"$ctrl.searchPixel\" class=\"search\" placeholder=\"Pixel\" ng-change=\"$ctrl.interactions.$refresh({email__pixel__icontains: $ctrl.searchPixel})\" autocomplete=\"off\">\n	</md-input-container>\n\n	<md-card>\n	    <div flex layout=\"row\" style=\"font-size: 12px; color: #bbb; padding: 20px 15px 20px 15px; border-bottom: 1px solid #e0e0e0\">\n		<div flex=\"20\">Name</div>\n		<div flex=\"10\" style=\"text-align: center\">Type</div>\n		<div flex=\"10\" style=\"text-align: center\">Opened</div>\n		<div flex=\"5\">First</div>\n		<div flex=\"10\" style=\"text-align: center\">Interacted At</div>\n		<div flex=\"20\" style=\"text-align: left\">To</div>\n		<div flex=\"10\" style=\"text-align: center\">Pixel</div>\n		<div flex=\"15\" style=\"text-align: center\">Last Interaction</div>\n	    </div>\n\n\n	    <div flex layout=\"row\" ng-repeat=\"interaction in $ctrl.interactions\" style=\"padding: 10px; font-size: 13px; border-bottom: 1px solid #e0e0e0; color: #000000de; padding: 15px\">\n		<div flex=\"20\" style=\"white-space: nowrap; overflow: hidden; text-overflow: ellipsis; padding-right: 15px\">\n		    <a ui-sref=\"organizationDetails({id: interaction.$_(\'org\').id})\">\n			{{interaction.$_(\'org\').name}}\n		    </a>\n		</div>\n		<div flex=\"10\" style=\"text-align: center\">{{interaction.$_(\'tt\').name}}</div>\n		<div flex=\"10\" style=\"text-align: center\">\n		    <md-icon style=\"cursor: pointer; font-size: 15px !important; color: #ccc; outline: none\" ng-if=\"interaction.email && !interaction.$_(\'email\').isOpen\">\n			check\n			<md-tooltip>Not Opened Yet</md-tooltip>\n		    </md-icon>\n		    <md-icon style=\"cursor: pointer; font-size: 15px !important; color: green; outline: none\" ng-if=\"interaction.email && interaction.$_(\'email\').isOpen\">\n			check\n			<md-tooltip>\n			    Opened {{interaction.$_(\'email\').count}} times. First opened at {{interaction.$_(\'email\').openAt | amDateFormat:\'DD-MM-YYYY HH:mm:ss\'}}\n			</md-tooltip>\n		    </md-icon>\n		</div>\n		<div flex=\"5\">\n		    <md-icon ng-if=\"interaction.firstInteraction\" style=\"cursor: pointer; font-size: 15px !important; color: #F7D342; outline: none\">\n			star\n			<md-tooltip>This is the first interaction</md-tooltip>\n		    </md-icon>\n		    <md-icon ng-if=\"!interaction.firstInteraction\" style=\"cursor: pointer; font-size: 15px !important; color: #ccc; outline: none\">\n			star\n			<md-tooltip>This is a follow up interaction</md-tooltip>\n		    </md-icon>\n		</div>\n		<div flex=\"10\" style=\"text-align: center\">{{interaction.interactedAt | amDateFormat:\'DD-MM-YYYY\'}}</div>\n		<div flex=\"20\" style=\"text-align: left\">{{interaction.$_(\'email\').to}}</div>\n		<div flex=\"10\" style=\"text-align: center\">\n		    <md-icon style=\"cursor: pointer; font-size: 15px !important; color: #ccc; outline: none\" ng-if=\"interaction.$_(\'email\').pixel\">\n			trending_up\n			<md-tooltip>{{interaction.$_(\'email\').pixel}}</md-tooltip>\n		    </md-icon>\n		</div>\n		<div flex=\"15\" style=\"text-align: center\">{{interaction.$_(\'org\').lastInteraction | amDateFormat:\'DD-MM-YYYY\'}}</div>\n	    </div>\n\n        </md-card>\n	<div style=\"float: right; font-size: 13px; color: #4a4a4a; margin-right: 25px\">{{$ctrl.interactions.$totalCount}} items</div>\n\n	<div>\n	    <paginator collection=\"$ctrl.interactions\">\n	</div>\n    </div>\n</md-content>\n");
$templateCache.put("app/components/mediaDetails/mediaDetails.html","<md-content ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 300, \'blur\': 0}, updateOnDefault: true}\" layout=\"row\" layout-wrap layout-align=\"space-around stretch\">\n\n    <md-card flex>\n	<md-card-header>\n	    <md-card-title>\n		Media\n	    </md-card-title>\n	</md-card-header>\n	<md-card-content>\n	    <p>id: {{$ctrl.media.id}}</p>\n	    <p>title: {{$ctrl.media.title}}</p>\n	    <p>link: <a href=\"{{$ctrl.media.link}}\" target=\"_blank\">{{$ctrl.media.link}}</a></p>\n	    <p>organization: {{$ctrl.media.$_(\'organization\').name}}</p>\n	    <p>created: {{$ctrl.media.created | amDateFormat:\'DD-MM-YYYY\'}}</p>\n	</md-card-content>\n    </md-card>\n</md-content>\n");
$templateCache.put("app/components/mediaList/mediaList.html","<md-content>\n\n    <div class=\"padding\">\n        <div layout=\"row\" layout-align=\"center center\">\n            <h1>Media Reader</h1>\n            <span flex></span>\n	    <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.displayNewMediaModal()\">\n                <md-icon>add</md-icon>\n                Add Media\n            </md-button>\n        </div>\n\n	<md-input-container>\n            <input type=\"text\" ng-model=\"$ctrl.searchTitle\" ng-model-options=\"{debounce : 500}\" class=\"search\" placeholder=\"Title\" ng-change=\"$ctrl.medias.$refresh({title__icontains: $ctrl.searchTitle})\" autocomplete=\"off\">\n	</md-input-container>\n\n	<md-input-container>\n            <input type=\"text\" ng-model=\"$ctrl.searchLink\" ng-model-options=\"{debounce : 500}\" class=\"search\" placeholder=\"Link\" ng-change=\"$ctrl.medias.$refresh({link__icontains: $ctrl.searchLink})\" autocomplete=\"off\">\n	</md-input-container>\n	<md-input-container>\n            <input type=\"text\" ng-model=\"$ctrl.searchOrganization\" ng-model-options=\"{debounce : 500}\" class=\"search\" placeholder=\"Organization\" ng-change=\"$ctrl.medias.$refresh({organization__name__icontains: $ctrl.searchOrganization})\" autocomplete=\"off\">\n	</md-input-container>\n	<md-input-container>\n	    <label>Read</label>\n	    <md-select ng-model=\"$ctrl.readFilter\" ng-change=\"$ctrl.changeFilters(\'read\', $ctrl.readFilter)\" aria-label=\"read filter\">\n		<md-option value=\"\">ALL</md-option>\n		<md-option value=\"0\">Not Read</md-option>\n		<md-option value=\"1\">Read</md-option>\n		<md-option value=\"2\">Read Later</md-option>\n	    </md-select>\n	</md-input-container>\n\n\n	<md-card>\n	    <div flex layout=\"row\" style=\"font-size: 12px; color: #bbb; padding: 20px 15px 20px 15px; border-bottom: 1px solid #e0e0e0\">\n		<div flex=\"5\">ID</div>\n		<div flex=\"45\">Title</div>\n		<div flex=\"5\">Link</div>\n		<div flex=\"10\" style=\"text-align: center\">Category</div>\n		<div flex=\"10\" style=\"text-align: center\">Created</div>\n		<div flex=\"10\" style=\"text-align: center\">Organization</div>\n		<div flex=\"10\" style=\"text-align: center\">Read</div>\n		<div flex=\"5\" style=\"text-align: center\"></div>\n	    </div>\n\n\n	    <div flex layout=\"row\" ng-repeat=\"media in $ctrl.medias\" style=\"padding: 10px; font-size: 13px; border-bottom: 1px solid #e0e0e0; color: #000000de; padding: 15px\">\n		<div flex=\"5\">\n		    <a ui-sref=\"mediaDetails({id: media.id})\">\n			{{media.id}}\n		    </a>\n		</div>\n		    <div flex=\"45\" style=\"white-space: nowrap; overflow: hidden; text-overflow: ellipsis; padding-right: 15px\">\n		    <span>{{media.title}}</span>\n		    <span ng-if=\"!media.title\">-</span>\n		</div>\n		<div flex=\"5\" style=\"white-space: nowrap; overflow: hidden; text-overflow: ellipsis\">\n		    <a href=\"{{media.link}}\" rel=\"noopener noreferrer\" target=\"_blank\">\n			<md-icon>open_in_new</md-icon>\n			<md-tooltip>\n			    {{media.link}}\n			</md-tooltip>\n		    </a>\n		</div>\n		<div flex=\"10\" style=\"text-align: center\" cg-busy=\"media.$category.$promise\">\n		    {{media.$_(\'category\').name}}\n		</div>\n		<div flex=\"10\" style=\"text-align: center\">{{media.created | amDateFormat:\'DD-MM-YYYY\'}}</div>\n		<div flex=\"10\" style=\"white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center\" cg-busy=\"media.$organization.$promise\">\n		    <a ui-sref=\"organizationDetails({id: media.$organization.id})\">\n			{{media.$_(\'organization\').name}}\n		    </a>\n		</div>\n		<div flex=\"10\" style=\"text-align: center\">\n		    <md-icon style=\"outline: none; cursor: pointer\" ng-style=\"$ctrl.getStyle(media)\" ng-click=\"$ctrl.toogleRead(media)\">\n			done\n		    </md-icon>\n		</div>\n		<div flex=\"5\">\n		    <a href=\"#\" ng-click=\"$ctrl.displayNewMediaModal(media)\">\n			<md-icon>\n			    edit\n			    <md-tooltip>Delete Media Item</md-tooltip>\n			</md-icon>\n		    </a>\n		    <a href=\"#\" ng-click=\"media.$destroy()\" style=\"margin-left: 15px\">\n		    <md-icon>\n			delete\n			<md-tooltip>Delete Media Item</md-tooltip>\n		    </md-icon>\n		    </a>\n		</div>\n	    </div>\n        </md-card>\n	<div style=\"float: right; font-size: 13px; color: #4a4a4a; margin-right: 25px\">{{$ctrl.medias.$totalCount}} items</div>\n\n\n	<div>\n	    <paginator collection=\"$ctrl.medias\">\n	</div>\n    </div>\n</md-content>\n");
$templateCache.put("app/components/mediaSelector/mediaSelector.html","<md-dialog aria-label=\"List dialog\">\n    <md-dialog-content class=\"md-dialog-content\" cg-busy=\"selectedMedia.$promise\">\n\n        <div layout=\"row\" layout-align=\"center center\" style=\"margin-bottom: 20px\">\n            <h1 style=\"margin: 0\">Select Media Resource</h1>\n            <span flex></span>\n            <md-button ng-click=\"closeDialog()\" class=\"md-icon-button\" style=\"margin-left: 20px\">\n                <md-icon>close</md-icon>\n            </md-button>\n        </div>\n\n        <div layout=\"row\" layout-align=\"center center\" class=\"show-images\" ng-if=\"medias.length>0\" layout-wrap>\n            <div layout=\"column\" layout-align=\"center center\" ng-repeat=\"image in medias\" class=\"image-preview\">\n                <img ng-src=\"{{image.file | mediaUrl}}\" style=\"max-width:400px\" ng-click=\"selectMedia(image.file);\" ng-dblclick=\"sendSelectedMedia()\">\n            </div>\n        </div>\n\n        <div layout=\"row\" ng-if=\"!medias.length\">\n            <h3 class=\"text-center text-fade\">\n                No media resource available\n            </h3>\n        </div>\n\n\n        <div layout=\"row\" layout-align=\"center center\">\n            <md-button class=\"md-raised md-accent\" ng-click=\"sendSelectedMedia()\">Select Media</md-button>\n            <md-button class=\"md-raised md-accent\" ng-click=\"sendSelectedMedia()\" disabled=\"disabled\" ng-if=\"!medias.length\">Select Media</md-button>\n        </div>\n\n    </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/components/municipalitiesList/municipalitiesList.html","<md-content>\n\n    <div class=\"padding\">\n        <div layout=\"row\" layout-align=\"center center\">\n            <h1>Municipalities</h1>\n            <span flex></span>\n        </div>\n\n	<md-card>\n	    <div flex layout=\"row\" style=\"font-size: 12px; color: #bbb; padding: 20px 15px 20px 15px; border-bottom: 1px solid #e0e0e0\">\n		<div flex=\"50\">Name</div>\n		<div flex=\"5\"></div>\n		<div flex=\"10\" style=\"text-align: center\"></div>\n		<div flex=\"10\" style=\"text-align: center\"></div>\n		<div flex=\"10\" style=\"text-align: center\"></div>\n		<div flex=\"10\" style=\"text-align: center\"></div>\n		<div flex=\"5\" style=\"text-align: center\"></div>\n	    </div>\n\n\n	    <div flex layout=\"row\" ng-repeat=\"municipality in $ctrl.municipalities\" style=\"padding: 10px; font-size: 13px; border-bottom: 1px solid #e0e0e0; color: #000000de; padding: 15px\">\n		<div flex=\"50\" style=\"white-space: nowrap; overflow: hidden; text-overflow: ellipsis; padding-right: 15px\">\n		    <a ui-sref=\"municipalityDetails({id: municipality.id})\">\n			<span>{{municipality.name}}</span>\n		    </a>\n		</div>\n		<div>\n		    {{municipality.$_(\'district\').name}}\n		</div>\n	    </div>\n        </md-card>\n	<div style=\"float: right; font-size: 13px; color: #4a4a4a; margin-right: 25px\">{{$ctrl.municipalities.$totalCount}} items</div>\n\n	<div>\n	    <paginator collection=\"$ctrl.municipalities\">\n	</div>\n    </div>\n</md-content>\n");
$templateCache.put("app/components/municipalityDetails/municipalityDetails.html","<md-content ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 300, \'blur\': 0}, updateOnDefault: true}\" layout=\"row\" layout-wrap layout-align=\"space-around stretch\">\n\n    <md-card flex>\n	<md-card-header>\n	    <md-card-title>\n		Configurações\n	    </md-card-title>\n	</md-card-header>\n	<md-card-content>\n	    <form>\n		<md-input-container class=\"md-block\">\n		    <label>Nome</label>\n		    <input type=\"text\" ng-model=\"$ctrl.municipality.name\" ng-change=\"$ctrl.municipality.$save([\'name\'])\">\n		</md-input-container>\n		<md-input-container class=\"md-block\" style=\"margin-top: 50px\">\n		    <label>Description</label>\n		    <textarea ng-model=\"$ctrl.municipality.description\" rows=\"5\" ng-change=\"$ctrl.municipality.$save([\'description\'])\"></textarea>\n		</md-input-container>\n	    </form>\n	</md-card-content>\n    </md-card>\n</md-content>\n");
$templateCache.put("app/components/ordering/ordering.html","<a href=\"#\" ng-click=\"$ctrl.toogle()\">\n    {{$ctrl.label}}\n    <md-icon ng-if=\"$ctrl.state && $ctrl.state == $ctrl.field\">arrow_drop_down</md-icon>\n    <md-icon ng-if=\"$ctrl.state && $ctrl.state != $ctrl.field\">arrow_drop_up</md-icon>\n</a>\n");
$templateCache.put("app/components/organizationDetails/organizationDetails.html","<md-content ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 1000, \'blur\': 0}, updateOnDefault: true}\" layout=\"row\" layout-wrap layout-align=\"space-around stretch\">\n\n    <h1 class=\"md-block\" flex=\"95\" layout=\"row\" layout-align=\"space-between center\">\n	<div flex=\"55\">\n	    <md-button class=\"md-icon-button\" aria-label=\"Back\" ng-click=\"$root.goBack();\">\n		<md-icon>arrow_back</md-icon>\n	    </md-button>\n	    {{$ctrl.organization.name}}\n	</div>\n	<div flex=\"40\">\n	    <rankings organization=\"$ctrl.organization\">\n	</div>\n	<div flex=\"5\">\n	    <md-button class=\"md-icon-button\" aria-label=\"Back\" ng-click=\"$ctrl.deleteOrganization();\" style=\"float: right\">\n		<md-icon>delete</md-icon>\n	    </md-button>\n	</div>\n    </h1>\n\n    <md-card flex=\"30\">\n	<md-card-header>\n	    <md-card-title>\n		Details\n	    </md-card-title>\n	    <profile-level level=\"$ctrl.organization.profileLevel\">\n	</profile-level></md-card-header>\n	<md-card-content>\n	    <md-input-container class=\"md-block organization-detail\">\n                <label>Name</label>\n                <textarea ng-model=\"$ctrl.organization.name\" ng-change=\"$ctrl.organization.$save([\'name\'])\" md-maxlength=\"1024\"></textarea>\n		<div style=\"position: absolute; top: -10px; right: 0\" ng-if=\"$ctrl.organization.name\">\n		    <md-menu md-position-mode=\"target-right target\">\n			<md-button aria-label=\"search\" class=\"md-icon-button\" ng-mouseenter=\"$mdMenu.open()\">\n			    <md-icon md-menu-origin style=\"font-size: 15px !important; color: #4a4a4a\">search</md-icon>\n			</md-button>\n			<md-menu-content width=\"2\">\n			    <md-menu-item>\n				<md-button ng-click=\"$ctrl.openQueryURL(\'https://www.racius.com/pesquisa/?q=\', $ctrl.organization.name)\">\n				    <md-icon>search</md-icon>\n				    Racius\n				</md-button>\n			    </md-menu-item>\n			    <md-menu-item>\n				<md-button ng-click=\"$ctrl.openQueryURL(\'http://www.hoovers.com/company-information/company-search.html?term=\', $ctrl.organization.name)\">\n				    <md-icon>search</md-icon>\n				    Hoovers\n				</md-button>\n			    </md-menu-item>\n			    <md-menu-item>\n				<md-button ng-click=\"$ctrl.googleSearch($ctrl.organization.name)\">\n				    <md-icon>search</md-icon>\n				    Google\n				</md-button>\n			    </md-menu-item>\n			    <md-menu-item>\n				<md-button ng-click=\"$ctrl.googleSearch($ctrl.organization.name, \'pt.linkedin.com\')\">\n				    <md-icon>search</md-icon>\n				    LinkedIn\n				</md-button>\n			    </md-menu-item>\n			    <md-menu-divider></md-menu-divider>\n			    <md-menu-item>\n				<md-button ng-click=\"$ctrl.googleSearch($ctrl.organization.name, \'portugueseshoes.pt\')\">\n				    <md-icon>search</md-icon>\n				    Portuguese Shoes\n				</md-button>\n			    </md-menu-item>\n			</md-menu-content>\n		    </md-menu>\n		</div>\n	    </md-input-container>\n	    <md-input-container class=\"md-block organization-detail\">\n                <label>Address</label>\n                <input type=\"text\" ng-model=\"$ctrl.organization.address\" ng-change=\"$ctrl.organization.$save([\'address\'])\">\n	    </md-input-container>\n\n	    <md-input-container class=\"md-block organization-detail\">\n                <label>Postal Code</label>\n                <input type=\"text\" ng-model=\"$ctrl.organization.zipCode\" ng-change=\"$ctrl.organization.$save([\'zipCode\'])\">\n	    </md-input-container>\n\n	    <md-input-container class=\"md-block organization-detail\">\n                <label>NIF</label>\n                <input type=\"text\" ng-model=\"$ctrl.organization.nif\" ng-change=\"$ctrl.organization.$save([\'nif\'])\">\n		<div style=\"position: absolute; top: -10px; right: 0\" ng-if=\"$ctrl.organization.name\">\n		    <md-menu md-position-mode=\"target-right target\">\n			<md-button aria-label=\"search\" class=\"md-icon-button\" ng-mouseenter=\"$mdMenu.open()\">\n			    <md-icon md-menu-origin style=\"font-size: 15px !important; color: #4a4a4a\">search</md-icon>\n			</md-button>\n			<md-menu-content width=\"2\">\n			    <md-menu-item>\n				<md-button ng-click=\"$ctrl.openQueryURL(\'https://www.racius.com/pesquisa/?q=\', $ctrl.organization.nif)\">\n				    <md-icon>search</md-icon>\n				    Racius\n				</md-button>\n			    </md-menu-item>\n			</md-menu-content></md-menu>\n		</div>\n	    </md-input-container>\n	    <md-input-container class=\"md-block organization-detail\">\n                <label>Legal Form</label>\n		<md-select placeholder=\"Legal Form\" ng-model=\"$ctrl.organization.legalForm\" ng-change=\"$ctrl.organization.$save([\'legalForm\'])\">\n		    <md-option value=\"ASSOCIATION\">Associação</md-option>\n		    <md-option value=\"PUBLIC\">Sociedade Anónima</md-option>\n		    <md-option value=\"SINGLE\">Sociedade Unipessoal</md-option>\n		    <md-option value=\"SHARE\">Sociedade por Quotas</md-option>\n		</md-select>\n	    </md-input-container>\n	    <md-input-container class=\"md-block organization-detail\">\n                <label>Status</label>\n		<md-select placeholder=\"Status\" ng-model=\"$ctrl.organization.status\" ng-change=\"$ctrl.organization.$save([\'status\'])\">\n		    <md-option value=\"ACTIVE\">Active</md-option>\n		    <md-option value=\"EXTINCT\">Extinct</md-option>\n		</md-select>\n	    </md-input-container>\n	    <md-input-container class=\"md-block organization-detail\">\n                <label>Control</label>\n		<md-select placeholder=\"Control\" ng-model=\"$ctrl.organization.control\" ng-change=\"$ctrl.organization.$save([\'control\'])\">\n		    <md-option value=\"INDEPENDENT\">Independent</md-option>\n		    <md-option value=\"SUBSIDIARY\">Subsidiary</md-option>\n		    <md-option value=\"PARENT\">Parent</md-option>\n		</md-select>\n	    </md-input-container>\n\n	    <md-input-container class=\"md-block organization-detail\">\n                <label>Phone</label>\n                <input type=\"text\" ng-model=\"$ctrl.organization.phone\" ng-change=\"$ctrl.organization.$save([\'phone\'])\">\n	    </md-input-container>\n	    <div style=\"margin-bottom: 25px; color: #ccc\">\n		{{$ctrl.organization.email}}\n		<md-tooltip>This is Temporary</md-tooltip>\n	    </div>\n	    <organization-emails organization=\"$ctrl.organization\" emails=\"$ctrl.organization.$emails\"></organization-emails>\n	    <md-input-container class=\"md-block organization-detail\">\n                <label>Foundation Year</label>\n                <input type=\"text\" ng-model=\"$ctrl.organization.foundation\" ng-change=\"$ctrl.organization.$save([\'foundation\'])\">\n	    </md-input-container>\n	    <md-input-container class=\"md-block organization-detail\">\n                <label>Size</label>\n                <input type=\"text\" ng-model=\"$ctrl.organization.rawSize\" ng-change=\"$ctrl.organization.$save([\'rawSize\'])\">\n	    </md-input-container>\n	    <md-input-container class=\"md-block organization-detail\">\n                <label>Turnover (in millions of €)</label>\n                <input type=\"text\" ng-model=\"$ctrl.organization.rawTurnover\" ng-change=\"$ctrl.organization.$save([\'rawTurnover\'])\">\n		<div style=\"position: absolute; top: -10px; right: 0\">\n		    <md-icon md-menu-origin style=\"font-size: 12px !important; color: gray; cursor: pointer; outline: none\" ng-click=\"$ctrl.convert(\'rawTurnover\')\">\n			euro\n			<md-tooltip>Convert to Euros</md-tooltip>\n		    </md-icon>\n		</div>\n	    </md-input-container>\n	    <md-input-container class=\"md-block organization-detail\">\n                <label>Net Income (in millions of €)</label>\n                <input type=\"text\" ng-model=\"$ctrl.organization.rawIncome\" ng-change=\"$ctrl.organization.$save([\'rawIncome\'])\">\n		<div style=\"position: absolute; top: -10px; right: 0\">\n		    <md-icon md-menu-origin style=\"font-size: 12px !important; color: gray; cursor: pointer; outline: none\" ng-click=\"$ctrl.convert(\'rawIncome\')\">\n			euro\n			<md-tooltip>Convert to Euros</md-tooltip>\n		    </md-icon>\n		</div>\n	    </md-input-container>\n\n	    <md-input-container class=\"md-block organization-detail\">\n		<label>Concelho</label>\n		<md-select placeholder=\"Municipality\" ng-model=\"$ctrl.organization.municipality\" ng-change=\"$ctrl.organization.$save([\'municipality\'])\">\n		    <md-option value=\"{{municipality.id}}\" ng-repeat=\"municipality in $ctrl.municipalities\">\n			{{municipality.name}}\n		    </md-option>\n		</md-select>\n		<div ng-click=\"$ctrl.zipcode = 1\" style=\"margin-left: 3px; margin-top: 10px; outline: none; cursor: pointer; font-size: 10px; color: #4a4a4a\" ng-if=\"!$ctrl.zipcode\">Zip Code</div>\n		<input type=\"text\" style=\"border: 0; background: transparent; margin-top: 10px; outline: none; font-size: 13px; color: #4a4a4a; padding: 2px\" size=\"6;\" ng-if=\"$ctrl.zipcode\" ng-model=\"$ctrl.zip\">\n		<a href=\"https://www.codigo-postal.pt/?cp4={{$ctrl.zip | limitTo:4}}&cp3={{$ctrl.zip | limitTo:3:5}}\" target=\"_blank\" rel=\"noopener noreferrer\" ng-if=\"$ctrl.zipcode\" style=\"font-size: 10px; color: #4a4a4a\">GO</a>\n	    </md-input-container>\n	</md-card-content>\n    </md-card>\n\n    <md-card flex=\"30\">\n	<md-card-header>\n	    <md-card-title>\n		Tags\n	    </md-card-title>\n	</md-card-header>\n	<md-card-content>\n	    <div ng-if=\"$ctrl.organization.$tags.length == 0\" style=\"font-size: 24px; color: #CCC; text-align: center\">\n		Sem etiquetas. Adiciona a primeira.\n	    </div>\n	    <div ng-repeat=\"tag in $ctrl.organization.$tags\" layout=\"row\" layout-align=\"start center\">\n		<span flex=\"60\">\n		    <a ui-sref=\"tagDetails({id: tag.$tag.id})\">\n			{{tag.$_(\'tag\').name}}\n		    </a>\n		</span>\n		<span flex=\"40\">\n		<a ng-click=\"tag.$destroy()\" class=\"md-button md-icon-button\">\n		    <md-icon>delete</md-icon>\n		</a>\n		</span>\n	    </div>\n	</md-card-content>\n	<md-card-footer>\n	    <searchable-selector items=\"$ctrl.tags\" search-placeholder=\"Search Tags\" search-items=\"$ctrl.tags.$refresh({name__icontains: searchText});\" select-item=\"$ctrl.onSelectTag($ctrl.organization, item)\">\n	    </searchable-selector>\n	</md-card-footer>\n    </md-card>\n\n    <md-card flex=\"30\">\n	<md-card-header>\n	    <md-card-title>\n		Notes\n	    </md-card-title>\n	</md-card-header>\n	<md-card-content>\n	    <div>\n		<div ng-repeat=\"comment in $ctrl.organization.$comments\">\n		    <comment data=\"comment\"></comment>\n		</div>\n\n	    </div>\n	</md-card-content>\n	<md-card-footer>\n	    <md-input-container style=\"width: 80%\">\n		<label>Nota</label>\n		<textarea ng-model=\"$ctrl.newCommentContent\" required md-maxlength=\"1024\"></textarea>\n	    </md-input-container>\n	    <md-button class=\"md-icon-button\" ng-click=\"$ctrl.createComment($ctrl.organization, $ctrl.newCommentContent)\">\n		<md-icon>\n		    add\n		    <md-tooltip>Adicionar Nota</md-tooltip>\n		</md-icon>\n	    </md-button>\n	</md-card-footer>\n    </md-card>\n\n\n    <md-card flex=\"30\">\n	<md-card-title>\n	    Links\n	</md-card-title>\n	<md-card-content>\n	    <related-links organization=\"$ctrl.organization\" links=\"$ctrl.organization.$links\" categories=\"$ctrl.categories\">\n	</md-card-content>\n    </md-card>\n\n\n    <md-card flex=\"30\">\n	<md-card-title>Individuals</md-card-title>\n	<md-card-content>\n	    <div>\n		<md-list>\n		    <md-list-item ng-repeat=\"organizationIndividual in $ctrl.organization.$organizationIndividuals\" layout=\"column\" layout-align=\"start start\" style=\"border-bottom: 1px solid #4a4a4a\">\n			<p><a ui-sref=\"individualDetails({id: organizationIndividual.$individual.id})\">{{organizationIndividual.$individual.name}}</a></p>\n			<p><span style=\"font-size: 12px\" ng-if=\"organizationIndividual.description\">({{organizationIndividual.description}})</span></p>\n			<p>\n			    <a ng-click=\"organizationIndividual.$destroy()\" class=\"md-button md-icon-button\">\n				<md-icon>\n				    delete</md-icon>\n			    </a>\n			    <a ng-click=\"$ctrl.editOrganizationIndividual($event, organizationIndividual)\" class=\"md-button md-icon-button\">\n				<md-icon>\n				    edit\n				</md-icon>\n			    </a>\n			    <a ng-click=\"$ctrl.generateEmails(organizationIndividual.$individual)\" class=\"md-button md-icon-button\">\n				<md-icon>\n				    power_settings_new\n				</md-icon>\n			    </a>\n			</p>\n		    </md-list-item>\n		</md-list>\n		<searchable-selector items=\"$ctrl.individuals\" search-placeholder=\"Search Individuals\" search-items=\"$ctrl.individuals.$refresh({name__icontains: searchText});\" select-item=\"$ctrl.onSelectIndividual($ctrl.organization, item)\" add-item=\"$ctrl.addIndividual(name)\">\n	    </div>\n	</md-card-content>\n    </md-card>\n\n    <md-card flex=\"30\">\n	<div>\n	    <p class=\"text-fade\">\n                Files (max. size 100MB)\n	    </p>\n	    <md-card cg-busy=\"$ctrl.organization.$files.$promise\">\n                <h3 class=\"text-center text-fade\" ng-if=\"!$ctrl.organization.$files.length\">\n		    Nenhum documento adicionado\n                </h3>\n\n                <table class=\"multi-table editable\">\n		    <tr ng-repeat=\"file in $ctrl.organization.$files\" cg-busy=\"file.$promise\">\n                        <td>\n			    <input type=\"text\" ng-model=\"file.name\" ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 1000, \'blur\': 0}, updateOnDefault: true}\" ng-change=\"file.$save()\">\n                        </td>\n                        <td class=\"minimun\">\n			    <a download href=\"{{::file.path | mediaUrl}}\" target=\"_blank\" class=\"md-button md-icon-button\" style=\"padding-top: 8px\">\n                                <md-icon aria-label=\"Download\">file_download</md-icon>\n			    </a>\n                        </td>\n                        <td class=\"minimun\">\n			    <md-button class=\"md-icon-button\" ng-click=\"file.$destroy()\">\n                                <md-icon>delete</md-icon>\n			    </md-button>\n                        </td>\n		    </tr>\n		    <tr>\n                        <td colspan=\"99\">\n			    <md-button ngf-select media-auto-upload ng-model=\"$ctrl.newFileAttachment\" ngf-model-invalid=\"$ctrl.invalidUploadedFiles\">\n                                <md-icon>file_upload</md-icon>\n                                adicionar documento\n			    </md-button>\n                        </td>\n		    </tr>\n                </table>\n	    </md-card>\n\n        </div>\n    </md-card>\n\n\n    <md-card flex=\"30\">\n	<md-card-header>\n	    <md-card-title>\n		Interações\n	    </md-card-title>\n	</md-card-header>\n	<md-card-content>\n            <md-list>\n                <md-list-item ng-repeat=\"interaction in $ctrl.organization.$interactions\" layout=\"column\" layout-align=\"center start\" class=\"organization-interaction\">\n                    <div>\n			<input type=\"text\" ng-model=\"interaction.description\" ng-change=\"interaction.$save([\'description\'])\" ng-if=\"interaction.editing\">\n			<p ng-if=\"!interaction.editing\">{{interaction.description}}</p>\n			<div layout=\"row\">\n			    <span>\n				{{interaction.$_(\'tt\').name}} | {{interaction.interactedAt | amDateFormat:\'DD-MM-YYYY\'}}\n				<md-icon ng-if=\"interaction.firstInteraction\" style=\"cursor: pointer; margin: 7px 0 0 5px;font-size: 15px !important; color: #F7D342; outline: none\" ng-click=\"$ctrl.toogleFirstInteraction(interaction)\">\n				    star\n				    <md-tooltip>This is the first interaction</md-tooltip>\n				</md-icon>\n				<md-icon ng-if=\"!interaction.firstInteraction\" style=\"cursor: pointer; margin: 7px 0 0 5px;font-size: 15px !important; color: #ccc; outline: none\" ng-click=\"$ctrl.toogleFirstInteraction(interaction)\">\n				    star\n				    <md-tooltip>This is a follow up interaction</md-tooltip>\n				</md-icon>\n				<md-icon style=\"cursor: pointer; margin: 7px 0 0 0; font-size: 15px !important; color: #ccc; outline: none\" ng-if=\"interaction.email && !interaction.$_(\'email\').isOpen\">\n				    check\n				    <md-tooltip>Not Opened Yet</md-tooltip>\n				</md-icon>\n				<md-icon style=\"cursor: pointer; margin: 7px 0 0 0; font-size: 15px !important; color: green; outline: none\" ng-if=\"interaction.email && interaction.$_(\'email\').isOpen\">\n				    check\n				    <md-tooltip>\n					Opened {{interaction.$_(\'email\').count}} times. First opened at {{interaction.$_(\'email\').openAt | amDateFormat:\'DD-MM-YYYY HH:mm:ss\'}}\n				    </md-tooltip>\n				</md-icon>\n				<md-icon style=\"cursor: pointer; margin: 7px 0 0 0; font-size: 15px !important; color: #ccc; outline: none\" ng-if=\"interaction.email\" ng-click=\"$ctrl.showEmail(interaction.email)\">\n				    more_horiz\n				    <md-tooltip>\n					More\n				    </md-tooltip>\n				</md-icon>\n			    </span>\n			    <span class=\"actions\">\n				<a href=\"#\" ng-click=\"interaction.editing = true\" class=\"md-button md-icon-button\" ng-if=\"!interaction.editing\"><md-icon>edit</md-icon></a>\n				<a href=\"#\" ng-click=\"interaction.editing = false\" class=\"md-button md-icon-button\" ng-if=\"interaction.editing\"><md-icon>cancel</md-icon></a>\n				<a href=\"#\" ng-click=\"interaction.$destroy()\" class=\"md-button md-icon-button\"><md-icon>delete</md-icon></a>\n			    </span>\n			</div>\n		    </div>\n                </md-list-item>\n            </md-list>\n\n\n\n\n	</md-card-content>\n	<md-card-footer>\n            <md-input-container class=\"md-block\">\n                <md-select ng-model=\"newInteractionType\" class=\"md-no-underline\">\n                    <md-select-header>\n                        <input ng-model=\"$ctrl.searchText\" type=\"search\" placeholder=\"Tipo Interação\" class=\"md-text task-project-select-search\" ng-change=\"$ctrl.interactionTypes.$refresh({name__icontains: $ctrl.searchText})\" ng-keydown=\"$event.stopPropagation();\" force-select-focus ng-model-options=\"{updateOnDefault: True, debounce: {\'default\': 500}}\">\n                    </md-select-header>\n                    <md-option ng-value=\"interactionType.id\" ng-repeat=\"interactionType in $ctrl.interactionTypes\" class=\"hide-icons\">\n                        <div layout=\"row\" layout-align=\"center center\">\n                            <span>{{interactionType.name}}</span>\n                        </div>\n                    </md-option>\n                </md-select>\n            </md-input-container>\n\n\n            <md-input-container class=\"md-block\">\n                <label>Descrição</label>\n                <textarea ng-model=\"$ctrl.newInteractionName\" required md-maxlength=\"1024\"></textarea>\n            </md-input-container>\n	    <md-button class=\"md-accent md-raised\" ng-click=\"$ctrl.createInteraction(newInteractionType, $ctrl.newInteractionName, $ctrl.newInteractionAt, $ctrl.newInteractionEmail)\" style=\"margin-bottom: 25px\">\n                Create Interaction\n            </md-button>\n	    <md-button class=\"md-accent md-raised\" style=\"margin-bottom: 25px\" ng-if=\"newInteractionType === 1\" ng-click=\"$ctrl.displayNewEmailModal()\">\n                Compose Email\n            </md-button>\n	    <div style=\"width: 100%\">\n		<mdp-date-picker mdp-placeholder=\"Date\" ng-model=\"$ctrl.newInteractionAt\"></mdp-date-picker>\n	    </div>\n\n	</md-card-footer>\n    </md-card>\n\n    <md-card flex=\"30\">\n	<md-card-title>\n	    Economic Activities\n	</md-card-title>\n	<md-card-content>\n	    <div>\n		<md-list>\n		    <md-list-item ng-repeat=\"economicActivity in $ctrl.organization.$economicActivities\" layout=\"row\">\n			<p style=\"font-size: 13px\">\n			    {{economicActivity.$_(\'economicActivity\').code}} - {{economicActivity.$economicActivity.name}}\n			    <a ng-click=\"economicActivity.$destroy()\" class=\"md-button md-icon-button\"><md-icon>delete</md-icon></a>\n			</p>\n		    </md-list-item>\n		</md-list>\n		<searchable-selector items=\"$ctrl.economicActivities\" search-placeholder=\"Search Economic Activities\" search-items=\"$ctrl.economicActivities.$refresh({name__icontains: searchText});\" select-item=\"$ctrl.onSelectIndustry($ctrl.organization, item)\" display=\"$ctrl.displayForEconomicActivities(item)\">\n	    </div>\n	</md-card-content>\n    </md-card>\n\n    <md-card flex=\"30\">\n	<md-card-title>\n	    Target\n	</md-card-title>\n	<md-card-content>\n\n	    <md-input-container class=\"md-block organization-detail\">\n		<label>State</label>\n		<md-select placeholder=\"Target State\" ng-model=\"$ctrl.organization.targetState\" ng-change=\"$ctrl.organization.$save([\'targetState\'])\">\n		    <md-option value=\"UNDEFINED\">Not Defined Yet</md-option>\n		    <md-option value=\"NOT_A_TARGET\">Not a Target</md-option>\n		    <md-option value=\"PAST_TARGET\">Past Target</md-option>\n		    <md-option value=\"CURRENT_TARGET\">Current Target</md-option>\n		    <md-option value=\"FUTURE_TARGET\">Future Target</md-option>\n		</md-select>\n	    </md-input-container>\n\n	    <md-input-container class=\"md-block organization-detail\">\n		<label>Score</label>\n		<md-select placeholder=\"Target Score\" ng-model=\"$ctrl.organization.targetScore\" ng-change=\"$ctrl.organization.$save([\'targetScore\'])\">\n		    <md-option value=\"1\">1</md-option>\n		    <md-option value=\"2\">2</md-option>\n		    <md-option value=\"3\">3</md-option>\n		    <md-option value=\"4\">4</md-option>\n		    <md-option value=\"5\">5</md-option>\n		</md-select>\n	    </md-input-container>\n\n	    <h5>Score Guidelines (source: solo-sales-presentation)</h5>\n	    <ol style=\"margin-bottom: 50px; padding-inline-start: 1em; font-size: 14px\">\n		<li>Size</li>\n		<li>Mindset</li>\n		<li>Commitment</li>\n		<li>Long-term engagement</li>\n	    </ol>\n\n	    <md-input-container style=\"width: 100%\">\n		<label>Interaction State Summary</label>\n		<textarea ng-model=\"$ctrl.organization.interactionStateSummary\" ng-change=\"$ctrl.organization.$save([\'interactionStateSummary\'])\"></textarea>\n	    </md-input-container>\n	</md-card-content>\n    </md-card>\n\n\n    <md-card flex=\"30\">\n	<md-card-title>\n	    Organization Site Visits\n	</md-card-title>\n	<h3 class=\"text-center text-fade\" ng-if=\"!$ctrl.organization.$siteVisits.length\">\n	    No site visits from this organization.\n        </h3>\n	<md-card-content>\n	    <div>\n		<div ng-repeat=\"visit in $ctrl.organization.$siteVisits\" class=\"site-visits\">\n		    <p><b>from</b> {{visit.ip}} <b>on</b> {{visit.time | amDateFormat:\'DD-MM-YYYY HH:mm:ss\'}}</p>\n		    <p><b>visited path</b> {{visit.path}}</p>\n		    <p><b>refered</b> {{visit.referer}}</p>\n		    <hr>\n		</div>\n	    </div>\n\n	</md-card-content>\n    </md-card>\n\n    <md-card flex=\"30\">\n	<md-card-title>\n	    Organization Domains\n	</md-card-title>\n	<md-card-content>\n	    <div ng-repeat=\"domain in $ctrl.organization.$domains\" class=\"site-visits\">\n		{{domain.domain}}\n	    </div>\n	</md-card-content>\n    </md-card>\n\n    <md-card flex=\"30\">\n	<md-card-title>\n	    Organization IPS\n	</md-card-title>\n	<md-card-content>\n	    <div ng-repeat=\"read in $ctrl.organization.$_(\'emailInteractionReads\') | unique:\'ip\'\">\n		{{read.ip}}\n	    </div>\n	</md-card-content>\n    </md-card>\n\n\n    <autocompletes organization=\"$ctrl.organization\" complete=\"$ctrl.autocomplete(completion)\">\n</autocompletes></md-content>\n");
$templateCache.put("app/components/organizationDetails/organizationIndividual.tmpl.html","<div role=\"dialog\" aria-label=\"Detalhes\" layout=\"column\" layout-align=\"center center\" style=\"padding-top: 25px; background-color: #fff; width: 500px; height: 450px\">\n    <div>\n        <md-input-container class=\"md-block\" style=\"padding: 25px\">\n            <label>Name</label>\n            <input ng-model=\"$ctrl.individual.$individual.name\" ng-change=\"$ctrl.individual.$individual.$save([\'name\'])\">\n        </md-input-container>\n	<md-input-container class=\"md-block\" style=\"padding: 25px\">\n            <label>Description</label>\n            <input ng-model=\"$ctrl.individual.description\" ng-change=\"$ctrl.individual.$save([\'description\'])\" ng-model-options=\"{updateOnDefault: True, debounce: {\'default\': 300}}\">\n        </md-input-container>\n    </div>\n</div>\n");
$templateCache.put("app/components/organizationEmail/organizationEmail.html","<md-input-container class=\"md-block organization-detail\">\n    <label>Email</label>\n    <input type=\"text\" autocomplete=\"off\" ng-model=\"$ctrl.email.email\" ng-disabled=\"$ctrl.email.email\" ng-change=\"$ctrl.email.$save([\'email\'])\" style=\"color: currentColor\">\n    <div style=\"position: absolute; top: -10px; right: 0\">\n	<md-icon md-menu-origin style=\"font-size: 15px !important; color: #4a4a4a\" ng-if=\"$ctrl.fetching\">more_horiz</md-icon>\n\n\n	<md-button class=\"md-icon-button\" ng-click=\"$ctrl.email.$destroy()\" aria-label=\"destroy email contact\">\n	    <md-icon md-menu-origin style=\"font-size: 15px !important; color: #9a9a9a; margin-right: -10px\" ng-if=\"!$ctrl.fetching\">\n		delete\n	    </md-icon>\n	</md-button>\n	<md-icon md-menu-origin style=\"font-size: 15px !important; color: green\" ng-if=\"$ctrl.email.validationCode === \'OK\'\">\n	    done\n	    <md-tooltip>{{$ctrl.email.validationCode}} {{$ctrl.email.validationCodeDate | amDateFormat:\'DD-MM-YYYY\'}}</md-tooltip>\n	</md-icon>\n	<md-icon md-menu-origin style=\"font-size: 15px !important; color: #ffd147\" ng-if=\"$ctrl.email.validationCode === \'CATCH_ALL\'\">\n	    warning\n	    <md-tooltip>{{$ctrl.email.validationCode}} {{$ctrl.email.validationCodeDate | amDateFormat:\'DD-MM-YYYY\'}}</md-tooltip>\n	</md-icon>\n	<md-icon md-menu-origin style=\"font-size: 15px !important; color: #ffd147\" ng-if=\"$ctrl.email.validationCode === \'UNKNOWN\'\">\n	    priority_high\n	    <md-tooltip>{{$ctrl.email.validationCode}} {{$ctrl.email.validationCodeDate | amDateFormat:\'DD-MM-YYYY\'}}</md-tooltip>\n	</md-icon>\n	<md-icon md-menu-origin style=\"font-size: 15px !important; color: red\" ng-if=\"$ctrl.email.validationCode === \'INVALID\'\">\n	    block\n	    <md-tooltip>{{$ctrl.email.validationCode}} {{$ctrl.email.validationCodeDate | amDateFormat:\'DD-MM-YYYY\'}}</md-tooltip>\n	</md-icon>\n	<md-icon md-menu-origin style=\"font-size: 15px !important; color: #ffd147\" ng-if=\"$ctrl.email.validationCode === \'DISPOSABLE\'\">\n	    warning\n	    <md-tooltip>{{$ctrl.email.validationCode}} {{$ctrl.email.validationCodeDate | amDateFormat:\'DD-MM-YYYY\'}}</md-tooltip>\n	</md-icon>\n	<md-icon md-menu-origin style=\"font-size: 15px !important; color: #4a4a4a\" ng-if=\"$ctrl.email.validationCode === \'ERROR\'\">\n	    timelapse\n	    <md-tooltip>PENDING {{$ctrl.email.validationCodeDate | amDateFormat:\'DD-MM-YYYY\'}}</md-tooltip>\n	</md-icon>\n	<md-icon md-menu-origin style=\"font-size: 15px !important; cursor: pointer; outline: none\" ng-click=\"$ctrl.toogleVerified()\" ng-style=\"{color: $ctrl.email.verified ? \'#006090\' : \'#9a9a9a\'}\">\n	    check_circle_outline\n	    <md-tooltip>Verified State</md-tooltip>\n	</md-icon>\n    </div>\n\n</md-input-container>\n");
$templateCache.put("app/components/organizationEmails/organizationEmails.html","<div ng-repeat=\"email in $ctrl.emails\">\n    <organization-email email=\"email\">\n</div>\n<md-input-container class=\"md-block organization-detail\">\n    <label>Email</label>\n    <input type=\"text\" autocomplete=\"off\" style=\"color: currentColor\" ng-model=\"$ctrl.newEmail\" ng-change=\"$ctrl.emailUpdated()\">\n    <div style=\"position: absolute; top: -10px; right: 0\">\n	<md-icon md-menu-origin style=\"font-size: 15px !important; color: #4a4a4a\" ng-if=\"$ctrl.fetching\">more_horiz</md-icon>\n    </div>\n</md-input-container>\n");
$templateCache.put("app/components/organizationsList/organizationsList.html","<md-content>\n\n    <div class=\"padding\">\n        <div layout=\"row\" layout-align=\"center center\">\n            <h1>Organizations</h1>\n            <span flex></span>\n            <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.displayNewOrganizationModal()\">\n                <md-icon>add</md-icon>\n                Add Organization\n            </md-button>\n        </div>\n\n	<div>\n	    <div layout=\"row\" layout-align=\"end center\">\n		<div layout=\"column\" layout-align=\"center center\">\n		    <md-button class=\"md-icon\" ng-click=\"$root.switchWorkspace(1)\">\n			<md-icon class=\"workspace-selector-icon\">\n			    desktop_windows\n			</md-icon>\n		    </md-button>\n		    <span style=\"font-size: 10px; color: #4a4a4a\">Workspace 1</span>\n		</div>\n		<div layout=\"column\" layout-align=\"center center\">\n		    <md-button class=\"md-icon\" ng-click=\"$root.switchWorkspace(2)\">\n			<md-icon class=\"workspace-selector-icon\">\n			    desktop_windows\n			</md-icon>\n		    </md-button>\n		    <span style=\"font-size: 10px; color: #4a4a4a\">Workspace 2</span>\n		</div>\n		<div layout=\"column\" layout-align=\"center center\">\n		    <md-button class=\"md-icon\" ng-click=\"$root.switchWorkspace(3)\">\n			<md-icon class=\"workspace-selector-icon\">\n			    desktop_windows\n			</md-icon>\n		    </md-button>\n		    <span style=\"font-size: 10px; color: #4a4a4a\">Workspace 3</span>\n		</div>\n	    </div>\n	</div>\n\n	<div class=\"my-filter-bar\" cg-busy=\"$root.workspace.$promise\">\n\n	    <!-- filter -->\n	    <md-input-container ng-if=\"$root.workspace.settings.organizationsFilters.name\">\n		<input type=\"text\" ng-model=\"$ctrl.searchText\" class=\"search\" placeholder=\"Name\" ng-change=\"$ctrl.organizations.$refresh({name__icontains: $ctrl.searchText})\" autocomplete=\"off\">\n	    </md-input-container>\n\n	    <!-- filter -->\n	    <md-input-container ng-if=\"$root.workspace.settings.organizationsFilters.client\">\n		<md-select ng-model=\"$ctrl.isClientFilter\" ng-change=\"$ctrl.changeFilters(\'is_client\', $ctrl.isClientFilter)\" aria-label=\"foundation filter format\">\n		    <md-option value=\"\">All</md-option>\n		    <md-option value=\"true\">Only Clients</md-option>\n		</md-select>\n\n	    </md-input-container>\n\n	    <!-- filter -->\n	    <md-input-container ng-if=\"$root.workspace.settings.organizationsFilters.nif\">\n		<input type=\"text\" class=\"search\" ng-model=\"$ctrl.searchNif\" placeholder=\"NIF\" ng-change=\"$ctrl.organizations.$refresh({nif: $ctrl.searchNif})\">\n	    </md-input-container>\n\n	    <!-- filter -->\n	    <md-input-container style=\"margin-right: -8px\" ng-if=\"$root.workspace.settings.organizationsFilters.year\">\n		<md-select ng-model=\"$ctrl.filterYearFormat\" ng-change=\"$ctrl.changeFilters($ctrl.filterYearFormat, $ctrl.filterYear)\" aria-label=\"foundation filter format\">\n		    <md-option value=\"foundation__lt\">&lt;</md-option>\n		    <md-option value=\"foundation\">=</md-option>\n		    <md-option value=\"foundation__gt\">&gt;</md-option>\n		</md-select>\n	    </md-input-container>\n	    <md-input-container ng-if=\"$root.workspace.settings.organizationsFilters.year\">\n		<input type=\"text\" ng-model=\"$ctrl.filterYear\" ng-change=\"$ctrl.changeFilters($ctrl.filterYearFormat, $ctrl.filterYear)\" placeholder=\"Ano\">\n	    </md-input-container>\n\n	    <!-- filter -->\n	    <md-input-container ng-if=\"$root.workspace.settings.organizationsFilters.profileLevel\">\n		<label>Profile Level</label>\n		<md-select ng-model=\"$ctrl.profileLevelFilter\" ng-change=\"$ctrl.changeFilters(\'profile_level\', $ctrl.profileLevelFilter)\" placeholder=\"Profile Level\" aria-label=\"profile level filter\">\n		    <md-option value=\"\">TODOS</md-option>\n		    <md-option value=\"0\">-</md-option>\n		    <md-option value=\"1\">1</md-option>\n		    <md-option value=\"2\">2</md-option>\n		    <md-option value=\"3\">3</md-option>\n		    <md-option value=\"4\">4</md-option>\n		    <md-option value=\"5\">5</md-option>\n		</md-select>\n	    </md-input-container>\n\n	    <!-- filter -->\n	    <md-input-container ng-if=\"$root.workspace.settings.organizationsFilters.interactions\">\n		<label>Interactions</label>\n		<md-select ng-model=\"$ctrl.interactionFilter\" ng-change=\"$ctrl.changeFilters(\'interactions\', $ctrl.interactionFilter)\" aria-label=\"interactions filter\">\n		    <md-option value=\"\">TODOS</md-option>\n		    <md-option value=\"0\">-</md-option>\n		    <md-option value=\"1\">1</md-option>\n		    <md-option value=\"2\">2</md-option>\n		    <md-option value=\"3\">3</md-option>\n		    <md-option value=\"4\">4</md-option>\n		    <md-option value=\"5\">5</md-option>\n		    <md-option value=\"6\">6</md-option>\n		    <md-option value=\"7\">7</md-option>\n		    <md-option value=\"8\">8</md-option>\n		    <md-option value=\"9\">9</md-option>\n		    <md-option value=\"10\">10</md-option>\n		</md-select>\n	    </md-input-container>\n\n	    <!-- filter -->\n	    <md-input-container ng-if=\"$root.workspace.settings.organizationsFilters.people\">\n		<label>People</label>\n		<md-select ng-model=\"$ctrl.peopleFilter\" ng-change=\"$ctrl.changeFilters(\'people_count\', $ctrl.peopleFilter)\" aria-label=\"people filter\">\n		    <md-option value=\"\">TODOS</md-option>\n		    <md-option value=\"0\">-</md-option>\n		    <md-option value=\"1\">1</md-option>\n		    <md-option value=\"2\">2</md-option>\n		    <md-option value=\"3\">3</md-option>\n		    <md-option value=\"4\">4</md-option>\n		    <md-option value=\"5\">5</md-option>\n		    <md-option value=\"6\">6</md-option>\n		    <md-option value=\"7\">7</md-option>\n		    <md-option value=\"8\">8</md-option>\n		    <md-option value=\"9\">9</md-option>\n		    <md-option value=\"10\">10</md-option>\n		</md-select>\n	    </md-input-container>\n\n	    <!-- filter -->\n	    <md-input-container ng-if=\"$root.workspace.settings.organizationsFilters.size\">\n		<label>Dimensão</label>\n		<md-select ng-model=\"$ctrl.sizeFilter\" ng-change=\"$ctrl.changeFilters(\'size\', $ctrl.sizeFilter)\">\n		    <md-option value=\"\">TODOS</md-option>\n		    <md-option value=\"B\">1-10 colaboradores</md-option>\n		    <md-option value=\"C\">11-50 colaboradores</md-option>\n		    <md-option value=\"D\">51-200 colaboradores</md-option>\n		    <md-option value=\"E\">201-500 colaboradores</md-option>\n		    <md-option value=\"F\">501-1000 colaboradores</md-option>\n		    <md-option value=\"G\">1001-5000 colaboradores</md-option>\n		    <md-option value=\"H\">5001-10000 colaboradores</md-option>\n		    <md-option value=\"I\">10001+ colaboradores</md-option>\n		</md-select>\n	    </md-input-container>\n\n	    <!-- filter -->\n	    <md-input-container ng-if=\"$root.workspace.settings.organizationsFilters.turnover\">\n		<label>Volume Negócios</label>\n		<md-select ng-model=\"$ctrl.turnoverFilter\" ng-change=\"$ctrl.changeFilters(\'turnover\', $ctrl.turnoverFilter)\">\n		    <md-option value=\"\">TODOS</md-option>\n		    <md-option value=\"{{tier}}\" ng-repeat=\"tier in [\'A\', \'B\', \'C\', \'D\', \'E\', \'F\', \'G\', \'H\']\">{{tier | companyTurnovers}}</md-option>\n		</md-select>\n	    </md-input-container>\n\n	    <!-- filter -->\n	    <md-input-container ng-if=\"$root.workspace.settings.organizationsFilters.municipalityDistrict\">\n		<label>Distrito</label>\n		<md-select ng-model=\"$ctrl.districtFilter\" ng-change=\"$ctrl.changeFilters(\'municipality__district\', $ctrl.districtFilter)\">\n		    <md-option value=\"\">TODOS</md-option>\n		    <md-option value=\"{{district.id}}\" ng-repeat=\"district in $ctrl.districts\">{{district.name}}</md-option>\n		</md-select>\n	    </md-input-container>\n\n	    <!-- filter -->\n	    <md-input-container ng-if=\"$root.workspace.settings.organizationsFilters.municipality\">\n		<label>Concelho</label>\n		<md-select ng-model=\"$ctrl.municipalityFilter\" ng-change=\"$ctrl.changeFilters(\'municipality\', $ctrl.municipalityFilter)\">\n		    <md-option value=\"\">TODOS</md-option>\n		    <md-option value=\"{{municipality.id}}\" ng-repeat=\"municipality in $ctrl.municipalities\">{{municipality.name}}</md-option>\n		</md-select>\n	    </md-input-container>\n\n	    <!-- filter -->\n	    <md-input-container ng-if=\"$root.workspace.settings.organizationsFilters.tag\">\n		<label>Etiquetas</label>\n		<md-select ng-model=\"$ctrl.tagFilter\" ng-change=\"$ctrl.changeFilters(\'tag\', $ctrl.tagFilter)\">\n		    <md-option value=\"\">TODOS</md-option>\n		    <md-option value=\"{{tag.id}}\" ng-repeat=\"tag in $ctrl.tags\">{{tag.name}}</md-option>\n		</md-select>\n	    </md-input-container>\n\n	    <!-- filter -->\n	    <md-input-container ng-if=\"$root.workspace.settings.organizationsFilters.targetState\">\n		<label>Target State</label>\n		<md-select ng-model=\"$ctrl.targetStateFilter\" ng-change=\"$ctrl.changeFilters(\'target_state\', $ctrl.targetStateFilter)\" aria-label=\"target state filter\">\n		    <md-option value=\"\">TODOS</md-option>\n		    <md-option value=\"UNDEFINED\">Not Defined Yet</md-option>\n		    <md-option value=\"NOT_A_TARGET\">Not a Target</md-option>\n		    <md-option value=\"PAST_TARGET\">Past Target</md-option>\n		    <md-option value=\"CURRENT_TARGET\">Current Target</md-option>\n		    <md-option value=\"FUTURE_TARGET\">Future Target</md-option>\n		</md-select>\n	    </md-input-container>\n\n	    <!-- filter -->\n	    <md-input-container ng-if=\"$root.workspace.settings.organizationsFilters.targetScore\">\n		<label>Target Score</label>\n		<md-select ng-model=\"$ctrl.targetScoreFilter\" ng-change=\"$ctrl.changeFilters(\'target_score\', $ctrl.targetScoreFilter)\" aria-label=\"target score filter\">\n		    <md-option value=\"\">TODOS</md-option>\n		    <md-option value=\"1\">1</md-option>\n		    <md-option value=\"2\">2</md-option>\n		    <md-option value=\"3\">3</md-option>\n		    <md-option value=\"4\">4</md-option>\n		    <md-option value=\"5\">5</md-option>\n		</md-select>\n	    </md-input-container>\n\n\n	</div>\n\n\n	<md-card>\n	    <div flex layout=\"row\" style=\"font-size: 12px; color: #bbb; padding: 20px 15px 20px 15px; border-bottom: 1px solid #e0e0e0\">\n		<div flex=\"15\" ng-if=\"$root.workspace.settings.organizationsFields.name\">Name</div>\n		<div flex=\"10\" style=\"text-align: center\" ng-if=\"$root.workspace.settings.organizationsFields.peopleCount\">People</div>\n		<div flex=\"5\" style=\"text-align: center\" ng-if=\"$root.workspace.settings.organizationsFields.interactions\">Interactions</div>\n		<div flex=\"10\" style=\"text-align: center\" ng-if=\"$root.workspace.settings.organizationsFields.contacts\">Contacts</div>\n		<div flex=\"10\" style=\"text-align: center\" ng-if=\"$root.workspace.settings.organizationsFields.foundation\">Foundation</div>\n		<div flex=\"5\" style=\"text-align: center\" ng-if=\"$root.workspace.settings.organizationsFields.profileLevel\">Profile Level</div>\n		<div flex=\"15\" style=\"text-align: center\" ng-if=\"$root.workspace.settings.organizationsFields.municipality\">Municipality</div>\n		<div flex=\"5\" style=\"text-align: center\" ng-if=\"$root.workspace.settings.organizationsFields.size\">Size</div>\n		<div flex=\"5\" style=\"text-align: center\" ng-if=\"$root.workspace.settings.organizationsFields.turnover\">Turnover</div>\n		<div flex=\"5\" style=\"text-align: center\" ng-if=\"$root.workspace.settings.organizationsFields.income\">Net Income</div>\n		<div flex=\"5\" style=\"text-align: center\" ng-if=\"$root.workspace.settings.organizationsFields.tags\">Tags</div>\n		<div flex=\"10\" style=\"text-align: center\" ng-if=\"$root.workspace.settings.organizationsFields.target\">Target</div>\n	    </div>\n\n\n	    <div flex layout=\"row\" ng-repeat=\"organization in $ctrl.organizations\" ui-sref=\"organizationDetails({id: organization.id})\" style=\"cursor: pointer; padding: 10px; font-size: 13px; border-bottom: 1px solid #e0e0e0; color: #000000de; padding: 15px\">\n		<!-- field -->\n		<div flex=\"15\" style=\"white-space: nowrap; overflow: hidden; text-overflow: ellipsis\" ng-if=\"$root.workspace.settings.organizationsFields.name\">\n		    <md-icon ng-if=\"organization.isClient\" style=\"font-size: 15px !important; color: #4a4a4a; margin-right: -10px\">\n			loyalty\n			<md-tooltip>This is a Client</md-tooltip>\n		    </md-icon>\n		    <a ui-sref=\"organizationDetails({id: organization.id})\">{{::organization.name}}</a>\n		</div>\n		<!-- field -->\n		<div flex=\"10\" style=\"text-align: center\" ng-if=\"$root.workspace.settings.organizationsFields.peopleCount\">\n		    <span ng-if=\"organization.peopleCount == 0\">-</span>\n		    <span ng-if=\"organization.peopleCount != 0\">{{organization.peopleCount}}</span>\n		</div>\n		<!-- field -->\n		<div flex=\"5\" style=\"text-align: center\" ng-if=\"$root.workspace.settings.organizationsFields.interactions\">\n		    <span ng-if=\"organization.interactions\">\n			<span ng-if=\"organization.lastInteraction\" style=\"text-decoration:underline\">\n			    {{organization.interactions}}\n			    <md-tooltip>\n				last interaction {{organization.lastInteraction | amDateFormat:\'DD-MM-YYYY\'}} (<span am-time-ago=\"organization.lastInteraction\"></span>)\n			    </md-tooltip>\n			</span>\n		    </span>\n		    <span ng-if=\"!organization.interactions\">-</span>\n		</div>\n		<!-- field -->\n		<div flex=\"10\" style=\"text-align: center\" ng-if=\"$root.workspace.settings.organizationsFields.contacts\">\n		    <span ng-if=\"organization.site\">\n			<a href=\"{{organization.site}}\" target=\"_blank\" rel=\"noopener noreferrer\" ng-click=\"$event.stopPropagation();\">\n			    S\n			    <md-tooltip>{{organization.site}}</md-tooltip>\n			</a>\n		    </span>\n		    <span ng-if=\"organization.email\">\n			<a href=\"mailto:{{organization.email}}\" ng-click=\"$event.stopPropagation();\">\n			    E\n			    <md-tooltip>{{organization.email}}</md-tooltip>\n			</a>\n		    </span>\n		    <span ng-if=\"organization.facebook\">\n			<a href=\"{{organization.facebook}}\" target=\"_blank\" rel=\"noopener noreferrer\" ng-click=\"$event.stopPropagation();\">\n			    F\n			    <md-tooltip>{{organization.facebook}}</md-tooltip>\n			</a>\n		    </span>\n		    <span ng-if=\"organization.linkedin\">\n			<a href=\"{{organization.linkedin}}\" target=\"_blank\" rel=\"noopener noreferrer\" ng-click=\"$event.stopPropagation();\">\n			    L\n			    <md-tooltip>{{organization.linkedin}}</md-tooltip>\n			</a>\n		    </span>\n		</div>\n		<!-- field -->\n		<div flex=\"10\" style=\"text-align: center\" ng-if=\"$root.workspace.settings.organizationsFields.foundation\">\n		    {{organization.foundation}}\n		</div>\n		<!-- field -->\n		<div flex=\"5\" style=\"text-align: center\" ng-if=\"$root.workspace.settings.organizationsFields.profileLevel\">\n		    <span ng-if=\"organization.profileLevel == 0\">-</span>\n		    <span ng-if=\"organization.profileLevel != 0\">\n			{{organization.profileLevel}}\n		    </span>\n		</div>\n		<!-- field -->\n		<div flex=\"15\" style=\"text-align: center\" ng-if=\"$root.workspace.settings.organizationsFields.municipality\">\n		    {{organization.$_(\'municipality\').name}}\n		</div>\n		<!-- field -->\n		<div flex=\"5\" style=\"text-align: center\" ng-if=\"$root.workspace.settings.organizationsFields.size\">\n		    <span ng-if=\"organization.rawSize\">{{organization.rawSize}}</span>\n		    <span ng-if=\"!organization.rawSize\">{{organization.size | companySizes}}</span>\n		</div>\n		<!-- field -->\n		<div flex=\"5\" style=\"text-align: center\" ng-if=\"$root.workspace.settings.organizationsFields.turnover\">\n		    <span ng-if=\"organization.rawTurnover\">{{organization.rawTurnover | number}}M</span>\n		    <span ng-if=\"!organization.rawTurnover\">{{organization.turnover | companyTurnovers}}</span>\n		</div>\n		<!-- field -->\n		<div flex=\"5\" style=\"text-align: center\" ng-if=\"$root.workspace.settings.organizationsFields.income\">\n		    <span ng-if=\"organization.rawIncome\">{{organization.rawIncome | number}}M</span>\n		</div>\n		<!-- field -->\n		<div flex=\"5\" style=\"text-align: center\" ng-if=\"$root.workspace.settings.organizationsFields.tags\">\n		    <md-icon>\n			label\n			<md-tooltip>\n			    <span ng-repeat=\"organizationTag in organization.$_(\'tags\')\">\n				{{organizationTag.$_(\'tag\').name}};\n			    </span>\n			</md-tooltip>\n		    </md-icon>\n		</div>\n		<!-- field -->\n		<div flex=\"10\" style=\"text-align: center\" ng-if=\"$root.workspace.settings.organizationsFields.target\">\n		    <span>\n			{{organization.targetState | limitTo : 1}}\n		    </span>\n		    <span ng-if=\"organization.targetScore\">\n			{{organization.targetScore}} &nbsp;\n		    </span>\n		    <span ng-if=\"!organization.targetScore\">\n			- &nbsp;\n		    </span>\n		    <md-icon ng-style=\"{color: organization.interactionStateSummary ? \'#F7D342\' : \'#ddd\'}\">\n			comment\n			<md-tooltip>\n			    <span ng-if=\"organization.interactionStateSummary\">{{organization.interactionStateSummary}}</span>\n			    <span ng-if=\"!organization.interactionStateSummary\">No Information Yet. Click to add.</span>\n			</md-tooltip>\n		    </md-icon>\n		</div>\n\n	    </div>\n        </md-card>\n	<div style=\"float: right; font-size: 13px; color: #4a4a4a; margin-right: 25px\">{{$ctrl.organizations.$totalCount}} organizations</div>\n    </div>\n    <div>\n	<paginator collection=\"$ctrl.organizations\">\n    </div>\n\n</md-content>\n");
$templateCache.put("app/components/pagination/pagination.html","<ul>\n    <li class=\"pagination-item\" ng-click=\"$ctrl.page = $index+1; $ctrl.$rootScope.$emit(\'pageChanged\', $ctrl.page)\" ng-repeat=\"i in $ctrl.counter($ctrl.links) track by $index\">\n        {{$index+1}}\n    </li>\n</ul>\n");
$templateCache.put("app/components/paginator/paginator.html","<div layout=\"row\" layout-align=\"center center\">\n    <md-button class=\"md-icon-button md-accent\" ng-click=\"$ctrl.goToPreviousPage()\" ng-disabled=\"$ctrl.collection.$page == 1\">\n        <md-icon>chevron_left</md-icon>\n    </md-button>\n    <div class=\"text-fade text-center\">\n        <span style=\"font-size: 14px; text-transform: uppercase\">Page</span>\n        <span>{{$ctrl.collection.$page}} of {{$ctrl.collection.$totalCount / $ctrl.pageSize | ceil}}</span>\n    </div>\n    <md-button class=\"md-icon-button md-accent\" ng-click=\"$ctrl.goToNextPage()\" ng-disabled=\"($ctrl.collection.$page * $ctrl.pageSize) >= $ctrl.collection.$totalCount\">\n        <md-icon>chevron_right</md-icon>\n    </md-button>\n\n</div>\n");
$templateCache.put("app/components/profileLevel/profileLevel.html","<div>\n    <md-icon ng-style=\"{ \'color\' : (n > $ctrl.level) ? \'gray\' : \'#F7D342\' }\" ng-repeat=\"n in [1,2,3,4,5]\" style=\"font-size: 15px\">\n	star\n	<md-tooltip>Foundation, Turnover, Municipality, Size, Industry</md-tooltip>\n    </md-icon>\n</div>\n");
$templateCache.put("app/components/proposalDetails/proposalDetails.html","<md-toolbar class=\"proposal-toolbar\">\n    <div class=\"md-toolbar-tools\">\n        <div layout=\"row\" layout-align=\"start center\" class=\"editable-wrap\">\n            <div layout=\"column\" layout-align=\"center center\" flex>\n                <input type=\"text\" ng-model=\"$ctrl.proposal.name\" aria-label=\"Proposal Name\" class=\"title-input editable-wrap\" style=\"margin:2px\" ng-change=\"$ctrl.proposal.$save([\'name\'])\">\n            </div>\n\n            <div layout=\"column\" layout-align=\"center center\">\n                <md-button class=\"md-raised md-accent\">\n                    <a href=\"{{$ctrl.proposalsApp + $ctrl.proposal.slug}}\" target=\"_blank\" layout=\"row\" layout-align=\"center center\">\n                        <md-icon>\n                            remove_red_eye\n                        </md-icon>\n                        <span style=\"margin-left: 5px; color:black\">Preview</span>\n                    </a>\n                </md-button>\n            </div>\n        </div>\n    </div>\n</md-toolbar>\n<md-toolbar class=\"proposal-toolbar\" style=\"min-height: 48px; max-height: 48px; background-color: #f2f2f2 !important\">\n    <div class=\"md-toolbar-tools\">\n        <md-nav-bar md-selected-nav-item=\"$ctrl.currentNav\" aria-label=\"navigation\">\n            <md-nav-item md-nav-click=\"$ctrl.currentNav=\'details\';\" name=\"details\">\n                Details\n            </md-nav-item>\n            <md-nav-item md-nav-click=\"$ctrl.currentNav=\'discussion\';\" name=\"discussion\">\n                Discussion\n            </md-nav-item>\n        </md-nav-bar>\n    </div>\n</md-toolbar>\n\n<md-content ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 1000, \'blur\': 0}, updateOnDefault: true}\" flex>\n    <div class=\"padding\" layout=\"column\" flex>\n        <div ng-if=\"$ctrl.currentNav==\'details\'\" flex>\n            <div layout=\"row\" flex>\n                <div layout=\"column\" flex=\"65\">\n                    <div layout=\"row\" class=\"proposal-client\" style=\"padding-top: 10px\">\n                        <div layout=\"column\" layout-align=\"center center\" style=\"margin-right: 10px; padding: 0px 5px\">\n                            <h3 style=\"margin: 0px\">Details: </h3>\n                        </div>\n                        <div layout=\"column\" layout-align=\"center center\" flex>\n                            <md-input-container class=\"editable-wrap\">\n                                <label>Slug</label>\n                                <input type=\"text\" ng-model=\"$ctrl.proposal.slug\" aria-label=\"Proposal Slug\" ng-change=\"$ctrl.proposal.$save([\'slug\'])\">\n                            </md-input-container>\n                        </div>\n                        <div layout=\"row\" layout-align=\"end center\">\n                            <md-input-container class=\"editable-wrap\">\n                                <label>State</label>\n                                <md-select ng-model=\"$ctrl.proposal.state\" placeholder=\"State\" ng-change=\"$ctrl.proposal.$save([\'state\']); $ctrl.proposal.$refresh();\" flex>\n                                    <md-option value=\"DRAFT\">Draft</md-option>\n                                    <md-option value=\"OPEN\">Open</md-option>\n                                    <md-option value=\"APPROVED\">Approved</md-option>\n                                    <md-option value=\"REJECTED\">Rejected</md-option>\n                                    <md-option value=\"EXPIRED\">Expired</md-option>\n                                </md-select>\n                            </md-input-container>\n                        </div>\n                        <div layout=\"row\" layout-align=\"end center\">\n                            <md-input-container style=\"max-width: 150px\">\n                                <input mdc-datetime-picker date=\"true\" time=\"false\" type=\"text\" short-time=\"true\" show-todays-date min-date=\"minDate\" format=\"MMMM DD YYYY\" ng-model=\"$ctrl.proposalDate\" aria-label=\"Proposal Date\" placeholder=\"Proposal Date\" ng-change=\"$ctrl.saveDate($ctrl.proposalDate)\" style=\"text-align: center\">\n                            </md-input-container>\n                        </div>\n\n                    </div>\n                    <div layout=\"column\" class=\"proposal-client\" style=\"margin-top: 8px\">\n                        <div layout=\"row\" style=\"margin-bottom: 6px\">\n                            <h2>Client: {{$ctrl.proposal.$client.name}}</h2>\n                        </div>\n                        <div layout=\"row\" flex>\n                            <md-input-container class=\"editable-wrap small-input\">\n                                <label>Briefing</label>\n                                <textarea rows=\"2\" ng-model=\"$ctrl.proposal.briefing\" aria-label=\"Client Briefing\" ng-change=\"$ctrl.proposal.$save([\'briefing\'])\"></textarea>\n                            </md-input-container>\n                        </div>\n                    </div>\n                </div>\n                <div flex></div>\n                <div layout=\"column\" class=\"small-input\" flex=\"33\" layout-align=\"start end\">\n                    <div layout=\"column\" class=\"proposal-client editable-wrap\">\n                        <div layout=\"row\" layout-align=\"end center\">\n                            <span style=\"opacity: 0.5; margin-right: 5px\">Version</span>\n                            <md-input-container style=\"max-width: 30px\">\n                                <input type=\"text\" style=\"text-align: center\" aria-label=\"Proposal Version\" ng-model=\"$ctrl.proposal.version\" ng-change=\"$ctrl.proposal.$save([\'version\'])\">\n                            </md-input-container>\n                        </div>\n                        <div layout=\"row\" class=\"spacer editable-wrap\">\n                            <md-input-container class=\"editable-wrap md-block\">\n                                <label>Authors</label>\n                                <textarea ng-model=\"$ctrl.proposal.authors\" aria-label=\"Proposal Authors\" ng-change=\"$ctrl.proposal.$save([\'authors\'])\"></textarea>\n                            </md-input-container>\n                        </div>\n                        <div layout=\"row\" class=\"spacer editable-wrap\">\n                            <md-input-container class=\"editable-wrap\">\n                                <label>Writers</label>\n                                <textarea ng-model=\"$ctrl.proposal.writers\" aria-label=\"Proposal Writers\" ng-change=\"$ctrl.proposal.$save([\'writers\'])\"></textarea>\n                            </md-input-container>\n                        </div>\n                        <div layout=\"row\" layout-align=\"end center\">\n                            <span style=\"opacity: 0.5; margin-right: 5px\">Expiration Date</span>\n                            <md-input-container style=\"max-width: 140px\">\n                                <input mdc-datetime-picker date=\"true\" time=\"false\" type=\"text\" short-time=\"true\" show-todays-date min-date=\"minDate\" format=\"MMMM DD YYYY\" ng-model=\"$ctrl.expirationDate\" aria-label=\"Proposal Expiration Date\" ng-change=\"$ctrl.proposal.expirationDate = $ctrl.expirationDate; $ctrl.proposal.$save([\'expirationDate\'])\" style=\"text-align: center\">\n                            </md-input-container>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <br><br>\n            <!--Description-->\n            <div layout=\"row\" layout-align=\"start center\">\n                <div layout=\"column\" flex>\n                    <h2>Description</h2>\n                </div>\n                <div layout=\"column\">\n                    <div layout=\"row\">\n                        <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.proposal.description=null; $ctrl.proposal.$save([\'description\']);\">\n                            <md-icon>\n                                clear\n                            </md-icon>\n                            <span>Clear</span>\n                        </md-button>\n                        <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.proposal.$save([\'description\'])\">\n                            <md-icon>\n                                save\n                            </md-icon>\n                            <span>Save</span>\n                        </md-button>\n                    </div>\n\n                </div>\n            </div>\n            <div layout=\"row\" layout-align=\"center center\">\n                <md-card class=\"edit-description\" flex>\n                    <md-card-content class=\"text-second\">\n                        <div text-angular ng-model=\"$ctrl.proposal.description\" ta-text-editor-class=\"clearfix border-around container\" ta-html-editor-class=\"border-around\" ta-toolbar=\"[[\'h1\',\'h2\',\'h3\',\'h4\',\'h5\',\'h6\',\'p\',\'quote\',\'ul\',\'ol\',\'insertLink\'],[\'bold\',\'italics\',\'underline\',\'strikeThrough\',\'justifyLeft\',\'justifyCenter\',\'justifyRight\',\'justifyFull\',\'indent\',\'outdent\',\'undo\',\'redo\',\'clear\'], [\'wordcount\', \'charcount\']]\"></div>\n                    </md-card-content>\n                </md-card>\n            </div>\n            <br><br>\n            <!--Services-->\n            <div layout=\"row\" layout-align=\"start center\">\n                <h1>Services</h1>\n            </div>\n            <div layout=\"row\" layout-align=\"center center\">\n                <div layout=\"column\" flex>\n                    <md-list data-as-sortable=\"$ctrl.sortableServices\" data-ng-model=\"$ctrl.proposal.$proposalServices\" cg-busy=\"$ctrl.proposal.$proposalServices.$promise\" layout=\"column\" flex>\n                        <md-list-item ng-repeat=\"service in $ctrl.proposal.$proposalServices | orderBy: \'order\'\" cg-busy=\"service.$promise\" data-as-sortable-item=\"service\" style=\"margin-bottom:5px\">\n                            <div layout=\"row\" layout-align=\"start center\" flex>\n                                <div layout=\"column\">\n                                    <md-icon data-as-sortable-item-handle style=\"margin-right: 5px; opacity: 0.5; cursor: move\" show-gt-xs>\n                                        drag_handle\n                                    </md-icon>\n                                </div>\n                                <div layout=\"column\" flex>\n                                    <div layout=\"row\" class=\"proposal-client small-input\" style=\"padding-right: 10px\" flex>\n                                        <div layout=\"column\">\n                                            <md-input-container>\n                                                <input type=\"text\" ng-model=\"service.name\" aria-label=\"Service Name\" ng-change=\"service.$save([\'name\'])\">\n                                            </md-input-container>\n                                        </div>\n                                        <div layout=\"column\" layout-align=\"center center\" class=\"separator\">\n                                            <md-input-container style=\"max-width: 90px\">\n                                                <input type=\"text\" style=\"text-align: center\" ng-model=\"service.price\" aria-label=\"Service Price\" ng-change=\"$ctrl.saveServicePrice(service);\">\n                                            </md-input-container>\n                                        </div>\n                                        <div layout=\"column\" flex>\n                                            <md-input-container class=\"editable-wrap md-block\">\n                                                <textarea ng-model=\"service.notes\" aria-label=\"Service Notes\" ng-change=\"service.$save([\'notes\'])\"></textarea>\n                                            </md-input-container>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div layout=\"column\">\n                                    <md-button class=\"md-icon-button\" ng-click=\"$ctrl.deleteService(service)\">\n                                        <md-icon>delete</md-icon>\n                                    </md-button>\n                                </div>\n                            </div>\n                        </md-list-item>\n                    </md-list>\n                    <br>\n                    <div layout=\"row\" layout-align=\"center center\" style=\"padding-right: 20px\">\n                        <div layout=\"row\" class=\"small-input\" style=\"padding: 0px 20px\" flex>\n                            <div layout=\"column\">\n                                <md-input-container>\n                                    <input type=\"text\" placeholder=\"name\" aria-label=\"New Service Name\" ng-model=\"$ctrl.newService.name\">\n                                </md-input-container>\n                            </div>\n                            <div layout=\"column\" layout-align=\"center center\" class=\"separator\">\n                                <md-input-container style=\"max-width: 90px\">\n                                    <input type=\"text\" style=\"text-align: center\" placeholder=\"price\" aria-label=\"New Service Price\" ng-model=\"$ctrl.newService.price\">\n                                </md-input-container>\n                            </div>\n                            <div layout=\"column\" flex>\n                                <md-input-container class=\"editable-wrap md-block\">\n                                    <textarea placeholder=\"notes\" ng-model=\"$ctrl.newService.notes\" aria-label=\"New Service Notes\"></textarea>\n                                </md-input-container>\n                            </div>\n                        </div>\n                        <div layout=\"column\">\n                            <md-button class=\"md-raised md-accent md-icon-button\" ng-click=\"$ctrl.addProposalService()\">\n                                <md-icon>\n                                    add\n                                </md-icon>\n                            </md-button>\n                        </div>\n                    </div>\n                    <br><br>\n                    <div layout=\"row\" layout-align=\"start center\" flex>\n                        <div layout=\"column\" flex>\n                            <div layout=\"row\" class=\"proposal-client small-input\" style=\"padding-right: 10px; background-color: #cccccc\" flex>\n\n                                <div layout=\"column\" layout-align=\"center center\" flex=\"10\">\n                                    <strong style=\"font-size: 16px\">Total</strong>\n                                </div>\n                                <div layout=\"column\" layout-align=\"center center\" class=\"separator\">\n                                    <md-input-container style=\"max-width: 100px\">\n                                        <label>Total Price</label>\n                                        <input type=\"text\" style=\"text-align: center; font-weight: bold; color: black\" ng-model=\"$ctrl.proposal.totalPrice\" aria-label=\"Proposal Total Price\" disabled=\"disabled\">\n                                    </md-input-container>\n                                </div>\n                                <div layout=\"column\" flex>\n                                    <md-input-container class=\"editable-wrap md-block\">\n                                        <label>Payment Plan</label>\n                                        <textarea style=\"font-weight: bold\" ng-model=\"$ctrl.proposal.aboutPayments\" aria-label=\"Proposal About Payments\" ng-change=\"$ctrl.proposal.$save([\'aboutPayments\'])\"></textarea>\n                                    </md-input-container>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <br><br>\n            <!--Sections-->\n            <div layout=\"row\" layout-align=\"start center\">\n                <h1>Sections</h1>\n            </div>\n            <div layout=\"row\" layout-align=\"center center\">\n                <div layout=\"column\" flex>\n                    <md-list data-as-sortable=\"$ctrl.sortableSections\" data-ng-model=\"$ctrl.proposal.$proposalSections\" cg-busy=\"$ctrl.proposal.$proposalSections.$promise\" layout=\"column\" flex>\n                        <md-list-item ng-repeat=\"section in $ctrl.proposal.$proposalSections | orderBy: \'order\'\" cg-busy=\"section.$promise\" data-as-sortable-item=\"section\" style=\"margin-bottom:5px\">\n                            <div layout=\"row\" layout-align=\"start center\" flex>\n                                <div layout=\"column\">\n                                    <md-icon data-as-sortable-item-handle style=\"margin-right: 5px; opacity: 0.5; cursor: move\" show-gt-xs>\n                                        drag_handle\n                                    </md-icon>\n                                </div>\n                                <div layout=\"column\" flex>\n                                    <a ui-sref=\"proposalSectionDetails({id: section.id})\">{{section.name}}</a>\n                                </div>\n                                <div layout=\"column\">\n                                    <md-button class=\"md-icon-button\" ng-click=\"section.$destroy()\">\n                                        <md-icon>delete</md-icon>\n                                    </md-button>\n                                </div>\n                            </div>\n                        </md-list-item>\n                    </md-list>\n                    <br>\n                    <div layout=\"row\" layout-align=\"center center\">\n                        <div layout=\"column\" class=\"small-input\">\n                            <md-input-container>\n                                <input type=\"text\" placeholder=\"name\" ng-model=\"$ctrl.newSection.name\" aria-label=\"New Section Name\">\n                            </md-input-container>\n                        </div>\n                        <div layout=\"column\" class=\"small-input\">\n                            <md-input-container style=\"max-width: 60px\">\n                                <input type=\"text\" placeholder=\"columns\" style=\"text-align: center\" ng-model=\"$ctrl.newSection.columnsCount\" aria-label=\"New Section Columns\">\n                            </md-input-container>\n                        </div>\n                        <div layout=\"column\" class=\"small-input\" style=\"padding-left: 10px\">\n                            <span style=\"opacity: 0.5\">cover: </span>\n                        </div>\n                        <div layout=\"row\" layout-align=\"end center\" style=\"padding: 0px 5px\">\n                            <div layout=\"column\">\n                                <md-button ngf-select media-auto-upload ng-model=\"$ctrl.newSection.cover\" ngf-model-invalid=\"$ctrl.invalidUploadedFiles\">\n                                    <md-icon>file_upload</md-icon>\n                                    upload\n                                </md-button>\n                            </div>\n                            <div layout=\"column\">\n                                <span>or</span>\n                            </div>\n                            <div layout=\"column\">\n                                <md-button ng-click=\"$ctrl.displayMediaSelector();\">\n                                    <md-icon>touch_app</md-icon>\n                                    choose from media\n                                </md-button>\n                            </div>\n                        </div>\n                        <div layout=\"column\" layout-align=\"center center\">\n                            <md-button class=\"md-raised md-accent md-icon-button\" ng-click=\"$ctrl.addProposalSection()\">\n                                <md-icon>\n                                    add\n                                </md-icon>\n                            \n                        </div>\n                    </div>\n                    <div layout=\"row\" layout-align=\"center center\">\n                        <div layout=\"column\" class=\"small-input\" style=\"padding: 0px 5px\">\n                            <span style=\"opacity: 0.5\">{{$ctrl.newSection.cover}}</span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <br><br>\n            <!--User Stories-->\n            <div layout=\"row\" layout-align=\"start center\">\n                <h1>User Stories</h1>\n            </div>\n            <div layout=\"row\" layout-align=\"center center\">\n                <div layout=\"column\" flex>\n                    <md-list data-as-sortable=\"$ctrl.sortableStories\" data-ng-model=\"$ctrl.proposal.$userStories\" cg-busy=\"$ctrl.proposal.$userStories.$promise\" layout=\"column\" flex>\n                        <md-list-item ng-repeat=\"story in $ctrl.proposal.$userStories | orderBy: \'order\'\" cg-busy=\"story.$promise\" data-as-sortable-item=\"story\" style=\"margin-bottom:5px\">\n                            <div layout=\"row\" layout-align=\"start center\" flex>\n                                <div layout=\"column\">\n                                    <md-icon data-as-sortable-item-handle style=\"margin-right: 5px; opacity: 0.5; cursor: move\" show-gt-xs>\n                                        drag_handle\n                                    </md-icon>\n                                </div>\n                                <div layout=\"column\" flex>\n                                    <a ui-sref=\"userStoryDetails({id: story.id})\">{{story.name}}</a>\n                                </div>\n                                <div layout=\"column\">\n                                    <md-button class=\"md-icon-button\" ng-click=\"story.$destroy()\">\n                                        <md-icon>delete</md-icon>\n                                    </md-button>\n                                </div>\n                            </div>\n                        </md-list-item>\n                    </md-list>\n                    <br>\n                    <div layout=\"row\" layout-align=\"center center\" style=\"padding: 0px 20px\">\n                        <div layout=\"column\" flex class=\"block-border\">\n                            <div layout=\"row\" flex>\n                                <md-input-container flex>\n                                    <input type=\"text\" placeholder=\"name\" ng-model=\"$ctrl.newStory.name\" aria-label=\"New Story Name\">\n                                </md-input-container>\n                            </div>\n                            <div layout=\"row\" flex>\n                                <md-input-container class=\"editable-wrap md-block\">\n                                    <textarea placeholder=\"description\" ng-model=\"$ctrl.newStory.description\" aria-label=\"New Story Description\"></textarea>\n                                </md-input-container>\n                            </div>\n                        </div>\n                        <div layout=\"column\" layout-align=\"center center\">\n                            <md-button class=\"md-raised md-accent md-icon-button\" ng-click=\"$ctrl.addUserStory()\">\n                            <md-icon>\n                                add\n                            </md-icon>\n                            \n                        </div>\n                    </div>\n                    <br>\n                    <div layout=\"row\" layout-align=\"center center\">\n                        <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.displayUserStorySelector()\">\n                            <md-icon>import_export</md-icon>\n                            Import Existing\n                        </md-button>\n                    </div>\n                </div>\n            </div>\n            <br><br>\n            <!--Documents-->\n            <div layout=\"row\" layout-align=\"start center\">\n                <div layout=\"column\" flex>\n                    <h1>Documents</h1>\n                </div>\n                <div layout=\"column\">\n                    <i style=\"opacity: 0.7\">(max. size 100MB)</i>\n                </div>\n            </div>\n            <div layout=\"row\" layout-align=\"center center\">\n                <md-card cg-busy=\"$ctrl.proposal.$files.$promise\" style=\"padding:5px\" flex>\n                    <h3 class=\"text-center text-fade\" ng-if=\"!$ctrl.proposal.$files.length\">\n                        No documents added\n                    </h3>\n\n                    <files-display files=\"$ctrl.proposal.$files\" deletable=\"true\" style=\"border-top: none\"></files-display>\n                </md-card>\n            </div>\n            <div layout=\"row\" layout-align=\"center center\">\n                <md-button ngf-select media-auto-upload ng-model=\"$ctrl.newFileAttachment\" ngf-model-invalid=\"$ctrl.invalidUploadedFiles\" ngf-max-size=\"100MB\" class=\"md-raised md-accent\">\n                    <md-icon>file_upload</md-icon>\n                    add file\n                </md-button>\n            </div>\n        </div>\n        <div ng-if=\"$ctrl.currentNav==\'discussion\'\" flex>\n            <md-list>\n                <md-list-item ng-repeat=\"comment in $ctrl.proposal.$comments | orderBy: \'created\' track by comment.id\">\n                    <md-card flex>\n                        <md-card-content>\n                            <div layout=\"row\" layout-align=\"space-between center\">\n                                <div layout=\"row\" layout-align=\"start center\" flex>\n                                    <img ng-src=\"{{comment.$user.avatar | mediaUrl}}\" class=\"avatar-xs\" style=\"margin-right: 10px\">\n                                    <span class=\"text-fade\">{{::comment.$user.name}}</span>\n                                </div>\n                                <span class=\"text-fade\">{{::comment.created | amCalendar}}</span>\n                            </div>\n                            <p class=\"comment-content\" bind-html-compile=\"::comment.content | nl2br\"></p>\n                        </md-card-content>\n                        <files-display style=\"padding: 0px 10px\" files=\"comment.$files\" ng-if=\"comment.$files.length\" deletable=\"false\"></files-display>\n                    </md-card>\n                </md-list-item>\n            </md-list>\n        </div>\n    </div>\n</md-content>\n\n<div layout=\"row\" class=\"new-comment-area\" ng-if=\"$ctrl.currentNav==\'discussion\'\">\n    <img ng-src=\"{{$root.me.avatar | mediaUrl}}\">\n    <md-input-container class=\"md-block\" flex>\n        <textarea type=\"text\" ng-enter=\"$ctrl.addComment();\" placeholder=\"Write something...\" ng-model=\"$ctrl.newComment.content\" aria-label=\"New Comment Content\"></textarea>\n    </md-input-container>\n    <md-button class=\"md-icon-button\" ngf-select media-auto-upload ng-model=\"$ctrl.fileUpload\" ngf-model-invalid=\"$ctrl.invalidUploadedFiles\" ngf-max-size=\"100MB\">\n        <md-tooltip md-direction=\"top\">Add an attachment to the comment</md-tooltip>\n        <md-icon>attachment</md-icon>\n    </md-button>\n    <md-button class=\"send-btn md-icon-button md-accent md-raised\" ng-click=\"$ctrl.addComment();\">\n        <md-icon>send</md-icon>\n    </md-button>\n</div>\n\n<files-display files=\"$ctrl.uploadedFiles\" deletable=\"true\" ng-if=\"$ctrl.uploadedFiles.length && $ctrl.currentNav==\'discussion\'\"></files-display>\n");
$templateCache.put("app/components/proposalSectionDetails/proposalSectionDetails.html","<md-content ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 1000, \'blur\': 0}, updateOnDefault: true}\">\n    <div class=\"padding\" layout=\"column\" flex>\n        <div layout=\"row\" layout-align=\"center center\" flex>\n            <input type=\"text\" ng-model=\"$ctrl.proposalSection.name\" class=\"title-input editable-wrap\" style=\"margin:2px\" ng-change=\"$ctrl.proposalSection.$save([\'name\'])\">\n        </div>\n        <br>\n        <!--cover-->\n        <div layout=\"row\" flex>\n            <div layout=\"column\">\n                <p>Cover:</p>\n            </div>\n            <div layout=\"column\" layout-align=\"center center\">\n                <div layout=\"row\" layout-align=\"center center\" class=\"proposal-client\" style=\"margin-left: 10px\">\n                    <div layout=\"column\" layout-align=\"center center\" style=\"margin-right: 15px\">\n                        <a href=\"{{$ctrl.proposalSection.cover | mediaUrl}}\" target=\"_blank\" flex>\n                            {{$ctrl.proposalSection.cover}}\n                        </a>\n                    </div>\n                    <div layout=\"column\" layout-align=\"center center\">\n                        <a href=\"{{$ctrl.proposalSection.cover | mediaUrl}}\" target=\"_blank\" download>\n                            <md-icon>file_download</md-icon>\n                        </a>\n                    </div>\n\n                </div>\n            </div>\n            <span flex></span>\n            <div layout=\"column\" layout-align=\"center center\">\n                <md-button class=\"md-raised md-accent\" ngf-select media-auto-upload ng-model=\"$ctrl.proposalSection.cover\" ngf-model-invalid=\"$ctrl.invalidUploadedFiles\">\n                    <md-icon>file_upload</md-icon>\n                    upload new\n                </md-button>\n            </div>\n            <div layout=\"column\" layout-align=\"center center\">\n                <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.displayMediaSelector();\">\n                    <md-icon>touch_app</md-icon>\n                    select new from media\n                </md-button>\n            </div>\n        </div>\n        <div layout=\"row\" layout-align=\"start center\">\n            <span style=\"margin-right: 5px\">Columns:</span>\n            <md-input-container style=\"max-width: 30px\">\n                <input type=\"text\" style=\"text-align: center\" aria-label=\"Section Columns\" ng-model=\"$ctrl.proposalSection.columnsCount\" ng-change=\"$ctrl.proposalSection.$save([\'columnsCount\'])\">\n            </md-input-container>\n        </div>\n        <br><br>\n        <div layout=\"row\" layout-align=\"start center\">\n            <h1>Contents</h1>\n        </div>\n        <div layout=\"row\" layout-align=\"center center\">\n            <div layout=\"column\" flex>\n                <md-list data-as-sortable=\"$ctrl.sortableContents\" data-ng-model=\"$ctrl.proposalSection.$sectionContents\" cg-busy=\"$ctrl.proposalSection.$sectionContents.$promise\" layout=\"column\" flex>\n                    <md-list-item ng-repeat=\"content in $ctrl.proposalSection.$sectionContents | orderBy: \'order\'\" cg-busy=\"content.$promise\" data-as-sortable-item=\"content\" style=\"margin-bottom: 10px\">\n                        <div layout=\"row\" layout-align=\"start center\" flex>\n                            <div layout=\"column\">\n                                <md-icon data-as-sortable-item-handle style=\"margin-right: 5px; opacity: 0.5; cursor: move\" show-gt-xs>\n                                    drag_handle\n                                </md-icon>\n                            </div>\n                            <div layout=\"column\" class=\"proposal-client small-input\" style=\"border-radius: 8px\" flex>\n\n                                <div layout=\"row\" style=\"padding: 5px\">\n                                    <div layout=\"column\" flex>\n                                        <h2><strong>{{content.name}}</strong></h2>\n                                    </div>\n                                    <div layout=\"column\">\n                                        <md-button class=\"md-raised md-accent md-icon-button\" ng-click=\"$ctrl.editingContent=content;$ctrl.newName=content.name;$ctrl.newDescription=content.description;\">\n                                            <md-icon>\n                                                edit\n                                            </md-icon>\n                                        </md-button>\n                                    </div>\n                                    <div layout=\"column\">\n                                        <md-button class=\"md-raised md-accent md-icon-button\" ng-click=\"content.$destroy()\">\n                                            <md-icon>\n                                                delete\n                                            </md-icon>\n                                        </md-button>\n                                    </div>\n                                </div>\n                                <div layout=\"row\" layout-align=\"center center\" flex>\n                                    <md-card class=\"editable-wrap\" style=\"border-radius: 8px; background-color: #f8f8f8\">\n                                        <md-card-content class=\"text-second\" ng-bind-html=\"content.description | unsafe\"></md-card-content>\n                                    </md-card>\n                                </div>\n                            </div>\n                        </div>\n                    </md-list-item>\n                </md-list>\n            </div>\n        </div>\n        <br><br>\n        <br>\n        <div layout=\"row\" layout-align=\"start center\">\n            <div layout=\"column\" flex>\n                <h2>Add/Edit Content</h2>\n            </div>\n            <div layout=\"column\">\n                <div layout=\"row\">\n                    <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.newDescription=\'\';$ctrl.newName=\'\';$ctrl.editingContent=$ctrl.proposalSection.$sectionContents.$build({section: $ctrl.proposalSection.id});\">\n                        <md-icon>\n                            clear\n                        </md-icon>\n                        <span>cancel</span>\n                    </md-button>\n                    <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.saveContent($ctrl.newName, $ctrl.newDescription);\">\n                        <md-icon>\n                            save\n                        </md-icon>\n                        <span>Save</span>\n                    </md-button>\n                </div>\n            </div>\n        </div>\n        <div layout=\"row\" style=\"margin: 0px 10px\">\n            <md-input-container flex>\n                <input type=\"text\" class=\"editable-wrap\" placeholder=\"Title\" ng-model=\"$ctrl.newName\">\n            </md-input-container>\n        </div>\n        <div layout=\"row\" layout-align=\"center center\">\n            <md-card class=\"edit-description\">\n                <md-card-content class=\"text-second\">\n                    <div text-angular ng-model=\"$ctrl.newDescription\" ta-text-editor-class=\"clearfix border-around container\" ta-html-editor-class=\"border-around\" ta-toolbar=\"[[\'h1\',\'h2\',\'h3\',\'h4\',\'h5\',\'h6\',\'p\',\'quote\',\'ul\',\'ol\',\'insertLink\'],[\'bold\',\'italics\',\'underline\',\'strikeThrough\',\'justifyLeft\',\'justifyCenter\',\'justifyRight\',\'justifyFull\',\'indent\',\'outdent\',\'undo\',\'redo\',\'clear\'], [\'wordcount\', \'charcount\']]\"></div>\n                </md-card-content>\n            </md-card>\n        </div>\n    </div>\n</md-content>\n");
$templateCache.put("app/components/proposalsList/proposalsList.html","<md-content class=\"page-list\" id=\"list-proposals\" flex>\n    <div class=\"padding\">\n        <div layout=\"row\" layout-align=\"center center\">\n            <h1>Proposals</h1>\n            <span flex></span>\n            <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.displayNewProposalModal()\">\n                <md-icon>add</md-icon>\n                Add Proposal\n            </md-button>\n        </div>\n\n        <div layout=\"row\" class=\"filters-bar\">\n            <div layout=\"column\" layout-align=\"center center\">\n                <md-icon>search</md-icon>\n            </div>\n            <search label=\"\'Search Proposals\'\"></search>\n        </div>\n        <br>\n        <div layout=\"row\">\n            <div flex=\"80\">\n                <md-card>\n                    <div layout=\"column\" class=\"padding\">\n                        <table class=\"table-list\">\n                            <tr>\n                                <th width=\"1%\">\n                                    <md-checkbox aria-label=\"Checkbox\" ng-checked=\"$ctrl.allChecked\" ng-click=\"$ctrl.checkAll($ctrl.proposals)\"></md-checkbox>\n                                </th>\n                                <th align=\"left\"><ordering field=\"\'name\'\" label=\"\'Name\'\"></th>\n                                <th align=\"center\"><ordering field=\"\'client\'\" label=\"\'Client\'\"></th>\n                                <th align=\"center\"><ordering field=\"\'date\'\" label=\"\'Date\'\"></th>\n                                <th align=\"center\"><ordering field=\"\'version\'\" label=\"\'Version\'\"></th>\n                                <th align=\"center\"><ordering field=\"\'state\'\" label=\"\'State\'\"></th>\n                                <th align=\"center\">Preview</th>\n                            </tr>\n                            <tr ng-repeat=\"proposal in $ctrl.proposals\">\n                                <td>\n                                    <md-checkbox aria-label=\"Checkbox\" ng-checked=\"$ctrl.proposalInList(proposal)\" ng-click=\"$ctrl.checkProposal(proposal)\"></md-checkbox>\n                                </td>\n                                <td>\n                                    <div layout=\"column\">\n                                        <div><a ui-sref=\"proposalDetails({id: proposal.id})\">{{::proposal.name}}</a></div>\n                                    </div>\n                                </td>\n                                <td align=\"center\">\n                                    {{::proposal.$client.name}}\n                                </td>\n                                <td align=\"center\">\n                                    {{::proposal.date}}\n                                </td>\n                                <td align=\"center\">\n                                    {{::proposal.version}}\n                                </td>\n                                <td align=\"center\">\n                                    {{proposal.state}}\n                                </td>\n                                <td align=\"center\">\n                                    <a href=\"{{$ctrl.proposalsApp + proposal.slug}}\" target=\"_blank\"><md-icon>remove_red_eye</md-icon></a>\n                                </td>\n                            </tr>\n                        </table>\n                    </div>\n                </md-card>\n\n                <div layout=\"column\" layout-align=\"center center\">\n                    <pagination size=\"25\" count=\"$ctrl.proposals.$totalCount\">\n                </div>\n            </div>\n\n            <div flex=\"20\">\n                <md-card>\n                    <div layout=\"row\" layout-align=\"center center\" class=\"search-by\" flex>\n                        <md-input-container flex>\n                            <input type=\"text\" class=\"search-box\" ng-model=\"$ctrl.versionFilter\" placeholder=\"Search Version\" ng-change=\"$ctrl.proposals.$refresh({version: $ctrl.versionFilter});$ctrl.proposals.$load(\'client\')\">\n                        </md-input-container>\n                    </div>\n                </md-card>\n\n                <md-card class=\"list-filters\">\n                    <md-card-header>\n                        <md-card-header-text>\n                            <span class=\"text-fade md-title\"><strong>Filter</strong></span>\n                        </md-card-header-text>\n                    </md-card-header>\n                    <md-card-content>\n                        <div class=\"filter-item\" layout=\"row\" layout-align=\"end center\">\n                            <md-select ng-model=\"$ctrl.stateFilter\" placeholder=\"--- All States ---\" class=\"md-no-underline\" ng-change=\"$ctrl.proposals.$refresh({state: $ctrl.stateFilter});$ctrl.proposals.$load(\'client\')\" flex>\n                                <md-option value=\"\">-- All --</md-option>\n                                <md-option value=\"DRAFT\">Draft</md-option>\n                                <md-option value=\"OPEN\">Open</md-option>\n                                <md-option value=\"APPROVED\">Approved</md-option>\n                                <md-option value=\"REJECTED\">Rejected</md-option>\n                                <md-option value=\"EXPIRED\">Expired</md-option>\n                            </md-select>\n                        </div>\n                        <div class=\"filter-item\" layout=\"row\" layout-align=\"end center\">\n                            <md-select ng-model=\"$ctrl.clientFilter\" placeholder=\"--- All Clients ---\" class=\"md-no-underline\" ng-change=\"$ctrl.proposals.$refresh({client: $ctrl.clientFilter});$ctrl.proposals.$load(\'client\')\" flex>\n                                <md-select-header>\n                                    <input ng-model=\"$ctrl.searchClient\" type=\"search\" placeholder=\"Search Clients\" class=\"md-text task-project-select-search\" ng-change=\"$ctrl.clients.$refresh({name__icontains: $ctrl.searchClient})\" ng-keydown=\"$event.stopPropagation();\" force-select-focus ng-model-options=\"{updateOnDefault: True, debounce: {\'default\': 500}}\">\n                                </md-select-header>\n                                <md-option value=\"\"><label>-- All --</label></md-option>\n                                <md-option value=\"{{client.id}}\" ng-repeat=\"client in $ctrl.clients\" class=\"hide-icons\">\n                                    <div layout=\"row\" layout-align=\"center center\">\n                                        <span>{{client.name}}</span>\n                                    </div>\n                                </md-option>\n                            </md-select>\n                        </div>\n                    </md-card-content>\n                </md-card>\n                <md-card class=\"list-filters\">\n                    <md-card-header>\n                        <md-card-header-text>\n                            <span class=\"text-fade md-title\"><strong>Actions</strong></span>\n                        </md-card-header-text>\n                    </md-card-header>\n                    <md-card-content>\n\n                        <div class=\"filter-item\" layout=\"row\" layout-align=\"end center\">\n                            <md-select ng-model=\"$ctrl.toState\" placeholder=\"Change State to\" class=\"md-no-underline\" ng-change=\"$ctrl.passProposalsTo($ctrl.toState);\" flex>\n                                <md-option value=\"\">-- None --</md-option>\n                                <md-option value=\"DRAFT\">Draft</md-option>\n                                <md-option value=\"OPEN\">Open</md-option>\n                                <md-option value=\"APPROVED\">Approved</md-option>\n                                <md-option value=\"REJECTED\">Rejected</md-option>\n                                <md-option value=\"EXPIRED\">Expired</md-option>\n                            </md-select>\n                        </div>\n                        <div class=\"filter-item\" layout=\"row\" layout-align=\"end center\">\n                            <md-select ng-model=\"$ctrl.toDelete\" placeholder=\"Delete Proposals\" class=\"md-no-underline\" ng-change=\"$ctrl.deleteProposals($ctrl.toDelete); $ctrl.toDelete=\'\';\" flex>\n                                <md-option value=\"\">-- None --</md-option>\n                                <md-option value=\"1\">Selected</md-option>\n                                <md-option value=\"2\">All</md-option>\n                            </md-select>\n                        </div>\n\n                    </md-card-content>\n                </md-card>\n            </div>\n        </div>\n    </div>\n</md-content>\n");
$templateCache.put("app/components/rankings/rankings.html","<div flex layout=\"row\" layout-align=\"space-between center\">\n    <div class=\"ranking-item\" ng-repeat=\"ranking in $ctrl.organization.$rankings\">\n	<span>{{$ctrl.indicatorAbbrev(ranking)}}</span>\n	{{ranking.position}} / {{ranking.population}}\n	<md-tooltip>\n	    {{ranking.indicator}}\n	</md-tooltip>\n    </div>\n</div>\n");
$templateCache.put("app/components/relatedLinks/relatedLinks.html","<div ng-show=\"$ctrl.links.length == 0\">\n    <p>No Links to Show</p>\n</div>\n\n<md-list>\n    <md-list-item ng-repeat=\"link in $ctrl.links\" layout=\"row\">\n        <div layout=\"row\" layout-align=\"space-between center\">\n	    <span flex=\"2\" style=\"background-color: #4a4a4a; padding: 2px; font-size: 10px; font-weight: bold; margin-right: 10px; color: #fff\">\n		{{link.$category.name.charAt(0)}}\n		<md-tooltip>\n		    {{link.$category.name}}\n		</md-tooltip>\n	    </span>\n	    <span flex=\"80\" style=\"white-space: nowrap; overflow: hidden; text-overflow: ellipsis\">\n		<a href=\"{{link.link}}\" target=\"_blank\">{{link.link}}</a>\n	    </span>\n	    <span flex=\"10\">\n		<a href=\"#\" ng-click=\"link.$destroy()\" class=\"md-button md-icon-button\"><md-icon>delete</md-icon></a>\n	    </span>\n        </div>\n    </md-list-item>\n</md-list>\n\n<md-input-container class=\"md-block\">\n    <label>Novo Link</label>\n    <input type=\"text\" ng-model=\"$ctrl.newLinkUrl\" ng-change=\"$ctrl.autoSelectCategory($ctrl.newLinkUrl)\">\n</md-input-container>\n\n<div layout=\"row\" layout-align=\"start center\">\n    <md-input-container flex=\"70\">\n	<md-select ng-model=\"$ctrl.newLinkCategory\" placeholder=\"Select Category\">\n            <md-option ng-value=\"category.id\" ng-repeat=\"category in $ctrl.categories\">{{category.name}}</md-option>\n	</md-select>\n    </md-input-container>\n\n    <md-button ng-click=\"$ctrl.createNewLink($ctrl.newLinkCategory, $ctrl.newLinkUrl)\" ng-disabled=\"!$ctrl.newLinkCategory || !$ctrl.newLinkUrl\">ADD\n    </md-button>\n</div>\n");
$templateCache.put("app/components/remindersList/remindersList.html","<md-content>\n\n    <div class=\"padding\">\n        <div layout=\"row\" layout-align=\"center center\">\n            <h1>Reminders</h1>\n            <span flex></span>\n        </div>\n\n        <md-card>\n            <md-input-container>\n                <input type=\"text\" placeholder=\"Name\" ng-model=\"$ctrl.newReminder.name\">\n            </md-input-container>\n            <md-input-container>\n            <input mdc-datetime-picker date=\"true\" time=\"true\" type=\"text\" id=\"time\" short-time=\"true\" show-todays-date placeholder=\"Time\" min-date=\"minDate\" format=\"MMMM DD YYYY, HH:mm\" ng-change=\"vm.saveChange()\" ng-model=\"$ctrl.newReminder.remind_at\">\n            </md-input-container>\n            <md-button ng-click=\"$ctrl.createReminder()\">\n                Add Reminder\n            </md-button>\n        </md-card>\n        <br><br>\n        <input type=\"text\" ng-model=\"$ctrl.searchText\" class=\"title-input\" placeholder=\"search\" ng-change=\"$ctrl.search()\">\n\n        <md-card>\n            <md-list>\n                <md-list-item ng-repeat=\"reminder in $ctrl.reminders | orderBy: \'name\'\">\n                    <div layout=\"row\">\n                        <span flex>{{reminder.name}} - {{reminder.remindAt | amDateFormat:\'MMMM DD YYYY, HH:mm\'}}</span>\n                        <a href=\"#\" ng-click=\"reminder.$destroy()\" class=\"md-button md-icon-button\"><md-icon>delete</md-icon></a>\n                    </div>\n\n                </md-list-item>\n            </md-list>\n        </md-card>\n    </div>\n\n</md-content>\n");
$templateCache.put("app/components/search/search.html","<input class=\"search-box\" type=\"text\" ng-model=\"$ctrl.searchText\" ng-change=\"$ctrl.$rootScope.$emit(\'searchText\', $ctrl.searchText)\" placeholder=\"{{::$ctrl.label}} \">\n");
$templateCache.put("app/components/searchableSelector/searchableSelector.html","<md-input-container class=\"md-block project-select\">\n    <md-select ng-model=\"$ctrl.ngModel\" ng-change=\"$ctrl.selectItemProxy()\" class=\"md-no-underline\">\n        <md-select-header>\n            <input ng-model=\"$ctrl.searchText\" type=\"search\" placeholder=\"{{$ctrl.searchPlaceholder}}\" style=\"width: 90%; height: 30px; border: none; outline: none; padding: 15px\" ng-change=\"$ctrl.searchItemsProxy()\" ng-keydown=\"$event.stopPropagation();\" force-select-focus ng-model-options=\"{updateOnDefault: True, debounce: {\'default\': 500}}\">\n        </md-select-header>\n	<md-option ng-click=\"$ctrl.showDialog()\" style=\"color: #3f51b5; background-color: #eee\">+ Add Item</md-option>\n        <md-option ng-value=\"item\" ng-repeat=\"item in $ctrl.items\" class=\"hide-icons\">\n            <div layout=\"row\" layout-align=\"center center\">\n                <span>{{$ctrl.displayTF(item)}}</span>\n            </div>\n        </md-option>\n	<div ng-if=\"$ctrl.items.length === 0\" style=\"padding: 15px\"><em>No Matches</em></div>\n    </md-select>\n</md-input-container>\n");
$templateCache.put("app/components/tagDetails/tagDetails.html","<md-content ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 300, \'blur\': 0}, updateOnDefault: true}\" layout=\"row\" layout-wrap layout-align=\"space-around stretch\">\n\n    <md-card flex=\"30\" ng-if=\"$ctrl.tag.isIndustry\">\n	<md-card-header>\n	    <md-card-title>\n		Caracterização e Recursos\n	    </md-card-title>\n	</md-card-header>\n	<md-card-content class=\"industry-characterization\">\n	    {{$ctrl.tag.description}}\n	</md-card-content>\n    </md-card>\n\n    <md-card flex=\"30\" class=\"organization-tag-list\" ng-if=\"$ctrl.tag.isIndustry\">\n	<md-card-header>\n	    <md-card-title>\n		Empresas Setor\n	    </md-card-title>\n	</md-card-header>\n	<md-card-content>\n	    <div>\n		<div ng-repeat=\"organizationTag in $ctrl.organizationTags\" layout=\"row\" layout-align=\"space-between center\" class=\"entry\">\n		    <span flex=\"60\"><a ui-sref=\"organizationDetails({id: organizationTag.organization})\">{{organizationTag.$_(\'organization\').name}}</a></span>\n		    <span flex=\"40\">{{organizationTag.$_(\'organization\').profileLevel}}</span>\n		</div>\n	    </div>\n	</md-card-content>\n	<md-card-footer>\n	</md-card-footer>\n    </md-card>\n\n    <md-card flex=\"30\" class=\"quick-add\" ng-if=\"$ctrl.tag.isIndustry\">\n	<md-card-header>\n	    <md-card-title>\n		Quick Add\n	    </md-card-title>\n	</md-card-header>\n	<md-card-content>\n	    <form>\n	    <md-input-container class=\"md-block\">\n		<label>Nome</label>\n		<input type=\"text\" ng-model=\"$ctrl.newOrganization.name\">\n	    </md-input-container>\n	    <md-input-container class=\"md-block\">\n                <label>NIF</label>\n                <input type=\"text\" ng-model=\"$ctrl.newOrganization.nif\">\n	    </md-input-container>\n	    <md-input-container class=\"md-block\">\n		<label>Ano Fundação</label>\n		<input type=\"text\" ng-model=\"$ctrl.newOrganization.foundation\">\n	    </md-input-container>\n	    <md-input-container class=\"md-block\">\n		<label>Dimensão</label>\n		<md-select placeholder=\"Dimensão\" ng-model=\"$ctrl.newOrganization.size\">\n		    <md-option value=\"B\">1-10 colaboradores</md-option>\n		    <md-option value=\"C\">11-50 colaboradores</md-option>\n		    <md-option value=\"D\">51-200 colaboradores</md-option>\n		    <md-option value=\"E\">201-500 colaboradores</md-option>\n		    <md-option value=\"F\">501-1000 colaboradores</md-option>\n		    <md-option value=\"G\">1001-5000 colaboradores</md-option>\n		    <md-option value=\"H\">5001-10000 colaboradores</md-option>\n		    <md-option value=\"I\">10001+ colaboradores</md-option>\n		</md-select>\n	    </md-input-container>\n	    <md-input-container class=\"md-block\">\n		<label>Volume Negócios</label>\n		<md-select placeholder=\"Volume Negócios\" ng-model=\"$ctrl.newOrganization.turnover\">\n		    <md-option value=\"{{tier}}\" ng-repeat=\"tier in [\'A\', \'B\', \'C\', \'D\', \'E\', \'F\', \'G\', \'H\']\">{{tier | companyTurnovers}}</md-option>\n		</md-select>\n	    </md-input-container>\n	    <md-input-container class=\"md-block\">\n		<label>Concelho</label>\n		<md-select placeholder=\"Concelho\" ng-model=\"$ctrl.newOrganization.municipality\">\n		    <md-option value=\"{{municipality.id}}\" ng-repeat=\"municipality in $ctrl.municipalities\">\n			{{municipality.name}}\n		    </md-option>\n		</md-select>\n	    </md-input-container>\n	    <md-button class=\"md-primary md-raised\" ng-click=\"$ctrl.quickAdd()\">\n		<md-icon>add</md-icon>\n		Quick Add\n	    </md-button>\n	    </form>\n	</md-card-content>\n    </md-card>\n\n    <md-card flex=\"30\" ng-if=\"$ctrl.tag.isIndustry\">\n	<md-card-header>\n	    <md-card-title>\n		Notas\n	    </md-card-title>\n	</md-card-header>\n	<md-card-content>\n	    <div>\n		<div ng-repeat=\"comment in $ctrl.tag.$comments\">\n		    <comment data=\"comment\"></comment>\n		</div>\n	</div></md-card-content>\n	<md-card-footer>\n	    <md-input-container style=\"width: 80%\">\n		<label>Nota</label>\n		<textarea ng-model=\"$ctrl.newCommentContent\" required md-maxlength=\"1024\"></textarea>\n	    </md-input-container>\n	    <md-button class=\"md-icon-button\" ng-click=\"$ctrl.createComment($ctrl.organization, $ctrl.newCommentContent)\">\n		<md-icon>\n		    add\n		    <md-tooltip>Adicionar Nota</md-tooltip>\n		</md-icon>\n	    </md-button>\n	</md-card-footer>\n    </md-card>\n\n    <md-card flex=\"30\">\n	<md-card-header>\n	    <md-card-title>\n		Configurações\n	    </md-card-title>\n	</md-card-header>\n	<md-card-content>\n	    <form>\n		<md-input-container class=\"md-block\">\n		    <label>Nome</label>\n		    <input type=\"text\" ng-model=\"$ctrl.tag.name\" ng-change=\"$ctrl.tag.$save([\'name\'])\">\n		</md-input-container>\n		<md-input-container class=\"md-block\">\n		    <label>Description</label>\n		    <input type=\"text\" ng-model=\"$ctrl.tag.description\" ng-change=\"$ctrl.tag.$save([\'description\'])\">\n		</md-input-container>\n		<md-switch ng-model=\"$ctrl.tag.isActive\" class=\"md-warn\" aria-label=\"Tag is in use\" ng-change=\"$ctrl.tag.$save([\'isActive\'])\">\n		    Is Active\n		</md-switch>\n		<md-switch ng-model=\"$ctrl.tag.isIndustry\" class=\"md-warn\" aria-label=\"Tag is an Industry\" ng-change=\"$ctrl.tag.$save([\'isIndustry\'])\">\n		    Is Industry\n		</md-switch>\n		<md-switch ng-model=\"$ctrl.tag.isTarget\" class=\"md-warn\" aria-label=\"Industry is a target\" ng-change=\"$ctrl.tag.$save([\'isTarget\'])\">\n		    Is Target\n		</md-switch>\n\n	    </form>\n	</md-card-content>\n    </md-card>\n\n    <files-manager ng-if=\"$ctrl.tag.isIndustry\" flex=\"30\" collection=\"$ctrl.tag.$files\" upload-file=\"$ctrl.tag.$files.$create({industry: $ctrl.tag.id, path: path, name: name})\">\n\n</md-content>\n");
$templateCache.put("app/components/tagsList/tagsList.html","<md-content>\n\n    <div class=\"padding\">\n        <div layout=\"row\" layout-align=\"center center\">\n            <h1>Tags</h1>\n            <span flex></span>\n            <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.displayNewTagModal()\">\n                <md-icon>add</md-icon>\n                Add Tag\n            </md-button>\n        </div>\n\n	<md-input-container>\n            <input type=\"text\" ng-model=\"$ctrl.searchText\" class=\"search\" placeholder=\"Search Name\" ng-change=\"$ctrl.tags.$refresh({name__icontains: $ctrl.searchText})\" autocomplete=\"off\">\n	</md-input-container>\n	<md-input-container>\n	    <label>Industry</label>\n	    <md-select ng-model=\"$ctrl.industryFilter\" ng-change=\"$ctrl.changeFilters(\'is_industry\', $ctrl.industryFilter)\">\n		<md-option value=\"\">ALL</md-option>\n		<md-option value=\"true\">Just Industries</md-option>\n	    </md-select>\n	</md-input-container>\n\n\n\n	<md-card class=\"prospector-table\">\n	    <div flex layout=\"row\" class=\"header\">\n		<div flex=\"25\" class=\"flush-left\">Name</div>\n		<div flex=\"25\" class=\"center\">Description</div>\n		<div flex=\"10\" class=\"center\">Industry</div>\n		<div flex=\"10\" class=\"center\">Active</div>\n		<div flex=\"15\" class=\"center\">Count</div>\n		<div flex=\"10\" class=\"center\">Average</div>\n		<div flex=\"5\" class=\"center\">Target</div>\n	    </div>\n\n\n	    <div flex layout=\"row\" ng-repeat=\"tag in $ctrl.tags | orderBy: \'name\'\" ui-sref=\"tagDetails({id: tag.id})\" class=\"body\">\n		<div flex=\"25\" class=\"truncate\">{{tag.name}}</div>\n		<div flex=\"25\" class=\"center truncate\">{{tag.description}}</div>\n		<div flex=\"10\" class=\"center\">{{tag.isIndustry ? \'Yes\' : \'No\'}}</div>\n		<div flex=\"10\" class=\"center\">{{tag.isActive ? \'Yes\' : \'No\'}}</div>\n		<div flex=\"15\" class=\"center\">{{tag.count}}</div>\n		<div flex=\"10\" class=\"center\">{{tag.organizationAverage}}</div>\n		<div flex=\"5\" style=\"text-align: center\">\n		    <md-icon style=\"outline: none; cursor: pointer\" ng-style=\"{ color: tag.isTarget ? \'green\' : \'#eee\' }\">\n			done\n		    </md-icon>\n		</div>\n\n	    </div>\n	</md-card>\n	<div style=\"float: right; font-size: 13px; color: #4a4a4a; margin-right: 25px\">{{$ctrl.tags.length}} of {{$ctrl.tags.$totalCount}} tags</div>\n    </div>\n    <div>\n        <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.tags.$page=$ctrl.tags.$page - 1; $ctrl.tags.$refresh()\">Previous</md-button>\n        <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.tags.$page = $ctrl.tags.$page +1; $ctrl.tags.$refresh()\">Next</md-button>\n</div></md-content>\n");
$templateCache.put("app/components/userProfile/userProfile.html","<md-content ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 1000, \'blur\': 0}, updateOnDefault: true}\">\n    <div class=\"padding\">\n\n        <user-badge user=\"$ctrl.user\" imgsize=\"20\"></user-badge>\n        <br> <br> <br>\n        <h2 class=\"text-fade\">Upcoming</h2>\n\n        <md-list as-sortable=\"$ctrl.sortableListeners\" ng-model=\"$ctrl.user.$openTasks\">\n\n            <md-list-item ng-repeat=\"task in $ctrl.user.$openTasks | orderBy: \'order\'\" layout=\"row\" as-sortable-item=\"task\">\n                <div layout=\"row\">\n                    <md-icon as-sortable-item-handle style=\"margin-right: 5px; opacity: 0.5; cursor: move\">drag_handle</md-icon>\n                    <task-preview task=\"task\" flex></task-preview>\n                </div>\n            </md-list-item>\n\n\n            <md-list-item cg-busy=\"$ctrl.newTask.$promise\">\n                <div layout=\"row\" style=\"width: 100%; padding-top: 15px\">\n                    <div layout=\"row\" layout-align=\"center center\" flex class=\"new-task-fake-input\">\n                        <input type=\"text\" ng-model=\"$ctrl.newTaskName\" flex placeholder=\"Task name\">\n                        <md-input-container class=\"no-margin\">\n                            <label>Project</label>\n                            <md-select ng-model=\"$ctrl.newTaskProject\" aria-label=\"Select a project\">\n                                <md-option><span class=\"text-fade\">None</span></md-option>\n                                <md-option ng-repeat=\"project in $root.projects | orderBy: \'name\'\" ng-value=\"project.id\">\n                                    <div layout=\"row\" layout-align=\"center center\">\n                                        <div>{{project.name}}</div>\n                                    </div>\n                                </md-option>\n                            </md-select>\n                        </md-input-container>\n                    </div>\n                    <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.createTask($ctrl.newTaskName, $ctrl.newTaskProject)\">\n                        <md-icon>add</md-icon>\n                        Add task\n                    </md-button>\n                </div>\n            </md-list-item>\n        </md-list>\n    </div>\n</md-content>\n");
$templateCache.put("app/components/userStoriesList/userStoriesList.html","<md-content class=\"page-list\" flex>\n    <div class=\"padding\">\n        <div layout=\"row\" layout-align=\"center center\">\n            <h1>User Stories</h1>\n            <span flex></span>\n            <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.displayNewUserStoryModal()\">\n                <md-icon>add</md-icon>\n                Add User Story\n            </md-button>\n        </div>\n\n        <div layout=\"row\" class=\"filters-bar\">\n            <div layout=\"column\" layout-align=\"center center\">\n                <md-icon>search</md-icon>\n            </div>\n            <search label=\"\'Search User Stories\'\"></search>\n        </div>\n        <br>\n        <md-list>\n            <md-list-item ui-sref=\"userStoryDetails({id: story.id})\" ng-repeat=\"story in $ctrl.userStories\">\n                <h3 flex style=\"margin-left: 15px\">{{ story.name }}</h3>\n                <div layout=\"column\" layout-align=\"center end\" style=\"margin-left: 10px\">\n                    <md-button class=\"md-icon-button\" ng-click=\"story.$destroy()\">\n                        <md-icon>delete</md-icon>\n                    </md-button>\n                </div>\n            </md-list-item>\n        </md-list>\n\n        <div layout=\"row\" layout-align=\"center center\">\n            <pagination size=\"25\" count=\"$ctrl.userStories.$totalCount\">\n        </div>\n    </div>\n</md-content>\n");
$templateCache.put("app/components/userStoryDetails/userStoryDetails.html","<md-toolbar class=\"proposal-toolbar\">\n    <div class=\"md-toolbar-tools\">\n        <div layout=\"row\" layout-align=\"start center\" class=\"editable-wrap\">\n            <div layout=\"column\" layout-align=\"center center\">\n                <md-button class=\"md-icon-button\" ng-if=\"$ctrl.userStory.proposal\" ui-sref=\"proposalDetails({id: $ctrl.userStory.proposal})\">\n                    <md-icon style=\"color: black\">\n                        arrow_back\n                    </md-icon>\n                </md-button>\n                <md-button class=\"md-icon-button\" ng-if=\"!$ctrl.userStory.proposal\" ui-sref=\"userStoriesList\">\n                    <md-icon style=\"color: black\">\n                        arrow_back\n                    </md-icon>\n                </md-button>\n            </div>\n            <div layout=\"column\" layout-align=\"center center\" flex>\n                <md-input-container class=\"editable-wrap\">\n                    <textarea class=\"title-input editable-wrap\" style=\"font-size: 22px; margin: 2px\" ng-model=\"$ctrl.userStory.name\" aria-label=\"User Story Name\" ng-change=\"$ctrl.userStory.$save([\'name\'])\" ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 1000, \'blur\': 0}, updateOnDefault: true}\" maxlength=\"150\"></textarea>\n                </md-input-container>\n            </div>\n        </div>\n    </div>\n</md-toolbar>\n<md-toolbar class=\"proposal-toolbar\" ng-if=\"$ctrl.userStory.proposal\" style=\"min-height: 48px; max-height: 48px; background-color: #f2f2f2 !important\">\n    <div class=\"md-toolbar-tools\">\n        <md-nav-bar md-selected-nav-item=\"$ctrl.currentNav\" aria-label=\"navigation\">\n            <md-nav-item md-nav-click=\"$ctrl.currentNav=\'details\';\" name=\"details\">\n                Details\n            </md-nav-item>\n            <md-nav-item md-nav-click=\"$ctrl.currentNav=\'discussion\';\" name=\"discussion\">\n                Discussion\n            </md-nav-item>\n        </md-nav-bar>\n    </div>\n</md-toolbar>\n\n<md-content ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 1000, \'blur\': 0}, updateOnDefault: true}\" flex>\n    <div class=\"padding\" layout=\"column\" flex>\n        <div ng-if=\"$ctrl.currentNav==\'details\'\" flex>\n            <!--Description-->\n            <div layout=\"row\" layout-align=\"start center\">\n                <div layout=\"column\" flex>\n                    <h2>Description</h2>\n                </div>\n                <div layout=\"column\">\n                    <div layout=\"row\">\n                        <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.userStory.description=null; $ctrl.userStory.$save([\'description\']);\">\n                            <md-icon>\n                                clear\n                            </md-icon>\n                            <span>Clear</span>\n                        </md-button>\n                        <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.userStory.$save([\'description\'])\">\n                            <md-icon>\n                                save\n                            </md-icon>\n                            <span>Save</span>\n                        </md-button>\n                    </div>\n\n                </div>\n            </div>\n            <div layout=\"row\" layout-align=\"center center\">\n                <md-card class=\"edit-description\" flex>\n                    <md-card-content class=\"text-second\">\n                        <div text-angular ng-model=\"$ctrl.userStory.description\" ta-text-editor-class=\"clearfix border-around container\" ta-html-editor-class=\"border-around\" ta-toolbar=\"[[\'h1\',\'h2\',\'h3\',\'h4\',\'h5\',\'h6\',\'p\',\'quote\',\'ul\',\'ol\',\'insertLink\'],[\'bold\',\'italics\',\'underline\',\'strikeThrough\',\'justifyLeft\',\'justifyCenter\',\'justifyRight\',\'justifyFull\',\'indent\',\'outdent\',\'undo\',\'redo\',\'clear\'], [\'wordcount\', \'charcount\']]\"></div>\n                    </md-card-content>\n                </md-card>\n            </div>\n            <br><br>\n            <div layout=\"row\" layout-align=\"start center\" ng-if=\"$ctrl.userStory.proposal\">\n                <div layout=\"column\" flex>\n                    <h2>Costs</h2>\n                </div>\n                <div layout=\"column\" layout-align=\"center center\" style=\"margin-right: 5px\">\n                    <span><i>Total:</i> {{$ctrl.userStory.price}}</span>\n                </div>\n            </div>\n            <br>\n            <div layout=\"row\" layout-align=\"center center\" layout-wrap ng-if=\"$ctrl.userStory.proposal\" style=\"margin: 0px 20px\">\n                <div layout=\"column\" ng-repeat=\"cost in $ctrl.userStory.$costs\" class=\"block-border\" style=\"margin: 5px\">\n                    <div layout=\"row\">\n                        <div layout=\"column\" layout-align=\"center center\" style=\"margin-right: 5px\">\n                            <span>{{cost.$component.name}}</span>\n                        </div>\n\n                        <div layout=\"column\" layout-align=\"center center\">\n                            <md-input-container style=\"max-width: 100px; min-width: 50px\">\n                                <input type=\"text\" style=\"text-align: center; font-weight: bold\" ng-model=\"cost.estimated\" aria-label=\"Estimated Cost\" ng-change=\"$ctrl.saveCost(cost)\">\n                            </md-input-container>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div ng-if=\"$ctrl.currentNav==\'discussion\'\" flex>\n            <md-list>\n                <md-list-item ng-repeat=\"comment in $ctrl.userStory.$comments | orderBy: \'created\' track by comment.id\">\n                    <md-card flex>\n                        <!--<md-card-content class=\"text-second\" ng-bind-html=\"comment.content | unsafe\"></md-card-content>-->\n                        <md-card-content>\n                            <div layout=\"row\" layout-align=\"space-between center\">\n                                <div layout=\"row\" layout-align=\"start center\" flex>\n                                    <img ng-src=\"{{comment.$user.avatar | mediaUrl}}\" class=\"avatar-xs\" style=\"margin-right: 10px\">\n                                    <span class=\"text-fade\">{{::comment.$user.name}}</span>\n                                </div>\n                                <span class=\"text-fade\">{{::comment.created | amCalendar}}</span>\n                            </div>\n                            <p class=\"comment-content\" bind-html-compile=\"::comment.content | nl2br\"></p>\n                        </md-card-content>\n                    </md-card>\n                </md-list-item>\n            </md-list>\n        </div>\n    </div>\n</md-content>\n\n<div layout=\"row\" class=\"new-comment-area\" ng-if=\"$ctrl.currentNav==\'discussion\'\">\n    <img ng-src=\"{{$root.me.avatar | mediaUrl}}\">\n    <md-input-container class=\"md-block\" flex>\n        <textarea type=\"text\" ng-enter=\"$ctrl.addComment();\" placeholder=\"Write something...\" ng-model=\"$ctrl.newComment.content\" aria-label=\"New Comment Content\"></textarea>\n    </md-input-container>\n    <md-button class=\"send-btn md-icon-button md-accent md-raised\" ng-click=\"$ctrl.addComment();\">\n        <md-icon>send</md-icon>\n    </md-button>\n</div>");
$templateCache.put("app/components/userStorySelector/userStorySelector.html","<md-dialog aria-label=\"List dialog\">\n    <md-dialog-content class=\"md-dialog-content\" cg-busy=\"selectedUserStory.$promise\">\n\n        <div layout=\"row\" layout-align=\"center center\" style=\"margin-bottom: 20px\">\n            <h1 style=\"margin: 0\">Select User Story</h1>\n            <span flex></span>\n            <md-button ng-click=\"closeDialog()\" class=\"md-icon-button\" style=\"margin-left: 20px\">\n                <md-icon>close</md-icon>\n            </md-button>\n        </div>\n\n        <div layout=\"column\" ng-if=\"userStories.length > 0\">\n            <div layout=\"row\" layout-align=\"center center\">\n                <i class=\"text-center text-fade\" style=\"font-size: 12px\">\n                    (Double click to import User Story)\n                </i>\n            </div>\n\n            <md-list>\n                <md-list-item ng-repeat=\"userStory in userStories\" ng-dblclick=\"sendUserStory(userStory.name)\">\n                    <span>{{::userStory.name}}</span>\n                </md-list-item>\n            </md-list>\n        </div>\n\n        <div layout=\"row\" layout-align=\"center center\" ng-if=\"!userStories.length\">\n            <h3 class=\"text-center text-fade\">\n                No user story available\n            </h3>\n        </div>\n\n    </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/components/workspaceDetails/workspaceDetails.html","<md-content ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 1000, \'blur\': 0}, updateOnDefault: true}\" layout=\"row\" layout-wrap layout-align=\"space-around stretch\">\n\n    <h1 class=\"md-block\" flex=\"95\" layout=\"row\" layout-align=\"space-between center\">\n	<div flex=\"55\">\n	    <md-button class=\"md-icon-button\" aria-label=\"Back\" ng-click=\"$root.goBack();\">\n		<md-icon>arrow_back</md-icon>\n	    </md-button>\n	    {{$ctrl.workspace.name}}\n	</div>\n	<div flex=\"5\">\n	    <md-button class=\"md-icon-button\" aria-label=\"Back\" ng-click=\"$ctrl.deleteOrganization();\" style=\"float: right\">\n		<md-icon>delete</md-icon>\n	    </md-button>\n	</div>\n    </h1>\n\n    <md-card flex=\"40\">\n	<md-card-header>\n	    <md-card-title>\n		Fields\n	    </md-card-title>\n	</md-card-header>\n	<md-card-content>\n	    <div ng-repeat=\"(key, value) in $ctrl.workspace.settings.organizationsFields\">\n		<md-switch ng-model=\"$ctrl.workspace.settings.organizationsFields[key]\" ng-change=\"$ctrl.saveWorkspace()\">\n		    {{key}}\n		</md-switch>\n	    </div>\n	</md-card-content>\n    </md-card>\n\n    <md-card flex=\"40\">\n	<md-card-header>\n	    <md-card-title>\n		Filters\n	    </md-card-title>\n	</md-card-header>\n	<md-card-content>\n	    <div ng-repeat=\"(key, value) in $ctrl.workspace.settings.organizationsFilters\">\n		<md-switch ng-model=\"$ctrl.workspace.settings.organizationsFilters[key]\" ng-change=\"$ctrl.saveWorkspace()\">\n		    {{key}}\n		</md-switch>\n	    </div>\n	</md-card-content>\n    </md-card>\n\n\n</md-content>\n");
$templateCache.put("app/shared/html/cgbusy/cgbusy.template.html","<div class=\"cg-busy-processing-wrapper\" layout=\"row\" layout-align=\"center center\">\n    <span>{{$message}}</span>\n    <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div>\n\n\n<style>\n    .cg-busy-processing-wrapper {\n        position: relative;\n        width: 100%;\n        height: 100%;\n    }\n</style>\n");
$templateCache.put("app/shared/html/menuBtn/menuBtn.html","<md-button class=\"md-icon-button\" ng-click=\"$ctrl.openMenu()\">\n    <md-icon>menu</md-icon>\n</md-button>\n");
$templateCache.put("app/components/auth/views/auth.forgot.html","<div layout=\"column\" flex>\n    <md-toolbar>\n        <div class=\"md-toolbar-tools\">\n            <md-button class=\"md-icon-button\" ui-sref=\"login\">\n                <md-icon>arrow_back</md-icon>\n            </md-button>\n            <span>Recuperar password</span>\n        </div>\n    </md-toolbar>\n\n    <md-content class=\"no-background\" id=\"login-view\" flex layout=\"column\" layout-align=\"center center\">\n\n        <md-card>\n            <md-card-content class=\"auth-wrapper\">\n                <md-input-container class=\"general-login-error\" ng-if=\"vm.member.data.non_field_errors\">\n                    <div ng-messages>\n                        <div ng-repeat=\"message in vm.member.data.non_field_errors\">\n                            {{message}}\n                        </div>\n                    </div>\n                </md-input-container>\n\n                <p class=\"text-fade\" translate=\"\">\n                    <small>Insere o teu email e vamos enviar instruções de como recuperar a tua password.</small>\n                </p>\n                <form ng-submit=\"vm.requestChange();\" cg-busy=\"vm.requestStatus\" ng-hide=\"vm.requestStatus.$$state.value.status==200\">\n                    <md-input-container class=\"md-block\" flex-gt-sm>\n                        <label>E-mail</label> <input ng-model=\"vm.email\" type=\"email\">\n                        <div ng-messages>\n                            <div ng-if=\"vm.requestStatus.$$state.value.data.detail\">\n                                {{vm.requestStatus.$$state.value.data.detail}}\n                            </div>\n                            <div ng-repeat=\"message in vm.requestStatus.$$state.value.data.email\" ng-if=\"vm.requestStatus.$$state.value.data.email\">\n                                {{message}}\n                            </div>\n                        </div>\n                    </md-input-container>\n\n                    <div layout=\"row\" layout-align=\"end center\">\n                        <md-button class=\"no-margin md-raised md-accent\" type=\"submit\" ng-disabled=\"!vm.email\"><span translate>Recupear password</span>\n                        </md-button>\n                    </div>\n                    <p class=\"text-justify text-xs text-second text-fade\" translate=\"\">\n                        <small>\n                            Se não receberes um email nos próximos 2 minutos, por favor verifique o spam\n                        </small>\n                    </p>\n\n                </form>\n\n                <div ng-if=\"vm.requestStatus.$$state.value.status==200\" layout=\"column\" layout-padding=\"\" layout-align=\"center center\" style=\"border: solid rgba(150, 255, 150, 0.6) 2px; background-color: rgba(150, 255, 150, 0.2)\">\n                    <md-icon>email_outline</md-icon>\n                    <p style=\"text-align: center\" translate=\"\">\n                        Um link foi enviado para o seu email para alterares a tua password <br>\n                    </p>\n                </div>\n            </md-card-content>\n        </md-card>\n\n    </md-content>\n\n    <style>\n        .wrapper {\n            max-width: 400px;\n            margin: auto;\n            padding-top: 50px;\n        }\n\n        #menu-sidenav {\n            border-right: solid 1px rgba(0, 0, 0, 0.1);\n        }\n    </style>\n</div>\n");
$templateCache.put("app/components/auth/views/auth.login.view.html","<md-content class=\"no-background\" id=\"login-view\" flex layout=\"column\" layout-align=\"center center\">\n\n    <h1 class=\"login-project-title\">The Prospector</h1>\n\n    <md-card>\n        <md-card-content class=\"auth-wrapper\">\n            <br>\n            <form ng-submit=\"vm.login();\" style=\"min-width: 400px\">\n                <md-input-container class=\"general-login-error no-margin\" ng-if=\"vm.member.data.non_field_errors\">\n                    <div ng-messages class=\"text-center\">\n                        <small ng-repeat=\"message in vm.member.data.non_field_errors\">\n                            {{message}}\n                        </small>\n                    </div>\n                </md-input-container>\n                <md-input-container class=\"md-block\" flex-gt-sm>\n                    <label>Email</label>\n                    <input type=\"text\" ng-model=\"vm.email\">\n                    <div ng-messages>\n                        <div ng-repeat=\"message in vm.member.data.email\">\n                            {{message}}\n                        </div>\n                    </div>\n                </md-input-container>\n\n                <md-input-container class=\"md-block\" flex-gt-sm>\n                    <label translate=\"\">Palavra-passe</label>\n                    <input type=\"password\" ng-model=\"vm.password\">\n                    <div ng-messages>\n                        <div ng-repeat=\"message in vm.member.data.password\">\n                            {{message}}\n                        </div>\n                    </div>\n                </md-input-container>\n\n                <div layout=\"column\" layout-align=\"center center\">\n                    <input type=\"submit\" value=\"Entrar\" class=\"md-button md-raised md-accent\">\n                    <a ui-sref=\"forgot\"><small>Esqueceu a password?</small></a>\n                </div>\n            </form>\n        </md-card-content>\n    </md-card>\n\n</md-content>\n");
$templateCache.put("app/components/auth/views/auth.set.password.html","<div layout=\"column\" flex>\n    <md-toolbar>\n        <div class=\"md-toolbar-tools\">\n            <md-button class=\"md-icon-button\" ui-sref=\"login\">\n                <md-icon>arrow_back</md-icon>\n            </md-button>\n            <span>Recuperar password</span>\n        </div>\n    </md-toolbar>\n\n    <md-content class=\"no-background\" id=\"login-view\" flex layout=\"column\" layout-align=\"center center\">\n\n\n        <div class=\"auth-wrapper\">\n            <h1>Entrar</h1>\n            <br>\n            <md-card>\n                <md-card-content>\n                    <p class=\"text-sm\" translate=\"\">Choose a new password.</p>\n                    <form ng-submit=\"vm.setPassword();\" cg-busy=\"vm.requestStatus\">\n                        <md-input-container class=\"md-block\" flex-gt-sm>\n                            <label translate=\"\">New password</label> <input type=\"password\" ng-model=\"vm.password\">\n                            <div ng-messages>\n                                <div>\n                                    {{vm.requestStatus.$$state.value.data.detail}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                        <md-input-container class=\"md-block\" flex-gt-sm>\n                            <label translate=\"\">Confirm password</label>\n                            <input type=\"password\" ng-model=\"vm.confirmPassword\">\n                            <div ng-messages>\n                                <div>\n                                    {{vm.requestStatus.$$state.value.data.detail}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                        <div layout=\"row\" layout-align=\"end end\">\n                            <md-tooltip ng-if=\"vm.password != vm.confirmPassword\">\n                                <span translate>Please check that both passwords matches</span>\n                            </md-tooltip>\n                            <md-button class=\"no-margin\" type=\"submit\" ng-disabled=\"(vm.password != vm.confirmPassword) || !vm.password\">\n                                <span translate>Change password</span>\n                            </md-button>\n                        </div>\n                    </form>\n                </md-card-content>\n            </md-card>\n        </div>\n\n\n    </md-content>\n\n    <style>\n        .wrapper {\n            max-width: 400px;\n            margin: auto;\n            padding-top: 50px;\n        }\n\n        #menu-sidenav {\n            border-right: solid 1px rgba(0, 0, 0, 0.1);\n        }\n    </style>\n</div>\n");
$templateCache.put("app/components/users/editProfile/editProfile.html","<md-content>\n    <div class=\"\" layout=\"row\" layout-margin>\n\n\n        <md-card flex=\"50\">\n            <md-card-content cg-busy=\"$ctrl.user.$promise\">\n                <form ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 1000, \'blur\': 0}, updateOnDefault: true}\">\n                    <h1 class=\"text-center text-fade\">Personal information</h1>\n                    <br> <br>\n\n                    <div layout=\"row\" layout-align=\"center center\">\n                        <div id=\"change-avatar-area\" layout=\"row\" layout-align=\"center center\" style=\"background-image: url(\'{{$ctrl.user.avatar | mediaUrl}}\')\">\n                            <div class=\"change-avatar-btn\" layout=\"row\" layout-align=\"center center\" ngf-select media-auto-upload ng-model=\"$ctrl.user.avatar\" ngf-model-invalid=\"$ctrl.invalidUploadedFiles\" ngf-resize=\"{ratio: \'1:1\', centerCrop: true}\" ngf-max-size=\"2MB\" accept=\"image/*\">\n                                <span>Change avatar</span>\n                            </div>\n                        </div>\n                    </div>\n\n                    <md-input-container class=\"md-block\">\n                        <label>Name</label>\n                        <input type=\"text\" ng-model=\"$ctrl.user.name\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.changeInfo()\">\n                        <div ng-messages>\n                            <div ng-repeat=\"message in $ctrl.user.$response.data.name\">\n                                {{message}}\n                            </div>\n                        </div>\n                    </md-input-container>\n                    <md-input-container class=\"md-block\">\n                        <label>Email</label> <input type=\"email\" ng-model=\"$ctrl.user.email\" disabled=\"disabled\">\n                        <div ng-messages>\n                            <div ng-repeat=\"message in $ctrl.user.$response.data.email\">\n                                {{message}}\n                            </div>\n                        </div>\n                    </md-input-container>\n                </form>\n            </md-card-content>\n        </md-card>\n        <br> <br>\n        <div flex=\"50\">\n            <md-card>\n                <md-card-content>\n                    <form ng-submit=\"$ctrl.changePass()\">\n                        <h1 class=\"text-center text-fade\">Change password</h1>\n                        <br> <br>\n                        <md-input-container class=\"md-block\">\n                            <label>Password</label>\n                            <input type=\"password\" ng-model=\"$ctrl.user.password\" minlength=\"3\">\n                        </md-input-container>\n                        <md-input-container class=\"md-block\">\n                            <label>Confirm password</label>\n                            <input type=\"password\" ng-model=\"$ctrl.user.confirmPassword\">\n                        </md-input-container>\n\n                        <div layout=\"row\" layout-align=\"center\">\n                            <input type=\"submit\" class=\"md-button md-raised md-accent\" value=\"Change\">\n                        </div>\n                    </form>\n                </md-card-content>\n            </md-card>\n        </div>\n	<div flex=\"50\">\n            <md-card>\n		<md-card-header>\n		    <md-card-title>\n			Workspaces\n		    </md-card-title>\n		</md-card-header>\n\n                <md-card-content>\n		    <div ng-repeat=\"workspace in $ctrl.workspaces\">\n			{{::workspace.id}} <a ui-sref=\"workspaceDetails({id: workspace.id})\">{{::workspace.name}}</a>\n		    </div>\n                </md-card-content>\n            </md-card>\n        </div>\n\n    </div>\n</md-content>\n");
$templateCache.put("app/components/users/usersList/usersList.html","<md-content>\n    <div class=\"padding\">\n        <div layout=\"row\" layout-align=\"center center\">\n            <h1>Team</h1>\n            <span flex></span>\n            <md-button class=\"md-raised md-accent\">\n                <md-icon>add</md-icon>\n                Add someone to the team\n            </md-button>\n        </div>\n        <md-card>\n            <table class=\"multi-table editable\">\n                <tr>\n                    <th>&nbsp;</th>\n                    <th align=\"left\">Nome</th>\n                    <th align=\"left\">Email</th>\n                    <th>&nbsp;</th>\n                    <th>&nbsp;</th>\n                </tr>\n                <tr ng-repeat=\"member in $ctrl.members\" cg-busy=\"member.$promise\">\n                    <!-- Member saved -->\n                    <td ng-if-start=\"member.id\" class=\"minimun\" align=\"center\"><b>{{$index + 1}}</b></td>\n                    <td><b>{{member.name}}</b></td>\n                    <td>{{member.email}}</td>\n                    <td>Criado {{member.created | amCalendar}}</td>\n                    <td class=\"minimun\" ng-if-end>\n                        <md-button class=\"md-icon-button\" ng-click=\"member.$destroy()\">\n                            <md-icon>delete</md-icon>\n                        </md-button>\n                    </td>\n\n                    <!-- Brand new member -->\n                    <td ng-if-start=\"!member.id\">\n                        <md-tooltip>Utilizador não salvo. Preencha as informações necessárias</md-tooltip>\n                        <md-icon class=\"md-warn\">warning</md-icon>\n                    </td>\n                    <td ng-class=\"{\'has-error\': member.$response.data.name}\">\n                        <input type=\"text\" ng-model=\"member.name\" placeholder=\"Nome\">\n                        <md-tooltip>\n                                <span ng-repeat=\"msg in member.$response.data.name\">\n                                    {{msg}}\n                                </span>\n                        </md-tooltip>\n                    </td>\n                    <td ng-class=\"{\'has-error\': member.$response.data.email}\">\n                        <input type=\"email\" ng-model=\"member.email\" placeholder=\"Email\">\n                        <md-tooltip>\n                                <span ng-repeat=\"msg in member.$response.data.email\">\n                                    {{msg}}\n                                </span>\n                        </md-tooltip>\n                    </td>\n                    <td ng-class=\"{\'has-error\': member.$response.data.password}\">\n                        <input type=\"password\" ng-model=\"member.password\" placeholder=\"Password\">\n                        <md-tooltip>\n                                <span ng-repeat=\"msg in member.$response.data.password\">\n                                    {{msg}}\n                                </span>\n                        </md-tooltip>\n                    </td>\n                    <td class=\"minimun\" ng-if-end>\n                        <md-button class=\"md-icon-button md-accent\" ng-disabled=\"!member.name || !member.email\" ng-click=\"member.$save()\">\n                            <md-icon>save</md-icon>\n                        </md-button>\n                    </td>\n                </tr>\n            </table>\n        </md-card>\n    </div>\n</md-content>\n");}]);
'use strict';

var cov_1c2k3loppc = function () {
    var path = '/home/lobo/repos/prospector-app/src/routes.js',
        hash = '1c1f71a901fced7dae62e90a01e0fff0bf21f162',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/routes.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 3,
                    column: 22
                }
            },
            '1': {
                start: {
                    line: 7,
                    column: 4
                },
                end: {
                    line: 7,
                    column: 54
                }
            },
            '2': {
                start: {
                    line: 8,
                    column: 4
                },
                end: {
                    line: 8,
                    column: 38
                }
            },
            '3': {
                start: {
                    line: 10,
                    column: 4
                },
                end: {
                    line: 200,
                    column: 7
                }
            },
            '4': {
                start: {
                    line: 27,
                    column: 46
                },
                end: {
                    line: 27,
                    column: 109
                }
            },
            '5': {
                start: {
                    line: 27,
                    column: 95
                },
                end: {
                    line: 27,
                    column: 99
                }
            },
            '6': {
                start: {
                    line: 46,
                    column: 45
                },
                end: {
                    line: 46,
                    column: 114
                }
            },
            '7': {
                start: {
                    line: 46,
                    column: 93
                },
                end: {
                    line: 46,
                    column: 104
                }
            },
            '8': {
                start: {
                    line: 53,
                    column: 60
                },
                end: {
                    line: 53,
                    column: 140
                }
            },
            '9': {
                start: {
                    line: 53,
                    column: 120
                },
                end: {
                    line: 53,
                    column: 130
                }
            },
            '10': {
                start: {
                    line: 60,
                    column: 59
                },
                end: {
                    line: 60,
                    column: 149
                }
            },
            '11': {
                start: {
                    line: 60,
                    column: 121
                },
                end: {
                    line: 60,
                    column: 139
                }
            },
            '12': {
                start: {
                    line: 67,
                    column: 49
                },
                end: {
                    line: 67,
                    column: 124
                }
            },
            '13': {
                start: {
                    line: 67,
                    column: 101
                },
                end: {
                    line: 67,
                    column: 114
                }
            },
            '14': {
                start: {
                    line: 74,
                    column: 64
                },
                end: {
                    line: 74,
                    column: 150
                }
            },
            '15': {
                start: {
                    line: 74,
                    column: 128
                },
                end: {
                    line: 74,
                    column: 140
                }
            },
            '16': {
                start: {
                    line: 81,
                    column: 41
                },
                end: {
                    line: 81,
                    column: 104
                }
            },
            '17': {
                start: {
                    line: 81,
                    column: 85
                },
                end: {
                    line: 81,
                    column: 94
                }
            },
            '18': {
                start: {
                    line: 88,
                    column: 56
                },
                end: {
                    line: 88,
                    column: 130
                }
            },
            '19': {
                start: {
                    line: 88,
                    column: 112
                },
                end: {
                    line: 88,
                    column: 120
                }
            },
            '20': {
                start: {
                    line: 95,
                    column: 70
                },
                end: {
                    line: 95,
                    column: 165
                }
            },
            '21': {
                start: {
                    line: 95,
                    column: 140
                },
                end: {
                    line: 95,
                    column: 155
                }
            },
            '22': {
                start: {
                    line: 102,
                    column: 59
                },
                end: {
                    line: 102,
                    column: 137
                }
            },
            '23': {
                start: {
                    line: 102,
                    column: 118
                },
                end: {
                    line: 102,
                    column: 127
                }
            },
            '24': {
                start: {
                    line: 110,
                    column: 45
                },
                end: {
                    line: 110,
                    column: 140
                }
            },
            '25': {
                start: {
                    line: 110,
                    column: 119
                },
                end: {
                    line: 110,
                    column: 130
                }
            },
            '26': {
                start: {
                    line: 117,
                    column: 41
                },
                end: {
                    line: 117,
                    column: 104
                }
            },
            '27': {
                start: {
                    line: 117,
                    column: 85
                },
                end: {
                    line: 117,
                    column: 94
                }
            },
            '28': {
                start: {
                    line: 124,
                    column: 49
                },
                end: {
                    line: 124,
                    column: 120
                }
            },
            '29': {
                start: {
                    line: 124,
                    column: 101
                },
                end: {
                    line: 124,
                    column: 110
                }
            },
            '30': {
                start: {
                    line: 131,
                    column: 30
                },
                end: {
                    line: 131,
                    column: 78
                }
            },
            '31': {
                start: {
                    line: 131,
                    column: 64
                },
                end: {
                    line: 131,
                    column: 68
                }
            },
            '32': {
                start: {
                    line: 138,
                    column: 46
                },
                end: {
                    line: 138,
                    column: 105
                }
            },
            '33': {
                start: {
                    line: 138,
                    column: 92
                },
                end: {
                    line: 138,
                    column: 95
                }
            },
            '34': {
                start: {
                    line: 145,
                    column: 43
                },
                end: {
                    line: 145,
                    column: 109
                }
            },
            '35': {
                start: {
                    line: 145,
                    column: 89
                },
                end: {
                    line: 145,
                    column: 99
                }
            },
            '36': {
                start: {
                    line: 152,
                    column: 51
                },
                end: {
                    line: 152,
                    column: 129
                }
            },
            '37': {
                start: {
                    line: 152,
                    column: 105
                },
                end: {
                    line: 152,
                    column: 119
                }
            },
            '38': {
                start: {
                    line: 159,
                    column: 65
                },
                end: {
                    line: 159,
                    column: 152
                }
            },
            '39': {
                start: {
                    line: 159,
                    column: 130
                },
                end: {
                    line: 159,
                    column: 142
                }
            },
            '40': {
                start: {
                    line: 166,
                    column: 55
                },
                end: {
                    line: 166,
                    column: 139
                }
            },
            '41': {
                start: {
                    line: 166,
                    column: 113
                },
                end: {
                    line: 166,
                    column: 129
                }
            },
            '42': {
                start: {
                    line: 177,
                    column: 34
                },
                end: {
                    line: 177,
                    column: 87
                }
            },
            '43': {
                start: {
                    line: 177,
                    column: 71
                },
                end: {
                    line: 177,
                    column: 77
                }
            },
            '44': {
                start: {
                    line: 184,
                    column: 49
                },
                end: {
                    line: 184,
                    column: 113
                }
            },
            '45': {
                start: {
                    line: 184,
                    column: 98
                },
                end: {
                    line: 184,
                    column: 103
                }
            },
            '46': {
                start: {
                    line: 191,
                    column: 59
                },
                end: {
                    line: 191,
                    column: 147
                }
            },
            '47': {
                start: {
                    line: 191,
                    column: 125
                },
                end: {
                    line: 191,
                    column: 137
                }
            },
            '48': {
                start: {
                    line: 198,
                    column: 58
                },
                end: {
                    line: 198,
                    column: 135
                }
            },
            '49': {
                start: {
                    line: 198,
                    column: 116
                },
                end: {
                    line: 198,
                    column: 125
                }
            }
        },
        fnMap: {
            '0': {
                name: 'routesConfig',
                decl: {
                    start: {
                        line: 6,
                        column: 9
                    },
                    end: {
                        line: 6,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 6,
                        column: 77
                    },
                    end: {
                        line: 201,
                        column: 1
                    }
                },
                line: 6
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 27,
                        column: 18
                    },
                    end: {
                        line: 27,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 27,
                        column: 46
                    },
                    end: {
                        line: 27,
                        column: 109
                    }
                },
                line: 27
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 27,
                        column: 87
                    },
                    end: {
                        line: 27,
                        column: 88
                    }
                },
                loc: {
                    start: {
                        line: 27,
                        column: 95
                    },
                    end: {
                        line: 27,
                        column: 99
                    }
                },
                line: 27
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 46,
                        column: 25
                    },
                    end: {
                        line: 46,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 46,
                        column: 45
                    },
                    end: {
                        line: 46,
                        column: 114
                    }
                },
                line: 46
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 46,
                        column: 78
                    },
                    end: {
                        line: 46,
                        column: 79
                    }
                },
                loc: {
                    start: {
                        line: 46,
                        column: 93
                    },
                    end: {
                        line: 46,
                        column: 104
                    }
                },
                line: 46
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 53,
                        column: 24
                    },
                    end: {
                        line: 53,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 53,
                        column: 60
                    },
                    end: {
                        line: 53,
                        column: 140
                    }
                },
                line: 53
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 53,
                        column: 106
                    },
                    end: {
                        line: 53,
                        column: 107
                    }
                },
                loc: {
                    start: {
                        line: 53,
                        column: 120
                    },
                    end: {
                        line: 53,
                        column: 130
                    }
                },
                line: 53
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 60,
                        column: 32
                    },
                    end: {
                        line: 60,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 60,
                        column: 59
                    },
                    end: {
                        line: 60,
                        column: 149
                    }
                },
                line: 60
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 60,
                        column: 99
                    },
                    end: {
                        line: 60,
                        column: 100
                    }
                },
                loc: {
                    start: {
                        line: 60,
                        column: 121
                    },
                    end: {
                        line: 60,
                        column: 139
                    }
                },
                line: 60
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 67,
                        column: 27
                    },
                    end: {
                        line: 67,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 67,
                        column: 49
                    },
                    end: {
                        line: 67,
                        column: 124
                    }
                },
                line: 67
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 67,
                        column: 84
                    },
                    end: {
                        line: 67,
                        column: 85
                    }
                },
                loc: {
                    start: {
                        line: 67,
                        column: 101
                    },
                    end: {
                        line: 67,
                        column: 114
                    }
                },
                line: 67
            },
            '11': {
                name: '(anonymous_11)',
                decl: {
                    start: {
                        line: 74,
                        column: 26
                    },
                    end: {
                        line: 74,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 74,
                        column: 64
                    },
                    end: {
                        line: 74,
                        column: 150
                    }
                },
                line: 74
            },
            '12': {
                name: '(anonymous_12)',
                decl: {
                    start: {
                        line: 74,
                        column: 112
                    },
                    end: {
                        line: 74,
                        column: 113
                    }
                },
                loc: {
                    start: {
                        line: 74,
                        column: 128
                    },
                    end: {
                        line: 74,
                        column: 140
                    }
                },
                line: 74
            },
            '13': {
                name: '(anonymous_13)',
                decl: {
                    start: {
                        line: 81,
                        column: 23
                    },
                    end: {
                        line: 81,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 81,
                        column: 41
                    },
                    end: {
                        line: 81,
                        column: 104
                    }
                },
                line: 81
            },
            '14': {
                name: '(anonymous_14)',
                decl: {
                    start: {
                        line: 81,
                        column: 72
                    },
                    end: {
                        line: 81,
                        column: 73
                    }
                },
                loc: {
                    start: {
                        line: 81,
                        column: 85
                    },
                    end: {
                        line: 81,
                        column: 94
                    }
                },
                line: 81
            },
            '15': {
                name: '(anonymous_15)',
                decl: {
                    start: {
                        line: 88,
                        column: 22
                    },
                    end: {
                        line: 88,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 88,
                        column: 56
                    },
                    end: {
                        line: 88,
                        column: 130
                    }
                },
                line: 88
            },
            '16': {
                name: '(anonymous_16)',
                decl: {
                    start: {
                        line: 88,
                        column: 100
                    },
                    end: {
                        line: 88,
                        column: 101
                    }
                },
                loc: {
                    start: {
                        line: 88,
                        column: 112
                    },
                    end: {
                        line: 88,
                        column: 120
                    }
                },
                line: 88
            },
            '17': {
                name: '(anonymous_17)',
                decl: {
                    start: {
                        line: 95,
                        column: 29
                    },
                    end: {
                        line: 95,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 95,
                        column: 70
                    },
                    end: {
                        line: 95,
                        column: 165
                    }
                },
                line: 95
            },
            '18': {
                name: '(anonymous_18)',
                decl: {
                    start: {
                        line: 95,
                        column: 121
                    },
                    end: {
                        line: 95,
                        column: 122
                    }
                },
                loc: {
                    start: {
                        line: 95,
                        column: 140
                    },
                    end: {
                        line: 95,
                        column: 155
                    }
                },
                line: 95
            },
            '19': {
                name: '(anonymous_19)',
                decl: {
                    start: {
                        line: 102,
                        column: 23
                    },
                    end: {
                        line: 102,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 102,
                        column: 59
                    },
                    end: {
                        line: 102,
                        column: 137
                    }
                },
                line: 102
            },
            '20': {
                name: '(anonymous_20)',
                decl: {
                    start: {
                        line: 102,
                        column: 105
                    },
                    end: {
                        line: 102,
                        column: 106
                    }
                },
                loc: {
                    start: {
                        line: 102,
                        column: 118
                    },
                    end: {
                        line: 102,
                        column: 127
                    }
                },
                line: 102
            },
            '21': {
                name: '(anonymous_21)',
                decl: {
                    start: {
                        line: 110,
                        column: 25
                    },
                    end: {
                        line: 110,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 110,
                        column: 45
                    },
                    end: {
                        line: 110,
                        column: 140
                    }
                },
                line: 110
            },
            '22': {
                name: '(anonymous_22)',
                decl: {
                    start: {
                        line: 110,
                        column: 104
                    },
                    end: {
                        line: 110,
                        column: 105
                    }
                },
                loc: {
                    start: {
                        line: 110,
                        column: 119
                    },
                    end: {
                        line: 110,
                        column: 130
                    }
                },
                line: 110
            },
            '23': {
                name: '(anonymous_23)',
                decl: {
                    start: {
                        line: 117,
                        column: 23
                    },
                    end: {
                        line: 117,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 117,
                        column: 41
                    },
                    end: {
                        line: 117,
                        column: 104
                    }
                },
                line: 117
            },
            '24': {
                name: '(anonymous_24)',
                decl: {
                    start: {
                        line: 117,
                        column: 72
                    },
                    end: {
                        line: 117,
                        column: 73
                    }
                },
                loc: {
                    start: {
                        line: 117,
                        column: 85
                    },
                    end: {
                        line: 117,
                        column: 94
                    }
                },
                line: 117
            },
            '25': {
                name: '(anonymous_25)',
                decl: {
                    start: {
                        line: 124,
                        column: 23
                    },
                    end: {
                        line: 124,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 124,
                        column: 49
                    },
                    end: {
                        line: 124,
                        column: 120
                    }
                },
                line: 124
            },
            '26': {
                name: '(anonymous_26)',
                decl: {
                    start: {
                        line: 124,
                        column: 88
                    },
                    end: {
                        line: 124,
                        column: 89
                    }
                },
                loc: {
                    start: {
                        line: 124,
                        column: 101
                    },
                    end: {
                        line: 124,
                        column: 110
                    }
                },
                line: 124
            },
            '27': {
                name: '(anonymous_27)',
                decl: {
                    start: {
                        line: 131,
                        column: 17
                    },
                    end: {
                        line: 131,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 131,
                        column: 30
                    },
                    end: {
                        line: 131,
                        column: 78
                    }
                },
                line: 131
            },
            '28': {
                name: '(anonymous_28)',
                decl: {
                    start: {
                        line: 131,
                        column: 56
                    },
                    end: {
                        line: 131,
                        column: 57
                    }
                },
                loc: {
                    start: {
                        line: 131,
                        column: 64
                    },
                    end: {
                        line: 131,
                        column: 68
                    }
                },
                line: 131
            },
            '29': {
                name: '(anonymous_29)',
                decl: {
                    start: {
                        line: 138,
                        column: 17
                    },
                    end: {
                        line: 138,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 138,
                        column: 46
                    },
                    end: {
                        line: 138,
                        column: 105
                    }
                },
                line: 138
            },
            '30': {
                name: '(anonymous_30)',
                decl: {
                    start: {
                        line: 138,
                        column: 85
                    },
                    end: {
                        line: 138,
                        column: 86
                    }
                },
                loc: {
                    start: {
                        line: 138,
                        column: 92
                    },
                    end: {
                        line: 138,
                        column: 95
                    }
                },
                line: 138
            },
            '31': {
                name: '(anonymous_31)',
                decl: {
                    start: {
                        line: 145,
                        column: 24
                    },
                    end: {
                        line: 145,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 145,
                        column: 43
                    },
                    end: {
                        line: 145,
                        column: 109
                    }
                },
                line: 145
            },
            '32': {
                name: '(anonymous_32)',
                decl: {
                    start: {
                        line: 145,
                        column: 75
                    },
                    end: {
                        line: 145,
                        column: 76
                    }
                },
                loc: {
                    start: {
                        line: 145,
                        column: 89
                    },
                    end: {
                        line: 145,
                        column: 99
                    }
                },
                line: 145
            },
            '33': {
                name: '(anonymous_33)',
                decl: {
                    start: {
                        line: 152,
                        column: 28
                    },
                    end: {
                        line: 152,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 152,
                        column: 51
                    },
                    end: {
                        line: 152,
                        column: 129
                    }
                },
                line: 152
            },
            '34': {
                name: '(anonymous_34)',
                decl: {
                    start: {
                        line: 152,
                        column: 87
                    },
                    end: {
                        line: 152,
                        column: 88
                    }
                },
                loc: {
                    start: {
                        line: 152,
                        column: 105
                    },
                    end: {
                        line: 152,
                        column: 119
                    }
                },
                line: 152
            },
            '35': {
                name: '(anonymous_35)',
                decl: {
                    start: {
                        line: 159,
                        column: 26
                    },
                    end: {
                        line: 159,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 159,
                        column: 65
                    },
                    end: {
                        line: 159,
                        column: 152
                    }
                },
                line: 159
            },
            '36': {
                name: '(anonymous_36)',
                decl: {
                    start: {
                        line: 159,
                        column: 114
                    },
                    end: {
                        line: 159,
                        column: 115
                    }
                },
                loc: {
                    start: {
                        line: 159,
                        column: 130
                    },
                    end: {
                        line: 159,
                        column: 142
                    }
                },
                line: 159
            },
            '37': {
                name: '(anonymous_37)',
                decl: {
                    start: {
                        line: 166,
                        column: 30
                    },
                    end: {
                        line: 166,
                        column: 31
                    }
                },
                loc: {
                    start: {
                        line: 166,
                        column: 55
                    },
                    end: {
                        line: 166,
                        column: 139
                    }
                },
                line: 166
            },
            '38': {
                name: '(anonymous_38)',
                decl: {
                    start: {
                        line: 166,
                        column: 93
                    },
                    end: {
                        line: 166,
                        column: 94
                    }
                },
                loc: {
                    start: {
                        line: 166,
                        column: 113
                    },
                    end: {
                        line: 166,
                        column: 129
                    }
                },
                line: 166
            },
            '39': {
                name: '(anonymous_39)',
                decl: {
                    start: {
                        line: 177,
                        column: 20
                    },
                    end: {
                        line: 177,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 177,
                        column: 34
                    },
                    end: {
                        line: 177,
                        column: 87
                    }
                },
                line: 177
            },
            '40': {
                name: '(anonymous_40)',
                decl: {
                    start: {
                        line: 177,
                        column: 61
                    },
                    end: {
                        line: 177,
                        column: 62
                    }
                },
                loc: {
                    start: {
                        line: 177,
                        column: 71
                    },
                    end: {
                        line: 177,
                        column: 77
                    }
                },
                line: 177
            },
            '41': {
                name: '(anonymous_41)',
                decl: {
                    start: {
                        line: 184,
                        column: 19
                    },
                    end: {
                        line: 184,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 184,
                        column: 49
                    },
                    end: {
                        line: 184,
                        column: 113
                    }
                },
                line: 184
            },
            '42': {
                name: '(anonymous_42)',
                decl: {
                    start: {
                        line: 184,
                        column: 89
                    },
                    end: {
                        line: 184,
                        column: 90
                    }
                },
                loc: {
                    start: {
                        line: 184,
                        column: 98
                    },
                    end: {
                        line: 184,
                        column: 103
                    }
                },
                line: 184
            },
            '43': {
                name: '(anonymous_43)',
                decl: {
                    start: {
                        line: 191,
                        column: 26
                    },
                    end: {
                        line: 191,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 191,
                        column: 59
                    },
                    end: {
                        line: 191,
                        column: 147
                    }
                },
                line: 191
            },
            '44': {
                name: '(anonymous_44)',
                decl: {
                    start: {
                        line: 191,
                        column: 109
                    },
                    end: {
                        line: 191,
                        column: 110
                    }
                },
                loc: {
                    start: {
                        line: 191,
                        column: 125
                    },
                    end: {
                        line: 191,
                        column: 137
                    }
                },
                line: 191
            },
            '45': {
                name: '(anonymous_45)',
                decl: {
                    start: {
                        line: 198,
                        column: 23
                    },
                    end: {
                        line: 198,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 198,
                        column: 58
                    },
                    end: {
                        line: 198,
                        column: 135
                    }
                },
                line: 198
            },
            '46': {
                name: '(anonymous_46)',
                decl: {
                    start: {
                        line: 198,
                        column: 103
                    },
                    end: {
                        line: 198,
                        column: 104
                    }
                },
                loc: {
                    start: {
                        line: 198,
                        column: 116
                    },
                    end: {
                        line: 198,
                        column: 125
                    }
                },
                line: 198
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0,
            '30': 0,
            '31': 0,
            '32': 0,
            '33': 0,
            '34': 0,
            '35': 0,
            '36': 0,
            '37': 0,
            '38': 0,
            '39': 0,
            '40': 0,
            '41': 0,
            '42': 0,
            '43': 0,
            '44': 0,
            '45': 0,
            '46': 0,
            '47': 0,
            '48': 0,
            '49': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0,
            '30': 0,
            '31': 0,
            '32': 0,
            '33': 0,
            '34': 0,
            '35': 0,
            '36': 0,
            '37': 0,
            '38': 0,
            '39': 0,
            '40': 0,
            '41': 0,
            '42': 0,
            '43': 0,
            '44': 0,
            '45': 0,
            '46': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1c2k3loppc.s[0]++;
angular.module('app').config(routesConfig);

/** @ngInject */
function routesConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    cov_1c2k3loppc.f[0]++;
    cov_1c2k3loppc.s[1]++;

    $locationProvider.html5Mode(true).hashPrefix('!');
    cov_1c2k3loppc.s[2]++;
    $urlRouterProvider.otherwise('/');

    cov_1c2k3loppc.s[3]++;
    $stateProvider.state('login', {
        url: '/login',
        templateUrl: 'app/components/auth/views/auth.login.view.html',
        controller: 'AuthLoginController',
        controllerAs: 'vm'
    }).state('logout', {
        url: '/logout',
        template: '<div></div>',
        controller: 'AuthLogoutController',
        controllerAs: 'vm'
    }).state('profile', {
        url: '/perfil',
        template: '<edit-profile user="$resolve.user" flex layout="column"/>',
        resolve: {
            user: ["$rootScope", "UsersTable", function user($rootScope, UsersTable) {
                cov_1c2k3loppc.f[1]++;
                cov_1c2k3loppc.s[4]++;
                return UsersTable.$find($rootScope.me.id).$then(function (user) {
                    cov_1c2k3loppc.f[2]++;
                    cov_1c2k3loppc.s[5]++;
                    return user;
                }).$promise;
            }]
        }
    }).state('forgot', {
        url: '/recuperar_password',
        templateUrl: 'app/components/auth/views/auth.forgot.html',
        controller: 'AuthForgotController',
        controllerAs: 'vm'
    }).state('set_password', {
        url: '/alterar_password?email&token',
        templateUrl: 'app/components/auth/views/auth.set.password.html',
        controller: 'AuthSetPasswordController',
        controllerAs: 'vm'
    }).state('individualsList', {
        url: '/individuals',
        template: '<individuals-list individuals="$resolve.individuals" flex layout="column"/>',
        resolve: {
            individuals: ["IndividualsTable", function individuals(IndividualsTable) {
                cov_1c2k3loppc.f[3]++;
                cov_1c2k3loppc.s[6]++;
                return IndividualsTable.$search().$then(function (individuals) {
                    cov_1c2k3loppc.f[4]++;
                    cov_1c2k3loppc.s[7]++;
                    return individuals;
                }).$promise;
            }]
        }
    }).state('individualDetails', {
        url: '/individual/:id',
        template: '<individual-details individual="$resolve.individual" flex layout="column"/>',
        resolve: {
            individual: ["IndividualsTable", "$stateParams", function individual(IndividualsTable, $stateParams) {
                cov_1c2k3loppc.f[5]++;
                cov_1c2k3loppc.s[8]++;
                return IndividualsTable.$find($stateParams.id).$then(function (individual) {
                    cov_1c2k3loppc.f[6]++;
                    cov_1c2k3loppc.s[9]++;
                    return individual;
                }).$promise;
            }]
        }
    }).state('economicActivitiesList', {
        url: '/economic-activities',
        template: '<economic-activities-list economic-activities="$resolve.economicActivities" flex layout="column"/>',
        resolve: {
            economicActivities: ["EconomicActivitiesTable", function economicActivities(EconomicActivitiesTable) {
                cov_1c2k3loppc.f[7]++;
                cov_1c2k3loppc.s[10]++;
                return EconomicActivitiesTable.$search().$then(function (economicActivities) {
                    cov_1c2k3loppc.f[8]++;
                    cov_1c2k3loppc.s[11]++;
                    return economicActivities;
                }).$promise;
            }]
        }
    }).state('organizationsList', {
        url: '/organizations?tag&size&turnover&municipality&municipality__district&profile_level&interactions&people_count&target_state&target_score',
        template: '<organizations-list organizations="$resolve.organizations" flex layout="column"/>',
        resolve: {
            organizations: ["OrganizationsTable", function organizations(OrganizationsTable) {
                cov_1c2k3loppc.f[9]++;
                cov_1c2k3loppc.s[12]++;
                return OrganizationsTable.$search().$then(function (organizations) {
                    cov_1c2k3loppc.f[10]++;
                    cov_1c2k3loppc.s[13]++;
                    return organizations;
                }).$promise;
            }]
        }
    }).state('organizationDetails', {
        url: '/organization/:id',
        template: '<organization-details organization="$resolve.organization" flex layout="column"/>',
        resolve: {
            organization: ["OrganizationsTable", "$stateParams", function organization(OrganizationsTable, $stateParams) {
                cov_1c2k3loppc.f[11]++;
                cov_1c2k3loppc.s[14]++;
                return OrganizationsTable.$find($stateParams.id).$then(function (organization) {
                    cov_1c2k3loppc.f[12]++;
                    cov_1c2k3loppc.s[15]++;
                    return organization;
                }).$promise;
            }]
        }
    }).state('proposalsList', {
        url: '/proposals',
        template: '<proposals-list proposals="$resolve.proposals" flex layout="column"/>',
        resolve: {
            proposals: ["ProposalsTable", function proposals(ProposalsTable) {
                cov_1c2k3loppc.f[13]++;
                cov_1c2k3loppc.s[16]++;
                return ProposalsTable.$search().$then(function (proposals) {
                    cov_1c2k3loppc.f[14]++;
                    cov_1c2k3loppc.s[17]++;
                    return proposals;
                }).$promise;
            }]
        }
    }).state('proposalDetails', {
        url: '/proposal/:id',
        template: '<proposal-details proposal="$resolve.proposal" flex layout="column"/>',
        resolve: {
            proposal: ["ProposalsTable", "$stateParams", function proposal(ProposalsTable, $stateParams) {
                cov_1c2k3loppc.f[15]++;
                cov_1c2k3loppc.s[18]++;
                return ProposalsTable.$find($stateParams.id).$then(function (proposal) {
                    cov_1c2k3loppc.f[16]++;
                    cov_1c2k3loppc.s[19]++;
                    return proposal;
                }).$promise;
            }]
        }
    }).state('proposalSectionDetails', {
        url: '/proposal-section/:id',
        template: '<proposal-section-details proposal-section="$resolve.proposalSection" flex layout="column"/>',
        resolve: {
            proposalSection: ["ProposalSectionsTable", "$stateParams", function proposalSection(ProposalSectionsTable, $stateParams) {
                cov_1c2k3loppc.f[17]++;
                cov_1c2k3loppc.s[20]++;
                return ProposalSectionsTable.$find($stateParams.id).$then(function (proposalSection) {
                    cov_1c2k3loppc.f[18]++;
                    cov_1c2k3loppc.s[21]++;
                    return proposalSection;
                }).$promise;
            }]
        }
    }).state('userStoryDetails', {
        url: '/user-story/:id',
        template: '<user-story-details user-story="$resolve.userStory" flex layout="column"/>',
        resolve: {
            userStory: ["UserStoriesTable", "$stateParams", function userStory(UserStoriesTable, $stateParams) {
                cov_1c2k3loppc.f[19]++;
                cov_1c2k3loppc.s[22]++;
                return UserStoriesTable.$find($stateParams.id).$then(function (userStory) {
                    cov_1c2k3loppc.f[20]++;
                    cov_1c2k3loppc.s[23]++;
                    return userStory;
                }).$promise;
            }]
        }
    }).state('userStoriesList', {
        url: '/user-stories',
        template: '<user-stories-list user-stories="$resolve.userStories" flex layout="column"/>',
        resolve: {
            /* eslint-disable camelcase */
            userStories: ["UserStoriesTable", function userStories(UserStoriesTable) {
                cov_1c2k3loppc.f[21]++;
                cov_1c2k3loppc.s[24]++;
                return UserStoriesTable.$search({ proposal__isnull: 'True' }).$then(function (userStories) {
                    cov_1c2k3loppc.f[22]++;
                    cov_1c2k3loppc.s[25]++;
                    return userStories;
                }).$promise;
            }]
        }
    }).state('remindersList', {
        url: '/reminders',
        template: '<reminders-list reminders="$resolve.reminders" flex layout="column"/>',
        resolve: {
            reminders: ["RemindersTable", function reminders(RemindersTable) {
                cov_1c2k3loppc.f[23]++;
                cov_1c2k3loppc.s[26]++;
                return RemindersTable.$search().$then(function (reminders) {
                    cov_1c2k3loppc.f[24]++;
                    cov_1c2k3loppc.s[27]++;
                    return reminders;
                }).$promise;
            }]
        }
    }).state('documentsList', {
        url: '/documents',
        template: '<documents-list documents="$resolve.documents" flex layout="column"/>',
        resolve: {
            documents: ["OrganizationFilesTable", function documents(OrganizationFilesTable) {
                cov_1c2k3loppc.f[25]++;
                cov_1c2k3loppc.s[28]++;
                return OrganizationFilesTable.$search().$then(function (documents) {
                    cov_1c2k3loppc.f[26]++;
                    cov_1c2k3loppc.s[29]++;
                    return documents;
                }).$promise;
            }]
        }
    }).state('tagsList', {
        url: '/tags',
        template: '<tags-list tags="$resolve.tag" flex layout="column"/>',
        resolve: {
            tag: ["TagsTable", function tag(TagsTable) {
                cov_1c2k3loppc.f[27]++;
                cov_1c2k3loppc.s[30]++;
                return TagsTable.$search().$then(function (tags) {
                    cov_1c2k3loppc.f[28]++;
                    cov_1c2k3loppc.s[31]++;
                    return tags;
                }).$promise;
            }]
        }
    }).state('tagDetails', {
        url: '/tag/:id',
        template: '<tag-details tag="$resolve.tag" flex layout="column"/>',
        resolve: {
            tag: ["TagsTable", "$stateParams", function tag(TagsTable, $stateParams) {
                cov_1c2k3loppc.f[29]++;
                cov_1c2k3loppc.s[32]++;
                return TagsTable.$find($stateParams.id).$then(function (tag) {
                    cov_1c2k3loppc.f[30]++;
                    cov_1c2k3loppc.s[33]++;
                    return tag;
                }).$promise;
            }]
        }
    }).state('componentsList', {
        url: '/components',
        template: '<components-list components="$resolve.components" flex layout="column"/>',
        resolve: {
            components: ["ComponentsTable", function components(ComponentsTable) {
                cov_1c2k3loppc.f[31]++;
                cov_1c2k3loppc.s[34]++;
                return ComponentsTable.$search().$then(function (components) {
                    cov_1c2k3loppc.f[32]++;
                    cov_1c2k3loppc.s[35]++;
                    return components;
                }).$promise;
            }]
        }
    }).state('municipalitiesList', {
        url: '/municipalities',
        template: '<municipalities-list municipalities="$resolve.municipalities" flex layout="column"/>',
        resolve: {
            municipalities: ["MunicipalitiesTable", function municipalities(MunicipalitiesTable) {
                cov_1c2k3loppc.f[33]++;
                cov_1c2k3loppc.s[36]++;
                return MunicipalitiesTable.$search().$then(function (municipalities) {
                    cov_1c2k3loppc.f[34]++;
                    cov_1c2k3loppc.s[37]++;
                    return municipalities;
                }).$promise;
            }]
        }
    }).state('municipalityDetails', {
        url: '/municipality/:id',
        template: '<municipality-details municipality="$resolve.municipality" flex layout="column"/>',
        resolve: {
            municipality: ["MunicipalitiesTable", "$stateParams", function municipality(MunicipalitiesTable, $stateParams) {
                cov_1c2k3loppc.f[35]++;
                cov_1c2k3loppc.s[38]++;
                return MunicipalitiesTable.$find($stateParams.id).$then(function (municipality) {
                    cov_1c2k3loppc.f[36]++;
                    cov_1c2k3loppc.s[39]++;
                    return municipality;
                }).$promise;
            }]
        }
    }).state('interactionTypesList', {
        url: '/interaction-types',
        template: '<interaction-types-list interaction-types="$resolve.interactionTypes" flex layout="column"/>',
        resolve: {
            interactionTypes: ["InteractionTypesTable", function interactionTypes(InteractionTypesTable) {
                cov_1c2k3loppc.f[37]++;
                cov_1c2k3loppc.s[40]++;
                return InteractionTypesTable.$search().$then(function (interactionTypes) {
                    cov_1c2k3loppc.f[38]++;
                    cov_1c2k3loppc.s[41]++;
                    return interactionTypes;
                }).$promise;
            }]
        }
    }).state('dashboard', {
        url: '/',
        template: '<dashboard flex layout="column"/>'
    }).state('mediaList', {
        url: '/media',
        template: '<media-list medias="$resolve.medias" flex layout="column"/>',
        resolve: {
            medias: ["LinksTable", function medias(LinksTable) {
                cov_1c2k3loppc.f[39]++;
                cov_1c2k3loppc.s[42]++;
                return LinksTable.$search().$then(function (medias) {
                    cov_1c2k3loppc.f[40]++;
                    cov_1c2k3loppc.s[43]++;
                    return medias;
                }).$promise;
            }]
        }
    }).state('mediaDetails', {
        url: '/media/:id',
        template: '<media-details media="$resolve.media" flex layout="column"/>',
        resolve: {
            media: ["LinksTable", "$stateParams", function media(LinksTable, $stateParams) {
                cov_1c2k3loppc.f[41]++;
                cov_1c2k3loppc.s[44]++;
                return LinksTable.$find($stateParams.id).$then(function (media) {
                    cov_1c2k3loppc.f[42]++;
                    cov_1c2k3loppc.s[45]++;
                    return media;
                }).$promise;
            }]
        }
    }).state('interactionsList', {
        url: '/interactions',
        template: '<interactions-list interactions="$resolve.interactions" flex layout="column"/>',
        resolve: {
            interactions: ["OrganizationInteractionsTable", function interactions(OrganizationInteractionsTable) {
                cov_1c2k3loppc.f[43]++;
                cov_1c2k3loppc.s[46]++;
                return OrganizationInteractionsTable.$collection().$then(function (interactions) {
                    cov_1c2k3loppc.f[44]++;
                    cov_1c2k3loppc.s[47]++;
                    return interactions;
                }).$promise;
            }]
        }
    }).state('workspaceDetails', {
        url: '/workspace/:id',
        template: '<workspace-details workspace="$resolve.workspace" flex layout="column"/>',
        resolve: {
            workspace: ["WorkspacesTable", "$stateParams", function workspace(WorkspacesTable, $stateParams) {
                cov_1c2k3loppc.f[45]++;
                cov_1c2k3loppc.s[48]++;
                return WorkspacesTable.$find($stateParams.id).$then(function (workspace) {
                    cov_1c2k3loppc.f[46]++;
                    cov_1c2k3loppc.s[49]++;
                    return workspace;
                }).$promise;
            }]
        }
    });
}